import { a as e } from "./rolldown-runtime-B1bRi_D7.js";
import { _ as t, a as n, c as r, d as i, f as a, g as o, h as s, i as c, l, m as u, n as d, o as f, p, r as m, s as h, u as g } from "./emoji-CgOyphi_.js";
import { t as _ } from "./svg-B8tpUV2-.js";
import { C as v, S as y, _ as b, a as x, b as S, c as C, d as w, f as T, g as E, h as D, i as ee, l as te, m as ne, n as re, o as ie, p as ae, r as oe, s as se, t as ce, u as le, v as ue, w as de, x as fe, y as pe } from "./vendor-DrJXh2d6.js";
import O from "classnames";
import { Fragment as k, jsx as A, jsxs as j } from "react/jsx-runtime";
import { Children as M, Component as me, Fragment as he, PureComponent as N, Suspense as ge, cloneElement as _e, createContext as ve, createElement as ye, createRef as P, forwardRef as F, isValidElement as I, lazy as be, memo as xe, useCallback as L, useContext as Se, useEffect as R, useImperativeHandle as Ce, useLayoutEffect as we, useMemo as z, useReducer as Te, useRef as B, useState as V } from "react";
import Ee from "react-dom";
import De from "lodash/noop";
import { useClickAway as Oe, useDebounce as ke, useKey as Ae, useMount as je, usePrevious as Me, useSetState as Ne, useToggle as Pe, useUnmount as Fe, useUpdateEffect as Ie } from "react-use";
import Le from "lodash/clamp";
import Re from "lodash/isNil";
import ze from "lodash/padStart";
import H from "moment-timezone";
import Be from "lodash/orderBy";
import Ve from "lodash/range";
import He from "lodash/escapeRegExp";
import Ue from "lodash/isEqual";
import We from "lodash/uniqueId";
import Ge from "lodash/isEmpty";
import Ke from "lodash/isString";
import { v4 as qe } from "uuid";
import Je from "lodash/isUndefined";
import Ye from "lodash/omit";
import Xe from "lodash/isElement";
import Ze from "lodash/intersection";
import { noop as Qe } from "ts-essentials";
import $e from "lodash/once";
//#region src/context/windowContext.tsx
function et(e) {
	let t = e, n = [];
	function r(e) {
		if (e !== t) {
			for (let { type: r, handler: i, options: a } of n) t.removeEventListener(r, i, a), e.addEventListener(r, i, a);
			t = e;
		}
	}
	return {
		proxy: new Proxy({}, { get(e, r) {
			if (r === "addEventListener") return (e, r, i) => {
				n.push({
					type: e,
					handler: r,
					options: i
				}), t.addEventListener(e, r, i);
			};
			if (r === "removeEventListener") return (e, r, i) => {
				let a = typeof i == "boolean" ? i : i?.capture ?? !1, o = n.findIndex((t) => {
					let n = typeof t.options == "boolean" ? t.options : t.options?.capture ?? !1;
					return t.type === e && t.handler === r && n === a;
				});
				o !== -1 && n.splice(o, 1), t.removeEventListener(e, r, i);
			};
			let i = t[r];
			return typeof i == "function" ? new Proxy(i, { apply(e, n, r) {
				return i.apply(t, r);
			} }) : i;
		} }),
		setWindow: r
	};
}
var tt = ve(typeof window < "u" ? window : {});
function nt({ value: e, children: t }) {
	let n = B(null);
	return n.current ||= et(e), we(() => {
		n.current.setWindow(e);
	}, [e]), /* @__PURE__ */ A(tt.Provider, {
		value: n.current.proxy,
		children: t
	});
}
function rt() {
	return Se(tt);
}
var it = {
	content: "h-tooltip--tooltip__content",
	contentLight: "h-tooltip--tooltip__contentLight",
	contentHasHead: "h-tooltip--tooltip__contentHasHead",
	body: "h-tooltip--tooltip__body",
	head: "h-tooltip--tooltip__head",
	arrow: "h-tooltip--tooltip__arrow",
	slideUp: "h-tooltip--tooltip__slideUp",
	slideDown: "h-tooltip--tooltip__slideDown",
	slideLeft: "h-tooltip--tooltip__slideLeft",
	slideRight: "h-tooltip--tooltip__slideRight"
}, at = 400;
function U({ children: e, content: t, onOpenChange: n, side: r = "top", className: i, head: a, defaultOpen: o, alwaysShow: s, disabled: c, delayDuration: l = at, align: u, "aria-label": d, wrap: f = "span", wrapProps: p, requireClick: m, light: h, ...g }) {
	let _ = rt(), [b, x] = V(!m && void 0), C = L(() => {
		x(!1), _.removeEventListener("click", C);
	}, [_]);
	R(() => () => {
		_.removeEventListener("click", C);
	}, [C, _]);
	let w = de();
	if (c || !t) return /* @__PURE__ */ A(k, { children: e });
	let T = (e) => {
		e.stopPropagation(), _[b ? "removeEventListener" : "addEventListener"]("click", C), x(!b);
	}, E = O(it.content, {
		[it.contentHasHead]: !!a,
		[it.contentLight]: h
	}, i);
	return /* @__PURE__ */ A(fe, { children: /* @__PURE__ */ j(y, {
		open: b ?? (s ? !0 : void 0),
		defaultOpen: o,
		delayDuration: l,
		"aria-label": d,
		onOpenChange: n,
		children: [/* @__PURE__ */ A(v, {
			asChild: !0,
			children: f === "none" ? m && I(e) ? _e(e, { onClick: T }) : e : /* @__PURE__ */ A(f, {
				onClick: m ? T : void 0,
				...p,
				...g,
				children: e
			})
		}), /* @__PURE__ */ A(S, {
			container: _.document.body,
			children: /* @__PURE__ */ A(pe, {
				id: w,
				side: r,
				sideOffset: 4,
				align: u,
				className: E,
				style: { zIndex: 2147483647 },
				children: /* @__PURE__ */ j(k, { children: [
					a && /* @__PURE__ */ A("div", {
						className: it.head,
						children: a
					}),
					/* @__PURE__ */ A("div", {
						className: it.body,
						children: t
					}),
					/* @__PURE__ */ A(ue, { className: it.arrow })
				] })
			})
		})]
	}) });
}
var ot = {
	root: "h-attachment--attachment__root",
	icon: "h-attachment--attachment__icon",
	name: "h-attachment--attachment__name",
	buttons: "h-attachment--attachment__buttons"
}, st = {
	jpg: "file-image",
	jpeg: "file-image",
	bmp: "file-image",
	gif: "file-image",
	tiff: "file-image",
	png: "file-image",
	mp4: "file-video",
	m4v: "file-video",
	mpeg: "file-video",
	mov: "file-video",
	avi: "file-video",
	wmv: "file-video",
	webm: "file-video",
	flv: "file-video",
	wav: "file-audio",
	mp3: "file-audio",
	aiff: "file-audio",
	acc: "file-audio",
	ogg: "file-audio",
	wma: "file-audio",
	flac: "file-audio",
	alac: "file-audio",
	pdf: "file-pdf",
	csv: "file-csv",
	doc: "file-word",
	docx: "file-word",
	xls: "file-excel",
	xlsx: "file-excel",
	ppt: "file-powerpoint",
	pptx: "file-powerpoint",
	zip: "file-archive",
	rar: "file-archive",
	arc: "file-archive",
	"7z": "file-archive",
	s7z: "file-archive",
	tar: "file-archive",
	bz2: "file-archive",
	gz: "file-archive"
};
function ct(e) {
	let t = e.split(".").pop()?.toLowerCase();
	return !t || !st[t] ? "file" : st[t];
}
var lt = (e) => {
	let { className: t, nameClassName: n, fileName: r, label: a, onDownload: o, onPreview: s, isPreviewLoading: c, isDownloadLoading: l, extraButtons: d, ...f } = e, p = O({ [ot.root]: !0 }, t);
	return /* @__PURE__ */ j("div", {
		...f,
		className: p,
		children: [
			/* @__PURE__ */ A(u, {
				className: ot.icon,
				name: ct(r),
				size: 24,
				color: "neutral.700"
			}),
			/* @__PURE__ */ A(U, {
				content: a || r,
				wrap: "div",
				wrapProps: { className: O(ot.name, n) },
				children: /* @__PURE__ */ A(i.Paragraph, {
					variant: "4",
					color: "secondary",
					children: a || r
				})
			}),
			/* @__PURE__ */ j("div", {
				className: ot.buttons,
				children: [
					s && /* @__PURE__ */ A(h, {
						isLoading: c,
						variant: "secondary",
						icon: "eye",
						onClick: c ? void 0 : s
					}),
					o && /* @__PURE__ */ A(h, {
						isLoading: l,
						variant: "secondary",
						icon: "download",
						onClick: l ? void 0 : o
					}),
					d
				]
			})
		]
	});
}, ut = ve({ onError(e, t) {
	console.error(e, t);
} }), dt = /* @__PURE__ */ e(b()), ft = { error: null }, pt = class e extends me {
	static getDerivedStateFromError(e) {
		return { error: e };
	}
	constructor(e) {
		super(e), this.state = ft, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
	}
	componentDidCatch(e, t) {
		this.props.onError?.(e, t), this.context?.onError?.(e, t);
	}
	static contextType = ut;
	resetErrorBoundary(...e) {
		this.props.onReset?.(...e), this.resetInternally();
	}
	resetInternally() {
		this.setState(ft);
	}
	hasError(e) {
		return e !== null;
	}
	ensureErrorHandlerExists() {
		let { fallback: t, fallbackRender: n } = this.props, r = this.hasFallbackElement(t), i = this.hasFallbackRenderer(n);
		if (!r && !i) throw Error(`${e.name} requires either a fallback component or a fallback renderer`);
	}
	hasFallbackRenderer(e) {
		return typeof e == "function";
	}
	hasFallbackElement(e) {
		return e === null || typeof e == "string" || I(e);
	}
	render() {
		let { error: e } = this.state, { fallbackRender: t, fallback: n } = this.props;
		if (this.ensureErrorHandlerExists(), !this.hasError(e)) return this.props.children;
		if (this.hasFallbackElement(n)) return n;
		if (this.hasFallbackRenderer(t)) return t({
			error: e,
			resetErrorBoundary: this.resetErrorBoundary
		});
	}
};
function mt(e, t) {
	let n = e.displayName || e.name || "Unknown";
	return (0, dt.default)(class extends me {
		static displayName = `withErrorBoundary(${n})`;
		static defaultProps = e.defaultProps;
		render() {
			let n = e;
			return /* @__PURE__ */ A(pt, {
				...t,
				children: /* @__PURE__ */ A(n, { ...this.props })
			});
		}
	}, e);
}
var ht = {
	root: "h-avatar--avatar__root",
	"avatar-24": "h-avatar--avatar__avatar-24",
	"avatar-32": "h-avatar--avatar__avatar-32",
	"avatar-40": "h-avatar--avatar__avatar-40"
}, gt = {
	24: 16,
	32: 20,
	40: 24
}, _t = ({ icon: e, size: t, color: n = "inherit" }) => /* @__PURE__ */ A(u, {
	name: e,
	size: gt[t],
	color: n
}), vt = {
	image: "h-image--image__image",
	error: "h-image--image__error",
	complete: "h-image--image__complete"
}, yt = class extends me {
	static defaultProps;
	mounted;
	constructor(e) {
		super(e), this.state = {
			imageSrc: "",
			loadingError: !1,
			loadingComplete: !1
		}, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
	}
	UNSAFE_componentWillMount() {
		let { src: e } = this.props;
		this.handleSource(e);
	}
	UNSAFE_componentWillReceiveProps(e) {
		let { src: t } = this.props;
		e.src !== t && this.handleSource(e.src);
	}
	componentWillUnmount() {
		this.mounted = !1;
	}
	handleSource(e) {
		typeof e == "string" ? this.setState({ imageSrc: e }) : e().then((e) => {
			this.mounted && typeof e == "string" && this.setState({ imageSrc: e });
		}).catch(() => {
			this.mounted && this.setState({ loadingError: !0 });
		});
	}
	onLoad(e) {
		this.setState({
			loadingComplete: !0,
			loadingError: !1
		}), this.props.onLoad?.(e);
	}
	onError(e) {
		this.setState({
			loadingError: !0,
			loadingComplete: !1
		}), this.props.onError?.(e);
	}
	render() {
		let { className: e, src: t, alt: n, ...r } = this.props, { imageSrc: i } = this.state, { loadingError: a, loadingComplete: o } = this.state, s = O({
			[vt.image]: !0,
			[vt.error]: !!a,
			[vt.complete]: !!o
		}, e);
		return /* @__PURE__ */ A("img", {
			...r,
			className: s,
			onError: this.onError,
			onLoad: this.onLoad,
			src: i,
			alt: n || ""
		});
	}
};
yt.defaultProps = {
	className: "",
	alt: ""
};
var bt = { root: "h-avatar--imageAvatar__root" }, xt = ({ src: e, alt: t = "avatar" }) => /* @__PURE__ */ A(yt, {
	src: e,
	alt: t,
	className: bt.root
}), St = {
	root: "h-avatar--textAvatar__root",
	"avatar-24": "h-avatar--textAvatar__avatar-24",
	"avatar-32": "h-avatar--textAvatar__avatar-32",
	"avatar-40": "h-avatar--textAvatar__avatar-40"
}, Ct = {
	24: St["avatar-24"],
	32: St["avatar-32"],
	40: St["avatar-40"]
}, wt = ({ text: e = "", size: t }) => /* @__PURE__ */ A("div", {
	className: O(St.root, Ct[t]),
	children: e.trim().split(" ").map((e, t, n) => n.length === 1 ? e : e[0]).join("").slice(0, 2)
}), Tt = [
	{
		contentColor: "var(--dixa-avatar-content-green)",
		backgroundColor: "var(--dixa-avatar-background-green)"
	},
	{
		contentColor: "var(--dixa-avatar-content-purple)",
		backgroundColor: "var(--dixa-avatar-background-purple)"
	},
	{
		contentColor: "var(--dixa-avatar-content-blue)",
		backgroundColor: "var(--dixa-avatar-background-blue)"
	},
	{
		contentColor: "var(--dixa-avatar-content-orange)",
		backgroundColor: "var(--dixa-avatar-background-orange)"
	},
	{
		contentColor: "var(--dixa-avatar-content-red)",
		backgroundColor: "var(--dixa-avatar-background-red)"
	}
], Et = /* @__PURE__ */ e(E()), Dt = class {
	colors;
	constructor(e) {
		this.colors = e, this.colors = e;
	}
	generate(e) {
		let t = this.getRandomIndex(e);
		return this.colors[t];
	}
	getRandomIndex(e) {
		let t = (0, Et.default)(e);
		return Math.floor(t() * this.colors.length);
	}
}, W = /* @__PURE__ */ function(e) {
	return e.Icon = "Icon", e.Image = "Image", e.Text = "Text", e;
}({});
//#endregion
//#region src/components/avatar/utils/removeSpecialChars.ts
function Ot(e) {
	return e.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
//#endregion
//#region src/components/avatar/utils/determineAvatarType.ts
function kt(e) {
	return !!e && e.trim().length !== 0;
}
function At(e) {
	if (e.icon) return {
		type: W.Icon,
		icon: e.icon,
		backgroundColor: e.color?.backgroundColor,
		iconColor: e.color?.contentColor
	};
	let { user: t } = e;
	if (!t) return {
		type: W.Icon,
		icon: "user-slash"
	};
	if (kt(t.avatar_url)) return {
		type: W.Image,
		src: t.avatar_url,
		alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
	};
	if (kt(t.name)) {
		let e = Ot(t.name.trim()).split(" ");
		if (e.length === 1) return {
			type: W.Text,
			text: e[0]?.[0] ?? ""
		};
		let n = e[0], r = e[e.length - 1];
		return {
			type: W.Text,
			text: (n?.[0] ?? "") + (r?.[0] ?? "")
		};
	}
	if (kt(t.display_name)) return {
		type: W.Text,
		text: Ot(t.display_name.trim())
	};
	if (kt(t.given_name) && kt(t.family_name)) return {
		type: W.Text,
		text: Ot(t.given_name.trim())[0] + Ot(t.family_name.trim())[0]
	};
	if (kt(t.given_name) && !kt(t.family_name)) return {
		type: W.Text,
		text: Ot(t.given_name.trim())[0]
	};
	if (!kt(t.given_name) && kt(t.family_name)) return {
		type: W.Text,
		text: Ot(t.family_name.trim())[0]
	};
	if (kt(t.email)) {
		let [e] = t.email.split("@");
		return {
			type: W.Text,
			text: e.trim()
		};
	}
	return kt(t.phone_number) ? {
		type: W.Text,
		text: t.phone_number.slice(-2)
	} : t.id ? {
		type: W.Icon,
		icon: "user-secret"
	} : {
		type: W.Icon,
		icon: "user-slash"
	};
}
//#endregion
//#region src/components/avatar/wellknownIconColors.ts
var jt = {
	backgroundColor: "var(--dixa-color-neutral-200)",
	contentColor: "var(--dixa-color-neutral-700)"
}, Mt = {
	shopify: {
		backgroundColor: "rgba(148, 190, 69, 0.1)",
		contentColor: "#94BE45"
	},
	agillic: {
		...jt,
		contentColor: "#000"
	},
	magento: {
		backgroundColor: "rgba(193, 72, 0, 0.1)",
		contentColor: "#C14800"
	},
	salesforce: {
		backgroundColor: "rgba(3, 161, 224, 0.1)",
		contentColor: "#03A1E0"
	},
	busylight: {
		backgroundColor: "rgba(27, 190, 246, 0.1)",
		contentColor: "#1BBEF6"
	},
	podio: {
		backgroundColor: "rgba(80, 145, 189, 0.1)",
		contentColor: "#5091BD"
	},
	"user-secret": jt,
	"user-slash": jt,
	"map-pin": jt,
	"web-form": jt,
	code: jt,
	history: jt,
	smile: jt,
	key: jt,
	webhooks: jt,
	plug: jt
}, Nt = {
	24: ht["avatar-24"],
	32: ht["avatar-32"],
	40: ht["avatar-40"]
}, Pt = mt(class extends N {
	static defaultProps = {
		size: "32",
		colorGenerator: new Dt(Tt)
	};
	getAvatarChild(e, t) {
		if (e.type === W.Icon) return /* @__PURE__ */ A(_t, {
			size: t,
			icon: e.icon,
			color: e.iconColor
		});
		if (e.type === W.Image) return /* @__PURE__ */ A(xt, {
			src: e.src,
			alt: e.alt
		});
		if (e.type === W.Text) return /* @__PURE__ */ A(wt, {
			size: t,
			text: e.text
		});
	}
	calculateColor(e) {
		if (e.type === W.Icon) {
			if (e.backgroundColor && e.iconColor) return {
				backgroundColor: e.backgroundColor,
				contentColor: e.iconColor
			};
			if (Mt[e.icon]) return Mt[e.icon];
		}
		return e.type === W.Image ? {
			backgroundColor: "transparent",
			contentColor: "initial"
		} : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : e.type === W.Text ? this.props.colorGenerator.generate(e.text) : this.props.colorGenerator.generate();
	}
	render() {
		let { className: e, size: t } = this.props, n = At(this.props), r = this.getAvatarChild(n, t), i = this.calculateColor(n);
		return /* @__PURE__ */ A("div", {
			style: {
				backgroundColor: i.backgroundColor,
				color: i.contentColor
			},
			className: O(ht.root, Nt[t], e),
			children: r
		});
	}
}, { fallback: null }), Ft = {
	badge: "h-badge--badge__badge",
	badgeSmall: "h-badge--badge__badgeSmall",
	badgeMedium: "h-badge--badge__badgeMedium",
	badgePrimary: "h-badge--badge__badgePrimary",
	badgeSecondary: "h-badge--badge__badgeSecondary",
	badgeSuccess: "h-badge--badge__badgeSuccess",
	badgeInfo: "h-badge--badge__badgeInfo",
	badgeWarning: "h-badge--badge__badgeWarning",
	badgeError: "h-badge--badge__badgeError",
	badgeWithIcon: "h-badge--badge__badgeWithIcon"
}, It = 12, Lt = {
	small: Ft.badgeSmall,
	medium: Ft.badgeMedium
}, Rt = {
	primary: Ft.badgePrimary,
	secondary: Ft.badgeSecondary,
	success: Ft.badgeSuccess,
	info: Ft.badgeInfo,
	warning: Ft.badgeWarning,
	error: Ft.badgeError
}, zt = "badge";
function Bt(e) {
	let { className: t, size: n, variant: r, icon: i, children: a, ...o } = e;
	return /* @__PURE__ */ A("span", {
		className: O(Ft.badge, Lt[n], Rt[r], t),
		...o,
		"data-testid": zt,
		children: i ? /* @__PURE__ */ j("span", {
			className: Ft.badgeWithIcon,
			children: [/* @__PURE__ */ A(u, {
				name: i,
				size: It
			}), a]
		}) : a
	});
}
//#endregion
//#region src/components/flexBox/flexBox.tsx
var G = F(function({ flexWrap: e, flexDirection: t, justifyItems: n, justifyContent: r, alignItems: i, alignContent: s, gap: c, style: l, children: u, ...d }, f) {
	let p = {
		...e && { flexWrap: e },
		...t && { flexDirection: t },
		...n && { justifyItems: n },
		...r && { justifyContent: r },
		...i && { alignItems: i },
		...s && { alignContent: s },
		...c && { gap: o(c) },
		display: "flex",
		...l
	};
	return /* @__PURE__ */ A(a, {
		...d,
		style: p,
		ref: f,
		children: u
	});
}), Vt = {
	root: "h-banner--banner__root",
	rootWithClose: "h-banner--banner__rootWithClose",
	iconContainer: "h-banner--banner__iconContainer",
	closeIcon: "h-banner--banner__closeIcon",
	headline: "h-banner--banner__headline",
	rootInfo: "h-banner--banner__rootInfo",
	icon: "h-banner--banner__icon",
	description: "h-banner--banner__description",
	rootWarning: "h-banner--banner__rootWarning",
	rootAnnouncement: "h-banner--banner__rootAnnouncement",
	rootSuccess: "h-banner--banner__rootSuccess",
	rootFail: "h-banner--banner__rootFail"
}, Ht = (e, t) => {
	if (t !== void 0) return t;
	switch (e) {
		case "info":
		case "announcement": return "info";
		case "warning": return "exclamation-triangle-filled";
		case "success": return "check-circle-filled";
		default: return "close-circle-filled";
	}
}, Ut = ({ actionSlot: e, className: t, description: n, headline: r, icon: a, variant: o, onClose: s }) => {
	let c = O(Vt.root, t, {
		[Vt.rootInfo]: o === "info",
		[Vt.rootAnnouncement]: o === "announcement",
		[Vt.rootWarning]: o === "warning",
		[Vt.rootSuccess]: o === "success",
		[Vt.rootFail]: o === "fail",
		[Vt.rootWithClose]: s
	}), l = Ht(o, a);
	return /* @__PURE__ */ j("div", {
		className: c,
		children: [/* @__PURE__ */ j(G, {
			justifyContent: "center",
			children: [l && /* @__PURE__ */ A("span", {
				className: Vt.iconContainer,
				children: /* @__PURE__ */ A(u, {
					name: l,
					size: 16,
					className: Vt.icon
				})
			}), /* @__PURE__ */ j(G, {
				flexDirection: "column",
				children: [r && /* @__PURE__ */ A(i.Heading, {
					as: "span",
					variant: "heading-3",
					className: Vt.headline,
					children: r
				}), _e(n, { className: Vt.description })]
			})]
		}), e ? /* @__PURE__ */ A(G, {
			gap: "250",
			margin: "0 0 0 250",
			children: e
		}) : s && /* @__PURE__ */ A(h, {
			icon: "close",
			variant: "tertiary",
			className: Vt.closeIcon,
			onClick: s
		})]
	});
}, Wt = {
	root: "h-buttonGroup--buttonGroup__root",
	button: "h-buttonGroup--buttonGroup__button",
	buttonWithBorder: "h-buttonGroup--buttonGroup__buttonWithBorder",
	buttonWithoutBorder: "h-buttonGroup--buttonGroup__buttonWithoutBorder"
}, Gt = ({ className: e, children: t, variant: n, size: r, disabled: i }) => /* @__PURE__ */ A("div", {
	className: O(Wt.root, e),
	role: "group",
	children: M.map(t, (e) => {
		if (!I(e)) return null;
		let t = (n ?? e.props.variant) === "secondary";
		return _e(e, {
			className: O(e.props.className, {
				[Wt.button]: !0,
				[Wt.buttonWithBorder]: t,
				[Wt.buttonWithoutBorder]: !t
			}),
			disabled: i ?? e.props.disabled,
			variant: n ?? e.props.variant,
			size: r
		});
	})
}), Kt = {
	root: "h-divider--divider__root",
	withChildren: "h-divider--divider__withChildren",
	horizontal: "h-divider--divider__horizontal",
	vertical: "h-divider--divider__vertical"
}, qt = F(function({ className: e, children: t, as: n, orientation: r = "horizontal", color: a, margin: c, padding: l, ...u }, d) {
	let f = n ?? (t ? "div" : "hr"), p = O(Kt.root, Kt[r], { [Kt.withChildren]: !!t }, e), m = {
		...u.style,
		...a ? { "--divider-color": s(a) } : {},
		...c ? { margin: o(c) } : {},
		...l ? { padding: o(l) } : {}
	};
	return /* @__PURE__ */ A(f, {
		...u,
		ref: d,
		className: p,
		style: m,
		children: typeof t == "string" ? /* @__PURE__ */ A(i.Paragraph, {
			variant: "2",
			children: t
		}) : t
	});
}), Jt = {
	buttonList: "h-buttonList--buttonList__buttonList",
	inner: "h-buttonList--buttonList__inner"
}, Yt = class extends N {
	render() {
		let { children: e, className: t, ...n } = this.props;
		return /* @__PURE__ */ A(qt, {
			as: "li",
			color: "tertiary",
			padding: "200 250",
			...n,
			children: e
		});
	}
}, Xt = {
	item: "h-buttonList--item__item",
	icon: "h-buttonList--item__icon",
	button: "h-buttonList--item__button",
	buttonDisabled: "h-buttonList--item__buttonDisabled",
	buttonCentered: "h-buttonList--item__buttonCentered",
	checkmark: "h-buttonList--item__checkmark",
	buttonLoading: "h-buttonList--item__buttonLoading",
	pulse: "h-buttonList--item__pulse",
	buttonContent: "h-buttonList--item__buttonContent"
}, Zt = F(function({ icon: e, iconProps: t, children: n, className: r, isSelected: a, isCentered: o, isLoading: s, isDisabled: c, buttonClassName: l, buttonProps: d, onClick: f, ...p }, m) {
	let h = O({ [Xt.item]: !0 }, r), g = O(Xt.button, {
		[Xt.buttonCentered]: o,
		[Xt.buttonLoading]: s,
		[Xt.buttonDisabled]: c
	}, l), _ = c ? { tabIndex: -1 } : {};
	return /* @__PURE__ */ A("li", {
		ref: m,
		...p,
		className: h,
		children: /* @__PURE__ */ j("button", {
			..._,
			...d,
			className: g,
			onClick: f,
			children: [/* @__PURE__ */ j("span", {
				className: Xt.buttonContent,
				children: [e && /* @__PURE__ */ A(u, {
					className: Xt.icon,
					name: e,
					...t
				}), /* @__PURE__ */ A(i.Paragraph, {
					variant: a ? "1" : "2",
					children: n
				})]
			}), a && /* @__PURE__ */ A(u, {
				name: "done",
				size: 20,
				color: "neutral.700",
				className: Xt.checkmark
			})]
		})
	});
}), Qt = class extends N {
	static get Item() {
		return Zt;
	}
	static get Header() {
		return Yt;
	}
	static get Divider() {
		return $t;
	}
	render() {
		let { children: e, className: t, ...n } = this.props, r = O({ [Jt.buttonList]: !0 }, t);
		return /* @__PURE__ */ A("div", {
			...n,
			className: r,
			children: /* @__PURE__ */ A("ul", {
				className: Jt.inner,
				children: e
			})
		});
	}
}, $t = () => /* @__PURE__ */ A(qt, {
	as: "li",
	margin: "100 0"
}), K = De, en = {
	root: "h-checkbox--checkbox__root",
	rootDisabled: "h-checkbox--checkbox__rootDisabled",
	rootChecked: "h-checkbox--checkbox__rootChecked",
	rootIndeterminate: "h-checkbox--checkbox__rootIndeterminate",
	checkbox: "h-checkbox--checkbox__checkbox",
	input: "h-checkbox--checkbox__input"
}, tn = class extends N {
	inputRef;
	constructor(e) {
		super(e), this.inputRef = P();
	}
	componentDidMount() {
		let e = this.inputRef.current;
		e && (e.indeterminate = !!this.props.indeterminate);
	}
	componentDidUpdate(e) {
		let t = this.inputRef.current;
		t && e.indeterminate !== this.props.indeterminate && (t.indeterminate = !!this.props.indeterminate);
	}
	render() {
		let { className: e, onChange: t, id: n, name: r, checked: i, indeterminate: a, disabled: o, tabIndex: s, ...c } = this.props;
		return /* @__PURE__ */ j("span", {
			className: O({
				[en.root]: !0,
				[en.rootDisabled]: o,
				[en.rootChecked]: i,
				[en.rootIndeterminate]: a
			}, e),
			"data-testid": "habla-checkbox",
			...c,
			children: [/* @__PURE__ */ A("span", {
				role: "checkbox",
				"aria-checked": a ? "mixed" : i,
				className: en.checkbox
			}), /* @__PURE__ */ A("input", {
				id: n,
				type: "checkbox",
				"aria-hidden": "true",
				name: r,
				className: en.input,
				onChange: t || K,
				checked: i,
				disabled: o,
				ref: this.inputRef,
				tabIndex: s
			})]
		});
	}
}, nn = { card: "h-collapseCard--collapseCard__card" }, rn = ve({
	isOpen: !1,
	onToggle: K
}), an = {
	content: "h-collapseCard--content__content",
	contentIsOpen: "h-collapseCard--content__contentIsOpen"
}, on = class extends N {
	static displayName = "CollapseCard.Content";
	getRootClassName(e) {
		return O(an.content, this.props.className, { [an.contentIsOpen]: e });
	}
	render() {
		let { children: e, className: t, ...n } = this.props;
		return /* @__PURE__ */ A(rn.Consumer, { children: ({ isOpen: t }) => t ? /* @__PURE__ */ A("ul", {
			...n,
			className: this.getRootClassName(t),
			"data-testid": "content",
			children: e
		}) : null });
	}
};
//#endregion
//#region src/utils/a11y.ts
function sn(e) {
	return {
		role: "button",
		onClick: e,
		onKeyDown: (t) => {
			t.key === "Enter" && e(t);
		}
	};
}
//#endregion
//#region src/utils/keyboard.ts
var cn = [
	"ArrowLeft",
	"ArrowUp",
	"ArrowRight",
	"ArrowDown",
	" "
], ln = ["Escape", "Esc"], un = (e) => cn.includes(e), dn = (e) => ln.includes(e), fn = [
	"input:not([disabled]):not([type=hidden])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"button:not([disabled])",
	"a[href]",
	"area[href]",
	"summary",
	"iframe",
	"object",
	"embed",
	"audio[controls]",
	"video[controls]",
	"[contenteditable]",
	"[tabindex]:not([tabindex=\"-1\"]):not([disabled])"
].join(":not([hidden]):not([tabindex=\"-1\"]),"), pn = xe(function({ containerRef: e, children: t, isActive: n, autoFocus: r, restoreFocus: i, onActiveStateChange: a, bringInFocusOnTab: o }) {
	let s = n !== void 0, c = n === void 0 || n, l = B(null), u = B(c ? document.activeElement : null), d = e || l;
	Ae("Tab", (e) => {
		if (!c) return;
		let t = d.current?.querySelectorAll(fn), n = !d.current?.contains(e.target instanceof Element ? e.target : null);
		if (!t) return;
		let r = t[0], i = t[t.length - 1];
		if (!e.shiftKey && document.activeElement === i || !e.shiftKey && o && n) return r?.focus(), e.preventDefault();
		(e.shiftKey && document.activeElement === r || e.shiftKey && o && n) && (i?.focus(), e.preventDefault());
	}, void 0, [c]);
	let f = () => {
		setTimeout(() => {
			r && (r === !0 ? d.current?.querySelector(fn)?.focus() : r.current && r.current.focus());
		});
	}, p = () => {
		document.activeElement !== document.body && !d.current?.contains(document.activeElement) || setTimeout(() => {
			i && (i === !0 ? u.current?.focus() : i.current && i.current.focus());
		});
	};
	return je(() => {
		s || (f(), a?.(!0));
	}), Fe(() => {
		s || (p(), a?.(!1));
	}), Ie(() => {
		n === !0 ? (u.current = document.activeElement, f()) : n === !1 && p(), a?.(!!n);
	}, [n]), e ? /* @__PURE__ */ A(k, { children: t }) : /* @__PURE__ */ A("div", {
		ref: l,
		children: t
	});
}), mn = {
	dropdown: "h-dropdown--dropdown__dropdown",
	dropdownOpen: "h-dropdown--dropdown__dropdownOpen",
	dropdownFromRight: "h-dropdown--dropdown__dropdownFromRight",
	dropdownFromBottom: "h-dropdown--dropdown__dropdownFromBottom",
	dropdownAnimating: "h-dropdown--dropdown__dropdownAnimating",
	dropdownFixed: "h-dropdown--dropdown__dropdownFixed",
	loader: "h-dropdown--dropdown__loader",
	error: "h-dropdown--dropdown__error",
	errorIcon: "h-dropdown--dropdown__errorIcon"
}, hn = class extends N {
	dropdownRef;
	timeoutAnimationStart;
	timeoutAnimationEnd;
	win;
	static defaultProps = {
		onClose: () => {},
		closeOnBlur: !0
	};
	constructor(e) {
		super(e), this.state = {
			fromRight: !1,
			fromBottom: !1,
			fromTop: !1,
			width: null,
			height: null,
			animating: !1
		}, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = P(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
	}
	componentDidMount() {
		this.win = this.getWindow(), this.calculatePosition();
	}
	getSnapshotBeforeUpdate() {
		if (this.dropdownRef.current) {
			let e = this.dropdownRef.current.getBoundingClientRect();
			return {
				oldWidth: e.width,
				oldHeight: e.height
			};
		}
		return null;
	}
	componentDidUpdate(e, t, n) {
		let { isOpen: r, isLoading: i, errorMessage: a, fixed: o, closeOnBlur: s } = this.props;
		if (n && (i !== e.isLoading || a !== e.errorMessage)) {
			let t = i !== e.isLoading && i;
			this.animate(n.oldWidth, n.oldHeight, t);
		}
		r && this.calculatePosition(), r !== e.isOpen && (this.win[r ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutsideDropdown), s && this.win[r ? "addEventListener" : "removeEventListener"]("blur", this.handleOnClose), o && this.win[r ? "addEventListener" : "removeEventListener"]("scroll", this.handleFixedScroll, !0));
	}
	getWindow() {
		return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
	}
	componentWillUnmount() {
		this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
	}
	handleOnClose() {
		let { onClose: e } = this.props;
		e();
	}
	animate(e, t, n) {
		if (this.dropdownRef.current) {
			let r = this.dropdownRef.current.getBoundingClientRect();
			this.setState({
				width: e,
				height: t,
				animating: !n
			}), this.timeoutAnimationStart = this.win.setTimeout(() => {
				this.setState({
					width: r.width,
					height: r.height
				}), this.timeoutAnimationEnd = this.win.setTimeout(() => {
					this.setState({
						width: null,
						height: null,
						animating: !1
					});
				}, 200);
			});
		}
	}
	handleClickOutsideDropdown(e) {
		if (!this.dropdownRef || !e.target) return;
		let t = e.target, { onClose: n } = this.props;
		this.dropdownRef.current && t !== this.dropdownRef.current && !this.dropdownRef.current.contains(t) && n();
	}
	handleDropdownClick(e) {
		e.stopPropagation();
	}
	handleFixedScroll() {
		this.forceUpdate();
	}
	calculatePosition() {
		if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
			let e = this.dropdownRef.current.parentElement.getBoundingClientRect(), t = e.left + e.width / 2, n = e.top + e.height / 2, r = this.getWindow(), i = r.innerWidth / 2, a = r.innerHeight / 2;
			this.setState({
				fromRight: t > i,
				fromBottom: n > a,
				fromTop: n <= a
			});
		}
	}
	getFixedPosition() {
		if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
			let { fromRight: e, fromBottom: t, fromTop: n } = this.state, r = this.dropdownRef.current.parentElement.getBoundingClientRect(), i = {}, a = this.getWindow();
			return e ? i.right = `${a.innerWidth - r.right}px` : i.left = `${r.left}px`, t && (i.bottom = `${a.innerHeight - r.top}px`), n && (i.top = `${r.top + r.height}px`), i;
		}
		return {};
	}
	render() {
		let { className: e, children: t, onClose: n, isOpen: r, isLoading: i, closeOnBlur: a, errorMessage: o, fixed: s, style: c, autoFocus: l, restoreFocus: d, bringInFocusOnTab: f, ...p } = this.props, { fromRight: m, fromBottom: h, animating: g, width: _, height: v } = this.state, y = O({
			[mn.dropdown]: !0,
			[mn.dropdownOpen]: r,
			[mn.dropdownFromRight]: m,
			[mn.dropdownFromBottom]: h,
			[mn.dropdownAnimating]: g,
			[mn.dropdownFixed]: s
		}, e), b = { ...c };
		_ && v && (b.width = `${_}px`, b.height = `${v}px`), s && (b = {
			...b,
			...this.getFixedPosition()
		});
		let x = !i && !o;
		return /* @__PURE__ */ j("div", {
			...p,
			className: y,
			ref: this.dropdownRef,
			style: b,
			onClick: this.handleDropdownClick,
			role: "menu",
			"aria-expanded": r,
			children: [
				i && /* @__PURE__ */ A("div", { className: mn.loader }),
				!!o && !i && /* @__PURE__ */ j("div", {
					className: mn.error,
					children: [/* @__PURE__ */ A(u, {
						className: mn.errorIcon,
						name: "exclamation"
					}), /* @__PURE__ */ A("span", { children: o })]
				}),
				x && /* @__PURE__ */ A(pn, {
					containerRef: this.dropdownRef,
					isActive: r,
					autoFocus: l,
					restoreFocus: d,
					bringInFocusOnTab: f,
					children: t
				})
			]
		});
	}
}, gn = {
	root: "h-dropdownButton--dropdownButton__root",
	wrapper: "h-dropdownButton--dropdownButton__wrapper"
}, _n = ve({
	toggleDropdown: K,
	openDropdown: K,
	closeDropdown: K,
	dropdownOpen: !1
}), vn = class extends me {
	buttonWrapperRef;
	buttonRef;
	contextState;
	timeoutId;
	win;
	static defaultProps = { allowEscClose: !0 };
	constructor(e) {
		super(e);
		let t = e.show ?? !1;
		this.state = {
			dropdownOpen: t,
			pristine: !0,
			fromBottom: !1
		}, this.timeoutId = null, this.win = window, this.buttonWrapperRef = P(), this.buttonRef = P(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
			toggleDropdown: this.toggle,
			openDropdown: this.open,
			closeDropdown: this.close,
			dropdownOpen: t
		};
	}
	getWindow() {
		return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
	}
	componentDidMount() {
		this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
	}
	componentDidUpdate(e) {
		this.toggleDropdownIfNeeded(e);
	}
	componentWillUnmount() {
		this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
	}
	shouldToggleDropdown(e) {
		return e.show !== this.props.show;
	}
	handleKeyDown(e) {
		dn(e.key) && this.state.dropdownOpen && (e.stopPropagation(), this.close());
	}
	toggleDropdownIfNeeded(e) {
		this.shouldToggleDropdown(e) && (this.props.show ? this.open() : this.close());
	}
	setTimeout(e, t = 0) {
		return this.win.setTimeout(e, t);
	}
	handleDropdownToggle() {
		let { dropdownOpen: e } = this.state, t = () => {
			this.timeoutId = this.setTimeout(() => {
				this.toggle(!e);
			});
		}, n = this.shouldDropdownBeAboveButton();
		e ? t() : this.setState({ fromBottom: n }, t);
	}
	close() {
		this.toggle(!1);
	}
	open() {
		this.toggle(!0);
	}
	toggle(e) {
		let { allowEscClose: t, onToggle: n } = this.props, { pristine: r, dropdownOpen: i } = this.state, a = e ?? !i;
		this.contextState = {
			...this.contextState,
			dropdownOpen: a
		}, this.setState({
			dropdownOpen: a,
			pristine: !1
		}), t && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, r);
	}
	shouldDropdownBeAboveButton() {
		let e = this.buttonWrapperRef.current?.getBoundingClientRect();
		return e ? e.bottom > this.getWindow().innerHeight / 2 : !1;
	}
	renderTheTriggerButton() {
		let { icon: e, buttonProps: t, children: n, noArrow: r, noStyle: i, onMouseEnter: a, onMouseLeave: o } = this.props, { fromBottom: s } = this.state;
		return i ? /* @__PURE__ */ A("div", {
			ref: this.buttonRef,
			className: t?.className,
			...t,
			onMouseEnter: a,
			onMouseLeave: o,
			...sn(this.handleDropdownToggle),
			children: n
		}) : e && !n ? /* @__PURE__ */ A(h, {
			ref: this.buttonRef,
			icon: e,
			variant: "secondary",
			onMouseEnter: a,
			onMouseLeave: o,
			...t,
			onClick: this.handleDropdownToggle
		}) : /* @__PURE__ */ A(g, {
			ref: this.buttonRef,
			icon: e,
			variant: "secondary",
			onMouseEnter: a,
			onMouseLeave: o,
			...t,
			onClick: this.handleDropdownToggle,
			slotEnd: r ? void 0 : /* @__PURE__ */ A(u, { name: s ? "angle-up" : "angle-down" }),
			children: n
		});
	}
	render() {
		let { className: e, children: t, icon: n, dropdown: r, buttonProps: i, dropdownProps: a, noArrow: o, noStyle: s, show: c, onToggle: l, isLoading: u, errorMessage: d, fixed: f, onMouseEnter: p, onMouseLeave: m, allowEscClose: h, destroyOnClose: g, ..._ } = this.props, { dropdownOpen: v, pristine: y } = this.state, b = O({ [gn.root]: gn.root }, e);
		return /* @__PURE__ */ A(_n.Provider, {
			value: this.contextState,
			children: /* @__PURE__ */ A("div", {
				..._,
				className: b,
				ref: this.buttonWrapperRef,
				children: /* @__PURE__ */ j("div", {
					className: gn.wrapper,
					children: [this.renderTheTriggerButton(), /* @__PURE__ */ A(hn, {
						restoreFocus: this.buttonRef,
						...a,
						isOpen: v,
						onClose: this.close,
						isLoading: u,
						errorMessage: d,
						fixed: f,
						children: (v || !y && !g) && r
					})]
				})
			})
		});
	}
}, yn = {
	header: "h-collapseCard--header__header",
	headerOpen: "h-collapseCard--header__headerOpen",
	headerHasDropdown: "h-collapseCard--header__headerHasDropdown",
	headerStatic: "h-collapseCard--header__headerStatic",
	titleWrapper: "h-collapseCard--header__titleWrapper",
	title: "h-collapseCard--header__title",
	chevronPlaceholder: "h-collapseCard--header__chevronPlaceholder"
}, bn = class extends N {
	static displayName = "CollapseCard.Header";
	static defaultProps = { title: "" };
	getRootClassName(e) {
		let { dropdown: t, className: n, nonCollapsible: r } = this.props;
		return O(yn.header, {
			[yn.headerOpen]: e,
			[yn.headerHasDropdown]: !!t,
			[yn.headerStatic]: !!r
		}, n);
	}
	render() {
		let { children: e, className: t, title: n, avatar: r, dropdown: a, onDropdownToggle: o, dropdownTrigger: s, slotBeforeTitle: c, slotAfterTitle: l, wrap: u = "nowrap", compact: d, nonCollapsible: f, ...p } = this.props;
		return /* @__PURE__ */ A(rn.Consumer, { children: ({ isOpen: t, onToggle: n }) => {
			let m = this.getRootClassName(t);
			return /* @__PURE__ */ j("div", {
				...p,
				onClick: f ? void 0 : n,
				className: m,
				"data-testid": "header",
				children: [/* @__PURE__ */ j(G, {
					alignItems: "center",
					padding: d ? "200 0" : "400 0",
					className: yn.titleWrapper,
					children: [
						c,
						r,
						/* @__PURE__ */ A("div", {
							className: yn.titleWrapper,
							onMouseDown: (e) => e.stopPropagation(),
							children: /* @__PURE__ */ A(i.Paragraph, {
								as: "div",
								variant: "1",
								wrap: u,
								className: yn.title,
								children: e
							})
						})
					]
				}), /* @__PURE__ */ j(G, {
					alignItems: "center",
					children: [
						l,
						!!a && /* @__PURE__ */ A(vn, {
							onClick: (e) => e.stopPropagation(),
							icon: s ? void 0 : "dots-h",
							dropdown: a,
							buttonProps: { variant: "tertiary" },
							onToggle: o,
							children: s
						}),
						f ? /* @__PURE__ */ A("span", {
							className: yn.chevronPlaceholder,
							"aria-hidden": !0
						}) : /* @__PURE__ */ A(h, {
							icon: t ? "angle-down" : "angle-right",
							variant: "tertiary"
						})
					]
				})]
			});
		} });
	}
}, xn = {
	line: "h-collapseCard--line__line",
	lineHasLabel: "h-collapseCard--line__lineHasLabel",
	value: "h-collapseCard--line__value",
	lineHideOverflow: "h-collapseCard--line__lineHideOverflow"
}, Sn = class extends N {
	render() {
		let { label: e, children: t, className: n, hideOverflow: r, ...a } = this.props, o = O({
			[xn.line]: !0,
			[xn.lineHasLabel]: !!e,
			[xn.lineHideOverflow]: r
		}, n);
		return /* @__PURE__ */ j("li", {
			...a,
			className: o,
			children: [e && /* @__PURE__ */ A(i.Paragraph, {
				variant: "2",
				subdued: !0,
				wrap: "nowrap",
				children: e
			}), e ? /* @__PURE__ */ A("span", {
				className: xn.value,
				children: t
			}) : t]
		});
	}
}, Cn = { readMore: "h-collapseCard--readMore__readMore" }, wn = class extends N {
	render() {
		let { onClick: e, url: t, children: n, className: r, ...a } = this.props, o = O({ [Cn.readMore]: !0 }, r);
		return t ? /* @__PURE__ */ A(i.ExternalLink, {
			...a,
			href: t,
			className: o,
			children: n
		}) : /* @__PURE__ */ A(g, {
			variant: "secondary",
			...a,
			onClick: e,
			className: o,
			children: n
		});
	}
}, Tn = { status: "h-collapseCard--status__status" }, En = class extends N {
	render() {
		let { children: e, className: t, ...n } = this.props, r = O({ [Tn.status]: !0 }, t);
		return /* @__PURE__ */ A("li", {
			...n,
			className: r,
			children: e
		});
	}
}, Dn = mt(class extends N {
	static defaultProps = { isOpen: !1 };
	constructor(e) {
		super(e), this.handleToggle = this.handleToggle.bind(this);
	}
	static Line = Sn;
	static Header = bn;
	static Content = on;
	static ReadMore = wn;
	static Status = En;
	handleToggle() {
		this.props.onToggle(!this.props.isOpen);
	}
	isHeader(e) {
		return e?.type?.displayName === "CollapseCard.Header" && I(e);
	}
	isContent(e) {
		return e?.type?.displayName === "CollapseCard.Content" && I(e);
	}
	getHeaderChildren() {
		return M.toArray(this.props.children).filter(this.isHeader);
	}
	getContentChildren() {
		return M.toArray(this.props.children).filter(this.isContent);
	}
	getRootClassName() {
		let { className: e } = this.props;
		return O(nn.card, e);
	}
	render() {
		let { className: e, onToggle: t, isOpen: n, children: r, containerRef: i, ...a } = this.props;
		return /* @__PURE__ */ A(rn.Provider, {
			value: {
				isOpen: n,
				onToggle: this.handleToggle
			},
			children: /* @__PURE__ */ j("div", {
				...a,
				ref: i,
				className: this.getRootClassName(),
				children: [this.getHeaderChildren(), this.getContentChildren()]
			})
		});
	}
}, { fallback: /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(i.Paragraph, {
	variant: "2",
	children: "Something went wrong"
}) }) }), On = {
	root: "h-collapsible--collapsible__root",
	collapsible: "h-collapsible--collapsible__collapsible",
	children: "h-collapsible--collapsible__children"
}, kn = class extends N {
	childrenRef;
	resizeObserver = null;
	constructor(e) {
		super(e), this.childrenRef = P(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = { childrenHeight: e.isOpen ? "auto" : 0 };
	}
	componentDidMount() {
		this.measureChildrenHeight(), this.setupResizeObserver();
	}
	componentDidUpdate(e) {
		e.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
	}
	componentWillUnmount() {
		this.disconnectResizeObserver();
	}
	setupResizeObserver() {
		this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
			this.measureChildrenHeight();
		}), this.resizeObserver.observe(this.childrenRef.current));
	}
	disconnectResizeObserver() {
		this.resizeObserver &&= (this.resizeObserver.disconnect(), null);
	}
	measureChildrenHeight() {
		let e = this.childrenRef.current;
		e && this.setState({ childrenHeight: e.offsetHeight });
	}
	render() {
		let { className: e, header: t, isOpen: n, children: r, ...i } = this.props, { childrenHeight: a } = this.state, o = O({ [On.root]: !0 }, e), s = { maxHeight: n ? a : 0 };
		return /* @__PURE__ */ j("div", {
			...i,
			className: o,
			children: [/* @__PURE__ */ A("div", { children: /* @__PURE__ */ A("div", { children: t }) }), !!r && /* @__PURE__ */ A("div", {
				style: s,
				className: On.collapsible,
				children: /* @__PURE__ */ A("span", {
					className: On.children,
					ref: this.childrenRef,
					children: r
				})
			})]
		});
	}
}, An = { root: "h-colorPicker--colorPicker__root" }, jn = { input: "h-colorPicker-input--colorPickerInput__input" }, Mn = ({ className: e, ...t }) => /* @__PURE__ */ A(n, {
	prefix: "#",
	children: /* @__PURE__ */ A(w, {
		className: O(jn.input, e),
		"aria-label": "Enter hex value",
		placeholder: "Hex value",
		...t
	})
}), Nn = { root: "h-colorPicker-presets--colorPickerPresets__root" }, Pn = {
	root: "h-colorPicker-presets-preset--colorPickerPreset__root",
	rootIsSelected: "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected",
	rootAlpha: "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha",
	preset: "h-colorPicker-presets-preset--colorPickerPreset__preset"
}, Fn = ({ color: e, onSelect: t, isSelected: n, alpha: r, className: i }) => /* @__PURE__ */ A("li", {
	className: O(Pn.root, i, {
		[Pn.rootIsSelected]: n,
		[Pn.rootAlpha]: r
	}),
	children: /* @__PURE__ */ A("button", {
		type: "button",
		"aria-label": e,
		className: Pn.preset,
		style: { backgroundColor: e },
		onClick: () => {
			t?.(e);
		}
	})
});
//#endregion
//#region src/components/colorPicker/presets/colorPickerPresets.tsx
ne([ae]);
var In = ({ presets: e, className: t, onChange: n, color: r, alpha: i, ...a }) => /* @__PURE__ */ A(G, {
	as: "ul",
	gap: "200",
	flexWrap: "wrap",
	className: O(Nn.root, t),
	...a,
	children: e.map((e) => /* @__PURE__ */ A(Fn, {
		onSelect: n,
		color: e,
		isSelected: r === (e.startsWith("#") ? e : D(e).toHex()),
		alpha: i
	}, e))
});
//#endregion
//#region src/components/colorPicker/sliders/colorPickerSliders.tsx
ne([ae]);
var Ln = ({ onChange: e, color: t, alpha: n, className: r, ...i }) => {
	let a = L((t) => {
		setTimeout(() => {
			e?.(D(t).toHex());
		});
	}, []);
	return n ? /* @__PURE__ */ A(le, {
		className: r,
		color: D(t ?? "").toRgbString(),
		onChange: a,
		...i
	}) : /* @__PURE__ */ A(T, {
		className: r,
		color: t,
		onChange: e,
		...i
	});
};
//#endregion
//#region src/components/colorPicker/colorPicker.tsx
ne([ae]);
var Rn = "colorPickerTestId", zn = ({ className: e, color: t, onChange: n, alpha: r, children: i, ...a }) => {
	let [o, s] = V();
	return z(() => {
		let e = t?.startsWith("#") ? t : D(t ?? "").toHex();
		s(e);
	}, [t]), /* @__PURE__ */ A(G, {
		flexDirection: "column",
		gap: "250",
		className: O(An.root, e),
		"data-testid": Rn,
		...a,
		children: M.map(i, (e) => I(e) && _e(e, {
			onChange: n,
			color: o,
			alpha: r,
			...e.props
		}))
	});
};
zn.Input = Mn, zn.Sliders = Ln, zn.Presets = In;
var Bn = { root: "h-columns--columns__root" }, Vn = "1fr", Hn = F(function({ as: e = "div", children: t, className: n, style: r, ...i }, a) {
	let o = M.toArray(t).map((e) => e.props.size ?? Vn).join(" ");
	return /* @__PURE__ */ A(e, {
		...i,
		ref: a,
		className: O(Bn.root, n),
		style: {
			...r,
			gridTemplateColumns: o
		},
		children: t
	});
}), Un = { root: "h-columns-column--column__root" }, Wn = {
	root: "h-columns-column-row--columnRow__root",
	noMinHeight: "h-columns-column-row--columnRow__noMinHeight",
	noVerticalPadding: "h-columns-column-row--columnRow__noVerticalPadding",
	noHorizontalPadding: "h-columns-column-row--columnRow__noHorizontalPadding",
	borderTop: "h-columns-column-row--columnRow__borderTop",
	borderBottom: "h-columns-column-row--columnRow__borderBottom",
	scrollable: "h-columns-column-row--columnRow__scrollable",
	slottable: "h-columns-column-row--columnRow__slottable"
}, Gn = 1, Kn = F(function({ as: e = "div", children: t, className: n, noVerticalPadding: r, noHorizontalPadding: i, noMinHeight: a, borderTop: o, borderBottom: s, scrollable: c, size: l, slottable: u, style: d, ...f }, p) {
	let m = O(n, Wn.root, {
		[Wn.slottable]: u,
		[Wn.noVerticalPadding]: u ?? r,
		[Wn.noHorizontalPadding]: i,
		[Wn.borderTop]: o,
		[Wn.borderBottom]: s,
		[Wn.scrollable]: c,
		[Wn.noMinHeight]: a
	});
	return /* @__PURE__ */ A(e, {
		...f,
		ref: p,
		className: m,
		style: {
			...d,
			flexGrow: l ?? c ? Gn : void 0
		},
		children: t
	});
}), qn = {
	root: "h-columns-column-slot--columnSlot__root",
	noVerticalPadding: "h-columns-column-slot--columnSlot__noVerticalPadding"
}, Jn = ({ children: e, className: t, noVerticalPadding: n, placement: r = "start" }) => /* @__PURE__ */ A(G, {
	alignItems: "center",
	alignSelf: "stretch",
	justifySelf: r,
	className: O(qn.root, t, { [qn.noVerticalPadding]: n }),
	children: e
}), q = ({ as: e, children: t, className: n }) => /* @__PURE__ */ A(G, {
	as: e,
	flexDirection: "column",
	className: O(Un.root, n),
	children: t
});
q.Row = Kn, q.Slot = Jn;
var Yn = {
	copyToClipboard: "h-copyToClipboard--copyToClipboard__copyToClipboard",
	copyToClipboardTooltip: "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip"
}, Xn = class extends me {
	timerHandle;
	static defaultProps = {
		tooltip: !0,
		disabled: !1,
		transitionDuration: 2e3,
		clickedProps: {}
	};
	constructor(e) {
		super(e), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
	}
	componentWillUnmount() {
		this.timerHandle && clearTimeout(this.timerHandle);
	}
	executeCopy(e) {
		let t = document.body;
		if (!e || !document.body) return;
		let n = document.createElement("textarea");
		n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", t.appendChild(n), n.select(), document.execCommand("copy"), t.removeChild(n);
	}
	handleClick(e) {
		let { disabled: t, textToCopy: n, transitionDuration: r, onClick: i } = this.props;
		t || (typeof i == "function" && i(e), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
			this.timerHandle = setTimeout(() => {
				this.setState({ clicked: !1 });
			}, r);
		}));
	}
	render() {
		let { className: e, children: t, clickedProps: n, tooltip: r } = this.props, { clicked: i } = this.state;
		return /* @__PURE__ */ A("div", {
			className: O(Yn.copyToClipboard, { [Yn.copyToClipboardTooltip]: i && r }, e),
			children: M.map(t, (e) => I(e) ? _e(e, {
				onClick: this.handleClick.bind(this),
				...i ? n : {}
			}) : e)
		});
	}
}, Zn = class extends N {
	render() {
		let { buttonProps: e, ...t } = this.props;
		return /* @__PURE__ */ A(Xn, {
			...t,
			children: /* @__PURE__ */ A(h, {
				icon: "copy",
				variant: "secondary",
				...e
			})
		});
	}
}, Qn = { paginationButton: "h-simplePagination--simplePagination__paginationButton" }, $n = "simplePaginationTestId", er = ({ nextButtonClick: e = K, previousButtonClick: t = K, nextButtonText: n = "Next page", previousButtonText: r = "Previous page", nextButtonDisabled: i = !1, previousButtonDisabled: a = !1, nextButtonHidden: o = !1, previousButtonHidden: s = !1, nextButtonExtraProps: c, previousButtonExtraProps: l, loading: u = !1, loadingText: d = "Loading...", ...f }) => /* @__PURE__ */ j("div", {
	"data-testid": $n,
	...f,
	children: [!s && /* @__PURE__ */ A(g, {
		disabled: a || u,
		onClick: t,
		variant: "secondary",
		...l,
		className: O(Qn.paginationButton, l?.className),
		children: u ? d : r
	}), !o && /* @__PURE__ */ A(g, {
		disabled: i || u,
		onClick: e,
		variant: "secondary",
		...c,
		className: O(Qn.paginationButton, c?.className),
		children: u ? d : n
	})]
}), tr = ve(void 0), nr = /* @__PURE__ */ function(e) {
	return e.Foot = "table-foot", e.Body = "table-body", e.Head = "table-head", e.Row = "table-row", e.PaginationRow = "table-pagination-row", e.Td = "table-body-cell", e.Th = "table-header-cell", e.RowExpansionTrigger = "table-row-expansion-trigger", e.LoadingRow = "table-loading-row", e.LoadingFailedRow = "table-loading-failed-row", e.EmptyRow = "table-empty-row", e;
}({}), rr = {
	root: "h-table-tfoot--tfoot__root",
	rootIsLoading: "h-table-tfoot--tfoot__rootIsLoading"
}, ir = ve(void 0), ar = ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ A(tr.Consumer, { children: (i) => i?.status.loading && ["spinner"].includes(i?.loading.loadingStrategy) ? null : /* @__PURE__ */ A(ir.Provider, {
	value: { isTableFoot: !0 },
	children: /* @__PURE__ */ A("tfoot", {
		...n,
		ref: r,
		className: O({ [rr.rootIsLoading]: i?.status.loading }, rr.root, e),
		"data-testid": nr.Foot,
		children: t
	})
}) }), or = Object.assign(F(ar), { name: ar.name }), sr = {
	root: "h-table-thead--thead__root",
	rootIsLoading: "h-table-thead--thead__rootIsLoading"
}, cr = ve(void 0), lr = ({ className: e, ...t }, n) => /* @__PURE__ */ A(tr.Consumer, { children: (r) => {
	let i = O(sr.root, e, { [sr.rootIsLoading]: r?.status.loading });
	return /* @__PURE__ */ A(cr.Provider, {
		value: { isTableHead: !0 },
		children: /* @__PURE__ */ A("thead", {
			...t,
			ref: n,
			className: i,
			"data-testid": nr.Head
		})
	});
} }), ur = Object.assign(F(lr), { name: lr.name }), dr = (e) => {
	let t = Se(tr);
	if (!t) throw Error("TableContext not accessible. Make sure <TableContextReader> is a child of <Table>");
	let n = Se(cr) || { isTableHead: !1 }, r = Se(ir) || { isTableFoot: !1 };
	return e.children({
		...t,
		...n,
		...r
	});
}, fr = {
	root: "h-table-tableFooter--tableFooter__root",
	rootIsLoading: "h-table-tableFooter--tableFooter__rootIsLoading"
}, pr = ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ A(dr, { children: ({ status: i }) => /* @__PURE__ */ A("div", {
	ref: r,
	className: O({ [fr.rootIsLoading]: i.loading }, fr.root, t),
	...n,
	children: e
}) }), mr = Object.assign(F(pr), { name: pr.name });
//#endregion
//#region src/components/table/categoriseTableChildren.ts
function hr(e) {
	return M.toArray(e).reduce((e, t) => {
		let n = t;
		return n.type === mr ? e.footers.push(n) : e.children.push(n), e;
	}, {
		children: [],
		footers: []
	});
}
//#endregion
//#region \0callable-external:lodash/clamp
var gr = Le, _r = /* @__PURE__ */ function(e) {
	return e.PageNumber = "page-number", e.PrevPageButton = "prev-page-button", e.NextPageButton = "next-page-button", e;
}({}), vr = {
	button: "h-pagination--pageNumber__button",
	text: "h-pagination--pageNumber__text",
	textSelected: "h-pagination--pageNumber__textSelected"
}, yr = ({ number: e, isSelected: t = !1, onClick: n }) => {
	let r = O(vr.text, { [vr.textSelected]: t });
	return /* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(g, {
		styleText: !1,
		variant: "tertiary",
		onClick: () => n(e),
		"data-testid": _r.PageNumber,
		className: vr.button,
		children: /* @__PURE__ */ A("span", {
			className: r,
			children: e
		})
	}) });
}, br = {
	root: "h-pagination--pagination__root",
	pageNumberSeparatorWrapper: "h-pagination--pagination__pageNumberSeparatorWrapper"
}, xr = class extends me {
	static defaultProps = { pageRangeDisplayed: 6 };
	constructor(e) {
		super(e), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
	}
	arePropsValid() {
		let { currentPage: e, pageCount: t, pageRangeDisplayed: n } = this.props;
		return [
			e,
			t,
			n
		].every((e) => !Number.isNaN(e) && Number.isInteger(e) && e > 0);
	}
	thereIsEnoughPagesToRender() {
		return this.props.pageCount > 1;
	}
	getBoundaries() {
		return {
			canGoToPrevPage: this.props.currentPage > 1,
			canGoToNextPage: this.props.currentPage < this.props.pageCount
		};
	}
	goToPrevPage() {
		this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
	}
	goToNextPage() {
		this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
	}
	handlePageSelect(e) {
		let { currentPage: t, onPageChange: n } = this.props;
		e !== t && n(e);
	}
	areAllPagedDisplayable() {
		let { pageCount: e, pageRangeDisplayed: t } = this.props;
		return t >= e;
	}
	leadingTruncationIsNeeded() {
		let { start: e } = this.calculateMiddlePagesRange();
		return e - 1 > 1;
	}
	trailingTruncationIsNeeded() {
		let { pageCount: e } = this.props, { start: t, length: n } = this.calculateMiddlePagesRange();
		return e - (t - 1 + n) > 1;
	}
	getMiddlePagesLength() {
		let { pageRangeDisplayed: e } = this.props;
		return e - 2;
	}
	calculateMiddlePagesRange(e) {
		let { pageCount: t, currentPage: n } = this.props, r = Math.max(this.getMiddlePagesLength() - (e?.extraPadding ?? 0), 1);
		return {
			start: gr(n - (r % 2 == 0 ? r / 2 - 1 : Math.floor(r / 2)), 2, t - r),
			length: r
		};
	}
	createPageNumbers(e, t = 1) {
		return Array.from({ length: e }, (e, n) => n + t);
	}
	renderPageNumbers(e, t = 1) {
		return this.createPageNumbers(e, t).map((e) => this.renderSinglePageNumber(e));
	}
	renderSinglePageNumber(e) {
		let { currentPage: t } = this.props;
		return /* @__PURE__ */ A(yr, {
			number: e,
			isSelected: e === t,
			onClick: this.handlePageSelect
		}, e);
	}
	renderAllPages() {
		return this.renderPageNumbers(this.props.pageCount);
	}
	renderGap(e = 0) {
		return /* @__PURE__ */ A("li", {
			className: br.pageNumberSeparatorWrapper,
			children: /* @__PURE__ */ A(u, { name: "dots-h" })
		}, `gap-${e}`);
	}
	renderLeadingTruncation() {
		return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
	}
	renderTrailingTruncation() {
		let { pageCount: e } = this.props;
		return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(e)] : this.renderSinglePageNumber(e);
	}
	renderMiddlePageNumbers() {
		if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
			let { start: e, length: t } = this.calculateMiddlePagesRange({ extraPadding: 1 });
			return this.renderPageNumbers(t, e);
		}
		let { start: e, length: t } = this.calculateMiddlePagesRange();
		return this.renderPageNumbers(t, e);
	}
	renderPages() {
		return this.areAllPagedDisplayable() ? this.renderAllPages() : [
			this.renderLeadingTruncation(),
			this.renderMiddlePageNumbers(),
			this.renderTrailingTruncation()
		];
	}
	warnAboutBadProps() {
		console.error("Pagination can not render due to bad props", this.props);
	}
	render() {
		let { className: e } = this.props;
		return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ j("ul", {
			className: O(br.root, e),
			children: [
				/* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(h, {
					icon: "angle-left",
					variant: "tertiary",
					onClick: this.goToPrevPage,
					disabled: !this.getBoundaries().canGoToPrevPage,
					"data-testid": _r.PrevPageButton
				}) }),
				this.renderPages(),
				/* @__PURE__ */ A("li", { children: /* @__PURE__ */ A(h, {
					icon: "angle-right",
					variant: "tertiary",
					onClick: this.goToNextPage,
					disabled: !this.getBoundaries().canGoToNextPage,
					"data-testid": _r.NextPageButton
				}) })
			]
		}) : (this.warnAboutBadProps(), null) : null;
	}
}, Sr = ({ children: e, ...t }, n) => /* @__PURE__ */ A(dr, { children: ({ pagination: e }) => !e.paginated || e.pageCount <= 1 ? null : /* @__PURE__ */ A(mr, { children: /* @__PURE__ */ A("div", {
	ref: n,
	...t,
	"data-testid": nr.PaginationRow,
	children: /* @__PURE__ */ A(G, {
		justifyContent: "center",
		alignItems: "center",
		children: /* @__PURE__ */ A(xr, {
			currentPage: e.selectedPage,
			pageCount: e.pageCount,
			onPageChange: e.onPageChange,
			pageRangeDisplayed: e.pageRangeDisplayed
		})
	})
}) }) }), Cr = Object.assign(F(Sr), { name: Sr.name }), wr = {
	root: "h-table-tbody--tbody__root",
	rootIsLoading: "h-table-tbody--tbody__rootIsLoading",
	rootIsLoadingFade: "h-table-tbody--tbody__rootIsLoadingFade"
}, Tr = {
	textWrapper: "h-emptyState--emptyState__textWrapper",
	rootSmall: "h-emptyState--emptyState__rootSmall",
	rootLarge: "h-emptyState--emptyState__rootLarge"
}, Er = ({ className: e, title: t, description: n, icon: r = "info", iconColor: a = "neutral.500", size: o = "large", buttonProps: c }) => /* @__PURE__ */ j(G, {
	flexDirection: "column",
	alignItems: "center",
	gap: "300",
	className: O({
		[Tr.rootSmall]: o === "small",
		[Tr.rootLarge]: o === "large"
	}, e),
	children: [
		r && /* @__PURE__ */ A(u, {
			name: r,
			size: 20,
			color: s(a)
		}),
		/* @__PURE__ */ j(G, {
			flexDirection: "column",
			alignItems: "center",
			gap: "100",
			className: Tr.textWrapper,
			children: [/* @__PURE__ */ A(i.Paragraph, {
				variant: "1",
				children: t
			}), /* @__PURE__ */ A(i.Paragraph, {
				variant: "2",
				as: typeof n == "string" ? "p" : "div",
				children: n
			})]
		}),
		c?.children && /* @__PURE__ */ A(g, { ...c })
	]
});
//#endregion
//#region src/components/table/components/tbody/tbodyEmptyRow.tsx
function Dr(e) {
	return /* @__PURE__ */ A("tr", {
		"data-testid": nr.EmptyRow,
		children: /* @__PURE__ */ A("td", {
			colSpan: 100,
			children: /* @__PURE__ */ A(G, {
				justifyContent: "center",
				alignItems: "center",
				padding: "500",
				children: /* @__PURE__ */ A(Er, { ...e })
			})
		})
	});
}
//#endregion
//#region src/components/table/components/tbody/tbodyLoadingFailedRow.tsx
function Or({ onRetry: e, ...t }) {
	return /* @__PURE__ */ A("tr", {
		"data-testid": nr.LoadingFailedRow,
		...t,
		children: /* @__PURE__ */ A("td", {
			colSpan: 100,
			children: /* @__PURE__ */ j(G, {
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				padding: "500",
				children: [/* @__PURE__ */ A(i.Paragraph, {
					variant: "2",
					children: "Something went wrong..."
				}), e && /* @__PURE__ */ A(g, {
					variant: "tertiary",
					onClick: e,
					children: "Try again"
				})]
			})
		})
	});
}
//#endregion
//#region src/components/table/components/tbody/tbodyLoadingSpinnerRow.tsx
function kr({ ...e }) {
	return /* @__PURE__ */ A("tr", {
		"data-testid": nr.LoadingRow,
		...e,
		children: /* @__PURE__ */ A("td", {
			align: "center",
			colSpan: 100,
			children: /* @__PURE__ */ j(G, {
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				padding: "500",
				children: [/* @__PURE__ */ A(r, {}), /* @__PURE__ */ A(a, {
					margin: "300",
					children: /* @__PURE__ */ A(i.Paragraph, {
						variant: "2",
						children: "Loading..."
					})
				})]
			})
		})
	});
}
//#endregion
//#region src/components/table/components/tbody/tbody.tsx
var Ar = ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ A(dr, { children: ({ status: { loading: i, loadingFailed: a, onLoadingRetry: o, emptyState: s }, loading: { loadingStrategy: c } }) => {
	let l = a && !i, u = ["spinner"].includes(c) ? !i && !l : !l;
	return /* @__PURE__ */ j("tbody", {
		...n,
		"data-testid": nr.Body,
		ref: r,
		className: O({
			[wr.rootIsLoading]: i,
			[wr.rootIsLoadingFade]: i && c === "fade"
		}, wr.root, t),
		children: [
			c === "spinner" && i && /* @__PURE__ */ A(kr, {}),
			l && /* @__PURE__ */ A(Or, { onRetry: o }),
			s && /* @__PURE__ */ A(Dr, { ...s }),
			u && e
		]
	});
} }), jr = Object.assign(F(Ar), { name: Ar.name }), Mr = {
	root: "h-table-td--td__root",
	rootExtraPaddingForFirstChild: "h-table-td--td__rootExtraPaddingForFirstChild",
	rootStickyFooterTd: "h-table-td--td__rootStickyFooterTd"
}, Nr = ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ A(dr, { children: ({ rows: i, presentation: o, isTableFoot: s }) => /* @__PURE__ */ A(a, {
	as: "td",
	ref: r,
	className: O(Mr.root, {
		[Mr.rootExtraPaddingForFirstChild]: !i.expandableRows,
		[Mr.rootStickyFooterTd]: o.stickyFooter === !0 && s === !0
	}, e),
	...n,
	"data-testid": nr.Td,
	children: t
}) }), Pr = Object.assign(F(Nr), { name: Nr.name }), Fr = Re, Ir = {
	root: "h-table-th--th__root",
	rootSticky: "h-table-th--th__rootSticky",
	rootShowBG: "h-table-th--th__rootShowBG",
	rootClickable: "h-table-th--th__rootClickable",
	icon: "h-table-th--th__icon",
	contentWrapper: "h-table-th--th__contentWrapper",
	tooltip: "h-table-th--th__tooltip"
}, Lr = class extends N {
	context = void 0;
	columnIsInSortableColumns() {
		return this.context?.sorting.sortableColumns?.some((e) => e === this.props.columnId) ?? !0;
	}
	getContextualInfo() {
		let { columnId: e } = this.props, { context: t } = this;
		return {
			sortByThisColumn: t?.sorting.sortStatus?.sortBy === e,
			sortDirection: t?.sorting.sortStatus?.direction,
			columnIsSortable: t?.sorting.sortable && !Fr(e) ? this.columnIsInSortableColumns() : !1
		};
	}
	getTheNewSortDirection(e) {
		let { sortByThisColumn: t, sortDirection: n } = this.getContextualInfo(), r = {
			sortBy: e,
			direction: "asc"
		};
		if (!t) return r;
		switch (n) {
			case void 0: return r;
			case "desc": return null;
			case "asc": return {
				sortBy: e,
				direction: "desc"
			};
			default: return r;
		}
	}
	getClickHandler() {
		let { onClick: e } = this.props, { context: t } = this;
		return (n) => {
			let { columnIsSortable: r } = this.getContextualInfo(), { columnId: i } = this.props;
			e?.(n), r && !Fr(i) && t?.sorting.onSortChange(this.getTheNewSortDirection(i));
		};
	}
	renderIcon(e) {
		return e ? /* @__PURE__ */ A(u, {
			className: Ir.icon,
			name: e === "asc" ? "sort-up" : "sort-down"
		}) : null;
	}
	warnAboutNoColumnIdProps() {
		console.error("\n      <Table.Th> needs a 'columnId' prop when table is sortable.\n      Pass 'columndId: null' prop if you want that column not to be sortable.\n    ");
	}
	render() {
		return /* @__PURE__ */ A(dr, { children: (e) => {
			this.context = e;
			let { sorting: t, presentation: n } = e;
			t.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
			let { className: r, children: i, tooltip: o, columnId: s, thRef: c, ...l } = this.props, { sortByThisColumn: u, columnIsSortable: d, sortDirection: f } = this.getContextualInfo(), p = O(Ir.root, {
				[Ir.rootClickable]: d,
				[Ir.rootSticky]: n.stickyHeader,
				[Ir.rootShowBG]: n.headerWithBackground
			}, r), m = O({ [Ir.tooltip]: o });
			return /* @__PURE__ */ A(a, {
				as: "th",
				...l,
				ref: c,
				className: p,
				onClick: this.getClickHandler(),
				"data-testid": nr.Th,
				children: /* @__PURE__ */ j("span", {
					className: Ir.contentWrapper,
					children: [/* @__PURE__ */ A(U, {
						content: o,
						disabled: !o,
						children: /* @__PURE__ */ A("span", {
							className: m,
							children: i
						})
					}), u && this.renderIcon(f)]
				})
			});
		} });
	}
}, Rr = Object.assign(F(function(e, t) {
	return /* @__PURE__ */ A(Lr, {
		...e,
		thRef: t
	});
}), { name: Lr.name }), zr = (e) => e === !1, Br = {
	trHoverable: "h-table-tr--tr__trHoverable",
	expansionTriggerWrapper: "h-table-tr--tr__expansionTriggerWrapper",
	expansionTriggerWrapperExpanded: "h-table-tr--tr__expansionTriggerWrapperExpanded",
	checkboxCell: "h-table-tr--tr__checkboxCell",
	checkboxCellExpanded: "h-table-tr--tr__checkboxCellExpanded",
	expandedRowContentWrapper: "h-table-tr--tr__expandedRowContentWrapper"
}, Vr = ({ rowId: e, isExpandable: t, isExpanded: n, onExpansionToggle: r, expandableContent: i, isSelectable: a, isSelected: o, onSelect: s, isHoverable: c, children: l, trRef: u, ...d }) => {
	let f = O(d.className, { [Br.trHoverable]: c }) || void 0;
	return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ j("tr", {
		...d,
		ref: u,
		className: f,
		"data-testid": nr.Row,
		children: [
			t && /* @__PURE__ */ A(Pr, {
				className: O(Br.expansionTriggerWrapper, { [Br.expansionTriggerWrapperExpanded]: n }),
				children: i && /* @__PURE__ */ A(h, {
					variant: "tertiary",
					icon: n ? "angle-down" : "angle-right",
					"data-testid": nr.RowExpansionTrigger,
					onClick: () => {
						Fr(e) || r(e);
					}
				})
			}),
			a && /* @__PURE__ */ A(Pr, {
				className: O(Br.checkboxCell, { [Br.checkboxCellExpanded]: n }),
				children: /* @__PURE__ */ A(G, {
					justifyContent: "center",
					alignItems: "center",
					children: /* @__PURE__ */ A(tn, {
						checked: o,
						name: `selection-trigger-${e}`,
						id: `selection-trigger-${e}`,
						onChange: () => {
							Fr(e) || s(e);
						}
					})
				})
			}),
			l
		]
	}), t && n && /* @__PURE__ */ j("tr", {
		"data-testid": nr.Row,
		children: [
			/* @__PURE__ */ A(Pr, { className: Br.expansionTriggerWrapper }),
			a && /* @__PURE__ */ A(Pr, { className: Br.checkboxCell }),
			/* @__PURE__ */ A(Pr, {
				colSpan: 2 ** 53 - 1,
				className: Br.expandedRowContentWrapper,
				children: i
			})
		]
	})] });
}, Hr = ({ isExpandable: e, children: t, trRef: n, ...r }) => /* @__PURE__ */ j("tr", {
	...r,
	ref: n,
	"data-testid": nr.Row,
	children: [e && /* @__PURE__ */ A(Pr, {
		className: Br.expansionTriggerWrapper,
		children: /* @__PURE__ */ A("span", {})
	}), t]
}), Ur = ({ isExpandable: e, isSelectable: t, allRowsSelected: n, allRowsSelectedIndeterminate: r, onAllRowsSelect: i, children: a, trRef: o, ...s }) => /* @__PURE__ */ j("tr", {
	...s,
	ref: o,
	"data-testid": nr.Row,
	children: [
		e && /* @__PURE__ */ A(Rr, {
			className: Br.expansionTriggerWrapper,
			columnId: null,
			children: /* @__PURE__ */ A("span", {})
		}),
		t && /* @__PURE__ */ A(Rr, {
			className: Br.checkboxCell,
			columnId: null,
			children: /* @__PURE__ */ A(G, {
				justifyContent: "center",
				alignItems: "center",
				children: /* @__PURE__ */ A(tn, {
					checked: n,
					indeterminate: r,
					onChange: i,
					name: "all-rows-selector",
					id: "all-rows-selector"
				})
			})
		}),
		a
	]
}), Wr = class extends N {
	context = void 0;
	isRowExpanded(e, t) {
		return e.includes(t);
	}
	hasSelectableRow() {
		let { rowId: e } = this.props;
		return this.context?.rows.selectableRows === !0 && !Fr(e);
	}
	hasExpandableRow() {
		let { expandableContent: e, rowId: t } = this.props;
		return this.context?.rows.expandableRows === !0 && !Fr(e) && !Fr(t);
	}
	shouldRenderRegularTr() {
		return [this.hasExpandableRow(), this.hasSelectableRow()].every(zr);
	}
	rowIdIsPresent(e) {
		return !Fr(e);
	}
	render() {
		let { children: e, expandableContent: t, rowId: n, ...r } = this.props;
		return /* @__PURE__ */ A(dr, { children: (i) => {
			this.context = i;
			let { rows: a } = i;
			if (i.isTableHead) return /* @__PURE__ */ A(Ur, {
				...r,
				isExpandable: a.expandableRows,
				isSelectable: a.selectableRows,
				allRowsSelected: a.allRowsSelected,
				allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
				onAllRowsSelect: a.onAllRowsSelect,
				children: e
			});
			if (i.isTableFoot) return /* @__PURE__ */ A(Hr, {
				...r,
				isExpandable: a.expandableRows,
				children: e
			});
			let o = !Fr(n) && this.isRowExpanded(a.expandedRows, n), s = !Fr(n) && a.selectedRowIds.includes(n);
			return /* @__PURE__ */ A(Vr, {
				...r,
				rowId: n,
				isExpanded: o,
				isSelected: s,
				onSelect: a.onRowSelect,
				isExpandable: a.expandableRows,
				expandableContent: t,
				isSelectable: a.selectableRows,
				onExpansionToggle: a.onExpansionToggle,
				isHoverable: i.presentation.hoverable,
				children: e
			});
		} });
	}
}, Gr = Object.assign(F(function(e, t) {
	return /* @__PURE__ */ A(Wr, {
		...e,
		trRef: t
	});
}), { name: Wr.name }), Kr = {
	wrapper: "h-table--table__wrapper",
	wrapperIsFramed: "h-table--table__wrapperIsFramed",
	wrapperIsLoading: "h-table--table__wrapperIsLoading",
	innerWrapper: "h-table--table__innerWrapper",
	wrapperIsDisabled: "h-table--table__wrapperIsDisabled",
	table: "h-table--table__table"
}, qr = class e extends N {
	static defaultProps = {
		headerWithBackground: !0,
		stickyHeader: !1,
		stickyFooter: !1,
		framed: !0,
		hoverable: !1,
		loadingStrategy: "spinner"
	};
	constructor(e) {
		super(e), this.state = { expandedRows: e.expandableRowsProps?.initiallyExpandedRows ?? [] }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
	}
	static fallback = /* @__PURE__ */ A(G, {
		justifyContent: "center",
		alignItems: "center",
		style: { minHeight: "10vh" },
		children: /* @__PURE__ */ A(i.Paragraph, { children: "Oops! something went wrong..." })
	});
	handleExpansionToggle(e) {
		this.state.expandedRows.includes(e) ? this.setState(({ expandedRows: t }) => ({ expandedRows: t.filter((t) => t !== e) })) : this.setState(({ expandedRows: t }) => ({ expandedRows: [...t, e] }));
	}
	getContextValue() {
		let { props: { headerWithBackground: e, stickyHeader: t, stickyFooter: n, sortingProps: r, paginationProps: i, selectableRowsProps: a, expandableRowsProps: o, loading: s, loadingFailed: c, onLoadingRetry: l, emptyState: u, loadingStrategy: d, hoverable: f } } = this;
		return {
			status: {
				loading: s ?? !1,
				loadingFailed: c ?? !1,
				onLoadingRetry: l,
				emptyState: u
			},
			presentation: {
				headerWithBackground: !!e,
				stickyHeader: !!t,
				stickyFooter: !!n,
				hoverable: !!f
			},
			sorting: {
				sortable: !!r,
				sortableColumns: r?.sortableColumns,
				sortStatus: r?.sortStatus ?? null,
				onSortChange: r?.onSortChange ?? K
			},
			pagination: {
				paginated: !!i,
				selectedPage: i?.selectedPage ?? 1,
				pageCount: i?.pageCount ?? 1,
				onPageChange: i?.onPageChange ?? K,
				pageRangeDisplayed: i?.pageRangeDisplayed
			},
			rows: {
				expandableRows: o?.expandableRows ?? !1,
				expandedRows: this.state.expandedRows,
				onExpansionToggle: this.handleExpansionToggle,
				selectableRows: !!a,
				selectedRowIds: a?.selectedRowIds ?? [],
				onRowSelect: a?.onRowSelect ?? K,
				onAllRowsSelect: a?.onAllRowsSelect ?? K,
				allRowsSelected: a?.allRowsSelected ?? !1,
				allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
			},
			loading: { loadingStrategy: d ?? "spinner" }
		};
	}
	render() {
		let { framed: t, className: n, children: r, wrapperProps: i, wrapperRef: a, innerWrapperClassName: o, nativeProps: s, tableRef: c } = this.props, l = hr(r), u = O(Kr.wrapper, i?.className, {
			[Kr.wrapperIsFramed]: t,
			[Kr.wrapperIsLoading]: this.props.loading,
			[Kr.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
		}), d = O({ [Kr.innerWrapper]: !0 }, o), f = O(Kr.table, n), p = this.getContextValue();
		return /* @__PURE__ */ A(pt, {
			fallback: e.fallback,
			children: /* @__PURE__ */ A(tr.Provider, {
				value: p,
				children: /* @__PURE__ */ j("div", {
					...i,
					className: u,
					children: [
						/* @__PURE__ */ A("div", {
							className: d,
							ref: a,
							children: /* @__PURE__ */ A("table", {
								...s,
								ref: c,
								className: f,
								children: l.children
							})
						}),
						p.pagination.paginated && /* @__PURE__ */ A(Cr, {}),
						!p.pagination.paginated && l.footers
					]
				})
			})
		});
	}
}, Jr = Object.assign(F(function(e, t) {
	return /* @__PURE__ */ A(qr, {
		...e,
		tableRef: t
	});
}), {
	name: qr.name,
	Thead: ur,
	Tbody: jr,
	Tfoot: or,
	Tr: Gr,
	Th: Rr,
	Td: Pr,
	Footer: mr
}), Yr = { infoIcon: "h-helpIcon--helpIcon__infoIcon" }, Xr = class extends N {
	render() {
		let { side: e, text: t, title: n, disabled: r, requireClick: i, className: a, alwaysShow: o, tooltipClassName: s, ...c } = this.props;
		return /* @__PURE__ */ A(U, {
			head: n,
			content: t,
			disabled: r,
			side: e,
			requireClick: i,
			alwaysShow: o,
			className: s,
			wrap: "none",
			...c,
			children: /* @__PURE__ */ A("span", {
				className: O(Yr.infoIcon, a),
				children: /* @__PURE__ */ A(u, { name: "info" })
			})
		});
	}
}, Zr = ({ columns: e }) => /* @__PURE__ */ A(k, { children: e.map(({ label: e, style: t, helpIcon: n, columnId: r }, i) => /* @__PURE__ */ j(Jr.Th, {
	columnId: r || e,
	style: t,
	children: [e, n?.title && n?.text && /* @__PURE__ */ A(Xr, {
		side: "bottom",
		...n
	})]
}, e || i)) }), Qr = ({ columns: e, data: t }) => /* @__PURE__ */ j(Jr, {
	headerWithBackground: !1,
	framed: !1,
	children: [/* @__PURE__ */ A(Jr.Thead, { children: /* @__PURE__ */ A(Jr.Tr, { children: /* @__PURE__ */ A(Zr, { columns: e }) }) }), /* @__PURE__ */ A(Jr.Tbody, { children: t.map((t, n) => /* @__PURE__ */ A(Jr.Tr, { children: e.map(({ selector: e }, n) => /* @__PURE__ */ A(Jr.Td, { children: e(t) }, n)) }, n)) })]
}), $r = ({ data: e, rowId: t, columns: n, subTableColumns: r, subTableDataSelector: i }) => /* @__PURE__ */ A(Jr.Tr, {
	expandableContent: !!(r && i) && /* @__PURE__ */ A(Qr, {
		data: i(e),
		columns: r
	}),
	rowId: t,
	children: n.map(({ selector: t }, n) => /* @__PURE__ */ A(Jr.Td, { children: t(e) }, n))
}), ei = ({ columns: e, subTableColumns: t, data: n, subTableDataSelector: r, tableWrapperProps: i, tableInnerWrapperClassName: a, paginationProps: o, sortingProps: s, selectableRowsProps: c, tableStyleProps: l, tableStatusProps: u, tableRowIdSelector: d, tableLoadingStrategy: f, tableWrapperRef: p }) => {
	let m = e.filter((e) => e.sortable).reduce((e, t) => t.columnId ? [...e, t.columnId] : e, []);
	return m.length && s && (s.sortableColumns = m), /* @__PURE__ */ j(Jr, {
		stickyHeader: !0,
		wrapperProps: i,
		innerWrapperClassName: a,
		expandableRowsProps: { expandableRows: !!(t && r) },
		sortingProps: s,
		selectableRowsProps: c,
		loadingStrategy: f,
		wrapperRef: p,
		...l,
		...u,
		children: [
			/* @__PURE__ */ A(Jr.Thead, { children: /* @__PURE__ */ A(Jr.Tr, { children: /* @__PURE__ */ A(Zr, { columns: e }) }) }),
			/* @__PURE__ */ A(Jr.Tbody, { children: n.map((n, i) => /* @__PURE__ */ A($r, {
				rowId: d ? d(n) : i,
				data: n,
				columns: e,
				subTableDataSelector: r,
				subTableColumns: t
			}, i)) }),
			o && /* @__PURE__ */ A(Jr.Footer, { children: /* @__PURE__ */ A(er, { ...o }) })
		]
	});
}, ti = ze, ni = {
	root: "h-datePickerOld--datePickerDay__root",
	rootActive: "h-datePickerOld--datePickerDay__rootActive",
	rootDisabled: "h-datePickerOld--datePickerDay__rootDisabled",
	rootDim: "h-datePickerOld--datePickerDay__rootDim",
	label: "h-datePickerOld--datePickerDay__label"
}, ri = class extends N {
	render() {
		let { className: e, dim: t, active: n, disabled: r, children: i, onClick: a, ...o } = this.props, s = O({
			[ni.root]: !0,
			[ni.rootDim]: t,
			[ni.rootActive]: n,
			[ni.rootDisabled]: !n && r
		}, e);
		return /* @__PURE__ */ A("button", {
			...o,
			onClick: a,
			className: s,
			disabled: r,
			children: /* @__PURE__ */ A("span", {
				className: ni.label,
				children: i
			})
		});
	}
}, J = {
	grid: "h-datePickerOld--datePickerOld__grid",
	gridItem: "h-datePickerOld--datePickerOld__gridItem",
	day: "h-datePickerOld--datePickerOld__day",
	month: "h-datePickerOld--datePickerOld__month",
	timeButtonContainerLeft: "h-datePickerOld--datePickerOld__timeButtonContainerLeft",
	timeButtonContainerRight: "h-datePickerOld--datePickerOld__timeButtonContainerRight",
	arrowTime: "h-datePickerOld--datePickerOld__arrowTime",
	arrow: "h-datePickerOld--datePickerOld__arrow",
	dayNames: "h-datePickerOld--datePickerOld__dayNames",
	dayName: "h-datePickerOld--datePickerOld__dayName",
	time: "h-datePickerOld--datePickerOld__time",
	timeDisplay: "h-datePickerOld--datePickerOld__timeDisplay"
}, ii = (e) => [0, 6].indexOf(e.getDay()) !== -1, ai = class e extends N {
	static defaultProps;
	static getDateValue(e) {
		let t = e.value instanceof Date ? e.value : /* @__PURE__ */ new Date();
		return new Date(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes());
	}
	constructor(t) {
		super(t);
		let n = e.getDateValue(t.input);
		this.state = {
			selectedDate: n,
			showDate: n
		};
	}
	UNSAFE_componentWillReceiveProps(t) {
		let { input: n } = this.props;
		t.input !== n && this.setState({ selectedDate: e.getDateValue(t.input) });
	}
	generateGrid() {
		let { selectedDate: t, showDate: n } = this.state, { input: r, disabled: i, minDate: a, maxDate: o } = this.props, s = [], c = new Date(n.getFullYear(), n.getMonth(), 1, t.getHours(), t.getMinutes()), l = c.getDay() || 7, u = new Date(c.getFullYear(), c.getMonth() + 1, 1);
		l < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (l - 1));
		let d = e.getDateValue(r).getTime(), f = 0;
		for (; c < u || c.getDay() !== 1 || f < 6;) {
			let e = c.getTime(), t = new Date(e);
			s.push({
				date: t,
				label: c.getDate().toString(),
				isThisMonth: c.getMonth() === n.getMonth(),
				selected: e === d,
				disabled: i(c) || !!(o && t > o) || !!(a && t < a)
			}), c.getDay() === 1 && (f += 1), c.setDate(c.getDate() + 1);
		}
		return s;
	}
	goToMonth(e) {
		let { showDate: t } = this.state, n = new Date(t.getTime());
		n.setMonth(t.getMonth() + e), this.setState({ showDate: n });
	}
	nextMonth = (e) => {
		e.preventDefault(), this.goToMonth(1);
	};
	prevMonth = (e) => {
		e.preventDefault(), this.goToMonth(-1);
	};
	handleDateClick(e, t) {
		e.preventDefault();
		let { input: { onChange: n } } = this.props, { showDate: r } = this.state, i = {
			...this.state,
			selectedDate: t
		};
		r.getMonth() !== t.getMonth() && (i.showDate = t), this.setState(i), n(t);
	}
	goToTime(e, t, n = "hours") {
		let r = n === "minutes" ? "setMinutes" : "setHours", i = n === "minutes" ? "getMinutes" : "getHours", { input: { onChange: a } } = this.props, { selectedDate: o } = this.state, s = new Date(o.getTime());
		s[r](s[i]() + t), this.setState({ selectedDate: s }), a(s);
	}
	nextMinutes = (e) => {
		e.preventDefault(), this.goToTime(e, 15, "minutes");
	};
	prevMinutes = (e) => {
		e.preventDefault(), this.goToTime(e, -15, "minutes");
	};
	nextHour = (e) => {
		e.preventDefault(), this.goToTime(e, 1);
	};
	prevHour = (e) => {
		e.preventDefault(), this.goToTime(e, -1);
	};
	canGoPrevMonth() {
		let { minDate: e } = this.props, { showDate: t } = this.state;
		return e === null || e < new Date(t.getFullYear(), t.getMonth(), 1);
	}
	canGoNextMonth() {
		let { maxDate: e } = this.props, { showDate: t } = this.state;
		return e === null || e > new Date(t.getFullYear(), t.getMonth() + 1, 1, 0, 0, 0, -1);
	}
	canGoDirection(e = "hours", t) {
		let n = e === "minutes" ? "setMinutes" : "setHours", r = e === "minutes" ? "getMinutes" : "getHours", { maxDate: i } = this.props, { selectedDate: a } = this.state, o = new Date(a.getTime());
		return o[n](o[r]() + t), o.getDate() === a.getDate() && (i === null || i >= o);
	}
	render() {
		let { className: e, input: t, hasTime: n, disabled: r, minDate: i, maxDate: a, ...o } = this.props, { selectedDate: s, showDate: c } = this.state, l = O({}, e), d = this.generateGrid(), f = {
			month: "long",
			year: "numeric"
		}, p = null;
		try {
			p = c.toLocaleDateString("en-US", f);
		} catch (e) {
			p = `${c.getMonth() + 1} / ${c.getFullYear()}`, console.warn("toLocaleDateString exception", e);
		}
		return /* @__PURE__ */ j("div", {
			...o,
			className: l,
			children: [
				/* @__PURE__ */ j("div", {
					className: J.month,
					children: [
						/* @__PURE__ */ A("button", {
							className: J.arrow,
							disabled: !this.canGoPrevMonth(),
							onClick: this.prevMonth,
							"aria-label": "Previous month",
							children: /* @__PURE__ */ A(u, {
								name: "angle-left",
								className: "icon-vertical-fix"
							})
						}),
						p,
						/* @__PURE__ */ A("button", {
							className: J.arrow,
							disabled: !this.canGoNextMonth(),
							onClick: this.nextMonth,
							"aria-label": "Next month",
							children: /* @__PURE__ */ A(u, {
								name: "angle-right",
								className: "icon-vertical-fix"
							})
						})
					]
				}),
				/* @__PURE__ */ j("div", {
					className: J.dayNames,
					children: [
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Mon"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Tue"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Wed"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Thu"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Fri"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Sat"
						}),
						/* @__PURE__ */ A("p", {
							className: J.dayName,
							children: "Sun"
						})
					]
				}),
				/* @__PURE__ */ A("div", {
					className: J.grid,
					children: d.map((e) => /* @__PURE__ */ A("div", {
						className: J.gridItem,
						children: /* @__PURE__ */ A(ri, {
							onClick: (t) => this.handleDateClick(t, e.date),
							dim: !e.isThisMonth,
							active: e.selected,
							disabled: e.disabled,
							className: J.day,
							children: e.label
						})
					}, e.date.getTime()))
				}),
				n && /* @__PURE__ */ j("div", {
					className: J.time,
					children: [
						/* @__PURE__ */ j("div", {
							className: J.timeButtonContainerLeft,
							children: [/* @__PURE__ */ A("button", {
								className: J.arrowTime,
								disabled: !this.canGoDirection("hours", -1),
								onClick: this.prevHour,
								"aria-label": "Previous hour",
								children: /* @__PURE__ */ A(u, {
									name: "angle-double-left",
									className: "icon-vertical-fix"
								})
							}), /* @__PURE__ */ A("button", {
								className: J.arrowTime,
								disabled: !this.canGoDirection("minutes", -15),
								onClick: this.prevMinutes,
								"aria-label": "Previous hour",
								children: /* @__PURE__ */ A(u, {
									name: "angle-left",
									className: "icon-vertical-fix"
								})
							})]
						}),
						/* @__PURE__ */ A("div", {
							className: J.timeDisplay,
							children: `${ti(s.getHours().toString(), 2, "0")}:${ti(s.getMinutes().toString(), 2, "0")}`
						}),
						/* @__PURE__ */ j("div", {
							className: J.timeButtonContainerRight,
							children: [/* @__PURE__ */ A("button", {
								className: J.arrowTime,
								disabled: !this.canGoDirection("minutes", 15),
								onClick: this.nextMinutes,
								"aria-label": "Next hour",
								children: /* @__PURE__ */ A(u, {
									name: "angle-right",
									className: "icon-vertical-fix"
								})
							}), /* @__PURE__ */ A("button", {
								className: J.arrowTime,
								disabled: !this.canGoDirection("hours", 1),
								onClick: this.nextHour,
								"aria-label": "Next hour",
								children: /* @__PURE__ */ A(u, {
									name: "angle-double-right",
									className: "icon-vertical-fix"
								})
							})]
						})
					]
				})
			]
		});
	}
};
ai.defaultProps = {
	disabled: () => !1,
	minDate: null,
	maxDate: null,
	hasTime: !1
};
//#endregion
//#region src/utils/date.ts
var oi = te();
function si(e) {
	return Math.abs(e.diff(H())) < 25e3 ? "just now" : e.fromNow();
}
function ci(e) {
	return H(e, H.ISO_8601).isValid();
}
function li(e) {
	return !!H.tz.zone(e ?? "");
}
//#endregion
//#region \0callable-external:lodash/orderBy
var ui = Be, di = Ve, fi = "HH:mm", pi = di(24), mi = di(0, 60, 15), hi = (e) => H("1995-12-25").format(e);
function gi(e) {
	if (e < 0 || e > 23) throw Error("Hour must be between 0 and 23.");
}
function _i(e) {
	if (e < 0 || e > 59) throw Error("Minute must be between 0 and 59.");
}
function vi({ hour: e, minute: t, timeFormat: n }) {
	let r = H({
		hour: e,
		minute: t
	});
	return {
		id: r.format(fi),
		name: r.format(n)
	};
}
function yi(e, t) {
	return t?.map(({ hour: t, minute: n }) => (gi(t), _i(n), vi({
		hour: t,
		minute: n,
		timeFormat: e
	}))) || [];
}
function bi({ hours: e, minutes: t, overrides: n, timeFormat: r }) {
	return ui(e.reduce((e, n, i) => [...e, ...t.map((e, t) => (t === 0 && gi(n), i === 0 && _i(e), vi({
		hour: n,
		minute: e,
		timeFormat: r
	})))], []).concat(yi(r, n)), ["id"]);
}
var xi = {
	root: "h-datePicker--datePicker__root",
	navigationButton: "h-datePicker--datePicker__navigationButton",
	nextMonthButton: "h-datePicker--datePicker__nextMonthButton",
	prevMonthButton: "h-datePicker--datePicker__prevMonthButton"
}, Si = {
	previousMonth({ ariaLabel: e, ...t }) {
		return /* @__PURE__ */ A("div", {
			className: O(xi.navigationButton, xi.prevMonthButton),
			children: /* @__PURE__ */ A(u, {
				...t,
				"aria-label": e,
				size: 24,
				name: "angle-left"
			})
		});
	},
	nextMonth({ ariaLabel: e, ...t }) {
		return /* @__PURE__ */ A("div", {
			className: O(xi.navigationButton, xi.nextMonthButton),
			children: /* @__PURE__ */ A(u, {
				...t,
				"aria-label": e,
				size: 24,
				name: "angle-right"
			})
		});
	}
}, Ci = (e) => /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
	className: "date-number-container",
	children: e.date()
}), /* @__PURE__ */ A("span", { className: "day-complimentary-highlight" })] }), wi = ({ month: e }) => /* @__PURE__ */ A("span", { children: e.format("MMMM YYYY") }), Ti = (e) => {
	let { value: t, presets: n, onSelect: r } = e, i = L((e) => {
		r(e.key === t ? null : e);
	}, [r, t]);
	return /* @__PURE__ */ j(he, { children: [/* @__PURE__ */ A(qt, { orientation: "vertical" }), /* @__PURE__ */ A(Qt, { children: n.map((e) => /* @__PURE__ */ A(Qt.Item, {
		isSelected: e.key === t,
		onClick: () => i(e),
		children: e.label
	}, e.key)) })] });
}, Ei = {
	root: "h-fieldLabel--fieldLabel__root",
	label: "h-fieldLabel--fieldLabel__label",
	labelChildren: "h-fieldLabel--fieldLabel__labelChildren",
	rootRequired: "h-fieldLabel--fieldLabel__rootRequired",
	helpIcon: "h-fieldLabel--fieldLabel__helpIcon"
}, Di = "fieldLabel", Oi = class extends N {
	render() {
		let { required: e, helpIcon: t, className: n, children: r, ...i } = this.props;
		return /* @__PURE__ */ j("div", {
			className: O(Ei.root, n, { [Ei.rootRequired]: e }),
			"data-testid": Di,
			children: [/* @__PURE__ */ A("label", {
				className: Ei.label,
				...i,
				children: /* @__PURE__ */ A("div", {
					className: Ei.labelChildren,
					children: r
				})
			}), !!t?.text && /* @__PURE__ */ A(Xr, {
				...t,
				className: O(Ei.helpIcon, t.className)
			})]
		});
	}
}, ki = He, Ai = Ue, ji = We, Mi = Ge, Ni = Ke, Pi = {
	item: "h-dropdownSelect--dropdownInfinite__item",
	list: "h-dropdownSelect--dropdownInfinite__list"
}, Fi = class extends N {
	render() {
		let { item: e, itemComponent: t, tooltip: n, onSelect: r, onChange: i, onKeyDown: a, clearSearch: o, checked: s, disabled: c, isLoading: l, active: u, id: d } = this.props, f = /* @__PURE__ */ A(t, {
			item: e,
			onSelect: r,
			onChange: i,
			onKeyDown: a,
			clearSearch: o,
			checked: s,
			disabled: c,
			isLoading: l,
			active: u,
			tabIndex: u ? 0 : -1,
			id: d,
			role: "option",
			"aria-disabled": c,
			"aria-selected": s
		});
		return n ? /* @__PURE__ */ A(U, {
			...n,
			children: f
		}, e.id) : f;
	}
}, Ii = 6, Li = 48, Ri = class extends N {
	listRef;
	infiniteListRef;
	static defaultProps = {
		selectedItems: [],
		disabledItems: [],
		tooltipItems: {},
		activeItem: null
	};
	constructor(e) {
		super(e), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = P(), this.infiniteListRef = P();
	}
	componentDidUpdate(e) {
		let { activeItem: t, items: n, pagination: r } = this.props, i = typeof e.activeItem == "object" && e.activeItem ? e.activeItem.id : e.activeItem, a = typeof t == "object" && t ? t.id : t;
		if (i !== a && a !== null) {
			let e = n.findIndex((e) => e.id === a);
			if (e >= 0) {
				if (typeof r == "object" && r.infinite && this.infiniteListRef.current) this.infiniteListRef.current.scrollToItem(e, "smart");
				else if (this.listRef.current) {
					let t = this.listRef.current.children[e];
					t && t.scrollIntoView({ block: "nearest" });
				}
			}
		}
	}
	isItemLoaded(e) {
		let { items: t } = this.props;
		return e < t.length;
	}
	isItemActive(e) {
		if (!e) return !1;
		let { activeItem: t } = this.props;
		return t ? typeof t == "object" && "id" in t ? e.id === t.id : e.id === t : !1;
	}
	isItemChecked(e) {
		if (!e) return !1;
		let { selectedItems: t } = this.props;
		return (t?.findIndex((t) => typeof t == "object" ? t.id === e.id : t === e.id) ?? -1) > -1;
	}
	isItemDisabled(e) {
		return !e || (this.props.disabledItems?.indexOf(e.id) ?? -1) >= 0;
	}
	getTooltip(e) {
		let { tooltipItems: t } = this.props;
		return !e || Mi(t?.[e.id]) ? null : t?.[e.id] ?? null;
	}
	goToTop() {
		this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
	}
	focusActiveItem() {
		let { items: e, activeItem: t } = this.props;
		if (!t || !this.listRef.current) return;
		let n = typeof t == "object" && "id" in t ? t.id : t, r = e.findIndex((e) => e.id === n);
		if (r >= 0 && this.listRef.current.children[r]) {
			let e = this.listRef.current.children[r];
			(e.querySelector("[tabindex=\"0\"]") || e)?.focus();
		}
	}
	getItemId(e) {
		let { id: t } = this.props;
		return t ? `${t}-option-${e}` : void 0;
	}
	ListItem = ({ index: e, style: t }) => {
		let { items: n, itemComponent: r, onSelect: i, onChange: a, clearSearch: o } = this.props, s = this.isItemLoaded(e), c = e === n.length - 1, l = s ? n[e] : {
			id: qe(),
			name: "Loading..."
		}, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
		return /* @__PURE__ */ j("div", {
			style: t,
			className: Pi.item,
			children: [/* @__PURE__ */ A(Fi, {
				id: this.getItemId(e),
				checked: this.isItemChecked(l),
				clearSearch: o,
				disabled: this.isItemDisabled(l),
				isLoading: !s,
				item: l,
				itemComponent: r,
				onChange: a,
				onSelect: i,
				tooltip: this.getTooltip(l),
				active: this.isItemActive(l)
			}), c && u && s && /* @__PURE__ */ A(se, { onEnter: this.loadMoreItems })]
		});
	};
	loadMoreItems = async () => {
		this.props.pagination && await this.props.pagination.onNext?.();
	};
	render() {
		let { items: e, pagination: t, itemComponent: n, onSelect: r, onChange: i, onKeyDown: a, clearSearch: o, itemsDisplayCount: s = Ii, itemHeight: c = Li, id: l, ariaLabelledby: u } = this.props;
		if (!t || !t.infinite || !t.onNext) return /* @__PURE__ */ A("div", {
			style: { maxHeight: `${s * c}px` },
			className: Pi.list,
			ref: this.listRef,
			role: "listbox",
			id: l,
			"aria-labelledby": u,
			children: e.map((e, t) => {
				let s = Ni(e) ? e : e.id.toString() || e.name.toString() || e.toString();
				return /* @__PURE__ */ A(Fi, {
					id: this.getItemId(t),
					checked: this.isItemChecked(e),
					clearSearch: o,
					disabled: this.isItemDisabled(e),
					item: e,
					itemComponent: n,
					onChange: i,
					onSelect: r,
					onKeyDown: a,
					tooltip: this.getTooltip(e),
					active: this.isItemActive(e)
				}, s);
			})
		});
		let { nextEnable: d, itemCount: f } = t, p = f || (d ? e.length + s : e.length), m = {
			items: e,
			selectedItems: this.props.selectedItems,
			disabledItems: this.props.disabledItems,
			tooltipItems: this.props.tooltipItems,
			activeItem: this.props.activeItem,
			pagination: this.props.pagination
		}, h = Math.min(p * c, s * c);
		return /* @__PURE__ */ A(C, {
			disableHeight: !0,
			doNotBailOutOnEmptyChildren: !0,
			children: ({ width: e }) => /* @__PURE__ */ A(ie, {
				...m,
				ref: this.infiniteListRef,
				width: e,
				height: h,
				itemCount: p,
				itemSize: c,
				"aria-labelledby": u,
				children: this.ListItem
			})
		});
	}
}, zi = {
	root: "h-selectItems-checkableBaseItem--checkableBaseItem__root",
	rootActive: "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive",
	rootDisabled: "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled",
	name: "h-selectItems-checkableBaseItem--checkableBaseItem__name",
	checkbox: "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox",
	content: "h-selectItems-checkableBaseItem--checkableBaseItem__content",
	icon: "h-selectItems-checkableBaseItem--checkableBaseItem__icon"
}, Bi = class extends N {
	constructor(e) {
		super(e), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
	}
	handleChange() {
		let { onChange: e, item: t, checked: n } = this.props;
		typeof e == "function" && e(t, !n);
	}
	handleKeyDown(e) {
		let { disabled: t, onKeyDown: n } = this.props;
		(e.key === "Enter" || e.key === " ") && !t && (e.preventDefault(), this.handleChange()), n && n(e);
	}
	noop(e) {
		e.preventDefault();
	}
	render() {
		let { item: e, onChange: t, clearSearch: n, checked: r, disabled: i, isLoading: a, children: o, active: s, tabIndex: c, onKeyDown: l, ...u } = this.props, d = O(zi.root, {
			[zi.rootDisabled]: i,
			[zi.rootActive]: s
		}), f = i ? K : this.handleChange;
		return /* @__PURE__ */ j("label", {
			...u,
			className: d,
			tabIndex: c,
			onKeyDown: this.handleKeyDown,
			children: [/* @__PURE__ */ A(tn, {
				id: e?.id,
				name: "",
				className: zi.checkbox,
				checked: r,
				onChange: f,
				tabIndex: -1
			}), /* @__PURE__ */ A("div", {
				className: zi.content,
				children: o
			})]
		});
	}
}, Vi = {
	root: "h-selectItems-emptySelectItem--emptySelectItem__root",
	name: "h-selectItems-emptySelectItem--emptySelectItem__name"
}, Hi = class extends N {
	render() {
		let { label: e, ...t } = this.props;
		return /* @__PURE__ */ A("div", {
			...t,
			className: Vi.root,
			children: /* @__PURE__ */ A("div", {
				className: Vi.name,
				children: e
			})
		});
	}
}, Ui = {
	root: "h-selectItems-selectItem--selectItem__root",
	rootActive: "h-selectItems-selectItem--selectItem__rootActive",
	name: "h-selectItems-selectItem--selectItem__name",
	nameBold: "h-selectItems-selectItem--selectItem__nameBold",
	nameWithDescription: "h-selectItems-selectItem--selectItem__nameWithDescription",
	description: "h-selectItems-selectItem--selectItem__description",
	icon: "h-selectItems-selectItem--selectItem__icon"
}, Wi = class extends me {
	static defaultProps = { checked: !1 };
	render() {
		let { item: e, onSelect: t, clearSearch: n, checked: r, disabled: i, active: a, isLoading: o, ...s } = this.props, { description: c, name: l, icon: d, iconSize: f } = e, p = O(Ui.root, { [Ui.rootActive]: a }), m = O(Ui.name, {
			[Ui.nameBold]: r,
			[Ui.nameWithDescription]: !!c
		});
		return /* @__PURE__ */ j("button", {
			...s,
			type: "button",
			"aria-current": a,
			className: p,
			disabled: i,
			onClick: () => {
				t(e);
			},
			children: [
				d ? /* @__PURE__ */ A(u, {
					className: Ui.icon,
					name: d,
					size: f ?? 16
				}) : null,
				/* @__PURE__ */ j(G, {
					flexDirection: "column",
					justifyContent: "center",
					width: "100%",
					children: [/* @__PURE__ */ A("span", {
						className: m,
						"data-testid": "name",
						children: l
					}), c && /* @__PURE__ */ A("span", {
						className: Ui.description,
						"data-testid": "description",
						children: c
					})]
				}),
				r && /* @__PURE__ */ A(u, {
					name: "done",
					size: 20,
					color: "neutral.700"
				})
			]
		});
	}
}, Gi = { name: "h-selectItems-checkableSelectItem--checkableSelectItem__name" }, Ki = class extends N {
	render() {
		let { item: e, isLoading: t } = this.props, { name: n } = t ? {
			id: "",
			name: "Loading..."
		} : e;
		return /* @__PURE__ */ A(Bi, {
			...this.props,
			children: /* @__PURE__ */ A("span", {
				className: Gi.name,
				children: n
			})
		});
	}
}, qi = {
	root: "h-selectItems-tagSelectItem--tagSelectItem__root",
	rootActive: "h-selectItems-tagSelectItem--tagSelectItem__rootActive",
	name: "h-selectItems-tagSelectItem--tagSelectItem__name",
	nameBold: "h-selectItems-tagSelectItem--tagSelectItem__nameBold",
	dotContainer: "h-selectItems-tagSelectItem--tagSelectItem__dotContainer",
	dot: "h-selectItems-tagSelectItem--tagSelectItem__dot"
}, Ji = class extends N {
	static defaultProps = { checked: !1 };
	render() {
		let { item: e, onSelect: t, clearSearch: n, checked: r, disabled: i, isLoading: a, active: o, ...s } = this.props, { name: c, color: l = "#000" } = e, d = O(qi.root, { [qi.rootActive]: o }), f = O(qi.name, { [qi.nameBold]: r });
		return /* @__PURE__ */ j("button", {
			...s,
			type: "button",
			"aria-current": o,
			className: d,
			onClick: () => {
				t(e), n();
			},
			tabIndex: 0,
			title: typeof c == "string" ? c : c.toString(),
			disabled: i,
			children: [
				/* @__PURE__ */ A("div", {
					className: qi.dotContainer,
					children: /* @__PURE__ */ A("div", {
						className: qi.dot,
						style: { backgroundColor: l ?? void 0 }
					})
				}),
				/* @__PURE__ */ A("div", {
					className: f,
					children: c
				}),
				r && /* @__PURE__ */ A(u, {
					name: "done",
					size: 20,
					color: "neutral.700"
				}),
				i && /* @__PURE__ */ A("span", { children: "Deactivated" })
			]
		});
	}
}, Yi = {
	name: "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name",
	dotContainer: "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer",
	dot: "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot",
	nameContainer: "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer"
}, Xi = class extends N {
	constructor(e) {
		super(e), this.handleChange = this.handleChange.bind(this);
	}
	handleChange() {
		let { onChange: e, item: t, checked: n } = this.props;
		typeof e == "function" && e(t, !n);
	}
	render() {
		let { item: e, isLoading: t, disabled: n } = this.props, { name: r, color: i } = t ? {
			id: "",
			name: "Loading...",
			color: "#000"
		} : e;
		return /* @__PURE__ */ A(Bi, {
			...this.props,
			disabled: !this.props.checked && n,
			children: /* @__PURE__ */ j("div", {
				className: Yi.nameContainer,
				children: [
					i && /* @__PURE__ */ A("div", {
						className: Yi.dotContainer,
						children: /* @__PURE__ */ A("div", {
							className: Yi.dot,
							style: { backgroundColor: i }
						})
					}),
					/* @__PURE__ */ A("span", {
						className: Yi.name,
						children: r
					}),
					n && /* @__PURE__ */ A("span", { children: "Deactivated" })
				]
			})
		});
	}
}, Zi = {
	root: "h-selectItems-avatarSelectItem--avatarSelectItem__root",
	rootActive: "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive",
	names: "h-selectItems-avatarSelectItem--avatarSelectItem__names",
	primaryName: "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName",
	secondaryName: "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName",
	namesBold: "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold",
	container: "h-selectItems-avatarSelectItem--avatarSelectItem__container",
	containerCheckable: "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable"
}, Qi = class extends N {
	static defaultProps = { checked: !1 };
	getNames(e) {
		let t = /* @__PURE__ */ new Set();
		typeof e.name == "string" && t.add(e.name), typeof e.name != "string" && typeof e.display_name == "string" && t.add(e.display_name), typeof e.phone_number == "string" && t.add(e.phone_number), typeof e.email == "string" && t.add(e.email);
		let n = Array.from(t);
		return {
			primaryName: n.length > 0 ? n[0] : "No name",
			secondaryName: n.length > 1 ? n[1] : null
		};
	}
	getAvatar(e) {
		return typeof e.icon == "string" ? /* @__PURE__ */ A(u, {
			name: e.icon,
			size: 16
		}) : /* @__PURE__ */ A(Pt, { user: e });
	}
	renderContent() {
		let e = this.props.isLoading ? {
			id: "",
			name: "Loading..."
		} : this.props.item, t = this.getAvatar(e), n = this.getNames(e);
		return /* @__PURE__ */ j("div", {
			className: O(Zi.container, { [Zi.containerCheckable]: this.props.checkable }),
			children: [t, /* @__PURE__ */ j("div", {
				className: O(Zi.names, { [Zi.namesBold]: this.props.checked }),
				children: [/* @__PURE__ */ A("div", {
					className: Zi.primaryName,
					children: n.primaryName
				}), n.secondaryName !== null && /* @__PURE__ */ A("div", {
					className: Zi.secondaryName,
					children: n.secondaryName
				})]
			})]
		});
	}
	render() {
		let e = this.renderContent(), { checkable: t, ...n } = this.props;
		if (t) return /* @__PURE__ */ A(Bi, {
			...n,
			children: e
		});
		let { item: r, disabled: i, onSelect: a, active: o, checked: s, isLoading: c, ...l } = n, d = O(Zi.root, { [Zi.rootActive]: o });
		return /* @__PURE__ */ j("button", {
			...l,
			type: "button",
			className: d,
			disabled: i,
			onClick: () => {
				a(r);
			},
			"aria-current": o,
			children: [e, s && /* @__PURE__ */ A(u, {
				name: "done",
				size: 20,
				color: "neutral.700"
			})]
		});
	}
}, $i = class extends N {
	render() {
		return /* @__PURE__ */ A(Qi, {
			checkable: !0,
			...this.props
		});
	}
}, ea = {
	root: "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root",
	rootActive: "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive",
	suggestion: "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion",
	icon: "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon"
}, ta = class extends me {
	static defaultProps = {
		searchSuggestion: (e, t) => e.find((e) => e.name.toLowerCase() === t.toLowerCase()),
		renderSuggestion: (e) => `Add "${e}" tag`
	};
	constructor(e) {
		super(e), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
	}
	componentDidUpdate(e) {
		let { searched: t, active: n } = this.props;
		t !== e.searched && this.searchItem(), n !== e.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
	}
	componentWillUnmount() {
		window.removeEventListener("keydown", this.handleKeyDown);
	}
	searchItem() {
		let { items: e, searched: t, searchSuggestion: n } = this.props;
		this.setState({ searching: !0 }, async () => {
			try {
				let r = await n?.(e, t);
				this.setState({ item: r });
			} catch (e) {
				console.error(e);
			} finally {
				this.setState({ searching: !1 });
			}
		});
	}
	onSuggest() {
		let { searched: e, onSuggest: t, clearSearch: n, triggerClose: r } = this.props;
		r?.(), t?.(e), n();
	}
	handleKeyDown(e) {
		this.props.active && e.key === "Enter" && this.onSuggest();
	}
	render() {
		let { className: e, triggerClose: t, onSuggest: n, searched: r, items: i, active: a, renderSuggestion: o, searchSuggestion: s, clearSearch: c, ...l } = this.props, { item: d, searching: f } = this.state;
		if (!r || f || d) return null;
		let p = O(e, ea.root, { [ea.rootActive]: a });
		return /* @__PURE__ */ j("button", {
			...l,
			type: "button",
			"aria-current": a,
			className: p,
			onClick: this.onSuggest,
			tabIndex: 0,
			children: [/* @__PURE__ */ A("div", {
				className: ea.suggestion,
				children: o?.(r)
			}), /* @__PURE__ */ A("div", {
				className: ea.icon,
				children: /* @__PURE__ */ A(u, { name: "plus" })
			})]
		});
	}
}, na = {
	root: "h-selectItems-deselectItem--deselectItem__root",
	rootDisabled: "h-selectItems-deselectItem--deselectItem__rootDisabled",
	name: "h-selectItems-deselectItem--deselectItem__name",
	icon: "h-selectItems-deselectItem--deselectItem__icon"
}, ra = class extends N {
	render() {
		let { item: e, onSelect: t, clearSearch: n, disabled: r, ...i } = this.props, { name: a } = e, o = O(na.root, { [na.rootDisabled]: r });
		return /* @__PURE__ */ j("div", {
			...i,
			className: o,
			children: [/* @__PURE__ */ A("div", {
				className: na.name,
				children: a
			}), /* @__PURE__ */ A("button", {
				className: na.icon,
				onClick: () => {
					t(e);
				},
				disabled: r,
				children: /* @__PURE__ */ A(u, { name: "close" })
			})]
		});
	}
}, ia = {
	root: "h-selectItems-tagDeselectItem--tagDeselectItem__root",
	name: "h-selectItems-tagDeselectItem--tagDeselectItem__name",
	icon: "h-selectItems-tagDeselectItem--tagDeselectItem__icon",
	dotContainer: "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer",
	dot: "h-selectItems-tagDeselectItem--tagDeselectItem__dot"
}, aa = class extends N {
	render() {
		let { item: e, onSelect: t, clearSearch: n, disabled: r, isLoading: i, ...a } = this.props, { name: o, color: s } = e, c = O(ia.root);
		return /* @__PURE__ */ j("div", {
			...a,
			className: c,
			children: [
				/* @__PURE__ */ A("div", {
					className: ia.dotContainer,
					children: /* @__PURE__ */ A("div", {
						className: ia.dot,
						style: { backgroundColor: s ?? void 0 }
					})
				}),
				/* @__PURE__ */ A("div", {
					className: ia.name,
					children: o
				}),
				r && /* @__PURE__ */ A("span", { children: "Deactivated" }),
				/* @__PURE__ */ A("button", {
					className: ia.icon,
					onClick: () => {
						t(e);
					},
					children: /* @__PURE__ */ A(u, { name: "close" })
				})
			]
		});
	}
}, oa = {
	root: "h-chip--chip__root",
	rootLight: "h-chip--chip__rootLight",
	rootNoBorder: "h-chip--chip__rootNoBorder",
	rootDisabled: "h-chip--chip__rootDisabled",
	rootInteractable: "h-chip--chip__rootInteractable"
}, sa = ({ className: e, children: t, onClick: n, light: r, noBorder: i, disabled: o, ...s }) => {
	let c = O({
		[oa.root]: !0,
		[oa.rootLight]: r,
		[oa.rootNoBorder]: i,
		[oa.rootDisabled]: o,
		[oa.rootInteractable]: typeof n == "function" && !o
	}, e), l = typeof n == "function" ? "button" : "div";
	return /* @__PURE__ */ A(a, {
		...s,
		as: l,
		className: c,
		onClick: n,
		children: t
	});
}, ca = {
	tag: "h-tag--tag__tag",
	tagLight: "h-tag--tag__tagLight",
	tagNoBorder: "h-tag--tag__tagNoBorder",
	tagDisabled: "h-tag--tag__tagDisabled",
	tagName: "h-tag--tag__tagName",
	tagNameTruncated: "h-tag--tag__tagNameTruncated",
	icon: "h-tag--tag__icon",
	deleteButton: "h-tag--tag__deleteButton",
	deleteButtonDisabled: "h-tag--tag__deleteButtonDisabled",
	deleteIcon: "h-tag--tag__deleteIcon"
}, la = ({ className: e, tagNameClassName: t, children: n, onDelete: r, color: i, light: a, noBorder: o, noTruncation: c = !1, disabled: l, ...d }) => {
	let f = O({
		[ca.tagName]: !0,
		[ca.tagNameTruncated]: !c
	}, t), p = O(ca.deleteButton, { [ca.deleteButtonDisabled]: l });
	return /* @__PURE__ */ j(sa, {
		...d,
		className: e,
		light: a,
		noBorder: o,
		disabled: l,
		children: [
			i && /* @__PURE__ */ A("span", {
				className: ca.icon,
				style: { backgroundColor: s(i) ?? void 0 }
			}),
			/* @__PURE__ */ A("span", {
				className: f,
				children: n
			}),
			!!r && !l && /* @__PURE__ */ A("button", {
				className: p,
				type: "button",
				onClick: r,
				children: /* @__PURE__ */ A(u, {
					name: "close",
					className: ca.deleteIcon
				})
			})
		]
	});
}, Y = {
	root: "h-select--select__root",
	rootDisabled: "h-select--select__rootDisabled",
	inputWrapper: "h-select--select__inputWrapper",
	control: "h-select--select__control",
	rootHasIcon: "h-select--select__rootHasIcon",
	selection: "h-select--select__selection",
	selectionItem: "h-select--select__selectionItem",
	tag: "h-select--select__tag",
	tagName: "h-select--select__tagName",
	tagLimiter: "h-select--select__tagLimiter",
	text: "h-select--select__text",
	rootSearchable: "h-select--select__rootSearchable",
	rootDropdownOpen: "h-select--select__rootDropdownOpen",
	rootIsSearching: "h-select--select__rootIsSearching",
	search: "h-select--select__search",
	rootSingle: "h-select--select__rootSingle",
	indicators: "h-select--select__indicators",
	spinner: "h-select--select__spinner",
	clearIndicator: "h-select--select__clearIndicator",
	dropdownIndicator: "h-select--select__dropdownIndicator",
	dropdown: "h-select--select__dropdown",
	dropdownFixed: "h-select--select__dropdownFixed",
	pagination: "h-select--select__pagination"
}, ua = class e extends N {
	static contextType = tt;
	controlRef;
	searchRef;
	listRef;
	static defaultProps = {
		id: ji("select"),
		selectedItems: [],
		disabledItems: [],
		itemComponent: Wi,
		emptyComponent: Hi,
		emptyMessage: "No options",
		placeholder: "",
		disabled: !1,
		loading: !1,
		multiple: !1,
		searchable: !1,
		clearable: !1,
		keepOpen: !1,
		hideSelectedItems: !1,
		hasDropDownIndicator: !0
	};
	constructor(t) {
		super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = P(), this.searchRef = P(), this.listRef = P();
		let n = this.initSelectedItems(), r = this.initHighlightedIndex(n);
		this.state = {
			dropdownOpen: !1,
			search: "",
			selectedItems: n,
			highlightedIndex: r
		}, !e.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn("SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"), e.isSuggestionComponentWarningShown = !0);
	}
	componentDidUpdate(e, t) {
		let { dropdownOpen: n } = this.state;
		if (n !== t.dropdownOpen) if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
			this.searchRef.current?.focus();
			let e = this.initHighlightedIndex();
			this.highlightIndex(e, "auto");
		} else this.searchRef.current?.blur();
		Ai(e.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
	}
	componentWillUnmount() {
		let { dropdownOpen: e } = this.state;
		e && (this.context ?? window).removeEventListener("click", this.handleClickOutside);
	}
	static isSuggestionComponentWarningShown = !1;
	get a11y() {
		let { id: e } = this.props, { highlightedIndex: t } = this.state, n = `${e}-label`, r = `${e}-dropdown`;
		return {
			label: n,
			dropdown: r,
			option: t === null ? "" : `${r}-option-${t}`
		};
	}
	isItemIdType(e) {
		return typeof e == "string" || typeof e == "number";
	}
	initSelectedItems() {
		let { selectedItems: e = [] } = this.props;
		return e.map(this.resolveItem).filter(Boolean);
	}
	initHighlightedIndex(e = this.state.selectedItems) {
		let { multiple: t, items: n, hideSelectedItems: r } = this.props;
		if (!t && !r && e.length) {
			let t = this.resolveItem(e[0]);
			return n.indexOf(t);
		}
		return null;
	}
	resolveItem(e) {
		return this.isItemIdType(e) ? this.props.items.find((t) => t.id === e) : e;
	}
	resetSearch() {
		this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
	}
	handleSearch(e) {
		let { onSearch: t } = this.props, { value: n } = e.target;
		this.setState({ search: n }, () => {
			t?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
		});
	}
	handleDropdown(e = "toggle") {
		let { dropdownOpen: t } = this.state, { keepOpen: n, onToggle: r } = this.props;
		if (n) return this.setState({ dropdownOpen: !0 });
		if (e === "toggle") return r?.(!t), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !t });
		if (e === "open") return r?.(!0), this.setState({ dropdownOpen: !0 });
		if (e === "close" && t) return r?.(!1), this.controlRef.current?.blur(), this.setState({
			dropdownOpen: !1,
			search: ""
		});
	}
	handleClickOutside(e) {
		if (!this.controlRef || !(e.target instanceof Node)) return;
		let t = this.controlRef.current, { target: n } = e;
		n && n !== t && !t?.contains(n) && this.handleDropdown("close");
	}
	highlightIndex(e, t = "smooth") {
		this.setState({ highlightedIndex: e }, () => {
			e === null || e === -1 || (this.listRef.current?.listRef.current?.children ?? [])[e]?.scrollIntoView({
				behavior: t,
				block: "nearest",
				inline: "start"
			});
		});
	}
	handleKeyDown(e) {
		let { search: t, dropdownOpen: n, highlightedIndex: r, selectedItems: i } = this.state, { multiple: a, hideSelectedItems: o } = this.props, s = this.getAvailableItems(), c = e.key === "Escape", l = e.key === "Enter", u = e.key === "ArrowUp", d = e.key === "ArrowDown", f = e.key === "Backspace";
		if ((l || u || d) && e.preventDefault(), d && !n) return e.preventDefault(), this.handleDropdown("open");
		if (c && (n && e.stopPropagation(), this.handleDropdown("close")), f && a && !t) {
			let e = i[i.length - 1];
			e && this.handleRemove(e);
		}
		if (this.hasSuggestionComponent()) {
			if (d && (r === null || r === s.length - 1 || r === 0 && s.length === 0) || u && r === 0) return this.highlightIndex(-1);
			if (l && r === -1) {
				this.props.onSuggest?.(t), this.resetSearch();
				return;
			}
		}
		if (d && r === null) return this.highlightIndex(0);
		if (r !== null) {
			if (d && r === s.length - 1) return this.highlightIndex(0);
			if (d) return this.highlightIndex(r + 1);
			if (u && r > 0) return this.highlightIndex(r - 1);
			if (u && r <= 0) return this.highlightIndex(s.length - 1);
			if (l) {
				let e = s[r], t = e && this.isItemDisabled(e);
				if (e && !t) {
					this.handleSelect(e);
					let t = Math.min(o ? r : r + 1, s.length - 2);
					this.highlightIndex(t);
				}
			}
		}
	}
	handleSelect(e) {
		let { multiple: t, keepOpen: n, onSelect: r } = this.props;
		if (t) {
			let t = this.isItemSelected(e);
			this.handleChange(e, !t);
		} else this.setState({
			selectedItems: [e],
			dropdownOpen: n ?? !1
		}), this.resetSearch(), r?.(e);
	}
	handleChange(e, t) {
		let { onChange: n } = this.props, { selectedItems: r } = this.state;
		this.setState({ selectedItems: t ? [...r, e] : r.filter((t) => t.id !== e.id) }), this.resetSearch(), n?.(e, t);
	}
	handleRemove(e, t) {
		t && (t.preventDefault(), t.stopPropagation()), this.handleChange(e, !1);
	}
	handleClear(e) {
		e.stopPropagation();
		let { onClear: t } = this.props;
		t?.(), this.setState({ selectedItems: [] });
	}
	handleDropdownClick(e) {
		e.stopPropagation();
	}
	getPlaceholder() {
		return this.state.selectedItems.length ? "" : this.props.placeholder;
	}
	getInputSize() {
		return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
	}
	getItemName(e) {
		return e.name.toString().trim();
	}
	getAvailableItems() {
		let { search: e } = this.state, { items: t, hideSelectedItems: n, onSearch: r, searchBy: i } = this.props, a = new RegExp(ki(e), "i");
		return t.filter((t) => {
			let o = [];
			return e && !r && (i && typeof i == "function" ? o.push(i(t, e)) : i && i instanceof Array ? o.push(i.some((e) => {
				let n = t[e];
				return (typeof n == "string" || typeof n == "number") && a.test(n.toString().trim());
			})) : o.push(a.test(this.getItemName(t)))), n && o.push(!this.isItemSelected(t)), o.every((e) => e);
		});
	}
	isItemSelected(e) {
		return this.state.selectedItems.some((t) => t.id === e.id);
	}
	isItemDisabled(e) {
		return this.props.disabledItems?.includes(e.id);
	}
	isEmpty() {
		return this.state.selectedItems.length === 0;
	}
	hasSuggestionComponent(e) {
		return !!this.state.search && typeof this.props.suggestionComponent == "function";
	}
	renderHiddenItems() {
		let { limit: e } = this.props, { selectedItems: t } = this.state;
		if (e && e > 0) return /* @__PURE__ */ A(G, {
			flexDirection: "column",
			children: t?.slice(e).map((e) => /* @__PURE__ */ j(G, {
				alignItems: "center",
				justifyContent: "space-between",
				"data-testid": "select-hidden-item",
				children: [/* @__PURE__ */ A(a, {
					margin: "0 400 0 0",
					children: this.getItemName(e)
				}), /* @__PURE__ */ A(h, {
					icon: "close",
					variant: "tertiary",
					onClick: (t) => this.handleRemove(e, t)
				})]
			}, e.id))
		});
	}
	renderSelection(e) {
		return this.props.renderSelection?.(e) ?? this.getItemName(e);
	}
	renderMultipleSelection() {
		let { selectedItems: e } = this.state, t = this.props.limit || e.length, n = t < e.length, r = e?.slice(0, t).map((e) => {
			let t = this.renderSelection(e);
			return /* @__PURE__ */ A("div", {
				onClick: (e) => e.stopPropagation(),
				"data-testid": "select-selection",
				className: Y.selectionItem,
				children: /* @__PURE__ */ A(la, {
					className: Y.tag,
					tagNameClassName: Y.tagName,
					onDelete: (t) => this.handleRemove(e, t),
					color: e.color,
					noTruncation: !0,
					"data-testid": "select-tag",
					children: t
				})
			}, e.id);
		});
		return /* @__PURE__ */ j(k, { children: [r, n && /* @__PURE__ */ A("div", {
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ A(U, {
				content: this.renderHiddenItems(),
				requireClick: !0,
				"data-testid": "select-limiter",
				light: !0,
				children: /* @__PURE__ */ j(la, {
					className: O(Y.tag, Y.tagLimiter),
					noTruncation: !0,
					children: ["+", e.length - t]
				})
			})
		})] });
	}
	renderSingleSelection() {
		let { search: e, selectedItems: t } = this.state, n = t[0];
		return n ? /* @__PURE__ */ A("span", {
			className: Y.text,
			"aria-hidden": !!e,
			"data-testid": "select-selection",
			children: this.renderSelection(n)
		}) : /* @__PURE__ */ A("span", {
			style: { width: 0 },
			"data-testid": "select-selection-empty",
			children: "\xA0"
		});
	}
	renderSearch() {
		let { searchable: e } = this.props;
		return !e && !this.isEmpty() ? null : /* @__PURE__ */ A("input", {
			className: Y.search,
			ref: this.searchRef,
			tabIndex: -1,
			onFocus: (e) => e.stopPropagation(),
			value: this.state.search,
			size: this.getInputSize(),
			onChange: this.handleSearch,
			placeholder: this.getPlaceholder(),
			autoComplete: "off",
			readOnly: !e,
			"aria-autocomplete": "list",
			"aria-controls": this.a11y.dropdown,
			"aria-labelledby": this.a11y.label,
			"data-testid": "select-input"
		});
	}
	renderDropdown() {
		let { dropdownOpen: e, highlightedIndex: t, search: n } = this.state, { disabledItems: r, tooltipItems: i, emptyComponent: a, suggestionComponent: o, emptyMessage: s, pagination: c, dropdownProps: l, searchSuggestion: u, renderSuggestion: d, onSuggest: f, multiple: p } = this.props, m = O({
			[Y.dropdown]: !0,
			[Y.dropdownFixed]: l?.fixed ?? !1
		}, l?.className), h = this.getAvailableItems(), _ = h[t ?? -1] ?? null, v = !h.length;
		return /* @__PURE__ */ j(hn, {
			onClick: this.handleDropdownClick,
			...l,
			className: m,
			isOpen: e,
			"data-testid": "select-dropdown",
			children: [
				v && typeof a == "function" && /* @__PURE__ */ A(a, {
					label: s ?? "No options",
					"data-testid": "select-dropdown-empty"
				}),
				this.hasSuggestionComponent(o) && /* @__PURE__ */ A(o, {
					searched: n,
					onSuggest: f,
					triggerClose: p ? void 0 : () => this.handleDropdown("close"),
					items: h,
					active: t === -1,
					clearSearch: this.resetSearch,
					searchSuggestion: u,
					renderSuggestion: d
				}),
				!v && /* @__PURE__ */ A(Ri, {
					id: this.a11y.dropdown,
					ariaLabelledby: this.a11y.label,
					ref: this.listRef,
					pagination: c,
					items: h,
					clearSearch: this.resetSearch,
					onSelect: this.handleSelect,
					onChange: this.handleChange,
					onKeyDown: this.handleKeyDown,
					selectedItems: this.state.selectedItems,
					disabledItems: r,
					tooltipItems: i,
					activeItem: _,
					itemComponent: this.props.itemComponent
				}),
				!!c && !c.infinite && /* @__PURE__ */ j("div", {
					className: Y.pagination,
					"data-testid": "select-dropdown-pagination",
					children: [/* @__PURE__ */ A(g, {
						variant: "secondary",
						disabled: !c.previousEnable,
						onClick: c.onPrevious,
						children: "Prev page"
					}), /* @__PURE__ */ A(g, {
						variant: "secondary",
						disabled: !c.nextEnable,
						onClick: c.onNext,
						children: "Next page"
					})]
				})
			]
		});
	}
	render() {
		let { className: e, disabled: t, hasDropDownIndicator: i, loading: a, multiple: o, searchable: s, clearable: c, prefix: l, suffix: u, icon: d, status: f } = this.props, { search: p, dropdownOpen: m } = this.state, g = O({
			[Y.root]: !0,
			[Y.rootSingle]: !o,
			[Y.rootDisabled]: t,
			[Y.rootSearchable]: s,
			[Y.rootDropdownOpen]: m,
			[Y.rootIsSearching]: !!p,
			[Y.rootHasIcon]: !!d
		}, e), _ = p ? void 0 : () => this.handleDropdown("toggle");
		return /* @__PURE__ */ j("div", {
			className: g,
			role: "combobox",
			"aria-expanded": m,
			"aria-owns": this.a11y.dropdown,
			"aria-haspopup": "listbox",
			"data-testid": "select-root",
			children: [/* @__PURE__ */ A(n, {
				prefix: l,
				suffix: u,
				icon: d,
				status: f,
				active: m,
				disabled: t,
				className: Y.inputWrapper,
				children: /* @__PURE__ */ j("div", {
					className: Y.control,
					ref: this.controlRef,
					onKeyDown: this.handleKeyDown,
					onClick: _,
					tabIndex: t ? -1 : 0,
					"aria-activedescendant": this.a11y.option,
					"data-testid": "select-control",
					children: [/* @__PURE__ */ j("div", {
						className: Y.selection,
						children: [o ? this.renderMultipleSelection() : this.renderSingleSelection(), this.renderSearch()]
					}), /* @__PURE__ */ j("div", {
						className: Y.indicators,
						children: [
							a && /* @__PURE__ */ A(r, {
								className: Y.spinner,
								size: 16,
								"aria-label": "Loading",
								"data-testid": "select-loading"
							}),
							!this.isEmpty() && c && /* @__PURE__ */ A(h, {
								tabIndex: -1,
								className: Y.clearIndicator,
								icon: "close",
								variant: "tertiary",
								onClick: this.handleClear,
								"aria-label": "Clear",
								"data-testid": "select-clear"
							}),
							i && /* @__PURE__ */ A(h, {
								tabIndex: -1,
								className: Y.dropdownIndicator,
								icon: m ? "angle-up" : "angle-down",
								variant: "tertiary",
								onClick: (e) => {
									e.stopPropagation(), this.handleDropdown("toggle");
								},
								"aria-label": m ? "Close" : "Open",
								"data-testid": "select-toggle"
							})
						]
					})]
				})
			}), !t && m && this.renderDropdown()]
		});
	}
};
function da(e) {
	return /* @__PURE__ */ A(pt, {
		fallback: /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(i.Paragraph, {
			variant: "2",
			children: "Something went wrong"
		}) }),
		children: /* @__PURE__ */ A(ua, { ...e })
	});
}
var fa = {
	root: "h-datePicker-timezoneSelector--timezoneSelector__root",
	label: "h-datePicker-timezoneSelector--timezoneSelector__label"
}, pa = ({ disabled: e, tooltipProps: t, selectedTimezone: n, onChange: r }) => {
	let i = H.tz.guess(!0), a = L((e, t) => {
		let [n, r] = H.tz(e).format("Z").split(":"), [i, a] = H.tz(t).format("Z").split(":");
		return parseInt(n) * 60 + parseInt(r) - (parseInt(i) * 60 + parseInt(a));
	}, []), o = (e) => `(GMT${H.tz(e).format("Z")})`, s = (e) => `${o(e)} ${e}`, c = z(() => {
		let e = H.tz.names().filter((e) => e !== i);
		return [{
			id: i,
			name: `Default ${o(i)}`
		}, ...e.sort(a).map((e) => ({
			id: e,
			name: s(e)
		}))];
	}, [a]), l = ({ id: e }) => {
		r(e);
	};
	return /* @__PURE__ */ j("div", {
		className: fa.root,
		children: [/* @__PURE__ */ A(Oi, {
			className: fa.label,
			children: "Time zone"
		}), /* @__PURE__ */ A(U, {
			...t,
			side: "top",
			children: /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(da, {
				disabled: e,
				items: c,
				onSelect: l,
				selectedItems: [li(n) ? n : i],
				searchable: !0
			}) })
		})]
	});
}, ma = {
	root: "h-fieldAlert--fieldAlert__root",
	alert: "h-fieldAlert--fieldAlert__alert",
	icon: "h-fieldAlert--fieldAlert__icon"
}, ha = { root: "h-fieldAlert-fieldAlertButton--fieldAlertButton__root" };
//#endregion
//#region src/components/fieldAlert/fieldAlertButton/fieldAlertButton.tsx
function ga({ className: e, variant: t = "tertiary", ...n }) {
	return /* @__PURE__ */ A(g, {
		...n,
		variant: t,
		className: O(e, ha.root)
	});
}
//#endregion
//#region src/components/fieldAlert/fieldAlert.tsx
var _a = {
	error: "exclamation-circle-filled",
	warning: "exclamation-triangle-filled",
	success: "check-circle-filled",
	title: null
};
function va({ children: e, className: t, ...n }) {
	let r = n.variant || "title", a = O(ma.root, t), [o, s] = V(!1), c = _a[r], l = L((e) => {
		if (!e) return;
		let { offsetWidth: t, scrollWidth: n } = e;
		s(t < n);
	}, [e]);
	return /* @__PURE__ */ j(i.Input, {
		...n,
		variant: r,
		className: a,
		children: [!!c && /* @__PURE__ */ A(u, {
			className: ma.icon,
			name: c
		}), /* @__PURE__ */ A("div", {
			className: ma.alert,
			ref: l,
			children: o ? /* @__PURE__ */ A(U, {
				content: e,
				children: e
			}) : e
		})]
	});
}
va.Button = ga;
//#endregion
//#region src/components/timePicker/single/timePicker.tsx
var ya = "hmm A", ba = (e, t) => `${`${e}`.padStart(2, "0")}:${`${t}`.padStart(2, "0")}`, xa = (e, t) => ({
	id: ba(e.hours(), e.minutes()),
	name: e.format(t)
}), Sa = ({ hasDropDownIndicator: e = !0, allowCustomTimeInput: t = !1, timeOptions: n, overrides: r, selectedItems: i, selectableHours: a = pi, selectableMinutes: o = mi, timeFormat: s = H.localeData().longDateFormat("LT"), onSelect: c, onIsCustomTimeValid: l, ...u }) => {
	let [d] = i || [], [f, p] = V(() => typeof d == "object" ? d?.id : d || null), [m, h] = V(""), g = z(() => n || bi({
		hours: a,
		minutes: o,
		overrides: r,
		timeFormat: s
	}), [
		n,
		a,
		o,
		r,
		s
	]), _ = z(() => {
		let e = H(m || (typeof d == "object" ? d.id : d) || f, [s, ya]);
		if (!e.isValid()) return null;
		let t = e.hours(), n = e.minutes();
		if (!l || l(t, n)) return xa(e, s);
		let r = t <= 12, i = t + 12, a = l(i, n);
		return r && a ? xa(H({
			hours: i,
			minutes: n
		}), s) : null;
	}, [d, m]), v = z(() => {
		if (!t) return g;
		let e = f ? g.filter(({ name: e }) => e !== _?.name) : g.filter(({ name: e }) => e.startsWith(m) && e !== _?.name);
		if (!_) return e;
		let n = f === _.id ? e.findIndex((e) => H(e.id, [s]) > H(_.id, [s])) : 0;
		return e.splice(n === -1 ? e.length : n, 0, _), e;
	}, [
		_,
		m,
		f,
		g
	]), y = L((e) => {
		e?.id !== _?.id && h(""), c(e?.id || null), p(e?.id || null);
	}, [_]);
	return R(() => {
		d ? (h(""), p(typeof d == "object" ? d.id : d)) : p(null);
	}, [d]), /* @__PURE__ */ A(ua, {
		searchable: !0,
		placeholder: hi(s),
		...u,
		selectedItems: i,
		hasDropDownIndicator: e,
		items: t ? v : g,
		onChange: K,
		onClear: y,
		onSelect: y,
		...t && { onSearch: h }
	});
}, Ca = {
	root: "h-timePicker-range--timeRangePicker__root",
	timePickerFrom: "h-timePicker-range--timeRangePicker__timePickerFrom",
	timePickerTo: "h-timePicker-range--timeRangePicker__timePickerTo",
	arrowContainer: "h-timePicker-range--timeRangePicker__arrowContainer",
	arrowContainerHasError: "h-timePicker-range--timeRangePicker__arrowContainerHasError",
	arrowContainerHasWarning: "h-timePicker-range--timeRangePicker__arrowContainerHasWarning",
	arrowContainerHasSuccess: "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess"
}, wa = ({ className: e, disabled: t, endTime: n, onSelect: r, overrides: i, placeholder: o, selectableHours: s = pi, selectableMinutes: c = mi, status: l, startTime: d, allowCustomTimeInput: f = !1, timeFormat: p = H.localeData().longDateFormat("LT"), ...m }) => {
	let [{ startTime: h, endTime: g }, _] = V({
		startTime: d || null,
		endTime: n || null
	}), v = z(() => bi({
		hours: s,
		minutes: c,
		overrides: i,
		timeFormat: p
	}), [
		s,
		c,
		i,
		p
	]), y = z(() => {
		let e = v.map(({ id: e }) => H(e, [p])), t = H(h, [p]), n = h && e.findIndex((e) => e > t) || 0;
		return v.slice(n);
	}, [
		v,
		h,
		p
	]);
	R(() => {
		let e = typeof d == "string", t = typeof d == "string";
		(e && d !== h || t && n !== g) && _((r) => ({
			...r,
			...e && { startTime: d },
			...t && { endTime: n }
		}));
	});
	let b = L((e) => (t) => void _((n) => {
		let i = H(t, [p]), a = H(n.startTime, [p]), o = H(n.endTime, [p]), s = v.map(({ id: e }) => H(e, [p])), c = s.findIndex((e) => e >= i) || -1, l = e === "startTime" ? c : s.findIndex((e) => e >= a), u = e === "endTime" ? -1 : s.findIndex((e) => e >= o), d = {
			...n,
			[e]: t,
			...n.endTime !== null && e !== "endTime" && l >= u && { endTime: v[c + 1]?.id || null }
		};
		return r(d), d;
	}), [r]), x = L((e, t) => {
		let n = H(h, [p]);
		if (!n.isValid()) return !0;
		let r = n.hours(), i = n.minutes();
		return r < e || r === e && i < t;
	}, [h, p]), S = (e) => o?.[e] || o || hi(p);
	return /* @__PURE__ */ j(a, {
		className: O(Ca.root, e),
		children: [
			/* @__PURE__ */ A(Sa, {
				className: Ca.timePickerFrom,
				searchable: !0,
				...m,
				disabled: t,
				hasDropDownIndicator: !1,
				timeOptions: v,
				onSelect: b("startTime"),
				placeholder: S("startTime"),
				allowCustomTimeInput: f,
				selectedItems: h ? [h] : [],
				status: l
			}),
			/* @__PURE__ */ A(a, {
				className: O(Ca.arrowContainer, {
					[Ca.arrowContainerHasError]: l === "error",
					[Ca.arrowContainerHasWarning]: l === "warning",
					[Ca.arrowContainerHasSuccess]: l === "success"
				}),
				children: /* @__PURE__ */ A(u, { name: "arrow-right" })
			}),
			/* @__PURE__ */ A(Sa, {
				className: Ca.timePickerTo,
				searchable: !0,
				disabled: t || !h,
				...m,
				hasDropDownIndicator: !1,
				timeOptions: y,
				onSelect: b("endTime"),
				placeholder: S("endTime"),
				...f && {
					allowCustomTimeInput: f,
					onIsCustomTimeValid: x
				},
				selectedItems: g ? [g] : [],
				status: l
			})
		]
	});
}, Ta = class e {
	dateFormat;
	dateParser;
	dateRangeConstraint;
	static validationOK = {
		isValid: !0,
		error: null
	};
	constructor(e, t, n) {
		this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n, this.dateFormat = e, this.dateParser = t, this.dateRangeConstraint = n;
	}
	isValidDate(e) {
		try {
			return this.dateParser(e).isValid();
		} catch {
			return !1;
		}
	}
	isSingleDateValid(t) {
		if (!this.isValidDate(t)) return {
			isValid: !1,
			error: "Date is not valid"
		};
		let { minDate: n, maxDate: r } = this.dateRangeConstraint, i = this.dateParser(t);
		return i.isBefore(n, "day") ? {
			isValid: !1,
			error: `Date must be after ${n.format(this.dateFormat)}`
		} : i.isAfter(r, "day") ? {
			isValid: !1,
			error: `Date must be before ${r.format(this.dateFormat)}`
		} : e.validationOK;
	}
	isStartDateValid({ startDateInputValue: t, endDateInputValue: n }) {
		let { minDate: r, maxDate: i } = this.dateRangeConstraint;
		if (!this.isValidDate(t)) return {
			isValid: !1,
			error: "From date is not valid"
		};
		let a = this.dateParser(t), o = this.dateParser(n);
		return a.isBefore(r, "day") ? {
			isValid: !1,
			error: `From date must be after ${r.format(this.dateFormat)}`
		} : n && this.isValidDate(n) && a.isAfter(o, "day") ? {
			isValid: !1,
			error: `From date must be before ${o.format(this.dateFormat)}`
		} : a.isAfter(i, "day") ? {
			isValid: !1,
			error: `From date must be before ${i.format(this.dateFormat)}`
		} : e.validationOK;
	}
	isEndDateValid({ startDateInputValue: t, endDateInputValue: n }) {
		let { minDate: r, maxDate: i } = this.dateRangeConstraint;
		if (!this.isValidDate(n)) return {
			isValid: !1,
			error: "To date is not valid"
		};
		let a = this.dateParser(t), o = this.dateParser(n);
		return o.isAfter(i, "day") ? {
			isValid: !1,
			error: `To date must be before ${i.format(this.dateFormat)}`
		} : t && this.isValidDate(t) && o.isBefore(a, "day") ? {
			isValid: !1,
			error: `To date must be after ${a.format(this.dateFormat)}`
		} : o.isBefore(r, "day") ? {
			isValid: !1,
			error: `To date must be after ${r.format(this.dateFormat)}`
		} : e.validationOK;
	}
	isTimeOrderValid({ startDate: t, endDate: n }) {
		return !t || !n ? e.validationOK : t.isAfter(n) ? {
			isValid: !1,
			error: "From time should be before to time"
		} : e.validationOK;
	}
}, Ea = {
	root: "h-datePicker-range-inputFields--dateRangePickerInputFields__root",
	rootPlacementTop: "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop",
	rootPlacementTopWithTimezoneSelector: "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector",
	rootPlacementBottom: "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom",
	fields: "h-datePicker-range-inputFields--dateRangePickerInputFields__fields",
	input: "h-datePicker-range-inputFields--dateRangePickerInputFields__input",
	alert: "h-datePicker-range-inputFields--dateRangePickerInputFields__alert"
};
Array(24).fill(0).map((e, t) => t);
var Da = class e extends N {
	dateRangeValidators;
	timeOptions;
	instanceId;
	constructor(t) {
		super(t);
		let { dateFormat: n } = t;
		this.state = {
			startDateInputValue: this.props.startDate?.format(n) ?? "",
			startDateError: null,
			endDateInputValue: this.props.endDate?.format(n) ?? "",
			endDateError: null,
			timeOrderError: null
		}, this.timeOptions = [], this.instanceId = e.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Ta(t.dateFormat, this.parseDateString, {
			maxDate: t.maxDate,
			minDate: t.minDate
		});
	}
	componentDidUpdate(e) {
		this.syncStartDateWithProps(e), this.syncEndDateWithProps(e), this.validateTimesOrder();
	}
	static instanceCount = 0;
	validateTimesOrder() {
		let { startDate: e, endDate: t } = this.props, { isValid: n, error: r } = this.dateRangeValidators.isTimeOrderValid({
			startDate: e,
			endDate: t
		});
		n ? this.setState({ timeOrderError: null }) : this.setState({ timeOrderError: r });
	}
	syncEndDateWithProps(e) {
		let { endDate: t, timeRoundingStrategy: n } = this.props;
		if (!(t === e.endDate || t?.isSame(e.endDate, n))) return this.props.endDate ? this.setState({
			endDateError: null,
			endDateInputValue: this.props.endDate.format(this.props.dateFormat)
		}) : this.setState({
			endDateError: null,
			endDateInputValue: ""
		});
	}
	syncStartDateWithProps(e) {
		let { startDate: t, timeRoundingStrategy: n } = this.props;
		if (!(t === e.startDate || t?.isSame(e.startDate, n))) return this.props.startDate ? this.setState({
			startDateError: null,
			startDateInputValue: this.props.startDate.format(this.props.dateFormat)
		}) : this.setState({
			startDateError: null,
			startDateInputValue: ""
		});
	}
	handleInputValueChange(e, t) {
		let n = e.target.value;
		switch (t) {
			case "startDate":
				this.setState({ startDateInputValue: this.ensureValidChars(n) }, this.propagateStartDateChangeEvent);
				break;
			case "endDate":
				this.setState({ endDateInputValue: this.ensureValidChars(n) }, this.propagateEndDateChangeEvent);
				break;
		}
	}
	propagateStartDateChangeEvent() {
		let { startDateInputValue: e, endDateInputValue: t } = this.state;
		if (e === "") {
			this.props.onStartDateChange(null);
			return;
		}
		let { isValid: n, error: r } = this.dateRangeValidators.isStartDateValid({
			startDateInputValue: e,
			endDateInputValue: t
		});
		if (!n) {
			this.setState({ startDateError: r });
			return;
		}
		let { isValid: i, error: a } = this.dateRangeValidators.isEndDateValid({
			startDateInputValue: e,
			endDateInputValue: t
		}), o = t !== "" && !i ? a : null;
		this.setState({
			startDateError: null,
			endDateError: o
		}, () => this.props.onStartDateChange(this.parseDateString(e)));
	}
	propagateEndDateChangeEvent() {
		let { startDateInputValue: e, endDateInputValue: t } = this.state;
		if (t === "") {
			this.props.onEndDateChange(null);
			return;
		}
		let { isValid: n, error: r } = this.dateRangeValidators.isEndDateValid({
			startDateInputValue: e,
			endDateInputValue: t
		});
		if (!n) {
			this.setState({ endDateError: r });
			return;
		}
		let { isValid: i, error: a } = this.dateRangeValidators.isStartDateValid({
			startDateInputValue: e,
			endDateInputValue: t
		}), o = e !== "" && !i ? a : null;
		this.setState({
			endDateError: null,
			startDateError: o
		}, () => this.props.onEndDateChange(this.parseDateString(t)));
	}
	parseDateString(e) {
		return H(e, this.props.dateFormat, !0);
	}
	ensureValidChars(e) {
		return e.replace(/[^0-9/]/g, "");
	}
	getOverrides(e) {
		if (e !== "startTime") return [{
			hour: 23,
			minute: 59
		}];
	}
	renderFields(e, t, n, r, i, a, o) {
		let { dateFormat: s, disabled: l, focusedInput: u, onFocusChange: d, onTimeChange: f, timeFormat: p, withTimePicker: m, withDateInput: h } = this.props, { timeOrderError: g } = this.state;
		return /* @__PURE__ */ j("div", { children: [
			/* @__PURE__ */ A(Oi, { children: e === "startDate" ? "From" : "To" }),
			h && /* @__PURE__ */ A(c, {
				className: Ea.input,
				placeholder: s.toLowerCase(),
				name: `input__${e}__${this.instanceId}`,
				value: i,
				onChange: (t) => this.handleInputValueChange(t, e),
				onFocus: () => d(e),
				autoComplete: "off",
				status: a ? "error" : void 0,
				disabled: l,
				active: u === e
			}),
			m && /* @__PURE__ */ A("div", {
				className: Ea.input,
				children: /* @__PURE__ */ A(U, {
					content: "Please select a date first.",
					disabled: !!n || l,
					side: "right",
					children: /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(Sa, {
						disabled: !n,
						overrides: this.getOverrides(t),
						selectedItems: r ? [r] : void 0,
						status: g ? "error" : void 0,
						...o,
						timeFormat: p,
						onSelect: (e) => f(t, e)
					}) })
				})
			})
		] });
	}
	getError() {
		let { startDateError: e, endDateError: t, timeOrderError: n } = this.state;
		return e || t || n || null;
	}
	renderErrors() {
		let e = this.getError();
		return /* @__PURE__ */ A(va, {
			className: Ea.alert,
			variant: e ? "error" : void 0,
			children: e
		});
	}
	render() {
		let { startDate: e, startTime: t, endDate: n, endTime: r, timePickerProps: i = {
			start: {},
			end: {}
		}, hasTimezoneSelector: a } = this.props, { startDateInputValue: o, startDateError: s, endDateInputValue: c, endDateError: l } = this.state, { placement: u } = this.props;
		return /* @__PURE__ */ j("div", {
			className: O(Ea.root, {
				[Ea.rootPlacementTop]: u === "top",
				[Ea.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
				[Ea.rootPlacementBottom]: u === "bottom"
			}),
			children: [/* @__PURE__ */ j("div", {
				className: Ea.fields,
				children: [this.renderFields("startDate", "startTime", e, t, o, s, i.start), this.renderFields("endDate", "endTime", n, r, c, l, i.end)]
			}), this.renderErrors()]
		});
	}
}, Oa = "dateRangePickerTestId", ka = class extends N {
	static defaultProps = {
		withDateInput: !0,
		withTimePicker: !1,
		timePickerProps: {
			start: {},
			end: {}
		},
		inputsPlacement: "bottom",
		timeRoundingStrategy: "day"
	};
	constructor(e) {
		super(e);
		let { startDate: t, endDate: n, timezone: r, presetKey: i, presets: a, focusedInput: o = "startDate" } = e;
		this.state = {
			startTime: t ? H(t).format(fi) : null,
			endTime: n ? H(n).format(fi) : null,
			timezone: li(r) ? r : H.tz.guess(!0),
			presetKey: a?.find(({ key: e }) => e === i)?.key ?? null,
			focusedInput: o,
			dateRangePickerKey: 0
		}, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
	}
	componentDidUpdate(e) {
		this.updateTimeOnDateChange(e), this.recalculateDatePickerKey(e), this.updateTimezoneFromProps(e), this.updatePresetKey(e);
	}
	visibleCalendarMonthRef = P();
	updatePresetKey(e) {
		let { presetKey: t } = this.props;
		e.presetKey !== t && this.setState({ presetKey: this.props.presets?.find(({ key: e }) => e === t)?.key ?? null });
	}
	updateTimezoneFromProps(e) {
		let { timezone: t } = this.props;
		e.timezone !== t && li(t) && this.setState({ timezone: t });
	}
	getDateConstraints() {
		let { maxDate: e, minDate: t } = this.props, n = this.dateFormat;
		return {
			minDate: t ? H(t, n) : H("0001-01-01"),
			maxDate: e ? H(e, n) : H("9999-12-31")
		};
	}
	onTimezoneChange(e) {
		let { startDate: t, endDate: n } = this.props, { presetKey: r } = this.state;
		this.setState({ timezone: e }, () => this.onDatesChange({
			startDate: t,
			endDate: n
		}, r));
	}
	onStartDateChange(e) {
		this.onDatesChange({
			startDate: e,
			endDate: this.props.endDate
		});
	}
	onEndDateChange(e) {
		this.onDatesChange({
			endDate: e,
			startDate: this.props.startDate
		});
	}
	onDatesChange(e, t = null) {
		let { startTime: n, endTime: r, timezone: i } = this.state, { timeRoundingStrategy: a } = this.props, o = this.addTimezoneToDate(e.startDate, i), s = this.addTimezoneToDate(e.endDate, i), c = o?.clone().startOf(a) || null, l = s?.clone().endOf(a) || null, u = e.startDate?.clone().startOf(a) || null, d = e.endDate?.clone().endOf(a) || null;
		if (this.setState({ presetKey: t }), t) {
			this.setState({
				startTime: e.startDate?.clone().startOf(a).format("HH:mm") ?? null,
				endTime: e.endDate?.clone().startOf(a).format("HH:mm") ?? null
			}, () => {
				this.props.onChange({
					startDate: c,
					localStartDate: u,
					endDate: l,
					localEndDate: d,
					timezone: i,
					localTimezone: H.tz.guess(!0),
					presetKey: t
				});
			});
			return;
		}
		n && (c = this.addTimeToDate(o, n, "startDate"), u = this.addTimeToDate(e.startDate, n, "startDate")), r && (l = this.addTimeToDate(s, r, "endDate"), d = this.addTimeToDate(e.endDate, r, "endDate")), this.props.onChange({
			startDate: c,
			localStartDate: u,
			endDate: l,
			localEndDate: d,
			timezone: i,
			localTimezone: H.tz.guess(!0)
		});
	}
	onPresetSelect(e) {
		if (!e) this.onDatesChange({
			startDate: null,
			endDate: null
		});
		else {
			let { startDate: t, endDate: n, key: r } = e;
			this.onDatesChange({
				startDate: t,
				endDate: n
			}, r);
		}
		this.handleFocusChange("startDate");
	}
	handleTimeChange(e, t) {
		let { startDate: n, endDate: r } = this.props;
		this.setState((n) => ({
			...n,
			[e]: t
		}), () => this.onDatesChange({
			startDate: n,
			endDate: r
		}));
	}
	addTimezoneToDate(e, t) {
		if (!e) return null;
		let { timeRoundingStrategy: n } = this.props;
		return li(t) ? e.clone().tz(t, !0) : e.clone().startOf(n);
	}
	handleFocusChange(e) {
		this.setState({ focusedInput: e ?? "startDate" });
	}
	addTimeToDate(e, t, n) {
		if (!e) return null;
		let { timeRoundingStrategy: r } = this.props, [i, a] = t.split(":");
		return !i || !a ? n === "startDate" ? e.clone().startOf(r) : e.clone().endOf(r) : e.clone().set({
			hours: parseInt(i, 10),
			minutes: parseInt(a, 10),
			seconds: 0,
			milliseconds: 0
		});
	}
	isDateOutsideOfSelectableRange(e) {
		if (this.props.disabled) return !0;
		let { timeRoundingStrategy: t } = this.props, { minDate: n, maxDate: r } = this.getDateConstraints();
		return !e.isBetween(n, r, t);
	}
	updateTimeOnDateChange({ startDate: e, endDate: t }) {
		let { startDate: n, endDate: r } = this.props;
		n?.isSame(e) || this.setState({ startTime: n ? H(n).format(fi) : null }), r?.isSame(t) || this.setState({ endTime: r ? H(r).format(fi) : null });
	}
	recalculateDatePickerKey({ startDate: e, endDate: t }) {
		let { startDate: n, endDate: r } = this.props;
		if (t && e && !n && !r) return this.setState({ dateRangePickerKey: this.generateRandomKey() });
		if (!(!r && !t) && !(!r && t)) {
			if (r && !t) {
				let e = this.visibleCalendarMonthRef.current?.state.currentMonth;
				if (this.visibleCalendarMonthRef.current && r.isSame(e, "month")) return;
				this.setState({ dateRangePickerKey: this.generateRandomKey() });
			}
			if (r && t) {
				if (r.isSame(t, "month")) return;
				this.setState({ dateRangePickerKey: this.generateRandomKey() });
			}
		}
	}
	generateRandomKey() {
		return Math.floor(Math.random() * 1e8);
	}
	get dateFormat() {
		let { dateFormat: e } = this.props;
		return e || H.localeData().longDateFormat("L");
	}
	renderTimezoneSelector() {
		let { startDate: e, endDate: t, disabled: n, withTimezoneSelector: r, timezoneSelectorProps: i } = this.props, { timezone: a } = this.state;
		if (!r) return null;
		let o = !!e || !!t, s = !o && !n;
		return /* @__PURE__ */ A(pa, {
			disabled: !o || n || i?.disabled,
			tooltipProps: {
				content: "Please select a date first",
				disabled: !s,
				...i?.tooltipProps
			},
			onChange: this.onTimezoneChange,
			selectedTimezone: a
		});
	}
	renderInputFields(e) {
		let { withDateInput: t, withTimePicker: n, withTimezoneSelector: r, timePickerProps: i, disabled: a, startDate: o, endDate: s, selectableMinutes: c, selectableHours: l, inputsPlacement: u, timeFormat: d, timeRoundingStrategy: f } = this.props;
		if (u !== e || !t && !n) return null;
		let { startTime: p, endTime: m, focusedInput: h } = this.state, { minDate: g, maxDate: _ } = this.getDateConstraints();
		return /* @__PURE__ */ A(Da, {
			dateFormat: this.dateFormat,
			timeFormat: d,
			onStartDateChange: this.onStartDateChange,
			onEndDateChange: this.onEndDateChange,
			onTimeChange: this.handleTimeChange,
			onFocusChange: this.handleFocusChange,
			startDate: o,
			endDate: s,
			startTime: p,
			endTime: m,
			minDate: g,
			maxDate: _,
			disabled: a,
			withDateInput: t,
			withTimePicker: n,
			hasTimezoneSelector: r,
			timePickerProps: i,
			selectableMinutes: c,
			selectableHours: l,
			placement: e,
			timeRoundingStrategy: f,
			focusedInput: h
		});
	}
	renderPresets() {
		let { presets: e } = this.props, { presetKey: t } = this.state;
		return e?.length ? /* @__PURE__ */ A(Ti, {
			value: t,
			presets: e,
			onSelect: this.onPresetSelect
		}) : null;
	}
	render() {
		let { className: e, calendarProps: t, disabled: n, startDate: r, endDate: i } = this.props, a = n ? () => /* @__PURE__ */ A("span", {}) : Si.previousMonth, o = n ? () => /* @__PURE__ */ A("span", {}) : Si.nextMonth;
		return /* @__PURE__ */ j("div", {
			"data-testid": Oa,
			className: O(xi.root, e),
			children: [/* @__PURE__ */ j(G, {
				flexDirection: "column",
				alignItems: "center",
				children: [
					this.renderTimezoneSelector(),
					this.renderInputFields("top"),
					/* @__PURE__ */ A(oi.DayPickerRangeController, {
						ref: this.visibleCalendarMonthRef,
						startDate: r,
						endDate: i,
						onDatesChange: this.onDatesChange,
						onFocusChange: this.handleFocusChange,
						focusedInput: this.state.focusedInput,
						isOutsideRange: this.isDateOutsideOfSelectableRange,
						numberOfMonths: 1,
						hideKeyboardShortcutsPanel: !0,
						noBorder: !0,
						renderDayContents: Ci,
						daySize: 32,
						minimumNights: 0,
						disabled: n,
						renderNavPrevButton: a,
						renderNavNextButton: o,
						renderMonthElement: wi,
						initialVisibleMonth: () => r || i || H(),
						transitionDuration: 0,
						...t
					}, this.state.dateRangePickerKey),
					this.renderInputFields("bottom")
				]
			}), this.renderPresets()]
		});
	}
}, Aa = {
	root: "h-datePicker-single-inputFields--datePickerInputFields__root",
	rootPlacementTop: "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop",
	rootPlacementTopWithTimezoneSelector: "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector",
	rootPlacementBottom: "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom",
	input: "h-datePicker-single-inputFields--datePickerInputFields__input",
	alert: "h-datePicker-single-inputFields--datePickerInputFields__alert"
}, ja = class e extends N {
	dateValidators;
	instanceId;
	constructor(t) {
		super(t);
		let { dateFormat: n } = t;
		this.state = {
			dateInputValue: this.props.date?.format(n) ?? "",
			dateError: null
		}, this.instanceId = e.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Ta(t.dateFormat, this.parseDateString, {
			maxDate: t.maxDate,
			minDate: t.minDate
		});
	}
	componentDidUpdate(e) {
		this.syncDateWithProps(e);
	}
	static instanceCount = 0;
	syncDateWithProps(e) {
		let { date: t, timeRoundingStrategy: n } = this.props, r = H(t);
		if (!(t === e.date || r?.isSame(H(e.date), n))) return this.props.date ? this.setState({
			dateError: null,
			dateInputValue: r.format(this.props.dateFormat)
		}) : this.setState({
			dateError: null,
			dateInputValue: ""
		});
	}
	handleInputValueChange(e) {
		let t = this.ensureValidChars(e.target.value);
		this.setState({ dateInputValue: t }, this.propagateDateChangeEvent);
	}
	propagateDateChangeEvent() {
		let { dateInputValue: e } = this.state;
		if (e === "") {
			this.props.onDateChange(null);
			return;
		}
		let { isValid: t, error: n } = this.dateValidators.isSingleDateValid(e);
		if (!t) {
			this.setState({ dateError: n });
			return;
		}
		this.setState({ dateError: null }, () => this.props.onDateChange(this.parseDateString(e)));
	}
	parseDateString(e) {
		return H(e, this.props.dateFormat, !0);
	}
	ensureValidChars(e) {
		return e.replace(/[^0-9/]/g, "");
	}
	renderDateInput() {
		let { disabled: e, dateFormat: t, withDateInput: n } = this.props, { dateInputValue: r, dateError: i } = this.state;
		return n ? /* @__PURE__ */ A(c, {
			className: Aa.input,
			required: !0,
			name: `date__input__${this.instanceId}`,
			value: r,
			onChange: this.handleInputValueChange,
			autoComplete: "off",
			placeholder: t.toLowerCase(),
			disabled: e,
			status: i ? "error" : void 0
		}) : null;
	}
	renderTimeInput() {
		let { date: e, time: t, withTimePicker: n, timePickerProps: r = {}, disabled: i, onTimeChange: a, timeFormat: o } = this.props;
		if (!n) return null;
		let s = !e && !i, c = !e || i;
		return /* @__PURE__ */ A(U, {
			content: "Please select a date first.",
			disabled: !s,
			side: "right",
			children: /* @__PURE__ */ A("div", {
				className: Aa.input,
				children: /* @__PURE__ */ A(Sa, {
					disabled: c,
					onSelect: a,
					selectedItems: t ? [t] : void 0,
					...r,
					timeFormat: o
				})
			})
		});
	}
	renderErrors() {
		let { dateError: e } = this.state;
		return /* @__PURE__ */ A(va, {
			className: Aa.alert,
			variant: e ? "error" : void 0,
			children: this.state.dateError
		});
	}
	render() {
		let { hasTimezoneSelector: e, placement: t } = this.props;
		return /* @__PURE__ */ j("div", {
			className: O(Aa.root, {
				[Aa.rootPlacementTop]: t === "top",
				[Aa.rootPlacementTopWithTimezoneSelector]: t === "top" && e,
				[Aa.rootPlacementBottom]: t === "bottom"
			}),
			children: [
				this.renderDateInput(),
				this.renderTimeInput(),
				this.renderErrors()
			]
		});
	}
}, Ma = "datePickerTestId", Na = class extends N {
	static defaultProps = {
		dateFormat: H.localeData().longDateFormat("L"),
		withDateInput: !1,
		withTimePicker: !1,
		timePickerProps: {},
		inputsPlacement: "bottom",
		timeRoundingStrategy: "day"
	};
	constructor(e) {
		super(e);
		let { date: t, timezone: n, presets: r, presetKey: i } = e;
		this.state = {
			time: t ? H(t).format(fi) : null,
			timezone: li(n) ? n : H.tz.guess(!0),
			presetKey: r?.find(({ key: e }) => e === i)?.key ?? null,
			datePickerKey: 0
		}, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
	}
	componentDidUpdate(e) {
		this.updateTimeOnDateChange(e), this.recalculateDatePickerKey();
	}
	visibleCalendarMonthRef = P();
	getDateConstraints() {
		let { maxDate: e, minDate: t } = this.props;
		return {
			minDate: t || H("0001-01-01"),
			maxDate: e || H("9999-12-31")
		};
	}
	onTimezoneChange(e) {
		let { date: t } = this.props, { presetKey: n } = this.state;
		this.setState({ timezone: e }, () => this.onDateChange(t, n));
	}
	onDateChange(e, t = null) {
		let { time: n, timezone: r } = this.state, { timeRoundingStrategy: i } = this.props, a = this.addTimezoneToDate(e, r), o = a?.clone().startOf(i) || null, s = e?.clone().startOf(i) || null;
		if (this.setState({ presetKey: t }), t) {
			this.setState({ time: e?.clone().startOf(i).format("HH:mm") ?? null }, () => {
				this.props.onChange({
					date: o,
					localDate: s,
					timezone: r,
					localTimezone: H.tz.guess(!0),
					presetKey: t
				});
			});
			return;
		}
		n && (o = this.addTimeToDate(a, n), s = this.addTimeToDate(e, n)), this.props.onChange({
			date: o,
			localDate: s,
			timezone: r,
			localTimezone: H.tz.guess(!0)
		});
	}
	onPresetSelect(e) {
		e ? this.onDateChange(e.date, e.key) : this.onDateChange(null);
	}
	handleTimeChange(e) {
		let { date: t } = this.props;
		this.setState((t) => ({
			...t,
			time: e
		}), () => this.onDateChange(t));
	}
	addTimezoneToDate(e, t) {
		if (!e) return null;
		let { timeRoundingStrategy: n } = this.props;
		return li(t) ? H(e).clone().tz(t, !0) : e.clone().startOf(n);
	}
	addTimeToDate(e, t) {
		if (!e) return null;
		let { timeRoundingStrategy: n } = this.props, [r, i] = t.split(":");
		return !r || !i ? e.clone().startOf(n) : e.clone().set({
			hours: parseInt(r, 10),
			minutes: parseInt(i, 10),
			seconds: 0,
			milliseconds: 0
		});
	}
	isDateOutsideOfSelectableRange(e) {
		let { disabled: t, timeRoundingStrategy: n } = this.props;
		if (t) return !0;
		let { minDate: r, maxDate: i } = this.getDateConstraints();
		return !e.isBetween(r, i, n);
	}
	updateTimeOnDateChange(e) {
		let { date: t } = this.props;
		e.date?.isSame(t) || this.setState({ time: t ? H(t).format(fi) : null });
	}
	recalculateDatePickerKey() {
		let { date: e } = this.props, t = this.visibleCalendarMonthRef.current?.state.currentMonth;
		if (t && e && !e.isSame(t, "month")) return this.setState({ datePickerKey: this.generateRandomKey() });
	}
	generateRandomKey() {
		return Math.floor(Math.random() * 1e8);
	}
	renderTimezoneSelector() {
		let { date: e, disabled: t, withTimezoneSelector: n, timezoneSelectorProps: r } = this.props, { timezone: i } = this.state;
		if (!n) return null;
		let a = !!e, o = !a && !t;
		return /* @__PURE__ */ A(pa, {
			disabled: !a || t || r?.disabled,
			tooltipProps: {
				content: "Please select a date first",
				disabled: !o,
				...r?.tooltipProps
			},
			onChange: this.onTimezoneChange,
			selectedTimezone: i,
			...r
		});
	}
	renderInputFields(e) {
		let { dateFormat: t, timeFormat: n, withDateInput: r, withTimePicker: i, withTimezoneSelector: a, timePickerProps: o, selectableMinutes: s, selectableHours: c, disabled: l, date: u, inputsPlacement: d, timeRoundingStrategy: f } = this.props;
		if (d !== e || !r && !i) return null;
		let { time: p } = this.state, { minDate: m, maxDate: h } = this.getDateConstraints();
		return /* @__PURE__ */ A(ja, {
			dateFormat: t,
			timeFormat: n,
			onDateChange: this.onDateChange,
			onTimeChange: this.handleTimeChange,
			time: p,
			date: u,
			minDate: m,
			maxDate: h,
			disabled: l,
			withDateInput: r,
			withTimePicker: i,
			hasTimezoneSelector: a,
			timePickerProps: o,
			selectableMinutes: s,
			selectableHours: c,
			placement: e,
			timeRoundingStrategy: f
		});
	}
	renderPresets() {
		let { presets: e } = this.props, { presetKey: t } = this.state;
		return e?.length ? /* @__PURE__ */ A(Ti, {
			value: t,
			presets: e,
			onSelect: this.onPresetSelect
		}) : null;
	}
	render() {
		let { className: e, calendarProps: t, disabled: n, date: r } = this.props, { datePickerKey: i } = this.state, a = n ? () => /* @__PURE__ */ A("span", {}) : Si.previousMonth, o = n ? () => /* @__PURE__ */ A("span", {}) : Si.nextMonth;
		return /* @__PURE__ */ j("div", {
			"data-testid": Ma,
			className: O(xi.root, e),
			children: [/* @__PURE__ */ j(G, {
				flexDirection: "column",
				alignItems: "center",
				children: [
					this.renderTimezoneSelector(),
					this.renderInputFields("top"),
					/* @__PURE__ */ A(oi.DayPickerSingleDateController, {
						ref: this.visibleCalendarMonthRef,
						date: r,
						onDateChange: this.onDateChange,
						isOutsideRange: this.isDateOutsideOfSelectableRange,
						numberOfMonths: 1,
						hideKeyboardShortcutsPanel: !0,
						noBorder: !0,
						renderDayContents: Ci,
						daySize: 32,
						renderNavPrevButton: a,
						renderNavNextButton: o,
						renderMonthElement: wi,
						initialVisibleMonth: () => r || H(),
						onFocusChange: K,
						focused: !0,
						transitionDuration: 0,
						...t
					}, i),
					this.renderInputFields("bottom")
				]
			}), this.renderPresets()]
		});
	}
}, Pa = {
	dialer: "h-dialer--dialer__dialer",
	number: "h-dialer--dialer__number",
	letters: "h-dialer--dialer__letters",
	asterisk: "h-dialer--dialer__asterisk"
}, Fa = [
	{
		value: "1",
		letters: " "
	},
	{
		value: "2",
		letters: "abc"
	},
	{
		value: "3",
		letters: "def"
	},
	{
		value: "4",
		letters: "ghi"
	},
	{
		value: "5",
		letters: "jkl"
	},
	{
		value: "6",
		letters: "mno"
	},
	{
		value: "7",
		letters: "pqrs"
	},
	{
		value: "8",
		letters: "tuv"
	},
	{
		value: "9",
		letters: "wxyz"
	},
	{
		value: "*",
		letters: null,
		classNames: Pa.asterisk
	},
	{
		value: "0",
		letters: null
	},
	{
		value: "#",
		letters: null
	}
], Ia = class extends N {
	render() {
		let { className: e, onInput: t, ...n } = this.props, r = O(Pa.dialer, e);
		return /* @__PURE__ */ A("div", {
			...n,
			className: r,
			children: Fa.map((e) => /* @__PURE__ */ ye("div", {
				className: O(Pa.number),
				...sn(() => t(e.value)),
				key: e.value
			}, /* @__PURE__ */ A(i.Heading, {
				variant: "heading-1",
				color: "neutral.700",
				children: /* @__PURE__ */ A("span", {
					className: e.classNames ?? "",
					children: e.value
				})
			}), /* @__PURE__ */ A(i.Paragraph, {
				variant: "1",
				color: "neutral.700",
				children: !!e.letters && /* @__PURE__ */ A("span", {
					className: Pa.letters,
					children: e.letters
				})
			})))
		});
	}
}, La = {
	root: "h-fieldWrapper--fieldWrapper__root",
	rootDisabled: "h-fieldWrapper--fieldWrapper__rootDisabled",
	label: "h-fieldWrapper--fieldWrapper__label",
	alert: "h-fieldWrapper--fieldWrapper__alert"
}, Ra = "fieldWrapper", X = class e extends N {
	static hasStatus(e, t) {
		return e?.[t] ? e?.touched === void 0 || e.touched === !0 : !1;
	}
	static getStatusMessage(e, t) {
		if (this.hasStatus(e, t)) return e?.[t];
	}
	static getStatus(t) {
		return e.hasStatus(t, "error") ? "error" : e.hasStatus(t, "warning") ? "warning" : e.hasStatus(t, "success") ? "success" : void 0;
	}
	renderAlerts() {
		let { meta: t, description: n } = this.props, r = n, i;
		return e.hasStatus(t, "error") ? (r = e.getStatusMessage(t, "error"), i = "error") : e.hasStatus(t, "warning") ? (r = e.getStatusMessage(t, "warning"), i = "warning") : e.hasStatus(t, "success") && (r = e.getStatusMessage(t, "success"), i = "success"), /* @__PURE__ */ A(va, {
			variant: i,
			className: La.alert,
			children: r
		});
	}
	render() {
		let { className: e, labelFor: t, label: n, meta: r, required: i, disabled: a, helpIcon: o, noAlert: s, noLabel: c, children: l, ...u } = this.props, d = O(La.root, { [La.rootDisabled]: a }, e);
		return /* @__PURE__ */ j("div", {
			"data-testid": Ra,
			...u,
			className: d,
			children: [
				!c && /* @__PURE__ */ A(Oi, {
					required: i,
					htmlFor: t,
					helpIcon: o,
					className: La.label,
					children: n
				}),
				l,
				!s && this.renderAlerts()
			]
		});
	}
}, za = class extends N {
	render() {
		let { className: e, input: t, label: n, meta: r, required: i, disabled: a, helpIcon: o, description: s, noLabel: l, noAlert: u, ...d } = this.props;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: n,
			labelFor: t.name,
			meta: r,
			required: i,
			disabled: a,
			helpIcon: o,
			description: s,
			noLabel: l,
			noAlert: u,
			children: /* @__PURE__ */ A(c, {
				status: X.getStatus(r),
				disabled: a,
				required: i,
				...t,
				...d
			})
		});
	}
}, Ba = {
	search: "h-dropdownSelect--dropdownSelectContainer__search",
	pagination: "h-dropdownSelect--dropdownSelectContainer__pagination",
	selectionActions: "h-dropdownSelect--dropdownSelectContainer__selectionActions",
	extra: "h-dropdownSelect--dropdownSelectContainer__extra"
}, Va = "DROP_SEARCH_INPUT", Ha = class extends me {
	listRef;
	searchRef;
	static getDerivedStateFromProps(e, t) {
		let { dropdownOpen: n } = e, r = { ...t };
		return n || (r.searchValue = "", r.activeItemIndex = 0), r;
	}
	constructor(e) {
		super(e), this.state = {
			searchValue: "",
			activeItemIndex: 0
		}, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = P(), this.searchRef = P();
	}
	componentDidMount() {
		this.onOpen();
	}
	componentDidUpdate(e) {
		let { dropdownOpen: t } = this.props;
		!e.dropdownOpen && t && this.onOpen();
	}
	getInput() {
		let { searchValue: e } = this.state;
		return {
			name: Va,
			value: e,
			onChange: this.search,
			onKeyDown: this.searchKeyDown,
			autoComplete: "off",
			"aria-label": "Search"
		};
	}
	searchKeyDown(e) {
		let { key: t } = e, { searchValue: n, activeItemIndex: r } = this.state, { triggerClose: i, items: a, disabledItems: o = [] } = this.props, s = a.map((e, t) => ({
			item: e,
			index: t
		})).filter(({ item: e }) => !o.includes(e.id)).map(({ index: e }) => e), c = s.indexOf(r);
		if (t === "Escape") n === "" ? i() : this.clearSearch();
		else if (t === "ArrowDown") {
			if (e.preventDefault(), s.length > 0) {
				let e = c < s.length - 1 ? c + 1 : 0;
				this.setState({ activeItemIndex: s[e] }, () => this.listRef.current?.focusActiveItem());
			}
		} else if (t === "ArrowUp") {
			if (e.preventDefault(), s.length > 0) {
				let e = c > 0 ? c - 1 : s.length - 1;
				this.setState({ activeItemIndex: s[e] }, () => this.listRef.current?.focusActiveItem());
			}
		} else if (t === "Home") e.preventDefault(), s.length > 0 && this.setState({ activeItemIndex: s[0] }, () => this.listRef.current?.focusActiveItem());
		else if (t === "End") e.preventDefault(), s.length > 0 && this.setState({ activeItemIndex: s[s.length - 1] }, () => this.listRef.current?.focusActiveItem());
		else if (t === "Enter") {
			e.preventDefault();
			let t = a[r];
			if (t && !o.includes(t.id)) {
				let { onChange: e, selectedItems: n = [] } = this.props;
				if (e) {
					let e = n.some((e) => (typeof e == "object" ? e.id : e) === t.id);
					this.onChange(t, !e);
				} else this.onSelect(t);
			}
		}
	}
	handleItemKeyDown(e) {
		let { key: t } = e, { activeItemIndex: n } = this.state, { triggerClose: r, items: i, disabledItems: a = [] } = this.props, o = i.map((e, t) => ({
			item: e,
			index: t
		})).filter(({ item: e }) => !a.includes(e.id)).map(({ index: e }) => e), s = o.indexOf(n);
		if (t === "Escape") r();
		else if (t === "ArrowDown") {
			if (e.preventDefault(), o.length > 0) {
				let e = s < o.length - 1 ? s + 1 : 0;
				this.setState({ activeItemIndex: o[e] }, () => this.listRef.current?.focusActiveItem());
			}
		} else if (t === "ArrowUp") {
			if (e.preventDefault(), o.length > 0) {
				let e = s > 0 ? s - 1 : o.length - 1;
				this.setState({ activeItemIndex: o[e] }, () => this.listRef.current?.focusActiveItem());
			}
		} else t === "Home" ? (e.preventDefault(), o.length > 0 && this.setState({ activeItemIndex: o[0] }, () => this.listRef.current?.focusActiveItem())) : t === "End" && (e.preventDefault(), o.length > 0 && this.setState({ activeItemIndex: o[o.length - 1] }, () => this.listRef.current?.focusActiveItem()));
	}
	search(e) {
		let { onSearch: t } = this.props, { value: n } = e.target;
		typeof t == "function" && t(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
			searchValue: n,
			activeItemIndex: 0
		});
	}
	onSelect(e) {
		let { onSelect: t, keepOpen: n, triggerClose: r } = this.props;
		typeof t == "function" && t(e), n && this.focusSearch(), !n && typeof r == "function" && r();
	}
	onChange(e, t) {
		let { onChange: n, keepOpen: r, triggerClose: i } = this.props;
		typeof n == "function" && n(e, t), r && this.focusSearch(), !r && typeof i == "function" && i();
	}
	onOpen() {
		let { hasSearch: e } = this.props;
		e ? this.focusSearch() : setTimeout(() => {
			this.listRef.current?.focusActiveItem();
		}, 0);
	}
	focusSearch() {
		let { hasSearch: e } = this.props;
		if (e && this.searchRef.current) {
			let e = this.searchRef.current.querySelector("input");
			e && e.focus();
		}
	}
	clearSearch = () => {
		let { onSearch: e } = this.props, { searchValue: t } = this.state;
		t && (typeof e == "function" && e(""), this.setState({ searchValue: "" }));
	};
	render() {
		let { className: e, itemComponent: t, emptyComponent: n, suggestionComponent: r, optionComponent: i, items: a, hasSearch: o, searchPlaceholder: s, pagination: c, keepOpen: l, onSelect: u, onSearch: d, onSuggest: f, onChange: p, onClear: m, onClearText: h, triggerClose: _, dropdownOpen: v, emptyMessage: y, selectedItems: b, disabledItems: x, tooltipItems: S, activeItem: C, itemsDisplayCount: w, itemHeight: T, renderSuggestion: E, searchSuggestion: D, ...ee } = this.props;
		if (!v) return null;
		let { searchValue: te, activeItemIndex: ne } = this.state, re = a.length === 0, ie = a[ne] ?? C ?? a[0] ?? null, ae = O(e);
		return /* @__PURE__ */ j("div", {
			...ee,
			className: ae,
			children: [
				o && /* @__PURE__ */ A("div", {
					className: Ba.search,
					ref: this.searchRef,
					children: /* @__PURE__ */ A(za, {
						input: this.getInput(),
						meta: {
							error: null,
							touched: !0
						},
						icon: "search",
						noAlert: !0,
						noLabel: !0,
						placeholder: s
					})
				}),
				!!(o && r || i) && /* @__PURE__ */ j("div", {
					className: Ba.extra,
					children: [i, o && typeof r == "function" && /* @__PURE__ */ A(r, {
						searched: te,
						onSuggest: f,
						triggerClose: l ? void 0 : _,
						clearSearch: this.clearSearch,
						items: a,
						searchSuggestion: D,
						renderSuggestion: E
					})]
				}),
				/* @__PURE__ */ j("div", { children: [!re && /* @__PURE__ */ A(Ri, {
					ref: this.listRef,
					pagination: c,
					items: a,
					onSelect: this.onSelect,
					onChange: this.onChange,
					onKeyDown: this.handleItemKeyDown,
					clearSearch: this.clearSearch,
					selectedItems: b,
					disabledItems: x,
					itemComponent: t,
					tooltipItems: S,
					itemsDisplayCount: w,
					itemHeight: T,
					activeItem: ie
				}), re && typeof n == "function" && /* @__PURE__ */ A(n, { label: y || "" })] }),
				typeof m == "function" && /* @__PURE__ */ A("div", {
					className: Ba.selectionActions,
					children: /* @__PURE__ */ A(g, {
						variant: "secondary",
						disabled: b?.length === 0,
						onClick: m,
						children: h || "Clear"
					})
				}),
				!!c && !c.infinite && /* @__PURE__ */ j("div", {
					className: Ba.pagination,
					children: [/* @__PURE__ */ A(g, {
						variant: "secondary",
						disabled: !c.previousEnable,
						onClick: c.onPrevious,
						children: "Prev page"
					}), /* @__PURE__ */ A(g, {
						variant: "secondary",
						disabled: !c.nextEnable,
						onClick: c.onNext,
						children: "Next page"
					})]
				})
			]
		});
	}
}, Ua = class extends N {
	static defaultProps = {
		className: "",
		buttonProps: {},
		dropdownProps: {},
		containerProps: {},
		noArrow: !0,
		hasSearch: !1,
		searchPlaceholder: "Search...",
		pagination: !1,
		keepOpen: !1,
		onSearch: () => {},
		onSuggest: () => {},
		onChange: () => {},
		onSelect: () => {},
		onToggle: () => {},
		onKeyDown: () => {},
		emptyComponent: Hi,
		emptyMessage: "No items found",
		selectedItems: [],
		disabledItems: [],
		tooltipItems: {},
		activeItem: null
	};
	render() {
		let { className: e, items: t, onSelect: n, onChange: r, onSearch: i, onClear: a, onClearText: o, onKeyDown: s, hasSearch: c, searchPlaceholder: l = "Search...", onSuggest: u, keepOpen: d, itemComponent: f, suggestionComponent: p, children: m, buttonProps: h, dropdownProps: g, containerProps: _, pagination: v, emptyComponent: y, emptyMessage: b, selectedItems: x, disabledItems: S, tooltipItems: C, activeItem: w, itemsDisplayCount: T, itemHeight: E, optionComponent: D, renderSuggestion: ee, searchSuggestion: te, ...ne } = this.props;
		return /* @__PURE__ */ A(vn, {
			...ne,
			className: e,
			buttonProps: {
				variant: "secondary",
				...h
			},
			dropdownProps: g,
			dropdown: /* @__PURE__ */ A(_n.Consumer, { children: ({ toggleDropdown: e, dropdownOpen: m }) => /* @__PURE__ */ A(Ha, {
				..._,
				items: t,
				itemComponent: f,
				hasSearch: c,
				searchPlaceholder: l,
				suggestionComponent: p,
				onSuggest: u,
				keepOpen: d,
				onSearch: i,
				onSelect: n,
				onChange: r,
				onClear: a,
				onClearText: o,
				onKeyDown: s,
				triggerClose: e,
				dropdownOpen: m,
				pagination: v,
				emptyComponent: y,
				emptyMessage: b,
				selectedItems: x,
				disabledItems: S,
				tooltipItems: C,
				activeItem: w,
				itemsDisplayCount: T,
				itemHeight: E,
				optionComponent: D,
				renderSuggestion: ee,
				searchSuggestion: te
			}) }),
			children: m
		});
	}
}, Wa = { button: "h-fieldButton--fieldButton__button" }, Ga = F(function({ className: e, buttonClassName: t, label: n, meta: r, disabled: i, helpIcon: a, description: o, noAlert: s, noLabel: c, children: l, ...u }, d) {
	let f = O(t, Wa.button);
	return /* @__PURE__ */ A(X, {
		className: e,
		label: n,
		meta: r,
		disabled: i,
		helpIcon: a,
		description: o,
		noAlert: s,
		noLabel: c,
		children: /* @__PURE__ */ A(g, {
			ref: d,
			disabled: i,
			...u,
			className: f,
			children: l
		})
	});
}), Ka = Je, qa = {
	root: "h-inputDatePicker--inputDatePicker__root",
	inputContainer: "h-inputDatePicker--inputDatePicker__inputContainer",
	input: "h-inputDatePicker--inputDatePicker__input",
	rootReadOnly: "h-inputDatePicker--inputDatePicker__rootReadOnly",
	iconsContainer: "h-inputDatePicker--inputDatePicker__iconsContainer",
	rootHasClearIcon: "h-inputDatePicker--inputDatePicker__rootHasClearIcon",
	rootHasWrapperIcon: "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon",
	calendarIcon: "h-inputDatePicker--inputDatePicker__calendarIcon",
	clearIcon: "h-inputDatePicker--inputDatePicker__clearIcon"
}, Ja = "inputDatePickerTestId", Ya = class extends N {
	inputRef;
	rootRef;
	datePickerContainerRef;
	static defaultProps = {
		dateFormat: H.localeData().longDateFormat("L"),
		name: Math.floor(Math.random() * 1e8).toString()
	};
	constructor(e) {
		super(e), this.inputRef = P(), this.rootRef = P(), this.datePickerContainerRef = P(), this.state = {
			isDropdownOpen: !1,
			shouldRerenderDatePicker: !0
		}, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
	}
	componentDidUpdate(e, t) {
		let { isDropdownOpen: n } = this.state;
		n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
	}
	componentWillUnmount() {
		window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
	}
	focusDatePickerInput() {
		(this.datePickerContainerRef.current?.querySelector("input[type=\"text\"]"))?.focus();
	}
	handleWindowClick(e) {
		this.rootRef.current?.contains(e.target) || this.hideDropdown();
	}
	handleWindowKeyDown(e) {
		dn(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
	}
	handleDateChange(e) {
		let { onChange: t, value: n } = this.props;
		typeof t == "function" && t(e), (n ?? e !== null) && this.inputRef.current?.focus();
	}
	handleClearIconClick() {
		this.handleDateChange({
			date: null,
			localDate: null,
			timezone: null,
			localTimezone: null
		});
	}
	showDropdown() {
		this.setState({
			isDropdownOpen: !0,
			shouldRerenderDatePicker: !1
		});
	}
	hideDropdown() {
		this.setState({ isDropdownOpen: !1 });
	}
	handleInputFocus() {
		let { readOnly: e } = this.props;
		e || this.showDropdown();
	}
	handleInputBlur(e) {
		this.rootRef.current?.contains(e.target) || this.hideDropdown();
	}
	handleInputClick(e) {
		let { readOnly: t } = this.props;
		t || (e.stopPropagation(), this.showDropdown());
	}
	handleInputKeydown({ key: e }) {
		un(e) && this.showDropdown();
	}
	handleCalendarIconClick(e) {
		let { readOnly: t } = this.props;
		t || (e.stopPropagation(), this.showDropdown());
	}
	renderInputAndIcons() {
		let { className: e, name: t, value: r, onChange: i, dateFormat: a, dropdownProps: o, prefix: s, suffix: c, icon: l, status: u, placeholder: d, disabled: f, datePickerProps: p, clearable: m, minDate: h, maxDate: g, readOnly: _, ...v } = this.props, { isDropdownOpen: y } = this.state;
		return /* @__PURE__ */ A(n, {
			prefix: s,
			suffix: c,
			disabled: f,
			icon: l,
			active: y,
			status: u,
			children: /* @__PURE__ */ j("div", {
				className: qa.inputContainer,
				children: [/* @__PURE__ */ A("input", {
					...v,
					id: t,
					name: t,
					className: qa.input,
					ref: this.inputRef,
					onClick: this.handleInputClick,
					onFocus: this.handleInputFocus,
					onBlur: this.handleInputBlur,
					onKeyDown: this.handleInputKeydown,
					disabled: f,
					placeholder: d || a?.toLowerCase(),
					autoComplete: "off",
					value: Ka(r) ? void 0 : r?.format(a) ?? "",
					onChange: Ka(r) ? void 0 : K,
					readOnly: !0
				}), /* @__PURE__ */ j("div", {
					className: qa.iconsContainer,
					children: [this.renderClearIcon(), this.renderCalendarIcon()]
				})]
			})
		});
	}
	renderCalendarIcon() {
		let { disabled: e } = this.props;
		return /* @__PURE__ */ A(h, {
			className: qa.calendarIcon,
			icon: "calendar",
			variant: "tertiary",
			onClick: this.handleCalendarIconClick,
			tabIndex: -1,
			disabled: e
		});
	}
	renderClearIcon() {
		let { clearable: e, value: t, disabled: n } = this.props;
		return !e || !t ? null : /* @__PURE__ */ A(h, {
			className: qa.clearIcon,
			variant: "tertiary",
			icon: "close",
			disabled: n,
			onClick: this.handleClearIconClick
		});
	}
	renderDropdown() {
		let { value: e, minDate: t, maxDate: n, timezone: r, datePickerProps: i, disabled: a, dropdownProps: o, dateFormat: s } = this.props, { isDropdownOpen: c, shouldRerenderDatePicker: l } = this.state;
		return /* @__PURE__ */ A(hn, {
			...o,
			isOpen: c,
			children: /* @__PURE__ */ A("div", {
				ref: this.datePickerContainerRef,
				children: /* @__PURE__ */ A(Na, {
					disabled: a,
					...i,
					dateFormat: s,
					date: e ?? null,
					timezone: r,
					onChange: this.handleDateChange,
					minDate: t,
					maxDate: n
				}, l.toString())
			})
		});
	}
	render() {
		let { className: e, value: t, clearable: n, readOnly: r, icon: i } = this.props, a = O(qa.root, e, {
			[qa.rootHasClearIcon]: n && t,
			[qa.rootHasWrapperIcon]: !!i,
			[qa.rootReadOnly]: r
		});
		return /* @__PURE__ */ j("div", {
			"data-testid": Ja,
			ref: this.rootRef,
			className: a,
			children: [this.renderInputAndIcons(), this.renderDropdown()]
		});
	}
}, Xa = class extends N {
	constructor(e) {
		super(e), this.handleChange = this.handleChange.bind(this);
	}
	handleChange(e) {
		let { input: { onChange: t } } = this.props;
		t?.({
			date: e?.date ? e.date.toISOString() : "",
			localDate: e?.localDate ? e.localDate.toISOString() : "",
			timezone: e?.timezone || "",
			localTimezone: e?.localTimezone || ""
		});
	}
	render() {
		let { className: e, input: { value: t, name: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, helpIcon: l, description: u, noLabel: d, noAlert: f, ...p } = this.props;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: a,
			labelFor: n,
			meta: o,
			required: s,
			disabled: c,
			helpIcon: l,
			description: u,
			noLabel: d,
			noAlert: f,
			children: /* @__PURE__ */ A(Ya, {
				name: n,
				value: ci(t?.localDate) ? H(t.localDate, H.ISO_8601) : null,
				timezone: t?.timezone,
				onChange: this.handleChange,
				...i,
				status: X.getStatus(o),
				disabled: c,
				required: s,
				...p
			})
		});
	}
}, Za = {
	root: "h-inputDateRangePicker--inputDateRangePicker__root",
	inputsContainer: "h-inputDateRangePicker--inputDateRangePicker__inputsContainer",
	arrowContainer: "h-inputDateRangePicker--inputDateRangePicker__arrowContainer",
	inputContainer: "h-inputDateRangePicker--inputDateRangePicker__inputContainer",
	input: "h-inputDateRangePicker--inputDateRangePicker__input",
	rootReadOnly: "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly",
	iconsContainer: "h-inputDateRangePicker--inputDateRangePicker__iconsContainer",
	rootStartDateHasClearIcon: "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon",
	startDateIconsContainer: "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer",
	rootEndDateHasClearIcon: "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon",
	endDateIconsContainer: "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer",
	rootHasWrapperIcon: "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon",
	calendarIcon: "h-inputDateRangePicker--inputDateRangePicker__calendarIcon",
	clearIcon: "h-inputDateRangePicker--inputDateRangePicker__clearIcon"
}, Qa = "inputDateRangePickerTestId", $a = class e extends N {
	inputsRef;
	rootRef;
	dateRangePickerContainerRef;
	static getInputName(e, t) {
		return e[t] || `${e}__${t}`;
	}
	static defaultProps = { name: {
		startDate: Math.floor(Math.random() * 1e8).toString(),
		endDate: Math.floor(Math.random() * 1e8).toString()
	} };
	constructor(e) {
		super(e), this.inputsRef = {
			startDate: P(),
			endDate: P()
		}, this.rootRef = P(), this.dateRangePickerContainerRef = P(), this.state = {
			isDropdownOpen: !1,
			focusedInput: "startDate",
			shouldRerenderDateRangePicker: !0
		}, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
	}
	componentDidUpdate(e, t) {
		let { isDropdownOpen: n, focusedInput: r } = this.state;
		n !== t.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== t.isDropdownOpen || r !== t.focusedInput) && this.focusDateRangePickerInput();
	}
	componentWillUnmount() {
		window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
	}
	focusDateRangePickerInput() {
		let { focusedInput: e } = this.state, t = this.dateRangePickerContainerRef.current?.querySelectorAll("input[type=\"text\"]");
		e === "startDate" ? t?.[0]?.focus() : t?.[1]?.focus();
	}
	handleWindowClick(e) {
		this.rootRef.current?.contains(e.target) || this.hideDropdown();
	}
	handleWindowKeyDown(e) {
		dn(e.key) && this.state.isDropdownOpen && (e.stopPropagation(), this.hideDropdown());
	}
	handleDatesChange(e) {
		let { onChange: t, value: n } = this.props, { focusedInput: r } = this.state;
		typeof t == "function" && t(e), (n?.[r] ?? e[r] !== null) && this.inputsRef[r].current?.focus();
	}
	handleClearIconClick(e, t) {
		let { value: n, timezone: r, localTimezone: i } = this.props, a = {
			startDate: t === "startDate" ? null : n?.startDate ?? null,
			localStartDate: t === "startDate" ? null : n?.localStartDate ?? null,
			endDate: t === "endDate" ? null : n?.endDate ?? null,
			localEndDate: t === "endDate" ? null : n?.localEndDate ?? null,
			timezone: r || null,
			localTimezone: i || null
		};
		this.handleDatesChange(a);
	}
	showDropdown(e) {
		this.setState({
			isDropdownOpen: !0,
			focusedInput: e,
			shouldRerenderDateRangePicker: !1
		});
	}
	hideDropdown() {
		this.setState({ isDropdownOpen: !1 });
	}
	handleInputFocus(e, t) {
		let { readOnly: n } = this.props;
		n || this.showDropdown(t);
	}
	handleInputBlur(e) {
		this.rootRef.current?.contains(e.target) || this.hideDropdown();
	}
	handleInputKeydown({ key: e }, t) {
		un(e) && this.showDropdown(t);
	}
	handleInputClick(e, t) {
		let { readOnly: n } = this.props;
		n || (e.stopPropagation(), this.showDropdown(t));
	}
	handleCalendarIconClick(e, t) {
		let { readOnly: n } = this.props;
		n || (e.stopPropagation(), this.showDropdown(t));
	}
	get dateFormat() {
		let { dateFormat: e } = this.props;
		return e || H.localeData().longDateFormat("L");
	}
	renderInputLayout() {
		let { prefix: e, suffix: t, icon: r, status: i, disabled: a } = this.props, { isDropdownOpen: o } = this.state;
		return /* @__PURE__ */ A(n, {
			prefix: e,
			suffix: t,
			disabled: a,
			icon: r,
			active: o,
			status: i,
			children: /* @__PURE__ */ j("div", {
				className: Za.inputsContainer,
				children: [
					this.renderInputAndIcons("startDate"),
					/* @__PURE__ */ A("div", {
						className: Za.arrowContainer,
						children: /* @__PURE__ */ A(u, { name: "arrow-right" })
					}),
					this.renderInputAndIcons("endDate", -1)
				]
			})
		});
	}
	renderInputAndIcons(t, n) {
		let { className: r, clearable: i, dateFormat: a, dateRangePickerProps: o, disabled: s, dropdownProps: c, icon: l, localTimezone: u, maxDate: d, minDate: f, name: p, onChange: m, placeholder: h, prefix: g, readOnly: _, status: v, suffix: y, tabIndex: b, timezone: x, value: S, ...C } = this.props;
		return /* @__PURE__ */ j("div", {
			className: Za.inputContainer,
			children: [/* @__PURE__ */ A("input", {
				...C,
				id: e.getInputName(p, t),
				name: e.getInputName(p, t),
				className: Za.input,
				ref: this.inputsRef[t],
				onClick: (e) => this.handleInputClick(e, t),
				onFocus: (e) => this.handleInputFocus(e, t),
				onBlur: (e) => this.handleInputBlur(e),
				onKeyDown: (e) => this.handleInputKeydown(e, t),
				disabled: s,
				placeholder: h?.[t] || h || this.dateFormat?.toLowerCase(),
				autoComplete: "off",
				value: S && H(S[t]).isValid() ? H(S[t]).format(this.dateFormat) : "",
				onChange: Ka(S) ? void 0 : K,
				tabIndex: n ?? b,
				readOnly: !0
			}), /* @__PURE__ */ j("div", {
				className: O(Za.iconsContainer, {
					[Za.startDateIconsContainer]: t === "startDate",
					[Za.endDateIconsContainer]: t === "endDate"
				}),
				children: [this.renderClearIcon(t), this.renderCalendarIcon(t)]
			})]
		});
	}
	renderCalendarIcon(e) {
		let { disabled: t } = this.props;
		return /* @__PURE__ */ A(h, {
			className: Za.calendarIcon,
			icon: "calendar",
			variant: "tertiary",
			onClick: (t) => this.handleCalendarIconClick(t, e),
			tabIndex: -1,
			disabled: t
		});
	}
	renderClearIcon(e) {
		let { clearable: t, value: n, disabled: r } = this.props;
		return !t || !n?.[e] ? null : /* @__PURE__ */ A(h, {
			className: Za.clearIcon,
			variant: "tertiary",
			icon: "close",
			disabled: r,
			onClick: (t) => this.handleClearIconClick(t, e)
		});
	}
	renderDropdown() {
		let { value: e, minDate: t, maxDate: n, timezone: r, dateRangePickerProps: i, disabled: a, dropdownProps: o } = this.props, { isDropdownOpen: s, focusedInput: c, shouldRerenderDateRangePicker: l } = this.state;
		return /* @__PURE__ */ A(hn, {
			...o,
			isOpen: s,
			children: /* @__PURE__ */ A("div", {
				ref: this.dateRangePickerContainerRef,
				children: /* @__PURE__ */ A(ka, {
					disabled: a,
					...i,
					dateFormat: this.dateFormat,
					onChange: this.handleDatesChange,
					startDate: e?.startDate ?? null,
					endDate: e?.endDate ?? null,
					timezone: r ?? null,
					minDate: t,
					maxDate: n,
					focusedInput: c
				}, l.toString())
			})
		});
	}
	render() {
		let { className: e, value: t, clearable: n, readOnly: r, icon: i } = this.props, a = O(Za.root, e, {
			[Za.rootStartDateHasClearIcon]: n && t?.startDate,
			[Za.rootEndDateHasClearIcon]: n && t?.endDate,
			[Za.rootHasWrapperIcon]: !!i,
			[Za.rootReadOnly]: r
		});
		return /* @__PURE__ */ j("div", {
			"data-testid": Qa,
			ref: this.rootRef,
			className: a,
			children: [this.renderInputLayout(), this.renderDropdown()]
		});
	}
}, eo = class extends N {
	constructor(e) {
		super(e), this.handleChange = this.handleChange.bind(this);
	}
	handleChange(e) {
		let { input: { onChange: t } } = this.props;
		t?.({
			startDate: e?.startDate ? e.startDate.toISOString() : "",
			localStartDate: e?.localStartDate ? e.localStartDate.toISOString() : "",
			endDate: e?.endDate ? e.endDate.toISOString() : "",
			localEndDate: e?.localEndDate ? e.localEndDate.toISOString() : "",
			timezone: e?.timezone ?? "",
			localTimezone: e?.localTimezone ?? ""
		});
	}
	getDateRange({ localStartDate: e, localEndDate: t }) {
		return {
			startDate: ci(e) ? H(e, H.ISO_8601) : null,
			endDate: ci(t) ? H(t, H.ISO_8601) : null
		};
	}
	render() {
		let { className: e, input: { name: t, value: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, description: l, helpIcon: u, noLabel: d, noAlert: f, ...p } = this.props, { timezone: m, localTimezone: h } = n;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: a,
			labelFor: $a.getInputName(t, "startDate"),
			meta: o,
			required: s,
			disabled: c,
			helpIcon: u,
			description: l,
			noLabel: d,
			noAlert: f,
			children: /* @__PURE__ */ A($a, {
				name: t,
				value: this.getDateRange(n),
				timezone: m,
				localTimezone: h,
				onChange: this.handleChange,
				...i,
				status: X.getStatus(o),
				disabled: c,
				required: s,
				...p
			})
		});
	}
}, to = [
	"link",
	"bold",
	"italic",
	"unorderedList",
	"orderedList",
	"format",
	"inlineCode",
	"blockquote"
], no = Ye, ro = Xe, io = (e) => ro(e), ao = (e, t = window) => t.getComputedStyle(e).display === "block", oo = Ze, so = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
//#endregion
//#region src/utils/keyCombination/isKeyCombination.ts
function co(e, t) {
	let n = {
		ctrlKey: ["Control", ...so ? ["$controlOrAlt"] : ["$metaOrCtrl"]],
		shiftKey: ["Shift"],
		altKey: ["Alt", ...so ? [] : ["$controlOrAlt"]],
		metaKey: [
			"Meta",
			"OS",
			...so ? ["$metaOrCtrl"] : []
		]
	};
	return e.some((e) => {
		if (t.code !== e[1]) return !1;
		let r = e[0] ?? [];
		return Object.entries(n).every(([e, n]) => {
			let i = oo(n, r).length;
			return t[e] ? i > 0 : i === 0;
		});
	});
}
//#endregion
//#region src/components/inputRichText/utils/editorUtils.ts
var lo = (e, t, n) => {
	if (!e || t < 0 || n < 0) return !1;
	let r = e?.textContent?.length ?? 0;
	return !(t > r || n > r);
}, uo = (e, t) => e.document.queryCommandState(t), fo = (e) => e.document.queryCommandValue("formatBlock"), po = (e) => e.type.indexOf("image/") === 0, mo = (e, t) => {
	let n = qe();
	return {
		src: (e.URL || e.webkitURL).createObjectURL(t),
		uid: n
	};
}, ho = (e) => {
	e && e.querySelectorAll("td").forEach((e) => {
		e.style.border = "1px solid currentColor";
	});
}, go = (e) => {
	e.setAttribute("dir", "auto");
	let t = window.getComputedStyle(e).direction;
	e.setAttribute("dir", t);
}, _o = (e) => {
	e && e.childNodes.forEach((e) => {
		e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE || io(e) && ao(e) && go(e);
	});
}, vo = (e, t = !0) => {
	let n = document.createElement("div");
	return n.style.display = "none", n.innerHTML = e, document.body.appendChild(n), n.childNodes.forEach((e) => {
		if (!(e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE)) {
			if (io(e) && ao(e)) e.innerHTML = vo(e.innerHTML, !1), go(e);
			else if (t) {
				let t = document.createElement("div");
				t.appendChild(e.cloneNode(!0)), e.replaceWith(t), go(t);
			}
		}
	}), document.body.removeChild(n), n.innerHTML;
}, yo = (e, t = { side: "both" }) => {
	let { side: n } = t, r = e.split(""), i = "&nbsp;", a = 0, o = r.length - 1;
	if (n === "both" || n === "start") for (; r[a] === " ";) r[a++] = i;
	if (n === "both" || n === "end") for (; r[o] === " ";) r[o--] = i;
	return r.join("");
}, bo = (e, t) => e.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? yo(e, { side: "end" }) : `<div>${yo(e)}</div>` : "<br />").join("");
function xo(e) {
	let t = "&nbsp;", n = So(e.anchorNode), r = Co(e.anchorNode);
	if (e.anchorNode?.nodeType === Node.TEXT_NODE && n.endsWith(t)) {
		let { focusOffset: n, anchorOffset: i } = e, a = Array.prototype.indexOf.call(e.anchorNode.parentElement?.childNodes, e.anchorNode), o = r.replaceAll(t, "\xA0").replace(/.$/, " "), s = document.createTextNode(o);
		if (e.anchorNode.parentElement?.childNodes[a].replaceWith(s), e?.rangeCount && e?.rangeCount > 0 && lo(s, n, i)) {
			let t = e.getRangeAt(0);
			t.setStart(s, n), t.setEnd(s, i);
		}
	}
}
function So(e) {
	if (!e) return "";
	if (e instanceof Element) return e.innerHTML;
	let t = document.createElement("span");
	return t.appendChild(e.cloneNode()), t.innerHTML;
}
function Co(e) {
	return !e || !e.textContent ? "" : e.textContent;
}
var wo = { root: "h-inputRichText-addonTrigger--addonTrigger__root" };
//#endregion
//#region src/components/inputRichText/addonTrigger/utils/getCharactersBeforeCursor.ts
function To(e) {
	if (!e) return null;
	let { focusOffset: t, anchorOffset: n, anchorNode: r } = e;
	return t !== n || !r || r.nodeName !== "#text" ? null : r?.textContent?.slice(0, t) || null;
}
//#endregion
//#region src/components/inputRichText/addonTrigger/utils/getMatchedTrigger.ts
var Eo = (e, t) => {
	let n = Oo(e, t);
	return n && e.triggers.isAddonTrigger(n.matchedTrigger) ? n.matchedTrigger : null;
}, Do = (e, t) => {
	let n = Oo(e, t);
	return n ? n.match : null;
}, Oo = (e, t) => t ? e.triggers.test(t) : null, ko = "input-rich-text-addon-trigger", Ao = (e, t) => {
	let n = e.selection.recreate({ focus: !1 });
	if (!n || !t) return null;
	let r = n.getRangeAt(0).getBoundingClientRect();
	return e.ref.current && r && n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0).getBoundingClientRect() : null;
}, jo = (e, t) => {
	if (e.ref.current && t) {
		let n = e.ref.current.getBoundingClientRect();
		return {
			left: `${t.x - n.x}px`,
			top: `${t.y - n.y}px`,
			height: "0",
			width: `${t.width}px`,
			position: "absolute"
		};
	}
	return {};
}, Mo = (e) => To(e.selection.recreate({ focus: !1 })) || "", No = (e, t) => !!t && e.triggers.isAddonTrigger(t), Po = (e) => e?.nodeType === Node.ELEMENT_NODE, Fo = (e, t) => e.dataset.testid === t ? e : e.parentElement ? Fo(e.parentElement, t) : null, Io = {}, Lo = new class extends EventTarget {
	callbacks = {
		focus: [],
		insert: [],
		up: [],
		down: []
	};
	addEventListener(e, t, n) {
		super.addEventListener(e, t, n), t && this.callbacks[e].push(t);
	}
	clearEventListeners(e) {
		this.callbacks[e].forEach((t) => {
			this.removeEventListener(e, t);
		}), this.callbacks[e] = [];
	}
}(), Ro = ve({
	matchText: "",
	insertContent: () => {},
	eventEmitter: Lo
}), zo = /* @__PURE__ */ function(e) {
	return e.FOCUS = "focus", e.INSERT = "insert", e.UP = "up", e.DOWN = "down", e;
}({}), Bo = (e) => {
	let { editor: t } = e, [n, r] = V(null), [i, a] = V(null), [o, s] = V(null), [c, l] = V(!1), u = jo(t, o), [d] = V(qe()), { dismissText: f } = Io[d] ?? { dismissText: "" }, p = n?.[0] ?? "", m = f && p?.replace(/\s+$/, " ").startsWith(f.replace(/\s+$/, " ")) || !1, h = L(() => {
		let e = Eo(t, Mo(t)), n = Do(t, Mo(t)), i = Ao(t, e);
		No(t, e) && e?.shouldHandleSelectionChange?.() !== !1 ? (a(e), r(n), s(i)) : (a(null), r(null), s(null)), l(!0);
	}, [t]), g = L(() => {
		let e = Eo(t, Mo(t)), n = Do(t, Mo(t))?.[0];
		return No(t, e) && !!n;
	}, [t]), _ = L(() => {
		let e = Eo(t, Mo(t)), n = Do(t, Mo(t))?.[0], r = Io[d]?.dismissText || "", i = r ? n?.startsWith(r) : !1;
		return No(t, e) && !!n && !i;
	}, [t, d]), v = L(() => {
		t.hotkeys.add([
			{
				keybindings: [[[], "Tab"]],
				condition: _,
				callback: () => {
					Lo.dispatchEvent(new Event("focus"));
				}
			},
			{
				keybindings: [[[], "Enter"]],
				condition: _,
				callback: () => {
					Lo.dispatchEvent(new Event("insert"));
				}
			},
			{
				keybindings: [[[], "ArrowUp"]],
				condition: _,
				callback: () => {
					Lo.dispatchEvent(new Event("up"));
				}
			},
			{
				keybindings: [[[], "ArrowDown"]],
				condition: _,
				callback: () => {
					Lo.dispatchEvent(new Event("down"));
				}
			},
			{
				keybindings: [[[], "Escape"]],
				condition: _,
				callback: (e, n) => {
					let i = Do(t, Mo(t))?.[0];
					if (!i) {
						Io[d] = { dismissText: "" };
						return;
					}
					Eo(t, Mo(t))?.persistOnEsc === !1 && (n.stopPropagation(), a(null), r(null), s(null)), Io[d] = { dismissText: (i.trim().length === 1 ? "" : i) ?? "" };
				}
			}
		]);
	}, [
		t,
		_,
		d
	]);
	R(() => {
		g() && f !== p && (m && i?.persistOnEsc !== !1 || !m && i?.persistOnEsc === !1) && (Io[d] = { dismissText: "" });
	}, [
		f,
		m,
		g,
		p,
		d,
		i
	]);
	let y = L((e) => {
		let t = e.nativeEvent.relatedTarget, n = Po(t) && Fo(t, "input-rich-text-editor"), r = Po(t) && Fo(t, ko);
		(!Po(t) || !n && !r) && l(!1);
	}, []), b = L((e, { inline: n } = {}) => {
		let r = t.selection.recreate();
		if (!r || !i) return;
		let a = r.anchorNode?.textContent?.match(`^${i?.trigger.source}`) && !n ? vo(bo(e, { inline: !1 })) : bo(e, { inline: !0 });
		r?.rangeCount && r?.rangeCount > 0 && t.content.insert(r.getRangeAt(0).createContextualFragment(a), { getSelection: () => {
			let e = t.selection.recreate();
			if (!e) return null;
			let { focusOffset: n } = e, r = i.trigger.exec(p)?.[1]?.length ?? 0, a = n - (p.length - r);
			if (e?.anchorNode && a >= 0) try {
				e.extend(e.anchorNode, a);
			} catch {}
			return e;
		} });
	}, [
		t,
		p,
		i
	]);
	if (je(() => {
		v(), t.selection.onUpdate(h), t.events.onBlur(y);
	}), Fe(() => {
		delete Io[d];
	}), !i || !c || !p || m) return null;
	let S = i.customContainer?.current || t.ref.current?.ownerDocument?.body || window.document.body;
	return /* @__PURE__ */ A("div", {
		style: u,
		children: /* @__PURE__ */ j(x, {
			open: !0,
			children: [/* @__PURE__ */ A(re, {}), /* @__PURE__ */ A(ee, {
				container: S,
				children: /* @__PURE__ */ A(oe, {
					onOpenAutoFocus: (e) => e.preventDefault(),
					"data-testid": ko,
					className: wo.root,
					side: i.popoverContent?.side ?? "top",
					align: i.popoverContent?.align ?? "start",
					children: /* @__PURE__ */ A(Ro.Provider, {
						value: {
							matchText: p,
							insertContent: b,
							eventEmitter: Lo
						},
						children: i.component
					})
				})
			})]
		})
	});
}, Vo = {
	root: "h-inputRichText-toolbarButton--toolbarButton__root",
	rootDisabled: "h-inputRichText-toolbarButton--toolbarButton__rootDisabled",
	rootActive: "h-inputRichText-toolbarButton--toolbarButton__rootActive",
	rootWithBadge: "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge"
};
//#endregion
//#region src/components/inputRichText/toolbarButton/toolbarButton.tsx
function Ho({ className: e, isActive: t, icon: n, disabled: r, showBadge: i, tooltip: a, tabIndex: o = -1, ...s }) {
	let c = O({
		[Vo.root]: Vo.root,
		[Vo.rootActive]: t,
		[Vo.rootDisabled]: r,
		[Vo.rootWithBadge]: i
	}, e), l = /* @__PURE__ */ A("button", {
		tabIndex: o,
		type: "button",
		...s,
		className: c,
		disabled: r,
		children: /* @__PURE__ */ A("span", { children: /* @__PURE__ */ A(u, { name: n }) })
	});
	return a ? /* @__PURE__ */ A(U, {
		content: a,
		side: "top",
		wrap: "none",
		children: l
	}) : l;
}
var Uo = {
	dropzone: "h-inputRichText-attachmentButton--attachmentButton__dropzone",
	fileInput: "h-inputRichText-attachmentButton--attachmentButton__fileInput",
	dropdown: "h-inputRichText-attachmentButton--attachmentButton__dropdown",
	dropzoneIcon: "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon"
}, Wo = class extends N {
	static displayName = "AttachmentButtonDropzone";
	constructor(e) {
		super(e), this.state = { fileHover: !1 };
	}
	handleDragEnter = (e) => {
		e.preventDefault();
		let { allowAttachments: t } = this.props;
		t && e.dataTransfer?.types?.includes("Files") && this.setState({ fileHover: !0 });
	};
	handleDragLeave = (e) => {
		e.preventDefault(), this.setState({ fileHover: !1 });
	};
	handleAttachmentDrop = (e) => {
		e.preventDefault();
		let { onAddAttachment: t } = this.props;
		e.dataTransfer && t(e.dataTransfer.files), this.setState({ fileHover: !1 });
	};
	render() {
		let { className: e, children: t, isAttachmentsUploading: n, allowAttachments: r, allowInline: i, onAddAttachment: a, ...o } = this.props, { fileHover: s } = this.state, c = O(e), l = s || n;
		return /* @__PURE__ */ j("div", {
			...o,
			className: c,
			onDragEnter: this.handleDragEnter,
			onDragOver: this.handleDragEnter,
			onDragLeave: this.handleDragLeave,
			onDrop: this.handleAttachmentDrop,
			children: [
				t,
				l && /* @__PURE__ */ A(he, { children: n ? "Uploading..." : "Drop to add an attachment" }),
				!l && "Drop the file or click to upload"
			]
		});
	}
}, Go = [{
	name: "addAttachment",
	label: "Add attachment",
	keybindings: [[["$metaOrCtrl"], "KeyU"]]
}], Ko = class extends N {
	unsubscribeAddAttachment;
	fileInputRef;
	constructor(e) {
		super(e), this.fileInputRef = P(), this.unsubscribeAddAttachment = Qe;
	}
	componentDidMount() {
		this.unsubscribeAddAttachment = this.props.editor.events.subscribe("addAttachment", () => {
			this.props.disabled || this.fileInputRef.current?.click();
		});
	}
	componentWillUnmount() {
		this.unsubscribeAddAttachment?.();
	}
	openFileBrowser = (e) => {
		e.preventDefault();
		let { current: t } = this.fileInputRef;
		t && t.click();
	};
	handleFileChanged = (e) => {
		let { onAttachFiles: t, editorWindow: n } = this.props, r = e.target;
		r !== null && r instanceof n.HTMLInputElement && (t(r.files), r.value = "");
	};
	renderDropdown() {
		let { isAttachmentsUploading: e, attachments: t, onAttachFiles: n, children: r, notice: i } = this.props;
		return /* @__PURE__ */ j("div", {
			className: Uo.dropdown,
			children: [
				i,
				/* @__PURE__ */ A(Wo, {
					className: Uo.dropzone,
					onAddAttachment: n,
					attachments: t,
					isAttachmentsUploading: e,
					allowInline: !1,
					onClick: this.openFileBrowser,
					allowAttachments: !0,
					children: /* @__PURE__ */ A(u, {
						name: "paperclip",
						className: Uo.dropzoneIcon
					})
				}),
				r
			]
		});
	}
	preventDefault = (e) => {
		e.preventDefault();
	};
	render() {
		let { className: e, attachments: t, onAttachFiles: n, onDetachFile: r, isAttachmentsUploading: i, dropdownRef: a, editorWindow: o, disabled: s, disabledTooltip: c, notice: l, fixed: u, ...d } = this.props, f = /* @__PURE__ */ A(Ho, {
			onMouseDown: this.preventDefault,
			icon: "paperclip",
			showBadge: t.length > 0,
			disabled: s,
			tooltip: "Insert attachment"
		});
		return s ? /* @__PURE__ */ A(U, {
			content: c,
			disabled: !c,
			children: f
		}) : /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("input", {
			ref: this.fileInputRef,
			type: "file",
			className: Uo.fileInput,
			onChange: this.handleFileChanged,
			multiple: !0
		}), /* @__PURE__ */ A(vn, {
			...d,
			className: e,
			noStyle: !0,
			fixed: u,
			ref: a,
			dropdown: this.renderDropdown(),
			children: f
		})] });
	}
}, qo = {
	root: "h-inputRichText-dropzone--dropzone__root",
	inlineDropzone: "h-inputRichText-dropzone--dropzone__inlineDropzone",
	attachmentDropzone: "h-inputRichText-dropzone--dropzone__attachmentDropzone",
	rootDual: "h-inputRichText-dropzone--dropzone__rootDual",
	icon: "h-inputRichText-dropzone--dropzone__icon"
}, Jo = class extends N {
	static displayName = "InputRichTextDropzone";
	internalDrag = !1;
	constructor(e) {
		super(e), this.state = {
			fileHover: !1,
			overDropzone: !1
		};
	}
	handleDragStart = () => {
		this.internalDrag = !0;
	};
	handleDragEnd = () => {
		this.internalDrag = !1;
	};
	get hasDropTarget() {
		let { allowInlineAttachments: e, allowAttachments: t } = this.props;
		return !!e || !!t;
	}
	handleDragEnter = (e) => {
		if (e.preventDefault(), !this.hasDropTarget || this.internalDrag) return;
		let t = e.dataTransfer?.types, n = t?.includes("Files"), r = t?.includes("text/uri-list");
		!n && !r || this.setState({ fileHover: !0 });
	};
	handleDragLeave = (e) => {
		e.preventDefault(), this.setState({ fileHover: !1 });
	};
	handleEnterDropzone = (e) => {
		e.preventDefault(), this.setState({ overDropzone: !0 });
	};
	handleLeaveDropzone = (e) => {
		e.preventDefault(), this.setState({ overDropzone: !1 });
	};
	async fetchDroppedUrl(e, t) {
		if (e.files.length > 0) {
			t(e.files);
			return;
		}
		let n = e.getData("text/uri-list");
		if (n) {
			try {
				let e = new URL(n);
				if (e.protocol !== "http:" && e.protocol !== "https:") return;
			} catch {
				return;
			}
			try {
				let e = await fetch(n);
				if (!e.ok) return;
				let r = await e.blob(), i = n.split("/").pop()?.split("?")[0] || "dropped-image", a = new File([r], i, { type: r.type }), o = new DataTransfer();
				o.items.add(a), t(o.files);
			} catch {}
		}
	}
	handleInlineDrop = (e) => {
		e.preventDefault();
		let { onAddInline: t } = this.props;
		e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
			overDropzone: !1,
			fileHover: !1
		});
	};
	handleUnclaimedDrop = (e) => {
		e.dataTransfer?.types?.includes("Files") && (e.preventDefault(), this.setState({
			overDropzone: !1,
			fileHover: !1
		}));
	};
	handleAttachmentDrop = (e) => {
		e.preventDefault();
		let { onAddAttachment: t } = this.props;
		e.dataTransfer && typeof t == "function" && this.fetchDroppedUrl(e.dataTransfer, t), this.setState({
			overDropzone: !1,
			fileHover: !1
		});
	};
	render() {
		let { className: e, children: t, allowInlineAttachments: n, allowAttachments: r, onAddInline: i, onMouseDown: a, attachments: o, onAddAttachment: s, ...c } = this.props, { fileHover: l, overDropzone: d } = this.state, f = O({
			[qo.root]: !0,
			[qo.rootDual]: n && r
		}, e), p = {
			onDragStart: this.handleDragStart,
			onDragEnd: this.handleDragEnd,
			onDragEnter: this.handleDragEnter,
			onDragOver: this.handleDragEnter,
			onDragLeave: this.handleDragLeave,
			onDrop: this.handleUnclaimedDrop
		};
		return a && (p.onClick = a), /* @__PURE__ */ j("div", {
			...c,
			tabIndex: -1,
			className: f,
			...p,
			children: [t, (l || d) && /* @__PURE__ */ j(he, { children: [n && /* @__PURE__ */ j("div", {
				onDragEnter: this.handleEnterDropzone,
				onDragLeave: this.handleLeaveDropzone,
				onDrop: this.handleInlineDrop,
				className: qo.inlineDropzone,
				children: [/* @__PURE__ */ A(u, {
					name: "upload",
					size: 24,
					className: qo.icon
				}), "Drop to add inline"]
			}), r && /* @__PURE__ */ j("div", {
				onDragEnter: this.handleEnterDropzone,
				onDragLeave: this.handleLeaveDropzone,
				onDrop: this.handleAttachmentDrop,
				className: qo.attachmentDropzone,
				children: [/* @__PURE__ */ A(u, {
					name: "paperclip",
					size: 24,
					className: qo.icon
				}), "Drop to add an attachment"]
			})] })]
		});
	}
}, Yo = (e, t) => e.split(RegExp(`(${ki(t)})`, "gi")).map((e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ A("span", { children: e }, n) : e), Xo = {
	root: "h-inputRichText-emoji--emoji__root",
	decorator: "h-inputRichText-emoji--emoji__decorator",
	suggestion: "h-inputRichText-emoji--emoji__suggestion",
	suggestionActive: "h-inputRichText-emoji--emoji__suggestionActive",
	suggestionName: "h-inputRichText-emoji--emoji__suggestionName"
}, Zo = be(() => import("./emoji-CgOyphi_.js").then((e) => e.t).then((e) => ({ default: e.EmojiPicker }))), Qo = {};
m.emojis.forEach((e) => {
	e.forEach((e) => {
		e.shortNames && e.shortNames.forEach((t) => {
			Qo[t.replace(/:/g, "")] = e.emoji;
		});
	});
});
var $o = (e) => {
	let { active: t, item: n, match: r, onSelect: i } = e, a = r ? Yo(n, r) : n;
	return /* @__PURE__ */ j("button", {
		onClick: () => i(n),
		type: "button",
		"aria-current": t,
		className: O(Xo.suggestion, { [Xo.suggestionActive]: t }),
		children: [Qo[n], /* @__PURE__ */ A("span", {
			className: Xo.suggestionName,
			children: a
		})]
	});
}, es = class extends N {
	constructor(e) {
		super(e), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
	}
	componentDidMount() {
		let { editor: e } = this.props;
		e.triggers.add({
			trigger: /(^|\s):/,
			minChars: 2,
			allowSpaces: !1,
			getSuggestions: this.getSuggestions,
			suggestionComponent: $o,
			insertContent: this.insertContent
		});
	}
	insertContent(e, t = "", n) {
		this.insertEmoji(Qo[e], t, n);
	}
	insertEmoji(e, t, n) {
		let { editor: r } = this.props, i = document.createElement("span");
		i.classList.add(Xo.decorator), i.innerHTML = e, r.content.insert(i, { getSelection: () => {
			let e = r.selection.recreate();
			return t && e?.anchorNode && e.extend(e.anchorNode, n), e;
		} });
	}
	getSuggestions = (e) => Object.keys(Qo).filter((t) => t.indexOf(e) !== -1);
	preventDefault = (e) => {
		e.preventDefault();
	};
	renderDropdown = () => /* @__PURE__ */ A(ge, {
		fallback: /* @__PURE__ */ A("div", { children: "Loading..." }),
		children: /* @__PURE__ */ A(_n.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ A(Zo, { onSelect: (t) => {
			this.insertEmoji(t), e();
		} }) })
	});
	render() {
		let { className: e, fixed: t } = this.props;
		return /* @__PURE__ */ A("div", {
			className: O({ [Xo.root]: !0 }, e),
			children: /* @__PURE__ */ A(vn, {
				icon: "smile",
				dropdown: this.renderDropdown(),
				noStyle: !0,
				fixed: t,
				children: /* @__PURE__ */ A(Ho, {
					icon: "smile",
					tooltip: "Emojis",
					onMouseDown: this.preventDefault
				})
			})
		});
	}
}, ts = {
	inputWrapper: "h-inputRichText--inputRichText__inputWrapper",
	root: "h-inputRichText--inputRichText__root",
	toolbar: "h-inputRichText--inputRichText__toolbar",
	toolbarEnd: "h-inputRichText--inputRichText__toolbarEnd",
	toolbarHint: "h-inputRichText--inputRichText__toolbarHint",
	toolbarHintVisible: "h-inputRichText--inputRichText__toolbarHintVisible",
	toolbarHintHidden: "h-inputRichText--inputRichText__toolbarHintHidden",
	editorWrap: "h-inputRichText--inputRichText__editorWrap",
	rootFileHover: "h-inputRichText--inputRichText__rootFileHover",
	placeholder: "h-inputRichText--inputRichText__placeholder",
	editor: "h-inputRichText--inputRichText__editor",
	pulse: "h-inputRichText--inputRichText__pulse",
	editorDisabled: "h-inputRichText--inputRichText__editorDisabled",
	fileInput: "h-inputRichText--inputRichText__fileInput",
	uiBlocker: "h-inputRichText--inputRichText__uiBlocker"
};
//#endregion
//#region src/components/inputRichText/utils/buildInsertLinkHtml.ts
function ns(e, t) {
	let n = (e) => e.replace(/&/g, "&amp;");
	return `<a href="${n(e)}">${n(t)}</a>`;
}
//#endregion
//#region src/components/inputRichText/utils/formatShortcut.ts
function rs(e) {
	if (!e || e.length === 0) return "";
	let [t = [], n = ""] = e[0];
	if (!n) return "";
	let r = [...new Set(t.map((e) => is(e)))].filter(Boolean), i = as(n);
	return so ? [...r, i].join("") : [...r, i].join("+");
}
function is(e) {
	if (so) switch (e) {
		case "$metaOrCtrl":
		case "Meta": return "⌘";
		case "Control":
		case "$controlOrAlt": return "⌃";
		case "Shift": return "⇧";
		case "Alt": return "⌥";
		default: return e;
	}
	switch (e) {
		case "$metaOrCtrl":
		case "Control": return "Ctrl";
		case "$controlOrAlt":
		case "Alt": return "Alt";
		case "Shift": return "Shift";
		case "Meta": return "Win";
		default: return e;
	}
}
function as(e) {
	if (e.startsWith("Key")) return e.slice(3);
	if (e.startsWith("Digit")) return e.slice(5);
	switch (e) {
		case "Backslash": return "\\";
		case "Slash": return "/";
		case "Enter": return so ? "↵" : "Enter";
		case "Escape": return "Esc";
		case "Space": return "Space";
		case "Backspace": return so ? "⌫" : "Backspace";
		case "Delete": return so ? "⌦" : "Del";
		case "ArrowUp": return "↑";
		case "ArrowDown": return "↓";
		case "ArrowLeft": return "←";
		case "ArrowRight": return "→";
		default: return e;
	}
}
var os = {
	linkOpener: "h-inputRichText-linkButton--linkButton__linkOpener",
	dropdownContainer: "h-inputRichText-linkButton--linkButton__dropdownContainer"
}, ss = {
	root: "h-inputRichText-linkButton--linkMenu__root",
	field: "h-inputRichText-linkButton--linkMenu__field"
}, cs = class extends N {
	constructor(e) {
		super(e);
		let { initialText: t, initialUrl: n } = e;
		this.state = {
			textValue: t,
			urlValue: n
		};
	}
	componentDidUpdate(e) {
		let { initialText: t, initialUrl: n } = this.props;
		(t !== e.initialText || n !== e.initialUrl) && this.setState({
			textValue: t,
			urlValue: n
		});
	}
	handleTextChange = (e) => {
		e && this.setState({ textValue: e.target.value });
	};
	handleUrlChange = (e) => {
		e && this.setState({ urlValue: e.target.value });
	};
	handleAddLink = (e) => {
		e?.preventDefault();
		let { onAddLink: t, toggleDropdown: n } = this.props, { textValue: r, urlValue: i } = this.state;
		i && (t(r || void 0, i), n());
	};
	handleUnlink = (e) => {
		e.preventDefault();
		let { onUnlink: t, toggleDropdown: n } = this.props;
		t(), n();
	};
	handleKeyDown = (e) => {
		e.key === "Enter" && (e.preventDefault(), this.handleAddLink());
	};
	render() {
		let { className: e, initialText: t, initialUrl: n, onAddLink: r, toggleDropdown: i, onUnlink: a, ...o } = this.props, { textValue: s, urlValue: c } = this.state, l = O({ [ss.root]: !0 }, e);
		return /* @__PURE__ */ j("div", {
			...o,
			className: l,
			children: [
				/* @__PURE__ */ A(za, {
					label: "Link title",
					noAlert: !0,
					className: ss.field,
					input: {
						value: s,
						name: "pleasedontautofillthis",
						onChange: this.handleTextChange
					},
					onKeyDown: this.handleKeyDown
				}),
				/* @__PURE__ */ A(za, {
					label: "Link URL",
					noAlert: !0,
					className: ss.field,
					input: {
						value: c,
						name: "link_url",
						onChange: this.handleUrlChange
					},
					onKeyDown: this.handleKeyDown,
					autoFocus: !0
				}),
				/* @__PURE__ */ j(G, {
					gap: "200",
					children: [/* @__PURE__ */ A(g, {
						variant: "primary",
						onClick: this.handleAddLink,
						children: "Add"
					}), !!c && /* @__PURE__ */ A(g, {
						variant: "secondary",
						onClick: this.handleUnlink,
						children: "Remove link"
					})]
				})
			]
		});
	}
}, ls = [{
	name: "hyperlink",
	label: "Link: insert",
	keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
}, {
	name: "removeHyperlink",
	label: "Link: remove",
	keybindings: [],
	callback: (e) => e.command.run("unlink")
}], us = ({ editor: e }) => {
	let [t, n] = Te((e) => e + 1, 0), [r, i] = Pe(!1), a = B(null), o = B(), [{ hoverLinkBounds: s, hoverLinkHref: c, selectedLink: l, selectedText: d }, f] = Ne({
		selectedLink: "",
		selectedText: "",
		hoverLinkHref: null,
		hoverLinkBounds: null
	});
	je(() => {
		e.events.onMouseOver((e) => {
			m(e);
		}), o.current = e.events.subscribe("hyperlink", () => {
			i(!0);
		}), e.selection.onUpdate(() => {
			p();
		});
	}), Fe(() => {
		o.current?.();
	});
	let p = () => {
		let t = e.selection.recreate();
		if (!t) return;
		let { anchorNode: n, focusNode: r } = t;
		if (n && r === n && n.parentElement?.nodeName === "A") {
			let { href: e, innerText: t } = n.parentElement;
			f({
				selectedLink: e,
				selectedText: t
			});
		} else f({
			selectedLink: "",
			selectedText: t.toString()
		});
	}, m = L((t) => {
		let { target: n } = t, { current: r } = e.ref;
		if (r && n && n instanceof HTMLAnchorElement) {
			let e = r.getBoundingClientRect(), t = n.getBoundingClientRect();
			f({
				hoverLinkHref: n.getAttribute("href"),
				hoverLinkBounds: {
					top: t.top - e.top,
					left: t.left - e.left,
					width: t.width
				}
			});
		} else f({
			hoverLinkHref: null,
			hoverLinkBounds: null
		});
	}, [e.ref, f]), h = L(() => {
		let t = e.selection.recreate();
		if (!t) return;
		let { anchorNode: n, focusNode: r } = t;
		if (n && n === r && n.parentElement?.nodeName === "A") {
			let e = document.createRange();
			e.selectNodeContents(n.parentElement), t.removeAllRanges(), t.addRange(e);
		}
	}, [e.selection]), g = L((t, r) => {
		r && (h(), e.command.run("insertHTML", ns(r, t || r)), n());
	}, [e.command, h]), _ = L(() => {
		h(), e.command.run("unlink");
	}, [e.command, h]), v = L((e) => {
		e.preventDefault();
	}, []);
	return Oe(a, () => {
		i(!1);
	}), Ae("Escape", () => {
		i(!1), h();
	}), /* @__PURE__ */ j(he, { children: [/* @__PURE__ */ j("div", {
		ref: a,
		className: os.dropdownContainer,
		children: [/* @__PURE__ */ A(Ho, {
			isActive: !!l,
			icon: "link",
			onMouseDown: v,
			onClick: () => i(),
			tooltip: `Insert link (${rs(ls[0].keybindings)})`
		}), r && /* @__PURE__ */ A(hn, {
			isOpen: r,
			children: /* @__PURE__ */ A(cs, {
				onAddLink: g,
				toggleDropdown: i,
				initialUrl: l,
				initialText: d,
				onUnlink: _
			})
		})]
	}), !!s && !!c && /* @__PURE__ */ A("a", {
		className: os.linkOpener,
		href: c,
		target: "_blank",
		rel: "noopener noreferrer",
		style: {
			top: `${s.top}px`,
			left: `${s.left + s.width}px`
		},
		children: /* @__PURE__ */ A(u, {
			className: "icon-vertical-fix",
			name: "external-link"
		})
	})] });
}, Z = {
	root: "h-tabs--tabs__root",
	tabs: "h-tabs--tabs__tabs",
	tabsTop: "h-tabs--tabs__tabsTop",
	tabsBottom: "h-tabs--tabs__tabsBottom",
	tab: "h-tabs--tabs__tab",
	tabTop: "h-tabs--tabs__tabTop",
	tabTopActive: "h-tabs--tabs__tabTopActive",
	tabTopSelected: "h-tabs--tabs__tabTopSelected",
	tabLeft: "h-tabs--tabs__tabLeft",
	tabLeftActive: "h-tabs--tabs__tabLeftActive",
	tabLeftSelected: "h-tabs--tabs__tabLeftSelected",
	tabBottom: "h-tabs--tabs__tabBottom",
	tabBottomActive: "h-tabs--tabs__tabBottomActive",
	tabBottomSelected: "h-tabs--tabs__tabBottomSelected",
	tabRight: "h-tabs--tabs__tabRight",
	tabRightActive: "h-tabs--tabs__tabRightActive",
	tabRightSelected: "h-tabs--tabs__tabRightSelected",
	tabDisabled: "h-tabs--tabs__tabDisabled"
}, ds = 13, fs = class extends N {
	constructor(e) {
		super(e), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
	}
	handleOnClick() {
		let { id: e, onChange: t, disabled: n } = this.props;
		n || t(e);
	}
	handleOnKeyDown(e) {
		e.keyCode === ds && this.handleOnClick();
	}
	getClassName() {
		let { selected: e, placement: t, className: n, disabled: r, active: i, selectedClassName: a } = this.props, o = O(Z.tab, n, {
			[Z.tabDisabled]: r,
			[Z.tabTop]: t === "top",
			[Z.tabRight]: t === "right",
			[Z.tabLeft]: t === "left",
			[Z.tabBottom]: t === "bottom",
			[Z.tabTopSelected]: t === "top" && e,
			[Z.tabRightSelected]: t === "right" && e,
			[Z.tabLeftSelected]: t === "left" && e,
			[Z.tabBottomSelected]: t === "bottom" && e,
			[Z.tabTopActive]: t === "top" && i,
			[Z.tabRightActive]: t === "right" && i,
			[Z.tabLeftActive]: t === "left" && i,
			[Z.tabBottomActive]: t === "bottom" && i
		});
		return a && (o = O(o, { [a]: e })), o;
	}
	render() {
		let { id: e, label: t, icon: n, disabled: r, slotEnd: i, slotStart: a } = this.props;
		return /* @__PURE__ */ j("div", {
			role: "tab",
			className: this.getClassName(),
			onClick: this.handleOnClick,
			onKeyDown: this.handleOnKeyDown,
			tabIndex: r ? -1 : 0,
			children: [
				a || !!n && /* @__PURE__ */ A(u, {
					name: n,
					className: "icon-vertical-fix"
				}),
				t,
				i
			]
		}, e);
	}
}, ps = class extends N {
	containerRef;
	static defaultProps = { tabsPlacement: "top" };
	constructor(e) {
		super(e), this.containerRef = P(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
	}
	renderTab({ id: e, label: t, icon: n, disabled: r, slotEnd: i, slotStart: a }) {
		let { selectedId: o, activeId: s, onChange: c, tabsPlacement: l, tabClassName: u, tabSelectedClassName: d } = this.props;
		return /* @__PURE__ */ A(fs, {
			selected: e === o,
			className: u,
			selectedClassName: d,
			id: e,
			label: t,
			icon: n,
			onChange: c,
			placement: l,
			disabled: r,
			active: e === s,
			slotEnd: i,
			slotStart: a
		}, e);
	}
	renderTabs() {
		let { tabs: e } = this.props;
		return e.map(this.renderTab);
	}
	render() {
		let { className: e, tabClassName: t, tabSelectedClassName: n, tabs: r, selectedId: i, onChange: a, tabsPlacement: o, activeId: s, ...c } = this.props, l = O(Z.root, e);
		return /* @__PURE__ */ A("div", {
			ref: this.containerRef,
			...c,
			className: l,
			children: /* @__PURE__ */ A("div", {
				className: Z.tabs,
				children: this.renderTabs()
			})
		});
	}
}, ms = mt(ps, { fallback: null }), hs = {
	root: "h-inputRichText-quickResponseSelector--quickResponseItem__root",
	rootActive: "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive",
	name: "h-inputRichText-quickResponseSelector--quickResponseItem__name",
	excerpt: "h-inputRichText-quickResponseSelector--quickResponseItem__excerpt"
}, gs = class extends N {
	constructor(e) {
		super(e), this.handleSelect = this.handleSelect.bind(this);
	}
	handleSelect() {
		let { isLoading: e, onSelect: t, item: n } = this.props;
		e || t(n);
	}
	render() {
		let { className: e, item: t, isLoading: n, onSelect: r, active: a, searchValue: o, clearSearch: s, ...c } = this.props, { name: l, content: u, matched: d } = !n && t ? t : {
			name: "Loading...",
			content: "",
			matched: ""
		}, f = O({
			[hs.root]: hs.root,
			[hs.rootActive]: a
		}, e), p = d ? Yo(l, d) : l;
		return /* @__PURE__ */ j("button", {
			type: "button",
			"aria-current": a,
			...c,
			className: f,
			onClick: this.handleSelect,
			title: l,
			children: [/* @__PURE__ */ A(i.Heading, {
				variant: "heading-3",
				className: hs.name,
				children: p
			}), /* @__PURE__ */ A(i.Paragraph, {
				variant: "4",
				className: hs.name,
				subdued: !0,
				children: u
			})]
		});
	}
}, _s = {
	container: "h-inputRichText-quickResponseSelector--quickResponseSelector__container",
	dropdownButtonContainer: "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer",
	tabbedDropdown: "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown",
	tabbedDropdownTabs: "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs",
	tabbedDropdownTabsContent: "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent",
	regularDropdown: "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown",
	noItemFound: "h-inputRichText-quickResponseSelector--quickResponseSelector__noItemFound"
}, vs = /(^|\s)=/, ys = "Quick replies", bs = class extends me {
	constructor(e) {
		super(e), this.state = {
			searchTerm: "",
			selectedTab: e.languages[0]?.code
		}, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
	}
	componentDidMount() {
		let { editor: e } = this.props;
		e.triggers.add({
			trigger: vs,
			minChars: 0,
			allowSpaces: !0,
			getSuggestions: this.handleSearchChange,
			suggestionComponent: gs,
			getPagination: this.getPagination,
			getTabs: this.getTabDefinitions,
			insertContent: this.insertContent
		});
	}
	normalizeSuggestion(e) {
		let { quickResponsesApi: t } = this.props;
		return {
			id: e.name,
			matched: t.params.search ?? "",
			...e
		};
	}
	getTabDefinitions() {
		let { languages: e } = this.props;
		return e.map((e) => ({
			id: e.code,
			label: e.label
		}));
	}
	handleNextPage() {
		let { quickResponsesApi: e } = this.props;
		return new Promise((t) => e.getItemsAsyncStatus === "loading" ? t(e.items.map(this.normalizeSuggestion)) : t(e.nextPage().then((e) => e.map(this.normalizeSuggestion)).catch((e) => {
			console.error(e);
		})));
	}
	preventDefault = (e) => {
		e.preventDefault();
	};
	handleSelect = (e, t) => {
		this.insertContent(e)?.then(() => {
			t && t();
		});
	};
	insertContent = (e, t, n) => {
		let { renderQuickResponse: r, sanitize: i, editor: a } = this.props;
		return r(e).then((e) => {
			let r = a.selection.recreate();
			if (!r) return;
			let o = !!t, s = o && !!r.anchorNode?.textContent?.match(`^${vs.source}`) || !o && !r.anchorNode?.textContent, c;
			c = s ? vo(bo(i(e), { inline: !1 })) : bo(i(e), { inline: !0 }), r?.rangeCount && r?.rangeCount > 0 && a.content.insert(r.getRangeAt(0).createContextualFragment(c), { getSelection: () => {
				let e = a.selection.recreate();
				return o && e?.anchorNode && e.extend(e.anchorNode, n), e;
			} });
		});
	};
	handleToggle(e) {
		let { quickResponsesApi: t, languages: n } = this.props;
		e && (t.params.search !== "" || t.params.locale !== n[0]?.code) && this.setState({
			searchTerm: "",
			selectedTab: n[0]?.code
		}, () => {
			let { searchTerm: e, selectedTab: t } = this.state;
			this.handleSearchChange(e, t, 0);
		});
	}
	getPagination() {
		let { quickResponsesApi: e } = this.props;
		return {
			nextEnable: e.hasNextPage,
			previousEnable: !1,
			infinite: !0,
			onNext: this.handleNextPage
		};
	}
	handleSearchChange(e, t, n) {
		let { quickResponsesApi: r } = this.props;
		return r.paramsChange({
			search: e,
			locale: t
		}, n).then((e) => e.map(this.normalizeSuggestion));
	}
	handleTabbedSearchChange(e) {
		this.setState({ searchTerm: e }, () => {
			let { searchTerm: e, selectedTab: t } = this.state;
			this.handleSearchChange(e, t);
		});
	}
	handleTabChange(e) {
		this.setState({ selectedTab: e }, () => {
			let { searchTerm: e, selectedTab: t } = this.state;
			this.handleSearchChange(e, t, 0);
		});
	}
	renderIcon() {
		return /* @__PURE__ */ A(Ho, {
			icon: this.props.iconName ?? "bolt",
			onMouseDown: this.preventDefault
		});
	}
	renderItemsWithoutTabs() {
		let { className: e, quickResponsesApi: t } = this.props;
		return /* @__PURE__ */ A(U, {
			content: `${ys} (=)`,
			children: /* @__PURE__ */ A(Ua, {
				className: e,
				dropdownProps: { className: _s.regularDropdown },
				containerProps: { className: _s.container },
				items: t.items.map(this.normalizeSuggestion),
				pagination: this.getPagination(),
				itemComponent: gs,
				hasSearch: !0,
				noStyle: !0,
				onSearch: this.handleSearchChange,
				onSelect: this.handleSelect,
				onToggle: this.handleToggle,
				emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
				children: this.renderIcon()
			})
		});
	}
	renderItemsWithTabs() {
		let { className: e } = this.props, { selectedTab: t } = this.state;
		return /* @__PURE__ */ A("div", {
			className: _s.dropdownButtonContainer,
			children: /* @__PURE__ */ A(U, {
				content: `${ys} (=)`,
				children: /* @__PURE__ */ A(vn, {
					className: e,
					noStyle: !0,
					onToggle: this.handleToggle,
					buttonProps: { title: ys },
					dropdown: /* @__PURE__ */ j("div", {
						className: _s.tabbedDropdown,
						children: [/* @__PURE__ */ A(ps, {
							className: _s.tabbedDropdownTabs,
							tabs: this.getTabDefinitions(),
							tabsPlacement: "left",
							selectedId: t,
							onChange: this.handleTabChange
						}), /* @__PURE__ */ A("div", {
							className: _s.tabbedDropdownTabsContent,
							children: this.renderTabItems()
						})]
					}),
					children: this.renderIcon()
				})
			})
		});
	}
	renderTabItems() {
		let { quickResponsesApi: e } = this.props;
		return /* @__PURE__ */ A(_n.Consumer, { children: ({ dropdownOpen: t, closeDropdown: n }) => /* @__PURE__ */ A(Ha, {
			dropdownOpen: t,
			triggerClose: n,
			hasSearch: !0,
			pagination: this.getPagination(),
			items: e.items.map(this.normalizeSuggestion),
			itemComponent: gs,
			onSearch: this.handleTabbedSearchChange,
			onSelect: (e) => this.handleSelect(e, n),
			emptyComponent: Hi,
			emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
		}) });
	}
	render() {
		let { languages: e } = this.props;
		return e?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
	}
}, xs = {
	root: "h-inputRichText-formatSelector--formatSelector__root",
	list: "h-inputRichText-formatSelector--formatSelector__list",
	selector: "h-inputRichText-formatSelector--formatSelector__selector",
	option: "h-inputRichText-formatSelector--formatSelector__option",
	optionActive: "h-inputRichText-formatSelector--formatSelector__optionActive",
	button: "h-inputRichText-formatSelector--formatSelector__button"
}, Ss = [
	{
		name: "noHeading",
		label: "Normal",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "div"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "h1",
		label: "Headline 1",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<H1>"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "h2",
		label: "Headline 2",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<H2>"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "h3",
		label: "Headline 3",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<H3>"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "h4",
		label: "Headline 4",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<H4>"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "h5",
		label: "Headline 5",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<H5>"),
		condition: (e) => e.allowFormatting.includes("format")
	},
	{
		name: "quote",
		label: "Blockquote",
		keybindings: [],
		callback: (e) => e.command.run("formatBlock", "<BLOCKQUOTE>"),
		condition: (e) => e.allowFormatting.includes("format")
	}
], Cs = {
	h1: { tag: "<H1>" },
	h2: { tag: "<H2>" },
	h3: { tag: "<H3>" },
	h4: { tag: "<H4>" },
	h5: { tag: "<H5>" },
	noHeading: {
		default: !0,
		tag: "div"
	},
	quote: { tag: "<BLOCKQUOTE>" }
}, ws = class extends N {
	preventDefault = (e) => {
		e.preventDefault();
	};
	renderDropdown() {
		let { editor: e } = this.props;
		return /* @__PURE__ */ A(_n.Consumer, { children: ({ closeDropdown: t }) => /* @__PURE__ */ A("ul", {
			className: xs.list,
			children: Ss.map((n) => {
				let r = "condition" in n;
				if (!(!r || r && n.condition(e))) return;
				let i = Cs[n.name];
				return /* @__PURE__ */ A("li", {
					className: O(xs.option, { [xs.optionActive]: this.isActiveFormat(i) }),
					children: /* @__PURE__ */ A("button", {
						type: "button",
						className: xs.button,
						onClick: () => {
							n.callback?.(e), t();
						},
						children: n.label
					})
				}, n.name);
			}).filter(Boolean)
		}) });
	}
	isActiveFormat(e) {
		let { formatBlock: t } = this.props;
		return !!(!t && e.default || e.tag === t || e.tag === `<${t.toUpperCase()}>`);
	}
	getCurrentFormatName() {
		return Ss.find((e) => this.isActiveFormat(Cs[e.name]))?.label ?? "Normal";
	}
	render() {
		let { className: e, editor: t, formatBlock: n, ...r } = this.props;
		return /* @__PURE__ */ A(vn, {
			className: O(xs.root, e),
			...r,
			dropdown: this.renderDropdown(),
			noStyle: !0,
			children: /* @__PURE__ */ j("div", {
				className: xs.selector,
				children: [this.getCurrentFormatName(), /* @__PURE__ */ A(u, {
					className: "icon-vertical-fix",
					name: "angle-down"
				})]
			})
		});
	}
}, Ts = {
	menu: "h-inputRichText-stylingMenu--stylingMenu__menu",
	buttonsContainer: "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer"
}, Es = [
	{
		name: "bold",
		label: "Bold",
		icon: "bold",
		keybindings: [[["$metaOrCtrl"], "KeyB"]],
		preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
		callback: (e) => e.command.run("bold"),
		condition: (e) => e.allowFormatting.includes("bold")
	},
	{
		name: "italic",
		label: "Italic",
		icon: "italic",
		keybindings: [[["$metaOrCtrl"], "KeyI"]],
		preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
		callback: (e) => e.command.run("italic"),
		condition: (e) => e.allowFormatting.includes("italic")
	},
	{
		name: "orderedList",
		label: "List: ordered",
		icon: "list-ol",
		keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
		callback: (e) => e.command.run("insertOrderedList"),
		condition: (e) => e.allowFormatting.includes("orderedList")
	},
	{
		name: "unorderedList",
		label: "List: unordered",
		icon: "list-ul",
		keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
		callback: (e) => e.command.run("insertUnorderedList"),
		condition: (e) => e.allowFormatting.includes("unorderedList")
	},
	{
		name: "inlineCode",
		label: "Inline code",
		icon: "code",
		keybindings: [[["$metaOrCtrl"], "KeyE"]],
		preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
		callback: (e) => e.command.run("inlineCode"),
		condition: (e) => e.allowFormatting.includes("inlineCode")
	},
	{
		name: "blockquote",
		label: "Quote text",
		icon: "quote",
		keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
		callback: (e) => {
			let t = e.window.getSelection();
			if (!t) return;
			let n = t.anchorNode, r = !!(io(n) ? n : n?.parentElement)?.closest("blockquote");
			e.command.run("formatBlock", r ? "div" : "<BLOCKQUOTE>");
		},
		condition: (e) => e.allowFormatting.includes("blockquote")
	},
	{
		name: "noFormat",
		label: "Clear formatting",
		icon: "pen-slash",
		keybindings: [[["$metaOrCtrl"], "Backslash"]],
		preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
		callback: (e) => e.command.run("removeFormat")
	}
], Ds = [...Ss, ...Es], Os = class extends N {
	domRef;
	constructor(e) {
		super(e), this.state = {
			isOpen: !1,
			currentFormat: ""
		}, this.domRef = P(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
	}
	componentDidMount() {
		let { editor: e } = this.props;
		e.selection.onUpdate(() => {
			this.updateCurrentFormat();
		});
	}
	componentDidUpdate(e, t) {
		let { isOpen: n } = this.state, { editorWindow: r } = this.props;
		n !== t.isOpen && r[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside, !0);
	}
	componentWillUnmount() {
		let { isOpen: e } = this.state, { editorWindow: t } = this.props;
		e && t.removeEventListener("click", this.handleClickOutside, !0);
	}
	updateCurrentFormat() {
		let { editorWindow: e } = this.props;
		this.setState({ currentFormat: fo(e) });
	}
	handleClickOutside = (e) => {
		let { current: t } = this.domRef;
		t && e.target instanceof Element && e.target !== t && !t.contains(e.target) && this.setState({ isOpen: !1 });
	};
	handleClick = (e) => {
		e.preventDefault();
		let { isOpen: t } = this.state;
		this.setState({ isOpen: !t });
	};
	handleToolbarButtonClick(e) {
		return (t) => {
			let { editor: n } = this.props;
			t.preventDefault(), e && (Ds.find((t) => t.name === e)?.callback(n), this.forceUpdate());
		};
	}
	styleActive(e) {
		let { editor: t } = this.props;
		if (e === "blockquote") {
			let e = t.window.getSelection();
			if (!e) return !1;
			let n = e.anchorNode;
			return !!(io(n) ? n : n?.parentElement)?.closest("blockquote");
		}
		return t.command.active(e);
	}
	render() {
		let { className: e, isActive: t, editor: n, editorWindow: r, ...i } = this.props, { isOpen: a, currentFormat: o } = this.state, s = O(e);
		return /* @__PURE__ */ j("div", {
			...i,
			className: s,
			ref: this.domRef,
			children: [a && /* @__PURE__ */ j("div", {
				className: Ts.menu,
				children: [n.allowFormatting.includes("format") && /* @__PURE__ */ A(ws, {
					formatBlock: o,
					editor: this.props.editor
				}), /* @__PURE__ */ A("div", {
					className: Ts.buttonsContainer,
					children: Es.map((e) => {
						let t = "condition" in e;
						if (!(!t || t && e.condition(n))) return;
						let r = rs(e.keybindings), i = r ? `${e.label} (${r})` : e.label;
						return /* @__PURE__ */ A(Ho, {
							isActive: this.styleActive(e.name),
							onMouseDown: this.handleToolbarButtonClick(e.name),
							icon: e.icon,
							tooltip: i
						}, e.name);
					}).filter(Boolean)
				})]
			}), /* @__PURE__ */ A(Ho, {
				isActive: t,
				icon: "format",
				onClick: this.handleClick,
				tooltip: "Formatting"
			})]
		});
	}
}, ks = {
	dropdown: "h-inputRichText-suggestions--suggestions__dropdown",
	dropdownWithTabs: "h-inputRichText-suggestions--suggestions__dropdownWithTabs",
	dropdownWithoutTabs: "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs",
	dropdownTabs: "h-inputRichText-suggestions--suggestions__dropdownTabs",
	dropdownTabsContent: "h-inputRichText-suggestions--suggestions__dropdownTabsContent"
};
//#endregion
//#region src/components/inputRichText/suggestions/suggestions.tsx
function As(e) {
	if (!e) return null;
	let { focusOffset: t, anchorOffset: n, anchorNode: r } = e;
	return t !== n || !r || r.nodeName !== "#text" ? null : r?.textContent?.slice(0, t);
}
var js = class extends N {
	dropdownRef;
	tabsRef;
	constructor(e) {
		super(e), this.state = {
			listenForSelectionChange: !0,
			suggestions: null,
			suggestionPosition: null,
			suggestionIndex: 0,
			suggestionExtendBy: 0,
			suggestionTrigger: null,
			suggestionMatchedString: "",
			selectedTab: null,
			selectionMode: "suggestion",
			tabIndex: 0
		}, this.dropdownRef = P(), this.tabsRef = P(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
	}
	componentDidMount() {
		let { editor: e } = this.props;
		e.selection.onUpdate(this.handleSelectionChange), e.events.onBlur(this.handleBlur), e.hotkeys.add([
			{
				keybindings: [[[], "ArrowUp"]],
				condition: () => this.shouldHandleKey(),
				callback: () => this.handleArrowKey(-1)
			},
			{
				keybindings: [[[], "ArrowDown"]],
				condition: () => this.shouldHandleKey(),
				callback: () => this.handleArrowKey(1)
			},
			{
				keybindings: [[[], "Escape"]],
				condition: () => this.hasSuggestions() || this.hasTabs(),
				callback: (e, t) => this.handleEscapeKey(t)
			},
			{
				keybindings: [[[], "Enter"]],
				condition: () => this.shouldHandleKey(),
				callback: () => this.handleEnterKey()
			}
		]);
	}
	componentDidUpdate(e, t) {
		let { suggestionIndex: n, tabIndex: r } = this.state;
		n !== t.suggestionIndex && this.updateSuggestionScroll(), r !== t.tabIndex && this.updateTabScroll();
	}
	shouldHandleKey() {
		let { selectionMode: e } = this.state;
		return e === "suggestion" && this.hasSuggestions() || e === "tab" && this.hasTabs();
	}
	handleArrowKey(e) {
		let { selectionMode: t } = this.state;
		t === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(e) : t === "tab" && this.hasTabs() && this.tabsNavigate(e);
	}
	handleEscapeKey(e) {
		let { selectionMode: t } = this.state;
		this.shouldRenderDropdown() && e.stopPropagation(), t === "suggestion" && this.hasTabs() ? this.setState({
			selectionMode: "tab",
			tabIndex: this.getSelectedTabIndex()
		}) : this.clearSuggestions();
	}
	handleEnterKey() {
		let { selectionMode: e, tabIndex: t, suggestionTrigger: n } = this.state;
		if (e === "suggestion" && this.hasSuggestions()) this.expandSuggestion();
		else if (e === "tab" && this.hasTabs()) {
			let e = n?.getTabs?.()[t];
			e && this.handleTabChange(e.id);
		}
	}
	handleBlur(e) {
		let { nativeEvent: { relatedTarget: t } } = e;
		t === null && this.clearSuggestions();
	}
	hasSuggestions() {
		let { suggestions: e } = this.state;
		return !!e?.length;
	}
	hasTabs() {
		return !!this.state.suggestionTrigger?.getTabs?.().length;
	}
	getSelectedTabIndex() {
		let { suggestionTrigger: e, selectedTab: t } = this.state;
		return this.hasTabs() ? e?.getTabs?.().findIndex((e) => e.id === t) : -1;
	}
	clearSuggestions() {
		this.setState({
			suggestions: null,
			suggestionPosition: null,
			selectedTab: null,
			selectionMode: "suggestion"
		});
	}
	suggestionsNavigate(e) {
		this.setState(({ suggestionIndex: t, suggestions: n }) => {
			if (n && n.length) {
				let r;
				return r = e < 0 ? t > 0 ? t - 1 : n.length - 1 : (t + 1) % n.length, { suggestionIndex: r };
			}
			return null;
		});
	}
	tabsNavigate(e) {
		this.setState(({ tabIndex: t, suggestionTrigger: n }) => {
			let r = n?.getTabs?.();
			if (r?.length) {
				let n;
				return n = e < 0 ? t > 0 ? t - 1 : r.length - 1 : (t + 1) % r.length, { tabIndex: n };
			}
			return null;
		});
	}
	lookForTriggers(e, t) {
		let { editor: n } = this.props, { selectedTab: r, selectionMode: i } = this.state, a = As(n.selection.recreate({ focus: !1 }));
		if (a) {
			let o = n.triggers.test(a);
			if (o && n.triggers.isSuggestionTrigger(o.matchedTrigger)) {
				let { match: n, matchedTrigger: a } = o, s = a?.getTabs?.();
				if (s?.length) {
					let t = null;
					if (e ? t = {
						selectionMode: "suggestion",
						selectedTab: e,
						tabIndex: -1
					} : r ? e = r : t = {
						selectionMode: "tab",
						selectedTab: s[0].id,
						tabIndex: 0
					}, t && this.setState(t, () => {
						e || this.lookForTriggers();
					}), !e) return;
				} else i !== "suggestion" && this.setState({ selectionMode: "suggestion" });
				Promise.resolve(a.getSuggestions(n[1], e, t)).then((e) => {
					this.updateSuggestions(n, a, e);
				});
				return;
			}
		}
		this.clearSuggestions();
	}
	findTriggerPosition(e, t) {
		this.setState({ listenForSelectionChange: !1 }, () => {
			let { onError: n, editor: r } = this.props, i = r.selection.recreate();
			if (i) {
				let { focusOffset: r, anchorNode: a } = i;
				if (a) {
					if (r - e >= 0) try {
						i.extend(a, r - e);
					} catch (e) {
						n?.(e);
					}
					if (i?.rangeCount && i?.rangeCount > 0) {
						let e = i.getRangeAt(0).getBoundingClientRect();
						i.collapseToEnd(), setTimeout(() => {
							t(e), this.setState({ listenForSelectionChange: !0 });
						});
					}
				}
			}
		});
	}
	updateSuggestions(e, t, n) {
		let { editor: r } = this.props;
		this.findTriggerPosition(e[0].length, (i) => {
			let a = r.selection.recreate();
			if (!a) return;
			let { focusOffset: o } = a, s = new RegExp(t.trigger).exec(e[0])?.[1]?.length ?? 0, c = e[0].length - s;
			this.setState({
				suggestions: n,
				suggestionTrigger: t,
				suggestionPosition: i,
				suggestionIndex: 0,
				suggestionMatchedString: e[1],
				suggestionExtendBy: o - c,
				listenForSelectionChange: !0
			});
		});
	}
	updateSuggestionScroll() {
		let { suggestionIndex: e } = this.state, { current: t } = this.dropdownRef;
		if (t) {
			if (t.infiniteListRef.current) t.infiniteListRef.current.scrollToItem(e);
			else if (t.listRef.current) {
				let n = t.listRef.current, r = t.listRef.current.children[e].getBoundingClientRect(), i = n.getBoundingClientRect();
				i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
			}
		}
	}
	updateTabScroll() {
		let { tabIndex: e } = this.state, { current: t } = this.tabsRef;
		if (!(e < 0 || !t) && t.containerRef.current) {
			let n = t.containerRef.current, r = t.containerRef.current.children[0].children[e].getBoundingClientRect(), i = n.getBoundingClientRect();
			i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
		}
	}
	expandSuggestion() {
		let { suggestions: e, suggestionIndex: t, suggestionExtendBy: n, suggestionTrigger: r } = this.state;
		if (!(!e || !e[t] || !r)) return r.insertContent(e[t], r.trigger, n);
	}
	handleSelectionChange() {
		let { listenForSelectionChange: e } = this.state;
		e && this.lookForTriggers();
	}
	handleSuggestionClick(e) {
		this.setState((t) => ({ suggestionIndex: t.suggestions ? t.suggestions.indexOf(e) : 0 }), () => {
			this.expandSuggestion();
		});
	}
	calculateSuggestionBoxPosition() {
		let { suggestionPosition: e } = this.state, { editor: t } = this.props;
		if (t.ref.current && e) {
			let n = t.ref.current.getBoundingClientRect();
			return {
				bottom: n.bottom - e.bottom + e.height,
				left: e.x - n.x + e.width
			};
		}
		return {};
	}
	suggestionBoxStyle() {
		let { suggestionPosition: e } = this.state, { editor: t } = this.props;
		if (t.ref.current && e) {
			let n = t.ref.current.getBoundingClientRect();
			return {
				left: `${e.x - n.x}px`,
				top: `${e.y - n.y + e.height / 2}px`,
				height: 1,
				width: e.width,
				position: "absolute"
			};
		}
		return {};
	}
	getPagination() {
		let { suggestionTrigger: e } = this.state;
		if (!e || !e.getPagination) return !1;
		let t = e.getPagination();
		return !t || !t.onNext ? !1 : {
			...t,
			onNext: () => t.onNext?.().then((e) => {
				this.setState({ suggestions: e });
			}) ?? Promise.resolve(void 0)
		};
	}
	handleTabChange(e) {
		this.lookForTriggers(e, 0);
	}
	renderEmptyState() {
		return /* @__PURE__ */ A(Hi, { label: "No suggestions found" });
	}
	renderTabs() {
		let { suggestions: e, suggestionTrigger: t, selectedTab: n, tabIndex: r } = this.state, i = t?.getTabs?.() ?? [], a = !!e?.length;
		return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(ps, {
			ref: this.tabsRef,
			className: ks.dropdownTabs,
			tabs: i,
			tabsPlacement: "left",
			selectedId: n,
			activeId: i?.[r]?.id,
			onChange: this.handleTabChange
		}), /* @__PURE__ */ A("div", {
			className: ks.dropdownTabsContent,
			children: a ? this.renderItems() : this.renderEmptyState()
		})] });
	}
	renderItems() {
		let { suggestions: e, suggestionIndex: t, suggestionTrigger: n, selectionMode: r } = this.state, i = n ? n.suggestionComponent : null;
		return /* @__PURE__ */ A(Ri, {
			ref: this.dropdownRef,
			pagination: this.getPagination(),
			items: e || void 0,
			onSelect: this.handleSuggestionClick,
			itemComponent: i,
			activeItem: r === "suggestion" ? e?.[t] : void 0
		});
	}
	shouldRenderDropdown() {
		let { suggestionPosition: e, selectedTab: t, suggestions: n } = this.state;
		return !(!e || !this.hasTabs() && !n?.length || this.hasTabs() && !t);
	}
	render() {
		let { editor: e, onError: t, ...n } = this.props;
		if (!this.shouldRenderDropdown()) return null;
		let r = O(ks.dropdown, {
			[ks.dropdownWithTabs]: this.hasTabs(),
			[ks.dropdownWithoutTabs]: !this.hasTabs()
		});
		return /* @__PURE__ */ A("div", {
			...n,
			children: /* @__PURE__ */ A("div", {
				style: this.suggestionBoxStyle(),
				children: /* @__PURE__ */ A(hn, {
					className: r,
					isOpen: !0,
					children: this.hasTabs() ? this.renderTabs() : this.renderItems()
				})
			})
		});
	}
};
//#endregion
//#region src/components/inputRichText/toolbar/toolbar.tsx
function Ms({ children: e, className: t }) {
	let n = B(null), [r, i] = V(0), a = () => n.current ? Array.from(n.current.querySelectorAll("button:not([disabled])")).filter((e) => e.closest("[role=\"toolbar\"]") === n.current) : [];
	return R(() => {
		let e = a();
		e.length !== 0 && e.forEach((e, t) => {
			t === 0 ? e.setAttribute("tabindex", "0") : e.setAttribute("tabindex", r === t ? "0" : "-1");
		});
	}, [r]), R(() => {
		let e = n.current;
		if (!e) return;
		let t = (e) => {
			let t = a(), n = e.target, r = t.indexOf(n);
			r !== -1 && i(r);
		}, r = (t) => {
			e.contains(t.relatedTarget) || i(0);
		};
		return e.addEventListener("focusin", t), e.addEventListener("focusout", r), () => {
			e.removeEventListener("focusin", t), e.removeEventListener("focusout", r);
		};
	}, []), /* @__PURE__ */ A("div", {
		ref: n,
		className: t,
		role: "toolbar",
		"aria-label": "Text formatting",
		onKeyDown: (e) => {
			let t = a();
			if (t.length === 0) return;
			let o = document.activeElement;
			if (!n.current?.contains(o)) return;
			let s = r;
			switch (e.key) {
				case "ArrowLeft":
				case "ArrowUp":
					e.preventDefault(), e.stopPropagation(), s = s <= 0 ? t.length - 1 : s - 1, i(s), t[s]?.focus();
					break;
				case "ArrowRight":
				case "ArrowDown":
					e.preventDefault(), e.stopPropagation(), s = s >= t.length - 1 ? 0 : s + 1, i(s), t[s]?.focus();
					break;
				case "Home":
					e.preventDefault(), e.stopPropagation(), i(0), t[0]?.focus();
					break;
				case "End":
					e.preventDefault(), e.stopPropagation();
					let n = t.length - 1;
					i(n), t[n]?.focus();
					break;
			}
		},
		children: e
	});
}
//#endregion
//#region src/components/inputRichText/utils/EditorTriggers.ts
function Ns(e) {
	return e instanceof RegExp ? e.source : e;
}
function Ps(e) {
	return e.replace(/\(/g, "(?:");
}
var Fs = class {
	storedTriggers;
	constructor() {
		this.storedTriggers = [];
	}
	get excludeTriggersRegex() {
		return this.storedTriggers.map((e) => `(?!${Ns(e.trigger)})`).join("");
	}
	add(e) {
		this.storedTriggers.push(e);
	}
	update(e) {
		let t = this.storedTriggers.findIndex((t) => this.isAddonTrigger(t) && t.id === e.id);
		t !== -1 && (this.storedTriggers[t] = e);
	}
	test(e) {
		let t;
		for (let n = 0; n < this.storedTriggers.length; n += 1) {
			let r = this.storedTriggers[n], { trigger: i, allowSpaces: a, minChars: o } = r, s = Ps(Ns(i)), c = this.excludeTriggersRegex;
			if (t = RegExp(`${s}((?:${c}${a ? "." : "\\S"})*)$`, "g").exec(e), t && (!o || t[1].length >= o)) return {
				match: t,
				matchedTrigger: r
			};
		}
		return null;
	}
	isSuggestionTrigger(e) {
		return "getSuggestions" in e;
	}
	isAddonTrigger(e) {
		return !this.isSuggestionTrigger(e);
	}
};
//#endregion
//#region src/components/inputRichText/utils/codeFormatting.ts
function Is(e, t) {
	let n = e.getSelection();
	if (!n || n.rangeCount === 0) return !1;
	let r = n.anchorNode, i = t === "inline" ? "CODE" : "PRE";
	for (; r;) {
		if (r.nodeType === Node.ELEMENT_NODE && r.tagName === i) return !0;
		r = r.parentNode;
	}
	return !1;
}
function Ls(e, t) {
	t?.();
	let n = e.getSelection();
	if (!n || n.rangeCount === 0) return;
	let r = n.getRangeAt(0);
	if (Is(e, "inline")) {
		Rs(e, "CODE");
		return;
	}
	let i = r.collapsed, a = e.document.createElement("code");
	if (i) {
		let t = e.document.createTextNode("​");
		a.appendChild(t), r.insertNode(a), r.setStart(a.firstChild, 1), r.setEnd(a.firstChild, 1);
	} else {
		let e = r.extractContents();
		a.appendChild(e), r.insertNode(a), r.setStartAfter(a), r.setEndAfter(a);
	}
	n.removeAllRanges(), n.addRange(r);
}
function Rs(e, t) {
	let n = e.getSelection();
	if (!n || n.rangeCount === 0) return;
	let r = n.anchorNode;
	for (; r;) {
		if (r.nodeType === Node.ELEMENT_NODE) {
			let i = r;
			if (i.tagName === t) {
				let t = i.parentNode;
				if (t) {
					let r = e.document.createDocumentFragment();
					for (; i.firstChild;) r.appendChild(i.firstChild);
					t.replaceChild(r, i);
					let a = e.document.createRange();
					a.selectNodeContents(t), a.collapse(!1), n.removeAllRanges(), n.addRange(a);
				}
				return;
			}
		}
		r = r.parentNode;
	}
}
//#endregion
//#region src/components/inputRichText/utils/imageResize.ts
var zs = 25, Bs = null, Vs = null;
function Hs(e, t) {
	let n = t.document.createElement("div");
	return n.className = `image-resize-handle image-resize-handle-${e}`, n.dataset.handle = e, n;
}
function Us(e, t) {
	let n = t.document.createElement("div");
	return n.className = "image-resize-wrapper", n.contentEditable = "false", e.parentNode?.insertBefore(n, e), n.appendChild(e), [
		"nw",
		"ne",
		"se",
		"sw"
	].forEach((e) => {
		let r = Hs(e, t);
		n.appendChild(r);
	}), n;
}
function Ws(e) {
	let t = e.querySelector("img");
	t && e.parentNode && (e.parentNode.insertBefore(t, e), e.remove());
}
function Gs(e, t, n) {
	let { startX: r, startWidth: i, handle: a, aspectRatio: o } = e, s = t - r, c = i;
	switch (a) {
		case "se":
		case "ne":
			c = i + s;
			break;
		case "sw":
		case "nw":
			c = i - s;
			break;
	}
	let l = c / o;
	c < zs && (c = zs, l = zs / o);
	let u = zs / o;
	return l < u && (l = u, c = u * o), {
		width: c,
		height: l
	};
}
function Ks(e) {
	if (!Bs) return;
	e.preventDefault(), e.stopPropagation();
	let { width: t } = Gs(Bs, e.clientX, e.clientY);
	Bs.img.style.width = `${t}px`, Bs.img.style.height = "auto";
}
function qs(e) {
	if (!Bs) return;
	e.preventDefault(), e.stopPropagation();
	let { img: t } = Bs, n = t.ownerDocument.defaultView;
	n.document.removeEventListener("mousemove", Ks), n.document.removeEventListener("mouseup", qs), Bs = null;
	let r = new Event("input", { bubbles: !0 });
	t.closest("[contenteditable=\"true\"]")?.dispatchEvent(r);
}
function Js(e, t, n) {
	e.preventDefault(), e.stopPropagation();
	let r = t.ownerDocument.defaultView, i = t.closest(".image-resize-wrapper");
	if (!i) return;
	let a = t.naturalWidth, o = t.naturalHeight, s = a / o, c = t.getBoundingClientRect(), l = c.width, u = c.height;
	Bs = {
		img: t,
		originalWidth: a,
		originalHeight: o,
		aspectRatio: s,
		startX: e.clientX,
		startY: e.clientY,
		startWidth: l,
		startHeight: u,
		handle: n,
		wrapper: i
	}, r.document.addEventListener("mousemove", Ks), r.document.addEventListener("mouseup", qs);
}
function Ys(e, t) {
	Vs &&= (Ws(Vs), null);
	let n = Us(e, t);
	Vs = n, n.querySelectorAll(".image-resize-handle").forEach((t) => {
		let n = t.dataset.handle;
		t.addEventListener("mousedown", (t) => Js(t, e, n));
	});
}
function Xs() {
	if (Vs &&= (Ws(Vs), null), Bs) {
		let e = Bs.img.ownerDocument.defaultView;
		e.document.removeEventListener("mousemove", Ks), e.document.removeEventListener("mouseup", qs), Bs = null;
	}
}
function Zs(e) {
	return e ? e.classList.contains("image-resize-wrapper") || e.classList.contains("image-resize-handle") || e.closest(".image-resize-wrapper") !== null : !1;
}
function Qs(e) {
	if (!e) return e;
	let t = new DOMParser().parseFromString(`<div>${e}</div>`, "text/html").body.firstChild;
	return t ? (t.querySelectorAll(".image-resize-wrapper").forEach((e) => {
		let t = e.querySelector("img");
		t && e.parentNode && (e.parentNode.insertBefore(t, e), e.remove());
	}), t.innerHTML) : e;
}
//#endregion
//#region src/components/inputRichText/inputRichText.tsx
var $s = "input-rich-text-editor", ec = [{
	name: "insertInlineAttachment",
	label: "Insert inline image",
	keybindings: [[["$metaOrCtrl"], "KeyM"]]
}], tc = [
	...ec,
	...Ds,
	...ls,
	...Go
], nc = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, rc = ve({
	command: {
		run: K,
		active: () => !1
	},
	content: {
		insert: K,
		setUiBlocker: K
	},
	hotkeys: {
		add: K,
		updateKeybindings: K
	},
	selection: {
		recreate: () => null,
		getRange: () => null,
		isWithinEditor: () => !1,
		onUpdate: K
	},
	events: {
		subscribe: () => K,
		publish: K,
		onMouseOver: K,
		onBlur: K
	},
	allowFormatting: [],
	triggers: new Fs(),
	ref: P(),
	window,
	history: {
		canUndo: () => !1,
		undo: K,
		takeSnapshot: K,
		reset: K
	}
}), ic = class e extends N {
	editor;
	editorRef;
	currentSuggestionRef;
	fileInputRef;
	attachmentDropdownButtonRef;
	unsubscribeInlineAttachment;
	isInserting;
	contentInsertionQueue;
	static ToolbarButton = Ho;
	static Context = rc;
	static contextType = tt;
	get effectiveWindow() {
		return this.context ?? window;
	}
	static defaultProps = {
		allowAttachments: !1,
		allowInlineAttachments: !1,
		allowEmoji: !0,
		languages: [],
		onTriggerSend() {
			console.warn("InputRichText: onTriggerSend callback missing in props");
		},
		onToggleSendOnEnter: K,
		sendOnEnter: !1,
		onMount: K,
		onUnmount: K,
		disabled: !1,
		hasAutocompleteSuggestionsFeature: !1
	};
	constructor(e) {
		super(e), this.editorRef = P(), this.currentSuggestionRef = P(), this.fileInputRef = P(), this.attachmentDropdownButtonRef = P(), this.unsubscribeInlineAttachment = K, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
			keyDownHandled: !1,
			keyCommands: tc,
			selectionUpdateListeners: [],
			mouseOverListeners: [],
			blurListeners: [],
			htmlOld: "",
			lastSelection: null,
			hasFocus: !1,
			selectedText: "",
			selectedLink: "",
			showHint: !1,
			pubsub: {},
			uiBlocker: e.uiBlocker,
			undoStack: []
		}, this.editor = {
			command: {
				run: this.commandRun.bind(this),
				active: this.commandActive.bind(this)
			},
			content: {
				insert: this.insertContent.bind(this),
				setUiBlocker: this.setUiBlocker.bind(this)
			},
			hotkeys: {
				add: this.addKeyCommands.bind(this),
				updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
			},
			selection: {
				onUpdate: this.addSelectionUpdateListener.bind(this),
				recreate: this.recreateSelection.bind(this),
				getRange: this.getSelectionRange.bind(this),
				isWithinEditor: this.isSelectionWithinEditor.bind(this)
			},
			events: {
				onMouseOver: this.addMouseOverListener.bind(this),
				onBlur: this.addBlurListener.bind(this),
				subscribe: this.subscribe.bind(this),
				publish: this.publish.bind(this)
			},
			allowFormatting: this.getAllowedFormattingOptions(),
			triggers: new Fs(),
			ref: this.editorRef,
			window: this.effectiveWindow,
			history: {
				undo: this.undo,
				canUndo: this.canUndo,
				reset: this.resetUndoStack,
				takeSnapshot: this.addCurrentContentToUndoStack
			}
		};
	}
	componentDidMount() {
		let e = this.effectiveWindow, { onMount: t } = this.props;
		e.document.execCommand("defaultParagraphSeparator", !1, "div");
		let { value: n } = this.props;
		n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe("insertInlineAttachment", () => {
			this.props.allowInlineAttachments && this.openFileBrowser();
		}), t(), this.updateKeyCommandsKeybindings(this.props.keybindings);
	}
	componentDidUpdate(e) {
		this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
		let { fileUploadStatuses: t, autocomplete: n, keybindings: r, uiBlocker: i, textInputDisabled: a } = this.props, { current: o } = this.editorRef;
		!e.textInputDisabled && a && this.focusReadOnlyEditor(), t && t !== e.fileUploadStatuses && o && (Object.keys(t).forEach((e) => {
			this.updateFileLoader(e, t[e]);
		}), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== e.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
			setTimeout(() => {
				this.setState({ showHint: !1 });
			}, 1e3);
		}), Ai(e.keybindings, r) || this.updateKeyCommandsKeybindings(r), e.uiBlocker !== i && this.setUiBlocker(i);
	}
	componentWillUnmount() {
		let { onUnmount: e } = this.props;
		this.unsubscribeInlineAttachment?.(), Xs(), e(this.getSanitizedHtml());
	}
	getCommandsWithInputKeybindings() {
		let { keybindings: e } = this.props;
		return tc.map((t) => ({
			...t,
			keybindings: e && t.name ? e[t.name] ?? [] : t.keybindings
		}));
	}
	subscribe(e, t) {
		return this.setState((n) => ({ pubsub: {
			...n.pubsub,
			[e]: [...n.pubsub[e] ?? [], t]
		} })), () => {
			this.setState((t) => no(t, e));
		};
	}
	publish(e) {
		this.state.pubsub[e]?.forEach((e) => e(this.editor));
	}
	handleSelectionChange = () => {
		let { onChange: e, onSelectionChange: t } = this.props, { htmlOld: n, selectionUpdateListeners: r } = this.state, { current: i } = this.editorRef;
		if (i) {
			this.forceUpdate();
			let t = this.extractEditorContent();
			t !== n && (this.setState({ htmlOld: t }), e(t));
		}
		r.forEach((e) => {
			e();
		}), t && t();
	};
	handleMouseOver = (e) => {
		let { mouseOverListeners: t } = this.state;
		t.forEach((t) => {
			t(e);
		});
	};
	handleEditorClick = (e) => {
		let t = e.target, n = this.effectiveWindow;
		if (io(t) && t.tagName === "IMG") {
			e.preventDefault();
			let r = n.getSelection();
			if (r) {
				let e = n.document.createRange();
				e.selectNode(t), r.removeAllRanges(), r.addRange(e), this.handleSelectionChange();
			}
			Ys(t, n);
		} else Zs(t) || Xs();
	};
	handleBlurListeners = (e) => {
		let { blurListeners: t } = this.state;
		t.forEach((t) => {
			t(e);
		});
	};
	handleKeyDown = (e) => {
		if (e.getModifierState(e.key)) return;
		let { keyCommands: t } = this.state, { onKeyDown: n, textInputDisabled: r } = this.props;
		if (n?.(e), r) return this.handleSendKeys(e), null;
		if (t.some(({ preventDefaultKeybinding: t }) => t && co(t, e)) && e.preventDefault(), t.some(({ name: t, keybindings: n, condition: r, callback: i }) => {
			if (co(n, e) && (r === void 0 || r(this.editor))) return i?.(this.editor, e), t && this.editor.events.publish(t), !0;
		})) {
			this.setKeyDownHandled(e), e.stopPropagation();
			return;
		}
		if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && this.editor.allowFormatting.includes("blockquote")) {
			let t = this.effectiveWindow, n = t.getSelection();
			if (!n) return;
			let r = n.anchorNode, i = (io(r) ? r : r?.parentElement)?.closest("blockquote");
			if (i && this.editorRef.current?.contains(i)) {
				let r = t.document, a = r.createElement("div");
				a.appendChild(r.createElement("br")), i.after(a);
				let o = r.createRange();
				o.setStart(a, 0), o.collapse(!0), n.removeAllRanges(), n.addRange(o), this.setKeyDownHandled(e), this.handleSelectionChange();
				return;
			}
		}
		return this.handleSendKeys(e), null;
	};
	handleSendKeys = (e) => {
		let { sendOnEnter: t, onTriggerSend: n, isAttachmentsUploading: r } = this.props;
		return co([[["$metaOrCtrl"], "Enter"]], e) || e.key === "Enter" && t && !e.shiftKey ? (this.setKeyDownHandled(e), r || n(), !0) : !1;
	};
	getBlockLevelParent = (e) => {
		let t = this.effectiveWindow, n = io(e) ? e : e.parentElement;
		for (; !ao(n, t);) n = n.parentElement;
		return n;
	};
	onInput = (e) => {
		let { current: t } = this.editorRef, n = e?.nativeEvent;
		if (!n) return;
		this.resetUndoStack();
		let { inputType: r } = n;
		if (r === "insertFromPaste" || !r) {
			_o(t), ho(t);
			return;
		}
		let i = document.getSelection()?.anchorNode;
		if (r === "insertText" && i && i.textContent?.length === 1) {
			let e = this.getBlockLevelParent(i);
			if ((e.tagName === "UL" || e.tagName === "OL") && e.hasAttribute("dir")) return;
			e.setAttribute("dir", "auto");
			let t = window.getComputedStyle(e).direction;
			e.setAttribute("dir", t), e.style.textAlign = "";
		}
	};
	handleKeyUp = () => {
		let { keyDownHandled: e } = this.state;
		e || this.handleSelectionChange(), this.setState({ keyDownHandled: !1 });
	};
	setKeyDownHandled = (e) => {
		e.preventDefault(), this.setState({ keyDownHandled: !0 });
	};
	addKeyCommands = (e) => {
		this.setState(({ keyCommands: t }) => ({ keyCommands: [...t, ...e] }));
	};
	updateKeyCommandsKeybindings = (e) => {
		if (!e) return;
		let { keyCommands: t } = this.state;
		Object.entries(e).forEach(([e, n]) => {
			let r = t.findIndex(({ name: t }) => t === e);
			r > -1 && n && (t[r].keybindings = n);
		});
	};
	addSelectionUpdateListener(e) {
		this.setState(({ selectionUpdateListeners: t }) => ({ selectionUpdateListeners: [...t, e] }));
	}
	addMouseOverListener(e) {
		this.setState(({ mouseOverListeners: t }) => ({ mouseOverListeners: [...t, e] }));
	}
	addBlurListener(e) {
		this.setState(({ blurListeners: t }) => ({ blurListeners: [...t, e] }));
	}
	handlePaste = (e) => {
		let { onFileDropped: t, allowInlineAttachments: n, sanitize: r, textInputDisabled: i } = this.props, a = this.effectiveWindow, { clipboardData: o } = e;
		if (i) {
			e.preventDefault();
			return;
		}
		if (!o) return;
		let s = o.getData("text/html"), c = o.getData("text/plain"), l = o.files.item(0);
		if (s) {
			e.preventDefault(), this.commandRun("insertHTML", r?.(s));
			return;
		}
		if (c && nc.test(c)) {
			e.preventDefault();
			let t = a.getSelection(), n = t && !t.isCollapsed ? t.toString() : "";
			s = ns(c, n && this.editor.allowFormatting.includes("link") ? n : c), this.commandRun("insertHTML", s);
			return;
		}
		if (l) {
			if (n && t) {
				let { src: e, uid: n } = mo(a, l);
				this.insertImageLoader(e, n), t(l, n);
			}
			e.preventDefault();
		}
	};
	commandRun(e, t = null) {
		setTimeout(() => {
			let { hasFocus: n } = this.state, { current: r } = this.editorRef, i = this.effectiveWindow;
			if (r) {
				if (n || this.recreateSelection(), e === "inlineCode") {
					Ls(i, this.addCurrentContentToUndoStack), this.handleSelectionChange();
					return;
				}
				i.document.execCommand(e, !1, t);
			}
		});
	}
	commandActive(e) {
		let { hasFocus: t } = this.state, n = this.effectiveWindow;
		return e === "inlineCode" ? !!(t && Is(n, "inline")) : !!(t && uo(n, e));
	}
	getText = () => {
		let { current: e } = this.editorRef;
		return e && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
	};
	getSanitizedHtml = () => this.props.sanitize?.(this.getText());
	getPlainText = () => {
		let { current: e } = this.editorRef, t = e && this.hasContent(this.extractEditorContent()) ? e.innerText : "";
		return t ? t.replace(/\n\n/g, "\n").trim() : "";
	};
	setHtml(e) {
		let { current: t } = this.editorRef, n = this.props.sanitize?.(e);
		t && (t.innerHTML = n || "", _o(t)), this.setState({ htmlOld: n }), this.handleSelectionChange();
	}
	handleInlineUpload = (e) => {
		if (e === null) return;
		let { onFileDropped: t } = this.props, n = this.effectiveWindow;
		e && t && Array.from(e).forEach((e) => {
			if (po(e)) {
				let { src: r, uid: i } = mo(n, e);
				this.insertImageLoader(r, i), t(e, i);
			} else {
				let n = qe();
				this.insertFileLoader(e.name, n), t(e, n);
			}
		});
	};
	handleAttachmentUpload = (e) => {
		let { onAttachmentsSelected: t, attachmentsDisabled: n } = this.props;
		if (n) return;
		let { current: r } = this.attachmentDropdownButtonRef;
		if (r && r.open(), e && typeof t == "function") {
			let n = Array.from(e);
			if (n.length === 0) return;
			t(n.map((e) => ({
				file: e,
				uid: qe()
			})));
		}
	};
	handleAttachmentDropdownToggle = (e) => {
		this.props.onAttachmentDropdownToggle?.(e);
	};
	handleDetachAttachmentFile = (e) => {
		let { onDetachAttachmentFile: t } = this.props;
		typeof t == "function" && t(e);
	};
	handleFileSelect = (e) => {
		let t = e.target;
		t?.ownerDocument?.defaultView && t instanceof t.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(t.files), t.value = "");
	};
	openFileBrowser = (e) => {
		e?.preventDefault();
		let { current: t } = this.fileInputRef;
		t && t.click();
	};
	insertImageLoader(e, t) {
		let n = this.effectiveWindow.document.createElement("img");
		n.setAttribute("class", "async-loading"), n.setAttribute("data-uid", t), n.setAttribute("src", e), this.insertContent(n);
	}
	insertFileLoader(e, t) {
		let n = this.effectiveWindow.document.createElement("a");
		n.setAttribute("class", "async-loading"), n.setAttribute("data-uid", t), n.setAttribute("href", "#"), n.innerText = e, this.insertContent(n);
	}
	updateFileLoader(e, { link: t, status: n, filename: r }) {
		let { current: i } = this.editorRef;
		if (i) {
			let a = i.querySelector(`[data-uid="${e}"]`);
			a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove("async-loading", "async-succeeded", "async-failed"), a.classList.add(`async-${n}`), t && a.tagName === "IMG" && (a.src = t, r && (a.title = r)), t && a.tagName === "A" && (a.href = t)));
		}
	}
	handleToggleSendOnEnter = (e) => {
		e.preventDefault();
		let { onToggleSendOnEnter: t } = this.props;
		t();
	};
	handleToggleAutocompleteSuggestions = (e) => {
		e.preventDefault();
		let { autocomplete: t } = this.props;
		t && t.onToggleShowAutocompleteSuggestions();
	};
	isSelectionWithinEditor(e) {
		let { anchorNode: t } = e, { parentElement: n = null } = t || {}, r = `.${ts.editor}`, i = t !== null && t.nodeType === Node.ELEMENT_NODE && t.matches(r);
		for (; !i && n !== null;) {
			if (n.matches(r)) {
				i = !0;
				break;
			}
			n = n.parentElement;
		}
		return i;
	}
	insertContent = (e, t) => {
		this.contentInsertionQueue.push(e), t?.getSelection ? this.processContentInsertionQueue(t.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
			this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
		}));
	};
	processContentInsertionQueue = (e) => {
		if (!e || !this.isSelectionWithinEditor(e)) {
			this.contentInsertionQueue = [];
			return;
		}
		if (xo(e), e?.rangeCount && e?.rangeCount > 0) {
			let t = e.getRangeAt(0);
			if (e.isCollapsed || t.deleteContents(), this.contentInsertionQueue.length === 1) t.insertNode(this.contentInsertionQueue[0]);
			else if (this.contentInsertionQueue.length > 1) {
				let e = document.createElement("span");
				this.contentInsertionQueue.forEach((t) => {
					e.appendChild(t);
				}), t.insertNode(e);
			}
		}
		this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
			e.collapseToEnd();
		}), this.handleSelectionChange();
	};
	setUiBlocker(e) {
		this.setState({ uiBlocker: e });
	}
	getSelectionRange() {
		let e = this.effectiveWindow;
		if (e.document.activeElement === this.editorRef.current) {
			let t = e.document.getSelection();
			return t?.rangeCount && t?.rangeCount > 0 ? t.getRangeAt(0) : null;
		}
		return this.state.lastSelection;
	}
	recreateSelection(e) {
		let { current: t } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
		return t && (!r || !this.isSelectionWithinEditor(r)) && e?.focus !== !1 && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
	}
	handleFocus = () => {
		let e = this.effectiveWindow;
		this.setState({ hasFocus: !0 }), e.document.addEventListener("selectionchange", this.handleSelectionChange);
	};
	handleBlur = (e) => {
		let t = this.effectiveWindow, n = t.getSelection();
		Xs(), this.setState({
			lastSelection: n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null,
			hasFocus: !1
		}), t.document.removeEventListener("selectionchange", this.handleSelectionChange), this.handleBlurListeners(e);
	};
	focus = () => {
		let { current: e } = this.editorRef, { hasFocus: t } = this.state;
		e && (t || e.focus());
	};
	focusReadOnlyEditor = () => {
		let { current: e } = this.editorRef, { activeElement: t, body: n } = this.effectiveWindow.document;
		e && (!t || t === n) && e.focus();
	};
	moveCursorToEnd = () => {
		let { current: e } = this.editorRef, t = this.effectiveWindow;
		if (!e) return;
		let n = t.getSelection();
		if (n) {
			let r = t.document.createRange();
			r.selectNodeContents(e), r.collapse(!1), n.removeAllRanges(), n.addRange(r);
		}
	};
	hasContent(e) {
		return e?.length ? !e.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
	}
	isStylingActive() {
		return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
	}
	getAllowedFormattingOptions() {
		let { allowFormatting: e } = this.props;
		return Array.isArray(e) ? e : e ? to : [];
	}
	lastExtractedContent = P();
	extractEditorContent() {
		let { editorContentExtractor: e, sanitize: t } = this.props, { current: n } = this.editorRef, r = n?.innerHTML ?? "";
		if (!e) return Qs(r);
		if (r === this.lastExtractedContent.current) return this.lastExtractedContent.current;
		let i = e(n);
		return this.lastExtractedContent.current = Qs(t?.(i) ?? i), this.lastExtractedContent.current;
	}
	canUndo = () => this.state.undoStack.length > 0;
	undo = () => {
		let { undoStack: e } = this.state;
		if (e.length > 0) {
			let t = e[e.length - 1];
			this.setHtml(t), this.setState({ undoStack: e.slice(0, -1) });
		}
	};
	resetUndoStack = () => {
		this.setState({ undoStack: [] });
	};
	addCurrentContentToUndoStack = () => {
		this.setState({ undoStack: [...this.state.undoStack.slice(-50), this.getText()] });
	};
	render() {
		let { className: t, wrapperClassName: r, renderQuickResponse: i, quickResponsesApi: a, sendOnEnter: o, placeholder: s, allowInlineAttachments: c, allowAttachments: l, attachmentsDisabled: u, attachmentsDisabledTooltip: d, textInputDisabled: f, allowEmoji: p, attachmentNotice: m, attachmentsFields: h, attachments: g, isAttachmentsUploading: _, hideSendOnEnterToggle: v, languages: y, disabled: b, status: x, onError: S, icon: C, prefix: w, suffix: T, id: E, autocomplete: D, toolbarAddons: ee, toolbarEnd: te } = this.props, { htmlOld: ne, uiBlocker: re } = this.state, ie = this.effectiveWindow, ae = O(ts.root, t);
		return /* @__PURE__ */ A(e.Context.Provider, {
			value: this.editor,
			children: /* @__PURE__ */ A(n, {
				status: x,
				icon: C,
				prefix: w,
				suffix: T,
				disabled: b,
				className: O(ts.inputWrapper, r),
				children: /* @__PURE__ */ j("div", {
					className: ae,
					children: [
						/* @__PURE__ */ j(Jo, {
							className: ts.editorWrap,
							onAddInline: this.handleInlineUpload,
							onAddAttachment: this.handleAttachmentUpload,
							attachments: Array.isArray(g) ? g : [],
							allowAttachments: l && !u,
							allowInlineAttachments: c,
							children: [/* @__PURE__ */ A("div", {
								id: E,
								ref: this.editorRef,
								onPaste: this.handlePaste,
								onKeyDown: this.handleKeyDown,
								onInput: this.onInput,
								onKeyUp: this.handleKeyUp,
								onBlur: this.handleBlur,
								onFocus: this.handleFocus,
								onMouseOver: this.handleMouseOver,
								onClick: this.handleEditorClick,
								className: O(ts.editor, { [ts.editorDisabled]: f }),
								"data-testid": $s,
								contentEditable: !f,
								...f && {
									tabIndex: 0,
									role: "textbox",
									"aria-readonly": !0
								}
							}), !this.hasContent(ne) && !!s && /* @__PURE__ */ A("span", {
								role: "presentation",
								className: ts.placeholder,
								children: s
							})]
						}),
						/* @__PURE__ */ j(Ms, {
							className: ts.toolbar,
							children: [
								this.editor.allowFormatting.length > 0 && /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(Os, {
									isActive: this.isStylingActive(),
									editor: this.editor,
									editorWindow: ie
								}), this.editor.allowFormatting.includes("link") && /* @__PURE__ */ A(us, { editor: this.editor })] }),
								c && /* @__PURE__ */ A(Ho, {
									icon: "upload",
									onMouseDown: this.openFileBrowser,
									tooltip: `Insert inline image (${rs(ec[0].keybindings)})`
								}),
								l && /* @__PURE__ */ A(Ko, {
									dropdownRef: this.attachmentDropdownButtonRef,
									onAttachFiles: this.handleAttachmentUpload,
									attachments: Array.isArray(g) ? g : [],
									isAttachmentsUploading: _,
									onDetachFile: this.handleDetachAttachmentFile,
									editorWindow: ie,
									editor: this.editor,
									disabled: u,
									disabledTooltip: d,
									notice: m,
									onToggle: this.handleAttachmentDropdownToggle,
									fixed: !0,
									children: h
								}),
								p && /* @__PURE__ */ A(es, {
									"data-tip": "Emojis",
									editor: this.editor,
									fixed: !0
								}),
								!!a && !!i && /* @__PURE__ */ A(bs, {
									languages: y,
									renderQuickResponse: i,
									quickResponsesApi: a,
									editor: this.editor,
									sanitize: this.props.sanitize,
									iconName: this.props.quickResponseIcon
								}),
								D && D.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ A(Ho, {
									isActive: D.showAutocompleteSuggestions,
									onMouseDown: this.handleToggleAutocompleteSuggestions,
									icon: "autocomplete",
									tooltip: "Autocomplete suggestions"
								}),
								ee,
								!v && /* @__PURE__ */ A(Ho, {
									isActive: o,
									onMouseDown: this.handleToggleSendOnEnter,
									icon: "enter",
									tooltip: "Send on Enter"
								}),
								D ? /* @__PURE__ */ j("span", {
									className: O(ts.toolbarHint, {
										[ts.toolbarHintVisible]: this.state.showHint,
										[ts.toolbarHintHidden]: !this.state.showHint
									}),
									children: [
										"Autocomplete",
										" ",
										D.showAutocompleteSuggestions ? "ON" : "OFF"
									]
								}) : null,
								te && /* @__PURE__ */ A("div", {
									className: ts.toolbarEnd,
									children: te
								})
							]
						}),
						/* @__PURE__ */ A("input", {
							tabIndex: -1,
							ref: this.fileInputRef,
							type: "file",
							className: ts.fileInput,
							onChange: this.handleFileSelect,
							multiple: !0
						}),
						/* @__PURE__ */ A(js, {
							editor: this.editor,
							onError: S
						}),
						/* @__PURE__ */ A(Bo, { editor: this.editor }),
						re && /* @__PURE__ */ A("div", {
							className: ts.uiBlocker,
							children: re
						})
					]
				})
			})
		});
	}
}, ac = {
	inputWrapper: "h-textarea--textarea__inputWrapper",
	input: "h-textarea--textarea__input"
}, oc = "textarea", sc = F(function(e, t) {
	let r = B(null), { className: i, disabled: a, readOnly: o, name: s, prefix: c, suffix: l, icon: u, status: d, height: f = 0, style: p, autoGrow: m, ...h } = e, [g, _] = V(f), v = {
		...p,
		height: g ? `${g}px` : void 0
	}, y = L(() => {
		if (!r.current) return;
		let e = r.current.clientHeight, t = window.getComputedStyle(r.current), n = parseInt(t.lineHeight || "16");
		r.current.style.height = "auto";
		let i = r.current.scrollHeight + n, a = Math.max(f, Math.min(e, i)), o = i > a ? i : a;
		r.current.style.height = `${o}px`, _(o);
	}, [f]);
	return R(() => {
		if (m) return y(), window.addEventListener("resize", y), () => {
			window.removeEventListener("resize", y);
		};
	}, [m, y]), /* @__PURE__ */ A(n, {
		className: ac.inputWrapper,
		status: d,
		disabled: a,
		prefix: c,
		suffix: l,
		icon: u,
		children: /* @__PURE__ */ A("textarea", {
			"data-testid": oc,
			className: ac.input,
			dir: "auto",
			id: s,
			...h,
			onChange: (e) => {
				h?.onChange?.(e), m && y();
			},
			ref: r,
			style: v,
			name: s,
			disabled: a,
			readOnly: o
		})
	});
}), cc = {
	editorContainer: "h-fieldRichText--fieldRichText__editorContainer",
	fallbackTextArea: "h-fieldRichText--fieldRichText__fallbackTextArea"
}, lc = class extends N {
	static defaultProps = { allowFormatting: !0 };
	render() {
		let { className: e, input: t, label: n, meta: r, required: i, disabled: a, helpIcon: o, description: s, noAlert: c, noLabel: l, ...u } = this.props;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: n,
			labelFor: t.name,
			meta: r,
			required: i,
			helpIcon: o,
			disabled: a,
			description: s,
			noAlert: c,
			noLabel: l,
			children: /* @__PURE__ */ A(pt, {
				fallback: /* @__PURE__ */ A(sc, {
					...t,
					className: cc.fallbackTextArea,
					disabled: a,
					value: t.value,
					onChange: (e) => t.onChange(e.target.value)
				}),
				children: /* @__PURE__ */ A("div", {
					className: cc.editorContainer,
					children: /* @__PURE__ */ A(ic, {
						disabled: a,
						status: X.getStatus(r),
						...t,
						...u,
						hideSendOnEnterToggle: !0,
						onTriggerSend: K
					})
				})
			})
		});
	}
}, uc = class extends N {
	constructor(e) {
		super(e), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
	}
	getSelectedItems() {
		let { input: { value: e }, items: t } = this.props;
		return typeof e == "string" && t?.some((t) => t.id === e) ? [e] : Array.isArray(e) && e.length && t?.some((t) => e.some((e) => e === t.id)) ? e : [];
	}
	handleSelect(e) {
		let { input: { onChange: t } } = this.props;
		typeof t == "function" && t(e === null ? "" : e.id.toString());
	}
	handleClear() {
		let { input: { value: e }, onClear: t } = this.props;
		typeof e == "string" && this.handleSelect(null), typeof t == "function" && t();
	}
	render() {
		let { className: e, input: t, meta: n, label: r, required: i, disabled: a, description: o, helpIcon: s, noAlert: c, noLabel: l, ...u } = this.props;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: r,
			labelFor: t.name,
			meta: n,
			required: i,
			disabled: a,
			helpIcon: s,
			description: o,
			noAlert: c,
			noLabel: l,
			children: /* @__PURE__ */ A(ua, {
				...u,
				id: t.name,
				disabled: a,
				selectedItems: this.getSelectedItems(),
				onSelect: this.handleSelect,
				onClear: this.handleClear,
				status: X.getStatus(n)
			})
		});
	}
};
//#endregion
//#region src/hooks/useWindowEvent.ts
function dc(e, t) {
	let n = rt(), r = B(t);
	r.current = t, R(() => {
		function t(e) {
			r.current?.(e);
		}
		return n.addEventListener(e, t), () => n.removeEventListener(e, t);
	}, [n, e]);
}
//#endregion
//#region src/utils/useFlatChildren.ts
function fc(e, t = "") {
	return M.toArray(e).reduce((e, n) => I(n) ? n.type === he ? [...e, ...fc(n.props.children, n.key)] : [...e, {
		...n,
		key: `${t}${n.key}`
	}] : e, []);
}
var pc = (e) => z(() => fc(e), [e]), mc = {
	root: "h-selectionList--selectionList__root",
	disabled: "h-selectionList--selectionList__disabled"
}, hc = $e(() => ve({
	list: {
		isMultiple: !1,
		isActive: !1,
		isFocused: !1,
		isDisabled: !1
	},
	item: {
		isActive: !1,
		setActive: K,
		register: K,
		isSelected: () => !1,
		onSelect: K,
		isOnlyVisibleItem: !1
	}
})), gc = ({ defaultActiveItemIndex: e = 0 } = { defaultActiveItemIndex: 0 }) => {
	let [t, n] = V(!1), [r, i] = V(-1), [a, o] = V([]), [s, c] = V({}), l = L(({ isActivatable: t, isLastChild: r, isOnlyVisibleItem: a, keysTakenOverHandlingFromParent: s }, l) => {
		t !== void 0 && o((n) => {
			let a = t ? [...n, l].sort((e, t) => e - t) : n.filter((e) => e !== l);
			return t && r && i((t) => (a.includes(l) && !n.includes(l) || l !== t) && a.includes(t) && l !== a[e] ? t : a[e] ?? a[0] ?? t), a;
		}), a !== void 0 && n(a), s !== void 0 && c((e) => ({
			...e,
			[l]: s
		}));
	}, [e]), u = L((e) => "index" in e ? e.index : e.step === "first" ? a[0] : e.step === "last" ? a[a.length - 1] : a[(a.findIndex((e) => e === r) + e.step + a.length) % a.length], [a, r]), d = L((e) => {
		i(u(e));
	}, [u]);
	R(() => {
		if (r < 0 || r === void 0) {
			i(a[e]);
			return;
		}
		a.length && !a.includes(r) && i(a[e] ?? a[0]);
	}, [
		r,
		a,
		e
	]);
	let f = z(() => s[r] ?? [], [r, s]);
	return z(() => ({
		activeItemIndex: r,
		getActiveItemIndex: u,
		activatableItemIndices: a,
		setActiveItem: d,
		handleItemRegister: l,
		isOnlyActiveItemVisible: t,
		keysDelegatedHandlingToItem: f
	}), [
		a,
		r,
		u,
		l,
		t,
		f,
		d
	]);
}, _c = ({ className: e, selectedValues: t = [], isActive: n, isDisabled: r, isMultiple: i = !1, onChange: a = K, equalityFn: o = Object.is, tabIndex: s = 0, defaultActiveItemIndex: c, children: l, ...u }, d) => {
	let [f, p] = V(!1), [m, h] = V({
		isActive: !!n,
		source: "parent"
	}), g = hc(), { activeItemIndex: _, setActiveItem: v, handleItemRegister: y, isOnlyActiveItemVisible: b, keysDelegatedHandlingToItem: x } = gc({ defaultActiveItemIndex: c }), S = pc(l), C = L((e) => e !== void 0 && (t || []).some((t) => o(t, e)), [o, t]), w = L(({ value: e, meta: n }, r) => {
		v({ index: r }), e !== void 0 && a(i ? {
			selectedValues: C(e) ? t.filter((t) => !o(t, e)) : [...t, e],
			selectedItem: {
				isNode: n?.isNode,
				isSelected: !C(e),
				value: e
			},
			event: n?.event
		} : {
			selectedValues: [e],
			selectedItem: {
				isNode: n?.isNode,
				isSelected: !0,
				value: e
			},
			event: n?.event
		});
	}, [
		o,
		C,
		i,
		a,
		t,
		v
	]), T = z(() => !r && (m.isActive || f), [
		r,
		m.isActive,
		f
	]);
	return R(() => {
		h({
			isActive: !!n,
			source: "parent"
		});
	}, [n]), dc("keydown", (e) => {
		!T || x.includes(e.key) || (e.key === "Enter" ? e.preventDefault() : e.key === "Home" ? (v({ step: "first" }), e.preventDefault()) : e.key === "End" ? (v({ step: "last" }), e.preventDefault()) : e.key === "ArrowDown" ? (v({ step: 1 }), e.preventDefault()) : e.key === "ArrowUp" && (v({ step: -1 }), e.preventDefault()));
	}), /* @__PURE__ */ A("ul", {
		ref: d,
		role: "listbox",
		tabIndex: r || n ? -1 : s,
		...u,
		className: O(e, mc.root, { [mc.disabled]: r }),
		onFocus: () => p(!0),
		onBlur: () => p(!1),
		onMouseLeave: () => {
			m.source === "child" && h({
				isActive: !1,
				source: "self"
			});
		},
		children: S.map((e, t) => I(e) && (!b || t === _) && /* @__PURE__ */ A(g.Provider, {
			value: {
				list: {
					isFocused: f,
					isMultiple: i,
					isActive: m.isActive,
					isDisabled: r
				},
				item: {
					isActive: T && t === _,
					setActive: () => {
						h({
							isActive: !0,
							source: "child"
						}), v({ index: t });
					},
					register: (e) => y(e, t),
					isSelected: C,
					onSelect: (e) => w(e, t),
					isOnlyVisibleItem: b,
					isLastChild: t === S.length - 1
				}
			},
			children: e
		}, t))
	});
}, vc = ({ className: e, label: t, ...n }, r) => {
	let { item: { register: a, isLastChild: o } } = Se(hc());
	return je(() => {
		a({
			isActivatable: !1,
			isLastChild: o
		});
	}), Fe(() => {
		a({
			isActivatable: !1,
			isLastChild: o
		});
	}), /* @__PURE__ */ A(qt, {
		ref: r,
		as: "li",
		color: "tertiary",
		padding: "200 250",
		...n,
		children: /* @__PURE__ */ A(i.Paragraph, {
			as: "span",
			variant: "4",
			color: "secondary",
			children: t
		})
	});
}, yc = Object.assign(F(vc), { name: vc.name }), bc = {
	root: "h-selectionList-subComponents-item--selectionListItem__root",
	rootDisabled: "h-selectionList-subComponents-item--selectionListItem__rootDisabled",
	rootActive: "h-selectionList-subComponents-item--selectionListItem__rootActive",
	selectionState: "h-selectionList-subComponents-item--selectionListItem__selectionState",
	fixedSize: "h-selectionList-subComponents-item--selectionListItem__fixedSize",
	content: "h-selectionList-subComponents-item--selectionListItem__content",
	contentDisabled: "h-selectionList-subComponents-item--selectionListItem__contentDisabled"
}, xc = ({ value: e, isDisabled: t = !1, isIndeterminate: n = !1, className: r, contentClassName: i, noFixedSelectionStateSpace: o, onActiveStateChange: s, onSelectedStateChange: c, onSelect: l, children: d, ...f }, p) => {
	let { list: { isMultiple: m, isDisabled: h, isActive: g, isFocused: _ }, item: { register: v, isSelected: y, onSelect: b, isActive: x, isNode: S = !1, isLastChild: C = !1, setActive: w } } = Se(hc()), T = y(e), E = z(() => !h && (g || _), [
		g,
		h,
		_
	]), D = z(() => !t && x && E, [
		x,
		t,
		E
	]), ee = B(null);
	Ce(p, () => ee.current);
	let te = L((n) => {
		!t && !h && (l?.({
			value: e,
			meta: { target: n?.target }
		}), b({
			value: e,
			meta: {
				target: n?.target,
				event: n || void 0
			}
		}));
	}, [
		t,
		h,
		l,
		b,
		e
	]), ne = L((n) => {
		D && n.key === "Enter" && !t && !h && (l?.({
			value: e,
			meta: { target: n.target ?? void 0 }
		}), b({
			value: e,
			meta: {
				target: n.target ?? void 0,
				event: n
			}
		}));
	}, [
		D,
		t,
		h,
		l,
		b,
		e
	]);
	R(() => {
		x && E && ee.current?.scrollIntoView({
			behavior: "smooth",
			block: "nearest",
			inline: "nearest"
		});
	}, [x]);
	let re = L(() => ({
		isActive: x,
		isSelected: T,
		isLastChild: C,
		isNode: S,
		value: e
	}), [
		x,
		C,
		S,
		T,
		e
	]), ie = Me(x), ae = Me(T);
	Ie(() => {
		x !== ie && s?.(re()), T !== ae && c?.(re());
	}, [
		re,
		x,
		T,
		s,
		c,
		ie,
		ae
	]), dc("keydown", ne), R(() => (v({
		isActivatable: !t,
		isLastChild: C
	}), () => v({
		isActivatable: !1,
		isLastChild: C
	})), [t]);
	let oe = !m && T || m && e !== void 0 || !o;
	return /* @__PURE__ */ j("li", {
		ref: ee,
		role: "option",
		"aria-selected": T,
		"aria-disabled": t,
		onClick: te,
		onMouseMove: w,
		className: O(bc.root, r, {
			[bc.rootActive]: D,
			[bc.rootDisabled]: t
		}),
		...f,
		children: [
			oe && /* @__PURE__ */ j(G, {
				className: O(bc.selectionState, { [bc.fixedSize]: !o }),
				children: [!m && T && /* @__PURE__ */ A(u, { name: "done" }), m && e !== void 0 && /* @__PURE__ */ A(tn, {
					checked: T,
					indeterminate: !T && n,
					disabled: t,
					onChange: K,
					tabIndex: -1
				})]
			}),
			/* @__PURE__ */ A(a, {
				className: O(bc.content, i, { [bc.contentDisabled]: t }),
				children: d
			}),
			S && /* @__PURE__ */ A(u, { name: "angle-right" })
		]
	});
}, Sc = Object.assign(F(xc), { name: xc.name }), Cc = {
	root: "h-selectionList-subComponents-list-backItem--selectionListBackItem__root",
	rootActive: "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive"
}, wc = ({ className: e, content: t, onActiveStateChange: n, onSelected: r, ...a }, o) => {
	let { list: { isDisabled: s, isActive: c, isFocused: l }, item: { register: d, isActive: f, onSelect: p, setActive: m } } = Se(hc()), h = z(() => !s && (c || l), [
		c,
		s,
		l
	]), g = z(() => f && h, [f, h]), _ = B(null);
	Ce(o, () => _.current);
	let v = L(() => {
		p({}), r?.();
	}, [p, r]), y = L((e) => {
		!g || s || e.key === "Enter" && v();
	}, [
		v,
		g,
		s
	]);
	R(() => {
		f && h && _.current?.scrollIntoView({
			behavior: "smooth",
			block: "nearest",
			inline: "nearest"
		});
	}, [f]);
	let b = Me(f);
	return Ie(() => {
		f !== b && n?.({ isActive: f });
	}, [
		f,
		n,
		b
	]), dc("keydown", y), je(() => {
		d({ isActivatable: !0 });
	}), Fe(() => {
		d({ isActivatable: !1 });
	}), /* @__PURE__ */ A("li", {
		ref: _,
		role: "navigation",
		className: O(Cc.root, e, { [Cc.rootActive]: g }),
		onClick: v,
		onMouseMove: m,
		...a,
		children: t || /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(u, { name: "angle-left" }), /* @__PURE__ */ A(i.Paragraph, {
			variant: "1",
			children: "Back"
		})] })
	});
}, Tc = Object.assign(F(wc), { name: wc.name }), Ec = { list: "h-selectionList-subComponents-list--selectionListList__list" }, Dc = ({ parentItem: e, children: t, backItemProps: n = {}, listProps: { className: r, ...i } = {}, onActiveStateChange: a, ...o }, s) => {
	let c = hc(), l = Se(c), { list: { isFocused: u, isActive: d, isDisabled: f }, item: { isActive: p, onSelect: m, isOnlyVisibleItem: h, register: g, setActive: _, isLastChild: v = !1 } } = l, y = z(() => !f && (d || u), [
		d,
		f,
		u
	]), b = pc(t), { activeItemIndex: x, setActiveItem: S, handleItemRegister: C, isOnlyActiveItemVisible: w, keysDelegatedHandlingToItem: T } = gc({ defaultActiveItemIndex: 1 }), E = L((e, t) => {
		S({ index: t }), m(e);
	}, [m, S]), D = (e) => {
		!y || !h || T.includes(e.key) || (e.key === "Home" ? (S({ step: "first" }), e.preventDefault()) : e.key === "End" ? (S({ step: "last" }), e.preventDefault()) : e.key === "ArrowDown" ? (S({ step: 1 }), e.preventDefault()) : e.key === "ArrowUp" && (S({ step: -1 }), e.preventDefault()));
	}, ee = Me(h);
	Ie(() => {
		h !== ee && a?.({
			isActive: h,
			isLastChild: v
		});
	}, [
		h,
		a,
		ee
	]), R(() => {
		g(h ? { keysTakenOverHandlingFromParent: [
			"Home",
			"End",
			"ArrowDown",
			"ArrowUp"
		] } : { keysTakenOverHandlingFromParent: [] });
	}, [h]), dc("keydown", D);
	let te = L(({ value: e, meta: t }) => {
		t?.target instanceof HTMLInputElement && t.target.type === "checkbox" ? m({
			value: e,
			meta: { isNode: !0 }
		}) : g({ isOnlyVisibleItem: !0 });
	}, [m]), ne = L(() => {
		g({ isOnlyVisibleItem: !1 });
	}, []);
	R(() => {
		h || S({ index: -1 });
	}, [h, S]);
	let re = z(() => ({
		...l,
		item: {
			...l.item,
			onSelect: te,
			isNode: !0
		}
	}), [te, l]), ie = z(() => ({
		...l,
		item: {
			...l.item,
			onSelect: ne,
			isActive: x === 0,
			setActive: () => {
				_(), S({ index: 0 });
			},
			register: (e) => C(e, 0)
		}
	}), [
		x,
		ne,
		C,
		l,
		_,
		S
	]);
	return h ? /* @__PURE__ */ j(k, { children: [!w && /* @__PURE__ */ A(c.Provider, {
		value: ie,
		children: /* @__PURE__ */ A(Tc, { ...n })
	}), /* @__PURE__ */ A("li", {
		ref: s,
		...o,
		children: /* @__PURE__ */ A("ul", {
			role: "listbox",
			className: O(Ec.list, r),
			...i,
			children: b.map((e, t) => {
				let n = t + 1;
				return I(e) && (!w || n === x) && /* @__PURE__ */ A(c.Provider, {
					value: {
						...l,
						item: {
							...l.item,
							isActive: p && n === x,
							setActive: () => {
								_(), S({ index: n });
							},
							register: (e) => C(e, n),
							onSelect: (e) => E(e, n),
							isOnlyVisibleItem: w,
							isLastChild: t === b.length - 1
						}
					},
					children: e
				}, t);
			})
		})
	})] }) : /* @__PURE__ */ A(c.Provider, {
		value: re,
		children: e
	});
}, Oc = Object.assign(F(Dc), { name: Dc.name }), kc = { section: "h-selectionList-subComponents-section--selectionListSection__section" }, Ac = ({ title: e, children: t, listProps: { className: n, ...r } = {}, onActiveStateChange: i, ...a }, o) => {
	let s = hc(), c = Se(s), { list: { isFocused: l, isActive: u, isDisabled: d }, item: { isActive: f, setActive: p, onSelect: m, register: h, isLastChild: g = !1 } } = c, _ = z(() => !d && (u || l), [
		u,
		d,
		l
	]), v = pc(t), { activatableItemIndices: y, activeItemIndex: b, setActiveItem: x, handleItemRegister: S, keysDelegatedHandlingToItem: C } = gc(), w = L((e, t) => {
		x({ index: t }), m(e);
	}, [m, x]), T = (e) => {
		!_ || C.includes(e.key) || (e.key === "Home" ? x({ step: "first" }) : e.key === "End" && x({ step: "last" }), f ? e.key === "ArrowDown" && b !== y[y.length - 1] ? (x({ step: 1 }), e.preventDefault()) : e.key === "ArrowUp" && b !== y[0] && (x({ step: -1 }), e.preventDefault()) : e.key === "ArrowDown" ? x({ step: "first" }) : e.key === "ArrowUp" && x({ step: "last" }));
	}, E = Me(f);
	return Ie(() => {
		f !== E && i?.({
			isActive: f,
			isLastChild: g
		});
	}, [
		f,
		i,
		E
	]), R(() => {
		let e = [];
		f && (b !== y[y.length - 1] && e.push("ArrowDown"), b !== y[0] && e.push("ArrowUp")), h({ keysTakenOverHandlingFromParent: e });
	}, [
		y,
		b,
		f
	]), je(() => h({ isActivatable: !0 })), Fe(() => h({ isActivatable: !1 })), dc("keydown", T), /* @__PURE__ */ A("li", {
		ref: o,
		...a,
		children: /* @__PURE__ */ j("ul", {
			role: "group",
			className: O(kc.section, n),
			...r,
			children: [/* @__PURE__ */ A(yc, { label: e }), v.map((e, t) => I(e) && /* @__PURE__ */ A(s.Provider, {
				value: {
					...c,
					item: {
						...c.item,
						isActive: f && t === b,
						setActive: () => {
							p(), x({ index: t });
						},
						register: (e) => S(e, t),
						onSelect: (e) => w(e, t),
						isLastChild: g && t === v.length - 1
					}
				},
				children: e
			}, t))]
		})
	});
}, jc = Object.assign(F(Ac), { name: Ac.name }), Mc = Object.assign(F(_c), {
	name: _c.name,
	Item: Sc,
	BackItem: Tc,
	Divider: yc,
	Section: jc,
	List: Oc
}), Nc = {
	root: "h-inputSelectionList-chip--inputSelectionListChip__root",
	name: "h-inputSelectionList-chip--inputSelectionListChip__name"
}, Pc = ({ onDelete: e, className: t, disabled: n, readOnly: r, ...i }) => {
	let a = z(() => {
		if (!(!e || n || r)) return (t) => {
			t.stopPropagation(), e();
		};
	}, [
		n,
		e,
		r
	]);
	return /* @__PURE__ */ A(la, {
		...i,
		onDelete: a,
		className: O(Nc.root, t),
		tagNameClassName: Nc.name
	});
}, Q = {
	root: "h-inputSelectionList--inputSelectionList__root",
	inputWrapper: "h-inputSelectionList--inputSelectionList__inputWrapper",
	inputWrapperChild: "h-inputSelectionList--inputSelectionList__inputWrapperChild",
	rootHasWrapperIcon: "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon",
	rootReadOnly: "h-inputSelectionList--inputSelectionList__rootReadOnly",
	titleContainer: "h-inputSelectionList--inputSelectionList__titleContainer",
	filterInput: "h-inputSelectionList--inputSelectionList__filterInput",
	placeholder: "h-inputSelectionList--inputSelectionList__placeholder",
	titleBox: "h-inputSelectionList--inputSelectionList__titleBox",
	iconContainer: "h-inputSelectionList--inputSelectionList__iconContainer",
	iconButton: "h-inputSelectionList--inputSelectionList__iconButton",
	dropdown: "h-inputSelectionList--inputSelectionList__dropdown",
	hiddenItemsTooltip: "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip",
	hiddenItemsChip: "h-inputSelectionList--inputSelectionList__hiddenItemsChip"
}, Fc = "inputSelectionListTestId", Ic = ({ className: e, name: t, value: r, onChange: i, prefix: o, suffix: s, icon: c, status: l, placeholder: u, disabled: d, readOnly: f, children: p, filter: m, multiple: g, getItemTitleByValue: _, tabIndex: v, keepOpen: y, onToggleDropdown: b, autoFocus: x, onClick: S, onBlur: C, onKeyDown: w, limit: T = Infinity, clearable: E = !1, equalityFn: D = Object.is, defaultActiveItemIndex: ee, valueArrayToStringFn: te = JSON.stringify, rootClassName: ne, dropdownProps: re, selectionListProps: ie, slotBeforeList: ae, slotAfterList: oe, ...se }, ce) => {
	let le = rt(), ue = B(null), de = B(null), fe = B(null), pe = B(null), [M, me] = V(!1), [he] = V(() => !!x);
	Ce(ce, () => de.current);
	let N = z(() => m?.value !== void 0 && m.onChange !== void 0, [m]), ge = z(() => N ? M ? !0 : he && (!!g || !r?.length) : !1, [
		N,
		he,
		M,
		g,
		r?.length
	]), _e = z(() => !ge || !M && r?.length ? !0 : g && !!r?.length, [
		M,
		g,
		ge,
		r?.length
	]), ve = z(() => {
		if (!r?.length) return u;
		if (_e) return "";
		if (!g) {
			let e = _(r[0]);
			return typeof e == "object" ? "" : e?.toString();
		}
		return "";
	}, [
		g,
		u,
		_,
		_e,
		r
	]), ye = L((e) => {
		!f && !d && i?.({
			selectedItem: {
				isSelected: !1,
				value: e
			},
			selectedValues: r?.filter((t) => !D(t, e)) ?? []
		});
	}, [
		d,
		D,
		i,
		f,
		r
	]), P = z(() => {
		if (!r?.length) return /* @__PURE__ */ A(G, {
			alignItems: "center",
			className: Q.placeholder,
			children: u
		});
		if (g) {
			let e = T < r.length ? r.slice(0, T) : r, t = T < r.length ? r.slice(T) : [];
			return /* @__PURE__ */ j(k, { children: [e?.map((e, t) => /* @__PURE__ */ A(Pc, {
				onDelete: () => {
					ye(e);
				},
				disabled: d,
				readOnly: f,
				children: _(e)
			}, t)), !!t.length && /* @__PURE__ */ A(U, {
				disabled: d,
				requireClick: !0,
				content: /* @__PURE__ */ A(G, {
					className: Q.hiddenItemsTooltip,
					gap: "100",
					flexWrap: "wrap",
					children: t?.map((e, t) => /* @__PURE__ */ A(Pc, {
						onDelete: () => {
							ye(e);
						},
						disabled: d,
						readOnly: f,
						children: _(e)
					}, t))
				}),
				light: !0,
				children: /* @__PURE__ */ j(Pc, {
					className: Q.hiddenItemsChip,
					disabled: d,
					children: ["+ ", t.length]
				})
			})] });
		}
		return /* @__PURE__ */ A(a, {
			className: Q.titleBox,
			children: _(r[0])
		});
	}, [
		r,
		g,
		_,
		u,
		T,
		d,
		f,
		ye
	]), F = L((e) => {
		(f || d) && e || (e !== M && b?.(e), me(e));
	}, [
		d,
		M,
		b,
		f
	]), I = L(() => {
		(ge ? fe.current : de.current)?.focus();
	}, [ge]), be = L((e) => {
		if (!N || !e) return !1;
		let t = `${m?.value ?? ""}${e}`;
		return m?.onChange?.({
			target: {
				value: t,
				name: m?.name
			},
			currentTarget: {
				value: t,
				name: m?.name
			}
		}), F(!0), !0;
	}, [
		m,
		N,
		F
	]), xe = L((e) => {
		M || F(!0), m?.onChange?.(e);
	}, [
		m,
		M,
		F
	]), Se = L(({ target: e }) => {
		pe.current?.contains(e) || (ue.current?.contains(e) && I(), F(!1));
	}, [I, F]), we = L((e) => {
		dn(e.key) && M && (F(!1), I());
	}, [
		I,
		M,
		F
	]), Te = L((e) => {
		e.relatedTarget && ue.current?.contains(e.relatedTarget) || (F(!1), C?.(e));
	}, [C, F]), Ee = L((e) => {
		M || e.stopPropagation(), F(!0), S?.(e);
	}, [
		M,
		S,
		F
	]), De = L((e) => {
		if (e.key.length === 1 && e.key !== " " && !e.metaKey && !e.ctrlKey && !e.altKey && !M && e.target === de.current && be(e.key)) {
			e.preventDefault(), w?.(e);
			return;
		}
		un(e.key) && F(!0), w?.(e);
	}, [
		M,
		w,
		be,
		F
	]), Oe = L((e) => {
		M || e.target !== de.current || be(e.clipboardData.getData("text").trim()) && e.preventDefault();
	}, [M, be]), ke = L((e) => {
		e.stopPropagation(), F(!M), I();
	}, [
		I,
		M,
		F
	]), Ae = L((e) => {
		e.stopPropagation(), I(), !d && !f && i?.({ selectedValues: [] });
	}, [
		d,
		I,
		i,
		f
	]), Me = L((e) => {
		i?.(e), !y && !g ? (F(!1), de.current?.focus()) : fe.current?.focus();
	}, [
		g,
		y,
		i,
		F
	]);
	return R(() => (M ? (le.addEventListener("click", Se), le.addEventListener("keydown", we)) : (le.removeEventListener("click", Se), le.removeEventListener("keydown", we)), () => {
		le.removeEventListener("click", Se), le.removeEventListener("keydown", we);
	}), [
		Se,
		we,
		M,
		le
	]), je(() => {
		!he || d || f || I();
	}), R(() => {
		M && fe.current?.focus();
	}, [M]), Fe(() => {
		le.removeEventListener("click", Se), le.removeEventListener("keydown", we);
	}), /* @__PURE__ */ j("div", {
		"data-testid": Fc,
		ref: ue,
		className: O(Q.root, ne, {
			[Q.rootHasWrapperIcon]: !!c,
			[Q.rootReadOnly]: f
		}),
		"aria-expanded": M,
		"aria-haspopup": "listbox",
		role: "combobox",
		children: [
			/* @__PURE__ */ A(n, {
				...se,
				ref: de,
				className: O(e, Q.inputWrapper),
				prefix: o,
				suffix: s,
				disabled: d,
				icon: c,
				active: M,
				status: l,
				onClick: Ee,
				onBlur: Te,
				onKeyDown: De,
				onPaste: Oe,
				tabIndex: d ? -1 : v ?? (ge ? -1 : 0),
				children: /* @__PURE__ */ j(G, {
					className: Q.inputWrapperChild,
					children: [/* @__PURE__ */ j(G, {
						gap: "100",
						flexWrap: "wrap",
						className: Q.titleContainer,
						children: [_e && P, ge && /* @__PURE__ */ A("input", {
							...m,
							ref: fe,
							onChange: xe,
							className: O(Q.filterInput, m?.className),
							autoComplete: "off",
							"aria-autocomplete": "list",
							placeholder: ve,
							disabled: d || m?.disabled
						})]
					}), /* @__PURE__ */ j(G, {
						alignItems: "center",
						className: Q.iconContainer,
						children: [E && !d && !f && !!r?.length && /* @__PURE__ */ A(h, {
							className: Q.iconButton,
							variant: "tertiary",
							icon: "close",
							disabled: d,
							onClick: Ae,
							"aria-label": "Clear"
						}), /* @__PURE__ */ A(h, {
							className: Q.iconButton,
							variant: "tertiary",
							icon: M ? "angle-up" : "angle-down",
							disabled: d,
							onClick: ke,
							"aria-label": M ? "Close" : "Open"
						})]
					})]
				})
			}),
			t && /* @__PURE__ */ A("input", {
				type: "hidden",
				disabled: d,
				name: t,
				value: te(r)
			}),
			/* @__PURE__ */ A(hn, {
				isOpen: M,
				...re,
				className: O(re?.className, Q.dropdown),
				children: /* @__PURE__ */ A("div", {
					ref: pe,
					style: { width: "100%" },
					children: M && /* @__PURE__ */ j(k, { children: [
						ae,
						/* @__PURE__ */ A(Mc, {
							...ie,
							equalityFn: D,
							defaultActiveItemIndex: ee,
							isActive: M,
							isMultiple: g,
							selectedValues: r,
							onChange: Me,
							children: p
						}),
						oe
					] })
				})
			})
		]
	});
}, Lc = Object.assign(F(Ic), { name: Ic.name }), Rc = ({ className: e, input: { value: t, name: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, helpIcon: l, description: u, noLabel: d, noAlert: f, ...p }) => /* @__PURE__ */ A(X, {
	className: e,
	label: a,
	labelFor: n,
	meta: o,
	required: s,
	disabled: c,
	helpIcon: l,
	description: u,
	noLabel: d,
	noAlert: f,
	children: /* @__PURE__ */ A(Lc, {
		name: n,
		value: t || [],
		onChange: (e) => {
			r(e.selectedValues);
		},
		...i,
		status: X.getStatus(o),
		disabled: c,
		required: s,
		...p
	})
}), zc = {
	rootWrapper: "h-slider--slider__rootWrapper",
	rootWrapperNoAnnotations: "h-slider--slider__rootWrapperNoAnnotations",
	root: "h-slider--slider__root",
	rootDark: "h-slider--slider__rootDark",
	rootDisabled: "h-slider--slider__rootDisabled",
	handle: "h-slider--slider__handle",
	trackWrapper: "h-slider--slider__trackWrapper",
	track: "h-slider--slider__track",
	highlight: "h-slider--slider__highlight",
	minValueIndicator: "h-slider--slider__minValueIndicator",
	maxValueIndicator: "h-slider--slider__maxValueIndicator"
}, Bc = /* @__PURE__ */ function(e) {
	return e.LowBoundIndicator = "input-slider-low-indicator", e.HighBoundIndicator = "input-slider-high-indicator", e.Handle = "input-slider-handle", e.Value = "input-slider-value", e.TrackBackground = "input-slider-tack-background", e.Track = "input-slider-track", e.Highlight = "input-slider-highlight", e;
}({}), Vc = (e) => {
	e.preventDefault();
}, Hc = (e, t, n) => typeof e != "number" && !Array.isArray(e) ? "" : typeof e == "number" ? /* @__PURE__ */ j(i.Paragraph, {
	variant: "3",
	children: [
		t,
		e,
		n
	]
}) : /* @__PURE__ */ j(i.Paragraph, {
	variant: "3",
	children: [
		t,
		e[0],
		n,
		" - ",
		t,
		e[1],
		n
	]
}), Uc = mt(class extends N {
	static defaultProps = {
		min: 0,
		max: 100,
		dark: !1,
		highlightRange: null,
		formatValue: Hc,
		hideAnnotations: !1
	};
	constructor(e) {
		super(e), this.state = {
			startX: 0,
			startVal: 0,
			sliderWidth: 0,
			currentIndex: null
		}, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
	}
	sliderRef = P();
	isInterval(e) {
		return Array.isArray(e);
	}
	handleChange(e) {
		typeof e == "number" ? this.props.onChange?.(Math.round(e)) : this.props.onChange?.(e.map((e) => Math.round(e)));
	}
	handleHandleGrab(e) {
		e.target instanceof Element && this.setState({ currentIndex: parseInt(e.target.getAttribute("data-index") || "", 10) });
	}
	handleHandleMove(e) {
		e.preventDefault();
		let { startVal: t, startX: n, sliderWidth: r, currentIndex: i } = this.state, a = t + (e.clientX - n) / r, o = this.getAbsoluteValue(a, i);
		this.handleChange(o);
	}
	handleHandleDrop() {
		window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
	}
	handleKeyDown(e) {
		let { step: t = 1, value: n } = this.props;
		e.preventDefault();
		let r = this.isInterval(n) && e.target instanceof Element ? parseInt(e.target.getAttribute("data-index") || "", 10) : null;
		switch (e.key) {
			case "ArrowRight":
			case "ArrowUp":
				this.increment(t, r);
				break;
			case "ArrowLeft":
			case "ArrowDown":
				this.increment(-t, r);
				break;
			default: break;
		}
	}
	handleSliderMouseDown(e) {
		if (!this.sliderRef.current) return;
		let { value: t } = this.props, { currentIndex: n } = this.state, r = this.sliderRef.current.getBoundingClientRect(), i = (e.clientX - r.left) / r.width;
		this.setState({
			startX: e.clientX,
			startVal: i,
			sliderWidth: r.width
		});
		let a;
		if (this.isInterval(t)) {
			let e = n ?? this.findTheNearestHandle(i, t);
			this.setState({ currentIndex: e }), a = this.getAbsoluteValue(i, e);
		} else a = this.getAbsoluteValue(i);
		this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
	}
	findTheNearestHandle(e, t) {
		let [n, r] = t.map(this.absoluteValueToRelativeValue);
		return e > r && e > n ? 1 : e < r && e < n ? 0 : +(Math.abs(n - e) > Math.abs(r - e));
	}
	getAdjustedStep(e) {
		let { min: t, max: n } = this.props;
		return e / (n - t);
	}
	getAbsoluteValue(e, t) {
		let { value: n, step: r } = this.props, i = gr(e, 0, 1);
		if (r) {
			let e = this.getAdjustedStep(r);
			i = Math.round(i / e) * e;
		}
		if (!this.isInterval(n)) return this.relativeValueToAbsoluteValue(i);
		let [a, o] = n, s = this.relativeValueToAbsoluteValue(i);
		t === 0 && s > o ? s = o : t === 1 && s < a && (s = a);
		let c = [a, o];
		return typeof t == "number" && (c[t] = s), c;
	}
	relativeValueToAbsoluteValue(e) {
		let { min: t, max: n } = this.props;
		return gr(t + (n - t) * e, t, n);
	}
	absoluteValueToRelativeValue(e) {
		let { min: t, max: n } = this.props;
		return gr((e - t) / (n - t), 0, 1);
	}
	increment(e, t) {
		let { value: n } = this.props, r;
		if (this.isInterval(n)) {
			let i = [...n];
			i[t ?? 0] = i[t ?? 0] + e, r = i;
		} else r = n + e;
		this.handleChange(r);
	}
	getTrackStyles() {
		let { value: e, min: t } = this.props, n = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[1]) - this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(e), r = this.isInterval(e) ? this.absoluteValueToRelativeValue(e[0]) : this.absoluteValueToRelativeValue(t);
		return {
			width: `${n * 100}%`,
			left: `${r * 100}%`
		};
	}
	getHandleStyles(e) {
		let { value: t } = this.props;
		return { left: `${(this.isInterval(t) ? this.absoluteValueToRelativeValue(t[e ?? 0]) : this.absoluteValueToRelativeValue(t)) * 100}%` };
	}
	getHighlightStyles() {
		let { highlightRange: e } = this.props;
		if (Fr(e)) return {};
		let [t, n] = e.map(this.absoluteValueToRelativeValue);
		return {
			left: `${t * 100}%`,
			width: `${(n - t) * 100}%`
		};
	}
	render() {
		let { className: e, value: t, step: n, highlightRange: r, min: a, max: o, dark: s, disabled: c, onChange: l, formatValue: u, hideAnnotations: d, valuePrefix: f, valueSuffix: p, onBlur: m, onFocus: h, children: g, ..._ } = this.props, v = O(zc.root, { [zc.rootDark]: s }, { [zc.rootDisabled]: c }, e);
		return /* @__PURE__ */ j("div", {
			className: O(zc.rootWrapper, { [zc.rootWrapperNoAnnotations]: d }),
			children: [/* @__PURE__ */ j("div", {
				..._,
				className: v,
				ref: this.sliderRef,
				onMouseDown: this.handleSliderMouseDown,
				children: [
					/* @__PURE__ */ j("div", {
						className: zc.trackWrapper,
						"data-testid": Bc.TrackBackground,
						children: [!Fr(r) && /* @__PURE__ */ A("div", {
							className: zc.highlight,
							style: this.getHighlightStyles(),
							"data-testid": Bc.Highlight
						}), /* @__PURE__ */ A("div", {
							className: zc.track,
							style: this.getTrackStyles(),
							"data-testid": Bc.Track
						})]
					}),
					!this.isInterval(t) && /* @__PURE__ */ A("button", {
						tabIndex: 0,
						role: "slider",
						type: "button",
						"aria-valuemin": a,
						"aria-valuemax": o,
						"aria-valuenow": t,
						className: zc.handle,
						onClick: Vc,
						onKeyDown: this.handleKeyDown,
						style: this.getHandleStyles(),
						"data-testid": Bc.Handle
					}),
					this.isInterval(t) && /* @__PURE__ */ j(he, { children: [/* @__PURE__ */ A("button", {
						tabIndex: 0,
						type: "button",
						"data-index": "0",
						className: zc.handle,
						onKeyDown: this.handleKeyDown,
						style: this.getHandleStyles(0),
						onMouseDown: this.handleHandleGrab,
						"data-testid": Bc.Handle
					}), /* @__PURE__ */ A("button", {
						tabIndex: 0,
						type: "button",
						"data-index": "1",
						className: zc.handle,
						onKeyDown: this.handleKeyDown,
						style: this.getHandleStyles(1),
						onMouseDown: this.handleHandleGrab,
						"data-testid": Bc.Handle
					})] }),
					!d && /* @__PURE__ */ A("span", {
						"data-testid": Bc.LowBoundIndicator,
						className: zc.minValueIndicator,
						children: /* @__PURE__ */ j(i.Paragraph, {
							variant: "4",
							as: "span",
							subdued: !0,
							children: [
								f,
								a,
								p
							]
						})
					}),
					!d && /* @__PURE__ */ A("span", {
						className: zc.maxValueIndicator,
						"data-testid": Bc.HighBoundIndicator,
						children: /* @__PURE__ */ j(i.Paragraph, {
							variant: "4",
							as: "span",
							subdued: !0,
							children: [
								f,
								o,
								p
							]
						})
					})
				]
			}), !d && /* @__PURE__ */ A("div", {
				"data-testid": Bc.Value,
				children: u(t, f, p)
			})]
		});
	}
}, { fallback: null }), Wc = { root: "h-fieldSlider--fieldSlider__root" }, Gc = class extends N {
	constructor(e) {
		super(e), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
	}
	handleChange(e) {
		let t = new Event("change");
		Object.defineProperty(t, "target", {
			writable: !0,
			value: {
				value: e,
				name: this.props.input.name
			}
		}), this.props.input.onChange(t);
	}
	handleBlur(e) {
		let { input: t } = this.props, n = new FocusEvent("blur", e);
		Object.defineProperty(n, "target", {
			writable: !0,
			value: {
				value: t.value,
				name: t.name
			}
		}), t.onBlur?.(n);
	}
	render() {
		let { className: e, input: t, meta: n, label: r, required: i, disabled: a, helpIcon: o, description: s, noAlert: c, noLabel: l, ...u } = this.props;
		return /* @__PURE__ */ A(X, {
			className: O(Wc.root, e),
			label: r,
			meta: n,
			required: i,
			disabled: a,
			helpIcon: o,
			description: s,
			noAlert: c,
			noLabel: l,
			children: /* @__PURE__ */ A(Uc, {
				...t,
				onChange: this.handleChange,
				disabled: a,
				...u
			})
		});
	}
}, Kc = {
	root: "h-switch--switch__root",
	input: "h-switch--switch__input",
	inner: "h-switch--switch__inner",
	pending: "h-switch--switch__pending",
	active: "h-switch--switch__active"
}, qc = {
	input: "Switch-input",
	label: "Switch-label"
}, Jc = class extends N {
	render() {
		let { id: e, className: t, variant: n, ...r } = this.props, i = e || `switch_${Math.random()}`;
		return /* @__PURE__ */ j("div", {
			className: O(t, Kc.root),
			"data-testid": e,
			children: [/* @__PURE__ */ A("input", {
				...r,
				id: i,
				type: "checkbox",
				className: Kc.input,
				"data-testid": qc.input
			}), /* @__PURE__ */ A("label", {
				htmlFor: i,
				className: O(Kc.inner, {
					[Kc.active]: n === "active",
					[Kc.pending]: n === "pending"
				}),
				"data-testid": qc.label
			})]
		});
	}
}, Yc = class extends N {
	render() {
		let { input: e, ...t } = this.props, { ref: n, ...r } = e;
		return /* @__PURE__ */ A(Jc, {
			...r,
			...t
		});
	}
}, Xc = class extends N {
	render() {
		let { className: e, input: t, label: n, meta: r, required: i, disabled: a, helpIcon: o, description: s, noAlert: c, noLabel: l, ...u } = this.props;
		return /* @__PURE__ */ A(X, {
			className: e,
			label: n,
			labelFor: t.name,
			meta: r,
			required: i,
			disabled: a,
			helpIcon: o,
			description: s,
			noAlert: c,
			noLabel: l,
			children: /* @__PURE__ */ A(sc, {
				status: X.getStatus(r),
				disabled: a,
				required: i,
				...t,
				...u
			})
		});
	}
}, Zc = ({ className: e, input: { name: t, value: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, description: l, helpIcon: u, noLabel: d, noAlert: f, ...p }) => {
	let m = L((e) => void r(e ?? ""), []);
	return /* @__PURE__ */ A(X, {
		className: e,
		description: l,
		disabled: c,
		helpIcon: u,
		label: a,
		labelFor: t,
		meta: o,
		noAlert: f,
		noLabel: d,
		required: s,
		children: /* @__PURE__ */ A(Sa, {
			selectedItems: n ? [n] : [],
			...i,
			...p,
			disabled: c,
			id: t,
			onSelect: m,
			status: X.getStatus(o)
		})
	});
}, Qc = ({ className: e, input: { name: t, value: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, description: l, helpIcon: u, noLabel: d, noAlert: f, ...p }) => {
	let m = L((e) => void r({
		startTime: e.startTime ?? "",
		endTime: e.endTime ?? ""
	}), []);
	return /* @__PURE__ */ A(X, {
		className: e,
		description: l,
		disabled: c,
		helpIcon: u,
		label: a,
		labelFor: t,
		meta: o,
		noAlert: f,
		noLabel: d,
		required: s,
		children: /* @__PURE__ */ A(wa, {
			endTime: n.endTime,
			startTime: n.startTime,
			...i,
			...p,
			disabled: c,
			id: t,
			onSelect: m,
			status: X.getStatus(o)
		})
	});
}, $c = {
	root: "h-inputColorPicker-indicator--inputColorPickerIndicator__root",
	rootAlpha: "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha",
	indicator: "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator",
	indicatorNoColor: "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor"
}, el = ({ color: e, alpha: t, className: n, ...r }) => /* @__PURE__ */ A("div", {
	...r,
	className: O($c.root, n, { [$c.rootAlpha]: t }),
	children: /* @__PURE__ */ A("div", {
		className: O($c.indicator, { [$c.indicatorNoColor]: !e }),
		style: { backgroundColor: e }
	})
}), tl = {
	root: "h-inputColorPicker--inputColorPicker__root",
	inputContainer: "h-inputColorPicker--inputColorPicker__inputContainer",
	input: "h-inputColorPicker--inputColorPicker__input",
	rootReadOnly: "h-inputColorPicker--inputColorPicker__rootReadOnly",
	iconContainer: "h-inputColorPicker--inputColorPicker__iconContainer",
	rootHasWrapperIcon: "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon",
	clearIcon: "h-inputColorPicker--inputColorPicker__clearIcon",
	colorIndicator: "h-inputColorPicker--inputColorPicker__colorIndicator"
}, nl = "inputColorPickerTestId", rl = F(function({ className: e, name: t = Math.floor(Math.random() * 1e8).toString(), value: r, onChange: i, dropdownProps: a, prefix: o, suffix: s, icon: c, status: l, placeholder: u, disabled: d, colorPickerProps: f, clearable: p, readOnly: m, children: g, ..._ }, v) {
	let y = B(null), b = B(null), x = B(null), [S, C] = V(!1);
	R(() => {
		S ? (window.addEventListener("click", T), window.addEventListener("keydown", E)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", E)), S && w();
	}, [S]), Fe(() => {
		window.removeEventListener("click", T), window.removeEventListener("keydown", E);
	});
	let w = () => {
		(x.current?.querySelector("input"))?.focus();
	}, T = ({ target: e }) => {
		b.current?.contains(e) || C(!1);
	}, E = (e) => {
		dn(e.key) && S && (e.stopPropagation(), C(!1));
	}, D = () => {
		m || C(!0);
	}, ee = ({ target: e }) => {
		b.current?.contains(e) || C(!1);
	}, te = () => {
		m || C(!0);
	}, ne = ({ key: e }) => {
		un(e) && C(!0);
	};
	return /* @__PURE__ */ j("div", {
		"data-testid": nl,
		ref: b,
		className: O(tl.root, e, {
			[tl.rootHasWrapperIcon]: !!c,
			[tl.rootReadOnly]: m
		}),
		children: [/* @__PURE__ */ A(n, {
			prefix: o,
			suffix: s,
			disabled: d,
			icon: c,
			active: S,
			status: l,
			children: /* @__PURE__ */ j("div", {
				className: tl.inputContainer,
				children: [
					/* @__PURE__ */ A("input", {
						..._,
						id: t,
						name: t,
						className: tl.input,
						ref: y,
						onClick: te,
						onFocus: D,
						onBlur: ee,
						onKeyDown: ne,
						disabled: d,
						placeholder: u,
						autoComplete: "off",
						value: r,
						onChange: Ka(r) ? void 0 : K,
						readOnly: !0
					}),
					/* @__PURE__ */ A("div", {
						className: tl.iconContainer,
						children: p && r && /* @__PURE__ */ A(h, {
							className: tl.clearIcon,
							variant: "tertiary",
							icon: "close",
							disabled: d,
							onClick: () => i?.("")
						})
					}),
					/* @__PURE__ */ A(el, {
						className: tl.colorIndicator,
						onClick: te,
						color: r,
						alpha: f?.alpha
					})
				]
			})
		}), /* @__PURE__ */ A(hn, {
			...a,
			isOpen: S,
			children: /* @__PURE__ */ A("div", {
				ref: x,
				children: /* @__PURE__ */ A(zn, {
					margin: "300",
					...f,
					color: r,
					onChange: i ?? K,
					children: g
				})
			})
		})]
	});
}), il = ({ className: e, input: { value: t, name: n, onChange: r, ...i }, label: a, meta: o, required: s, disabled: c, helpIcon: l, description: u, noLabel: d, noAlert: f, ...p }) => /* @__PURE__ */ A(X, {
	className: e,
	label: a,
	labelFor: n,
	meta: o,
	required: s,
	disabled: c,
	helpIcon: l,
	description: u,
	noLabel: d,
	noAlert: f,
	children: /* @__PURE__ */ A(rl, {
		name: n,
		value: t,
		onChange: r,
		...i,
		status: X.getStatus(o),
		disabled: c,
		required: s,
		...p
	})
}), al = {
	root: "h-fieldAddonDropdown--fieldAddonDropdown__root",
	prefix: "h-fieldAddonDropdown--fieldAddonDropdown__prefix",
	suffix: "h-fieldAddonDropdown--fieldAddonDropdown__suffix",
	angleDown: "h-fieldAddonDropdown--fieldAddonDropdown__angleDown"
}, ol = ({ className: e, noArrow: t, ...n }) => Mi(n) ? null : /* @__PURE__ */ A(f.Consumer, { children: ({ position: r, disabled: i }) => /* @__PURE__ */ A(Ua, {
	...no(n, "meta"),
	noStyle: !0,
	itemComponent: Wi,
	children: /* @__PURE__ */ j("button", {
		className: O(al.root, {
			[al.prefix]: r === "prefix",
			[al.suffix]: r === "suffix"
		}, e),
		disabled: i || n.meta.disabled,
		type: "button",
		children: [/* @__PURE__ */ A("span", { children: n.meta.selectedValue }), !t && /* @__PURE__ */ A(u, {
			name: "angle-down",
			className: O("icon-vertical-fix", al.angleDown)
		})]
	})
}) }), sl = {
	flag: "h-countryFlag--countryFlag__flag",
	ad: "h-countryFlag--countryFlag__ad",
	ae: "h-countryFlag--countryFlag__ae",
	af: "h-countryFlag--countryFlag__af",
	ag: "h-countryFlag--countryFlag__ag",
	ai: "h-countryFlag--countryFlag__ai",
	al: "h-countryFlag--countryFlag__al",
	am: "h-countryFlag--countryFlag__am",
	ao: "h-countryFlag--countryFlag__ao",
	aq: "h-countryFlag--countryFlag__aq",
	ar: "h-countryFlag--countryFlag__ar",
	as: "h-countryFlag--countryFlag__as",
	at: "h-countryFlag--countryFlag__at",
	au: "h-countryFlag--countryFlag__au",
	aw: "h-countryFlag--countryFlag__aw",
	ax: "h-countryFlag--countryFlag__ax",
	az: "h-countryFlag--countryFlag__az",
	ba: "h-countryFlag--countryFlag__ba",
	bb: "h-countryFlag--countryFlag__bb",
	bd: "h-countryFlag--countryFlag__bd",
	be: "h-countryFlag--countryFlag__be",
	bf: "h-countryFlag--countryFlag__bf",
	bg: "h-countryFlag--countryFlag__bg",
	bh: "h-countryFlag--countryFlag__bh",
	bi: "h-countryFlag--countryFlag__bi",
	bj: "h-countryFlag--countryFlag__bj",
	bl: "h-countryFlag--countryFlag__bl",
	bm: "h-countryFlag--countryFlag__bm",
	bn: "h-countryFlag--countryFlag__bn",
	bo: "h-countryFlag--countryFlag__bo",
	bq: "h-countryFlag--countryFlag__bq",
	br: "h-countryFlag--countryFlag__br",
	bs: "h-countryFlag--countryFlag__bs",
	bt: "h-countryFlag--countryFlag__bt",
	bv: "h-countryFlag--countryFlag__bv",
	bw: "h-countryFlag--countryFlag__bw",
	by: "h-countryFlag--countryFlag__by",
	bz: "h-countryFlag--countryFlag__bz",
	ca: "h-countryFlag--countryFlag__ca",
	cd: "h-countryFlag--countryFlag__cd",
	cf: "h-countryFlag--countryFlag__cf",
	cg: "h-countryFlag--countryFlag__cg",
	ch: "h-countryFlag--countryFlag__ch",
	ci: "h-countryFlag--countryFlag__ci",
	ck: "h-countryFlag--countryFlag__ck",
	cl: "h-countryFlag--countryFlag__cl",
	cm: "h-countryFlag--countryFlag__cm",
	cn: "h-countryFlag--countryFlag__cn",
	co: "h-countryFlag--countryFlag__co",
	cp: "h-countryFlag--countryFlag__cp",
	cr: "h-countryFlag--countryFlag__cr",
	cu: "h-countryFlag--countryFlag__cu",
	cv: "h-countryFlag--countryFlag__cv",
	cw: "h-countryFlag--countryFlag__cw",
	cy: "h-countryFlag--countryFlag__cy",
	cz: "h-countryFlag--countryFlag__cz",
	de: "h-countryFlag--countryFlag__de",
	dj: "h-countryFlag--countryFlag__dj",
	dk: "h-countryFlag--countryFlag__dk",
	dm: "h-countryFlag--countryFlag__dm",
	do: "h-countryFlag--countryFlag__do",
	dz: "h-countryFlag--countryFlag__dz",
	ec: "h-countryFlag--countryFlag__ec",
	ee: "h-countryFlag--countryFlag__ee",
	eg: "h-countryFlag--countryFlag__eg",
	eh: "h-countryFlag--countryFlag__eh",
	er: "h-countryFlag--countryFlag__er",
	es: "h-countryFlag--countryFlag__es",
	et: "h-countryFlag--countryFlag__et",
	eu: "h-countryFlag--countryFlag__eu",
	fi: "h-countryFlag--countryFlag__fi",
	fj: "h-countryFlag--countryFlag__fj",
	fm: "h-countryFlag--countryFlag__fm",
	fo: "h-countryFlag--countryFlag__fo",
	fr: "h-countryFlag--countryFlag__fr",
	ga: "h-countryFlag--countryFlag__ga",
	gb: "h-countryFlag--countryFlag__gb",
	gd: "h-countryFlag--countryFlag__gd",
	ge: "h-countryFlag--countryFlag__ge",
	gg: "h-countryFlag--countryFlag__gg",
	gh: "h-countryFlag--countryFlag__gh",
	gi: "h-countryFlag--countryFlag__gi",
	gl: "h-countryFlag--countryFlag__gl",
	gm: "h-countryFlag--countryFlag__gm",
	gn: "h-countryFlag--countryFlag__gn",
	gp: "h-countryFlag--countryFlag__gp",
	gq: "h-countryFlag--countryFlag__gq",
	gr: "h-countryFlag--countryFlag__gr",
	gt: "h-countryFlag--countryFlag__gt",
	gu: "h-countryFlag--countryFlag__gu",
	gw: "h-countryFlag--countryFlag__gw",
	gy: "h-countryFlag--countryFlag__gy",
	hk: "h-countryFlag--countryFlag__hk",
	hn: "h-countryFlag--countryFlag__hn",
	hr: "h-countryFlag--countryFlag__hr",
	ht: "h-countryFlag--countryFlag__ht",
	hu: "h-countryFlag--countryFlag__hu",
	id: "h-countryFlag--countryFlag__id",
	ie: "h-countryFlag--countryFlag__ie",
	il: "h-countryFlag--countryFlag__il",
	im: "h-countryFlag--countryFlag__im",
	in: "h-countryFlag--countryFlag__in",
	iq: "h-countryFlag--countryFlag__iq",
	ir: "h-countryFlag--countryFlag__ir",
	is: "h-countryFlag--countryFlag__is",
	it: "h-countryFlag--countryFlag__it",
	je: "h-countryFlag--countryFlag__je",
	jm: "h-countryFlag--countryFlag__jm",
	jo: "h-countryFlag--countryFlag__jo",
	jp: "h-countryFlag--countryFlag__jp",
	ke: "h-countryFlag--countryFlag__ke",
	kg: "h-countryFlag--countryFlag__kg",
	kh: "h-countryFlag--countryFlag__kh",
	ki: "h-countryFlag--countryFlag__ki",
	km: "h-countryFlag--countryFlag__km",
	kn: "h-countryFlag--countryFlag__kn",
	kp: "h-countryFlag--countryFlag__kp",
	kr: "h-countryFlag--countryFlag__kr",
	kw: "h-countryFlag--countryFlag__kw",
	ky: "h-countryFlag--countryFlag__ky",
	kz: "h-countryFlag--countryFlag__kz",
	la: "h-countryFlag--countryFlag__la",
	lb: "h-countryFlag--countryFlag__lb",
	lc: "h-countryFlag--countryFlag__lc",
	li: "h-countryFlag--countryFlag__li",
	lk: "h-countryFlag--countryFlag__lk",
	lr: "h-countryFlag--countryFlag__lr",
	ls: "h-countryFlag--countryFlag__ls",
	lt: "h-countryFlag--countryFlag__lt",
	lu: "h-countryFlag--countryFlag__lu",
	lv: "h-countryFlag--countryFlag__lv",
	ly: "h-countryFlag--countryFlag__ly",
	ma: "h-countryFlag--countryFlag__ma",
	mc: "h-countryFlag--countryFlag__mc",
	md: "h-countryFlag--countryFlag__md",
	me: "h-countryFlag--countryFlag__me",
	mf: "h-countryFlag--countryFlag__mf",
	mg: "h-countryFlag--countryFlag__mg",
	mh: "h-countryFlag--countryFlag__mh",
	mk: "h-countryFlag--countryFlag__mk",
	ml: "h-countryFlag--countryFlag__ml",
	mm: "h-countryFlag--countryFlag__mm",
	mn: "h-countryFlag--countryFlag__mn",
	mo: "h-countryFlag--countryFlag__mo",
	mq: "h-countryFlag--countryFlag__mq",
	mr: "h-countryFlag--countryFlag__mr",
	ms: "h-countryFlag--countryFlag__ms",
	mt: "h-countryFlag--countryFlag__mt",
	mu: "h-countryFlag--countryFlag__mu",
	mv: "h-countryFlag--countryFlag__mv",
	mw: "h-countryFlag--countryFlag__mw",
	mx: "h-countryFlag--countryFlag__mx",
	my: "h-countryFlag--countryFlag__my",
	mz: "h-countryFlag--countryFlag__mz",
	na: "h-countryFlag--countryFlag__na",
	nc: "h-countryFlag--countryFlag__nc",
	ne: "h-countryFlag--countryFlag__ne",
	ng: "h-countryFlag--countryFlag__ng",
	ni: "h-countryFlag--countryFlag__ni",
	nl: "h-countryFlag--countryFlag__nl",
	no: "h-countryFlag--countryFlag__no",
	np: "h-countryFlag--countryFlag__np",
	nq: "h-countryFlag--countryFlag__nq",
	nr: "h-countryFlag--countryFlag__nr",
	nu: "h-countryFlag--countryFlag__nu",
	nz: "h-countryFlag--countryFlag__nz",
	om: "h-countryFlag--countryFlag__om",
	pa: "h-countryFlag--countryFlag__pa",
	pe: "h-countryFlag--countryFlag__pe",
	pf: "h-countryFlag--countryFlag__pf",
	pg: "h-countryFlag--countryFlag__pg",
	ph: "h-countryFlag--countryFlag__ph",
	pk: "h-countryFlag--countryFlag__pk",
	pl: "h-countryFlag--countryFlag__pl",
	pr: "h-countryFlag--countryFlag__pr",
	ps: "h-countryFlag--countryFlag__ps",
	pt: "h-countryFlag--countryFlag__pt",
	pw: "h-countryFlag--countryFlag__pw",
	py: "h-countryFlag--countryFlag__py",
	qa: "h-countryFlag--countryFlag__qa",
	re: "h-countryFlag--countryFlag__re",
	ro: "h-countryFlag--countryFlag__ro",
	rs: "h-countryFlag--countryFlag__rs",
	ru: "h-countryFlag--countryFlag__ru",
	rw: "h-countryFlag--countryFlag__rw",
	sa: "h-countryFlag--countryFlag__sa",
	sb: "h-countryFlag--countryFlag__sb",
	sc: "h-countryFlag--countryFlag__sc",
	sd: "h-countryFlag--countryFlag__sd",
	se: "h-countryFlag--countryFlag__se",
	sg: "h-countryFlag--countryFlag__sg",
	sh: "h-countryFlag--countryFlag__sh",
	si: "h-countryFlag--countryFlag__si",
	sj: "h-countryFlag--countryFlag__sj",
	sk: "h-countryFlag--countryFlag__sk",
	sl: "h-countryFlag--countryFlag__sl",
	sm: "h-countryFlag--countryFlag__sm",
	sn: "h-countryFlag--countryFlag__sn",
	so: "h-countryFlag--countryFlag__so",
	sr: "h-countryFlag--countryFlag__sr",
	ss: "h-countryFlag--countryFlag__ss",
	st: "h-countryFlag--countryFlag__st",
	sv: "h-countryFlag--countryFlag__sv",
	sx: "h-countryFlag--countryFlag__sx",
	sy: "h-countryFlag--countryFlag__sy",
	sz: "h-countryFlag--countryFlag__sz",
	tc: "h-countryFlag--countryFlag__tc",
	td: "h-countryFlag--countryFlag__td",
	tg: "h-countryFlag--countryFlag__tg",
	th: "h-countryFlag--countryFlag__th",
	tj: "h-countryFlag--countryFlag__tj",
	tl: "h-countryFlag--countryFlag__tl",
	tm: "h-countryFlag--countryFlag__tm",
	tn: "h-countryFlag--countryFlag__tn",
	to: "h-countryFlag--countryFlag__to",
	tr: "h-countryFlag--countryFlag__tr",
	tt: "h-countryFlag--countryFlag__tt",
	tv: "h-countryFlag--countryFlag__tv",
	tw: "h-countryFlag--countryFlag__tw",
	tz: "h-countryFlag--countryFlag__tz",
	ua: "h-countryFlag--countryFlag__ua",
	ug: "h-countryFlag--countryFlag__ug",
	us: "h-countryFlag--countryFlag__us",
	uy: "h-countryFlag--countryFlag__uy",
	uz: "h-countryFlag--countryFlag__uz",
	va: "h-countryFlag--countryFlag__va",
	vc: "h-countryFlag--countryFlag__vc",
	ve: "h-countryFlag--countryFlag__ve",
	vg: "h-countryFlag--countryFlag__vg",
	vi: "h-countryFlag--countryFlag__vi",
	vn: "h-countryFlag--countryFlag__vn",
	vu: "h-countryFlag--countryFlag__vu",
	ws: "h-countryFlag--countryFlag__ws",
	ye: "h-countryFlag--countryFlag__ye",
	yt: "h-countryFlag--countryFlag__yt",
	za: "h-countryFlag--countryFlag__za",
	zm: "h-countryFlag--countryFlag__zm",
	zw: "h-countryFlag--countryFlag__zw"
}, cl = 127365, ll = /^[a-z]{2}$/, ul = (e) => ll.test(e) ? String.fromCodePoint(...e.split("").map((e) => cl + e.charCodeAt(0))) : "", dl = ({ className: e, countryCode: t, size: n = 16 }) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ A(a, {
	style: {
		width: n,
		height: n
	},
	children: /* @__PURE__ */ A(a, {
		className: O(sl.flag, sl[t], e),
		style: {
			width: 32,
			height: 32,
			transform: `scale(calc(${n} / 32))`
		}
	})
}) : /* @__PURE__ */ A("span", {
	className: e,
	style: { fontSize: n },
	children: ul(t)
}), fl = /* @__PURE__ */ "ad.ae.af.ag.ai.al.am.ao.ar.as.at.au.aw.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bm.bn.bo.br.bs.bt.bw.by.bz.ca.cd.cf.cg.ch.ci.ck.cl.cm.cn.co.cr.cu.cv.cw.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.er.es.et.fi.fj.fk.fm.fo.fr.bl.mf.ga.gb.gd.ge.gf.gh.gi.gl.gm.gn.gp.gq.gr.gt.gu.gw.gy.hk.hn.hr.ht.hu.id.ie.il.in.io.iq.ir.is.it.jm.jo.jp.ke.kg.kh.ki.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.lr.ls.lt.lu.lv.ly.ma.mc.md.me.mg.mh.mk.ml.mm.mn.mo.mp.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.bq.no.np.nr.nu.nz.om.pa.pe.pf.pg.ph.pk.pl.pm.pr.ps.pt.pw.py.qa.re.ro.rs.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sk.sl.sm.sn.so.sr.ss.st.sv.sx.sy.sz.tc.td.tg.th.tj.tk.tl.tm.tn.to.tr.tt.tv.tw.tz.ua.ug.us.uy.uz.va.vc.ve.vg.vi.vn.vu.wf.ws.ye.za.zm.zw".split("."), pl = { root: "h-formGrid--formGrid__root" }, ml = "formGridTestId", hl = F(function({ className: e, children: t, ...n }, r) {
	return /* @__PURE__ */ A("div", {
		"data-testid": ml,
		className: O(pl.root, e),
		...n,
		ref: r,
		children: t
	});
}), gl = {
	root: "h-formGrid-field--formField__root",
	rootSpan5: "h-formGrid-field--formField__rootSpan5",
	rootSpan4: "h-formGrid-field--formField__rootSpan4",
	rootSpan3: "h-formGrid-field--formField__rootSpan3",
	rootSpan2: "h-formGrid-field--formField__rootSpan2",
	rootSpan1: "h-formGrid-field--formField__rootSpan1"
}, _l = "formFieldTestId", vl = {
	1: gl.rootSpan1,
	2: gl.rootSpan2,
	3: gl.rootSpan3,
	4: gl.rootSpan4,
	5: gl.rootSpan5,
	6: void 0
}, yl = class extends N {
	static defaultProps = { span: 6 };
	render() {
		let { span: e, className: t, children: n, ...r } = this.props;
		return /* @__PURE__ */ A("div", {
			"data-testid": _l,
			className: O(gl.root, t, vl[e]),
			...r,
			children: n
		});
	}
}, bl = {
	root: "h-helperField--helperField__root",
	label: "h-helperField--helperField__label",
	helpIcon: "h-helperField--helperField__helpIcon",
	error: "h-helperField--helperField__error",
	rootRequired: "h-helperField--helperField__rootRequired"
}, xl = class extends N {
	render() {
		let { className: e, label: t, required: n, disabled: r, errorMessage: i, fieldId: a, children: o, helpIcon: s, ...c } = this.props, l = O({
			[bl.root]: !0,
			[bl.rootRequired]: n
		}, e);
		return /* @__PURE__ */ j("div", {
			...c,
			className: l,
			children: [
				!!t && /* @__PURE__ */ A("label", {
					className: bl.label,
					htmlFor: a,
					id: `${a}-label`,
					children: t
				}),
				!!s?.text && /* @__PURE__ */ A(Xr, {
					...s,
					className: O(bl.helpIcon, s?.className ?? "")
				}),
				!!i && /* @__PURE__ */ A("p", {
					className: bl.error,
					children: i
				}),
				o
			]
		});
	}
}, Sl = { root: "h-inputDuration--inputDuration__root" }, Cl = (e, t = [
	"hours",
	"minutes",
	"seconds"
]) => {
	let n = Math.floor(e / 1e3), r = {}, i = n;
	return t.includes("days") && (r.days = Math.floor(n / (24 * 3600)), i = n % (24 * 3600)), t.includes("hours") && (r.hours = Math.floor(i / 3600), i %= 3600), t.includes("minutes") && (r.minutes = Math.floor(i / 60), i %= 60), t.includes("seconds") && (r.seconds = i), r;
}, wl = (e) => ((e.days ?? 0) * 86400 + (e.hours ?? 0) * 3600 + (e.minutes ?? 0) * 60 + (e.seconds ?? 0)) * 1e3, Tl = [
	"hours",
	"minutes",
	"seconds"
], El = F(function(e, t) {
	let n = B(null);
	Ce(t, () => n.current);
	let { className: r, name: i = "input-duration", value: a = 0, required: o = !1, disabled: s = !1, readOnly: l = !1, inputParts: u = Tl, status: d, onChange: f, onBlur: p } = e, [m, h] = V(() => Cl(a, u));
	R(() => {
		let e = wl(m);
		if (a !== e) {
			let e = Cl(a, u);
			h(e);
		}
	}, [a, u]);
	let g = L((e, t) => {
		let n = Math.max(0, parseInt(t) || 0);
		if ((e === "minutes" || e === "seconds") && n > 60) return;
		let r = {
			...m,
			[e]: n
		};
		h(r);
		let i = wl(r);
		f?.(i);
	}, [m, f]), _ = L(() => {
		let e = Cl(wl(m), u);
		h(e), p?.();
	}, [
		m,
		u,
		p
	]), v = (e) => {
		let t = m[e] ?? 0, n = t === 0;
		return {
			type: "number",
			id: `${i}-${e}`,
			name: `${i}-${e}`,
			value: n ? "" : t,
			placeholder: n ? "0" : void 0,
			suffix: {
				type: "custom",
				value: e.charAt(0).toUpperCase() + e.slice(1)
			},
			min: 0,
			step: 1,
			required: o,
			disabled: s,
			readOnly: l,
			status: d,
			"aria-required": o,
			"aria-disabled": s,
			"aria-readonly": l,
			onBlur: _,
			onChange: (t) => g(e, t.target.value)
		};
	};
	return /* @__PURE__ */ j("div", {
		ref: n,
		className: O(r, Sl.root),
		children: [
			u.includes("days") && /* @__PURE__ */ A(c, { ...v("days") }),
			u.includes("hours") && /* @__PURE__ */ A(c, { ...v("hours") }),
			u.includes("minutes") && /* @__PURE__ */ A(c, {
				...v("minutes"),
				max: 60
			}),
			u.includes("seconds") && /* @__PURE__ */ A(c, {
				...v("seconds"),
				max: 60
			})
		]
	});
}), Dl = /* @__PURE__ */ new Map();
function Ol({ containerId: e, children: t }) {
	let [n, r] = V(null), i = (t) => {
		let n = Dl.get(e);
		n !== void 0 && Dl.set(e, n + t);
	}, a = () => {
		let t = document.createElement("div");
		return t.id = e, t;
	};
	return R(() => {
		let t = document.getElementById(e);
		return t || (t = a(), document.body.appendChild(t), Dl.set(e, 0)), r(t), i(1), () => {
			i(-1), Dl.get(e) === 0 && t && (Dl.delete(e), t.remove());
		};
	}, [e]), n ? Ee.createPortal(t, n) : null;
}
var kl = {
	root: "h-modal--modal__root",
	rootSkipAnimation: "h-modal--modal__rootSkipAnimation",
	modalContainer: "h-modal--modal__modalContainer",
	modalContent: "h-modal--modal__modalContent",
	rootDisplayed: "h-modal--modal__rootDisplayed",
	rootOpened: "h-modal--modal__rootOpened",
	modal: "h-modal--modal__modal",
	modalStacked: "h-modal--modal__modalStacked",
	ghostPanel: "h-modal--modal__ghostPanel",
	ghostLabel: "h-modal--modal__ghostLabel"
}, Al = ve(!1), jl = class extends N {
	rootRef;
	haskeydownEventListner;
	closeTimer;
	static defaultProps = {
		allowEscClose: !0,
		restoreFocus: !0,
		bringInFocusOnTab: !0
	};
	constructor(e) {
		super(e), this.rootRef = P(), this.closeTimer = null, this.state = {
			opened: !1,
			displayed: !1
		}, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
	}
	componentDidMount() {
		let { isOpen: e } = this.props;
		e && this.animateOpening();
	}
	componentDidUpdate(e) {
		let { isOpen: t, allowEscClose: n } = this.props, { isOpen: r } = e;
		n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), t !== r && (t ? this.animateOpening() : this.animateClosing());
	}
	componentWillUnmount() {
		this.cancelAnimation(), this.removeKeyDownEventListener();
	}
	handleKey(e) {
		let { isOpen: t, onClose: n } = this.props;
		t && dn(e.key) && (this.rootRef.current?.querySelector("[role=\"menu\"][aria-expanded=\"true\"]") || (e.preventDefault(), e.stopPropagation(), this.animateClosing(), n(e)));
	}
	removeKeyDownEventListener = () => {
		window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
	};
	cancelAnimation() {
		let { current: e } = this.rootRef;
		e && e.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer &&= (clearTimeout(this.closeTimer), null);
	}
	animateOpening() {
		let { skipAnimation: e } = this.props;
		e ? this.setState({
			displayed: !0,
			opened: !0
		}) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
	}
	animateClosing() {
		let { skipAnimation: e } = this.props;
		this.removeKeyDownEventListener(), e ? this.setState({
			opened: !1,
			displayed: !1
		}) : (this.rootRef.current && this.rootRef.current.addEventListener("transitionend", this.onTransitionEnd), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
	}
	closeIfNoTransitionOccurred() {
		this.closeTimer = setTimeout(() => {
			this.closeTimer && this.onTransitionEnd();
		}, 400);
	}
	onTransitionEnd() {
		this.setState({ displayed: !1 }), this.closeTimer &&= (clearTimeout(this.closeTimer), null), this.rootRef.current && this.rootRef.current.removeEventListener("transitionend", this.onTransitionEnd);
	}
	render() {
		let { className: e, isOpen: t, children: n, onClose: r, allowClickOutside: i, allowEscClose: a, skipAnimation: o, wrapProps: s, autoFocus: c, restoreFocus: l, bringInFocusOnTab: d, ...f } = this.props, { displayed: p, opened: m } = this.state, h = O(kl.root, s?.className, {
			[kl.rootDisplayed]: p,
			[kl.rootOpened]: m,
			[kl.rootSkipAnimation]: o
		});
		return /* @__PURE__ */ A(Ol, {
			containerId: "modal-container",
			children: /* @__PURE__ */ A("div", {
				...s,
				className: h,
				children: /* @__PURE__ */ A("div", {
					className: kl.modalContainer,
					ref: this.rootRef,
					...i ? { onClick: r } : {},
					...f,
					children: m && /* @__PURE__ */ A(pn, {
						containerRef: this.rootRef,
						autoFocus: c,
						restoreFocus: l,
						bringInFocusOnTab: d,
						children: /* @__PURE__ */ A("div", {
							className: kl.modalContent,
							children: /* @__PURE__ */ A(Al.Consumer, { children: (t) => /* @__PURE__ */ j("div", {
								className: O(kl.modal, e, { [kl.modalStacked]: t }),
								onClick: (e) => i && e.stopPropagation(),
								children: [t && /* @__PURE__ */ A("div", {
									role: "button",
									tabIndex: -1,
									className: kl.ghostPanel,
									onClick: r,
									children: /* @__PURE__ */ j("span", {
										className: kl.ghostLabel,
										children: [/* @__PURE__ */ A(u, {
											name: "arrow-left",
											size: 12
										}), "Go back"]
									})
								}), n]
							}) })
						})
					})
				})
			})
		});
	}
}, Ml = {
	lightSource: "h-lightbox--lightbox__lightSource",
	closeButton: "h-lightbox--lightbox__closeButton",
	downloadButton: "h-lightbox--lightbox__downloadButton",
	downloadButtonActive: "h-lightbox--lightbox__downloadButtonActive",
	downloadButtonLabel: "h-lightbox--lightbox__downloadButtonLabel",
	image: "h-lightbox--lightbox__image",
	loadingContainer: "h-lightbox--lightbox__loadingContainer",
	navButton: "h-lightbox--lightbox__navButton",
	navButtonPrevious: "h-lightbox--lightbox__navButtonPrevious",
	navButtonNext: "h-lightbox--lightbox__navButtonNext",
	counter: "h-lightbox--lightbox__counter"
}, Nl = class extends N {
	render() {
		let { className: e, src: t, alt: n, isOpen: i, onClose: a, showNavigation: o = !1, currentIndex: s = 0, totalImages: c = 1, onPrevious: l, onNext: d, isLoading: f = !1 } = this.props, p = c > 1;
		return /* @__PURE__ */ A(jl, {
			className: e,
			isOpen: i,
			allowClickOutside: !0,
			onClose: a,
			children: /* @__PURE__ */ j("div", {
				className: Ml.lightSource,
				children: [
					f ? /* @__PURE__ */ A("div", {
						className: Ml.loadingContainer,
						children: /* @__PURE__ */ A(r, { size: 64 })
					}) : t && /* @__PURE__ */ A(yt, {
						className: Ml.image,
						alt: n,
						src: t
					}),
					a && /* @__PURE__ */ A(h, {
						onClick: a,
						icon: "close",
						variant: "secondary",
						className: Ml.closeButton
					}),
					t && typeof t == "string" && /* @__PURE__ */ A("a", {
						href: t,
						target: "_blank",
						download: !0,
						className: Ml.downloadButton,
						rel: "noreferrer",
						children: /* @__PURE__ */ A(u, {
							name: "cloud-download",
							className: O("icon-vertical-fix")
						})
					}),
					o && p && /* @__PURE__ */ j(k, { children: [
						/* @__PURE__ */ A(h, {
							icon: "arrow-left",
							variant: "primary",
							size: "large",
							onClick: l,
							className: `${Ml.navButton} ${Ml.navButtonPrevious}`
						}),
						/* @__PURE__ */ A(h, {
							icon: "arrow-right",
							variant: "primary",
							size: "large",
							onClick: d,
							className: `${Ml.navButton} ${Ml.navButtonNext}`
						}),
						/* @__PURE__ */ j("div", {
							className: Ml.counter,
							children: [
								s + 1,
								" / ",
								c
							]
						})
					] })
				]
			})
		});
	}
}, Pl = {
	root: "h-list-items--item__root",
	rootWithHoverEffect: "h-list-items--item__rootWithHoverEffect",
	rootDense: "h-list-items--item__rootDense",
	rootLarge: "h-list-items--item__rootLarge",
	contentLeft: "h-list-items--item__contentLeft",
	contentRight: "h-list-items--item__contentRight",
	titles: "h-list-items--item__titles",
	title: "h-list-items--item__title",
	titleSecondary: "h-list-items--item__titleSecondary",
	link: "h-list-items--item__link",
	arrow: "h-list-items--item__arrow"
}, Fl = class extends N {
	static defaultProps = {
		variant: "dense",
		withHoverEffect: !0
	};
	renderTitle() {
		let { title: e, titleSecondary: t } = this.props;
		return e || t ? /* @__PURE__ */ j("div", {
			className: Pl.titles,
			children: [!!e && /* @__PURE__ */ A(i.Paragraph, {
				as: "div",
				variant: "2",
				className: Pl.title,
				children: e
			}), !!t && /* @__PURE__ */ A(i.Paragraph, {
				as: "div",
				variant: "4",
				subdued: !0,
				className: Pl.titleSecondary,
				children: t
			})]
		}) : null;
	}
	renderContentLeft() {
		let { contentLeft: e } = this.props;
		return e ? /* @__PURE__ */ A("div", {
			className: Pl.contentLeft,
			children: e
		}) : null;
	}
	renderContentRight() {
		let { contentRight: e } = this.props;
		return e ? /* @__PURE__ */ A("div", {
			className: Pl.contentRight,
			children: e
		}) : null;
	}
	renderIcon() {
		let { isLink: e, contentRight: t } = this.props;
		return e && !t ? /* @__PURE__ */ A(u, {
			className: O(Pl.arrow, "icon-vertical-fix"),
			name: "angle-right",
			size: 24
		}) : null;
	}
	renderContent() {
		return /* @__PURE__ */ j(he, { children: [
			this.renderContentLeft(),
			this.renderTitle(),
			this.renderContentRight(),
			this.renderIcon()
		] });
	}
	getChildrenWithFallback() {
		return this.props.children ?? this.renderContent();
	}
	render() {
		let { className: e, children: t, contentLeft: n, contentRight: r, title: i, titleSecondary: a, secondaryTitleBelow: o, isLink: s, variant: c, withHoverEffect: l, ...u } = this.props, d = O(Pl.root, e, {
			[Pl.rootDense]: c === "dense",
			[Pl.rootLarge]: c === "large",
			[Pl.rootWithHoverEffect]: l
		});
		return /* @__PURE__ */ A("li", {
			...u,
			className: d,
			children: this.getChildrenWithFallback()
		});
	}
}, Il = {
	root: "h-list-items--keyValue__root",
	label: "h-list-items--keyValue__label",
	value: "h-list-items--keyValue__value"
}, Ll = class extends N {
	static defaultProps = { hideIfValueIsEmpty: !0 };
	isValueEmpty() {
		return !this.props.pair.value;
	}
	render() {
		let { hideIfValueIsEmpty: e, className: t, pair: n, ...r } = this.props, a = O(Il.root, t);
		return e && this.isValueEmpty() ? null : /* @__PURE__ */ A(Fl, {
			...r,
			className: a,
			title: /* @__PURE__ */ A(i.Paragraph, {
				as: "span",
				variant: "4",
				subdued: !0,
				children: n.key
			}),
			titleSecondary: /* @__PURE__ */ A(i.Paragraph, {
				as: "span",
				variant: "2",
				children: n.value
			}),
			"data-testid": "List-KeyValue"
		});
	}
}, Rl = { root: "h-list-items--text__root" }, zl = class extends N {
	render() {
		let { children: e, className: t, ...n } = this.props, r = O(Rl.root, t);
		return /* @__PURE__ */ A(Fl, {
			...n,
			className: r,
			"data-testid": "List-Text",
			children: /* @__PURE__ */ A(i.Paragraph, {
				variant: "2",
				children: e
			})
		});
	}
}, Bl = {
	root: "h-list-items--user__root",
	avatarWrapper: "h-list-items--user__avatarWrapper"
}, Vl = class extends N {
	getTitle() {
		let { user: e, title: t } = this.props;
		return t || e.display_name || e.name || e.phone_number || e.id;
	}
	getSubTitle() {
		let { user: e, titleSecondary: t } = this.props;
		return t || e.email;
	}
	render() {
		let { className: e, user: t, title: n, titleSecondary: r, ...i } = this.props;
		return /* @__PURE__ */ A(Fl, {
			className: O(e, Bl.root),
			contentLeft: /* @__PURE__ */ A("div", {
				className: Bl.avatarWrapper,
				children: /* @__PURE__ */ A(Pt, { user: t })
			}),
			title: this.getTitle(),
			titleSecondary: this.getSubTitle(),
			"data-testid": "<List.User>",
			...i
		});
	}
}, Hl = { root: "h-list--list__root" }, Ul = mt(class extends N {
	static Item = Fl;
	static Text = zl;
	static User = Vl;
	static KeyValue = Ll;
	render() {
		let { className: e, ...t } = this.props;
		return /* @__PURE__ */ A("ul", {
			...t,
			className: O(Hl.root, e)
		});
	}
}, { fallback: null }), Wl = /* @__PURE__ */ e(ce()), Gl = () => {
	document.exitFullscreen && document.exitFullscreen();
}, Kl = (e) => {
	e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
}, ql = (e) => document.fullscreenElement === e, Jl = class extends Error {
	status;
	url;
	response;
	constructor(e) {
		super(`NetworkError ${e.status} ${e.url}`), this.status = e.status, this.url = e.url, this.response = e;
	}
}, Yl = { fetch: (e, ...t) => fetch(e, ...t).then((e) => {
	if (!(e.status >= 200 && e.status < 300)) throw new Jl(e);
	return e;
}) }, $ = {
	root: "h-mediaPlayer--mediaPlayer__root",
	controls: "h-mediaPlayer--mediaPlayer__controls",
	unstyled: "h-mediaPlayer--mediaPlayer__unstyled",
	rootFullScreen: "h-mediaPlayer--mediaPlayer__rootFullScreen",
	rootHideControls: "h-mediaPlayer--mediaPlayer__rootHideControls",
	control: "h-mediaPlayer--mediaPlayer__control",
	progress: "h-mediaPlayer--mediaPlayer__progress",
	progressSlider: "h-mediaPlayer--mediaPlayer__progressSlider",
	volumeSlider: "h-mediaPlayer--mediaPlayer__volumeSlider",
	timestamp: "h-mediaPlayer--mediaPlayer__timestamp",
	videoWrapper: "h-mediaPlayer--mediaPlayer__videoWrapper",
	rootWaiting: "h-mediaPlayer--mediaPlayer__rootWaiting",
	rootAudio: "h-mediaPlayer--mediaPlayer__rootAudio",
	video: "h-mediaPlayer--mediaPlayer__video",
	volume: "h-mediaPlayer--mediaPlayer__volume",
	volumeMuteControl: "h-mediaPlayer--mediaPlayer__volumeMuteControl",
	downloadLink: "h-mediaPlayer--mediaPlayer__downloadLink"
};
//#endregion
//#region src/components/mediaPlayer/mediaPlayer.tsx
function Xl(e) {
	let t = e >= 3600 ? 8 : 5;
	return Number.isNaN(e) || !Number.isFinite(e) ? "00:00" : (/* @__PURE__ */ new Date(e * 1e3)).toISOString().substr(19 - t, t);
}
var Zl = class extends N {
	static defaultProps = { headers: {} };
	constructor(e) {
		super(e), this.state = {
			src: void 0,
			playing: !1,
			actuallyPlaying: !1,
			duration: 0,
			time: 0,
			prevVolume: 1,
			volume: 100,
			isFullScreen: !1,
			hideControls: !1,
			isWaiting: !1,
			buffer: null,
			asyncStatus: null
		}, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.resolveSrc = this.resolveSrc.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleDownloadClick = this.handleDownloadClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
	}
	componentDidMount() {
		let { current: e } = this.playerRef;
		e && e.addEventListener("fullscreenchange", this.handleFullscreenChange);
		let { mediaFile: { src: t } } = this.props;
		typeof t != "function" && this.loadSrc();
	}
	componentDidUpdate(e, t) {
		let { mediaFile: { src: n } } = e, { mediaFile: { src: r } } = this.props;
		!(typeof r == "function" && typeof n == "function") && n !== r && (this.pendingAction = null, typeof r == "function" ? (this.pendingLoad = null, this.tryStopPlayer(), this.setSrc(), this.setState({ asyncStatus: null })) : this.loadSrc()), this.tryReloadPlayer(t);
	}
	componentWillUnmount() {
		this.mounted = !1;
		let { current: e } = this.playerRef;
		e && e.removeEventListener("fullscreenchange", this.handleFullscreenChange), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
	}
	videoRef = P();
	playerRef = P();
	hideControlsTimeout = void 0;
	controller = new AbortController();
	mounted = !0;
	pendingAction = null;
	pendingLoad = null;
	loadSrc() {
		let { mediaFile: { src: e }, isPrivateFile: t } = this.props;
		this.pendingLoad = null, this.tryStopPlayer(), this.setState({ asyncStatus: null }), typeof e == "function" ? this.resolveSrc(e) : t ? this.fetchFile() : this.setSrc(e);
	}
	resolveSrc(e) {
		this.pendingLoad = e, this.setState({ asyncStatus: "loading" }), e().then((t) => {
			if (!(!this.mounted || this.pendingLoad !== e)) {
				if (!t) {
					this.failSrc();
					return;
				}
				this.setSrc(t), this.setState({ asyncStatus: "succeeded" });
			}
		}).catch(() => {
			!this.mounted || this.pendingLoad !== e || this.failSrc();
		});
	}
	failSrc() {
		this.pendingAction = null, this.setState({ asyncStatus: "failed" });
	}
	setSrc(e) {
		this.setState({ src: e });
	}
	tryStopPlayer() {
		let { current: e } = this.videoRef;
		if (!e) return;
		e.currentTime = 0;
		let { playing: t, actuallyPlaying: n } = this.state;
		t && n && (e.pause(), this.setState({
			playing: !1,
			actuallyPlaying: !1
		}));
	}
	tryReloadPlayer(e) {
		let { current: t } = this.videoRef;
		if (!t) return;
		let { src: n } = this.state;
		if (n !== e.src) {
			t.load();
			let e = this.pendingAction;
			this.pendingAction = null, e === "play" ? this.handleTogglePlayClick() : e === "download" && this.fetchFile(!0);
		}
	}
	fetchFile(e) {
		let { mediaFile: { src: t }, headers: n, filename: r } = this.props, i = typeof t == "string" ? t : this.state.src;
		if (!i) return;
		this.setState({ asyncStatus: "loading" });
		let a = new Headers(n);
		Yl.fetch(i, {
			headers: a,
			method: "GET",
			mode: "cors",
			cache: "no-cache",
			signal: this.controller.signal
		}).then((e) => e.blob()).then((t) => {
			let n = window.URL.createObjectURL(t);
			e ? Wl.default.saveAs(t, r || decodeURIComponent(i.split("/").pop())) : this.setSrc(n), this.setState({ asyncStatus: "succeeded" });
		}).catch((e) => {
			e && e.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", e), this.pendingAction = null, this.setState({ asyncStatus: "failed" }));
		});
	}
	updateProgress() {
		let { current: e } = this.videoRef;
		e && this.setState({
			time: e.currentTime,
			duration: e.duration
		});
	}
	updateBuffer() {
		let { current: e } = this.videoRef, { time: t, duration: n } = this.state;
		if (e) {
			let r = null, i = e.buffered;
			for (let e = 0; e < i.length; e += 1) {
				let a = i.start(e), o = i.end(e);
				a <= t && t <= o && (r = [a / n, o / n]);
			}
			this.setState({ buffer: r });
		}
	}
	handleWaiting() {
		this.setState({ isWaiting: !0 });
	}
	handlePlaying() {
		this.setState({ isWaiting: !1 });
	}
	handleTogglePlayClick() {
		let { playing: e, actuallyPlaying: t, src: n, asyncStatus: r } = this.state, { current: i } = this.videoRef;
		if (!n) {
			if (r === "loading") return;
			this.pendingAction = "play", this.loadSrc();
			return;
		}
		i && (e && t ? (i.pause(), this.setState({
			isWaiting: !1,
			playing: !1,
			actuallyPlaying: !1
		})) : e || (this.setState({
			isWaiting: !0,
			playing: !0,
			actuallyPlaying: !1
		}), i.play().then(() => {
			this.mounted && this.setState({ actuallyPlaying: !0 });
		}).catch(() => {
			this.mounted && this.setState({
				isWaiting: !1,
				playing: !1,
				actuallyPlaying: !1
			});
		})));
	}
	handleDownloadClick() {
		let { src: e, asyncStatus: t } = this.state;
		if (!e) {
			if (t === "loading") return;
			this.pendingAction = "download", this.loadSrc();
			return;
		}
		this.fetchFile(!0);
	}
	startHideControlCountdown() {
		this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({ hideControls: !1 }), this.hideControlsTimeout = setTimeout(() => {
			this.setState({ hideControls: !0 });
		}, 2e3);
	}
	handleFullscreenChange() {
		let { current: e } = this.playerRef, t = ql(e);
		this.setState({ isFullScreen: t }), t ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
	}
	handleFullscreenToggle() {
		let { current: e } = this.playerRef, { isFullScreen: t } = this.state;
		e && (t ? Gl() : Kl(e));
	}
	handleEnded() {
		this.setState({ playing: !1 });
	}
	handleError() {
		this.props.onError && this.props.onError();
	}
	seek(e) {
		let { current: t } = this.videoRef, { duration: n } = this.state;
		t && e && !Number.isNaN(e) && (t.currentTime = n * e);
	}
	handleVolume = (e) => {
		let { current: t } = this.videoRef;
		!t || e === void 0 || !Number.isFinite(e) || this.setState({ volume: e }, () => {
			this.setPlayerVolume(e);
		});
	};
	handleMute() {
		let { current: e } = this.videoRef;
		if (!e) return;
		let { volume: t, prevVolume: n } = this.state, r = t === 0, i = r ? n : 0;
		this.setState({
			volume: i,
			prevVolume: r ? n : t
		}, () => {
			this.setPlayerVolume(i);
		});
	}
	setPlayerVolume(e) {
		let { current: t } = this.videoRef;
		t && (t.volume = e / 100);
	}
	render() {
		let { className: e, mediaFile: { type: t, src: n }, headers: r, isPrivateFile: i, width: a, controls: o, noControlsStyle: s, filename: c, onError: l, ...d } = this.props, { src: f, playing: p, duration: m, time: _, volume: v, hideControls: y, isFullScreen: b, isWaiting: x, buffer: S, asyncStatus: C } = this.state, w = o?.play ?? !0, T = o?.download ?? !0, E = o?.progress ?? !0, D = o?.volume ?? !0, ee = o?.maximize ?? !0, te = w || T || E || D || ee, ne = typeof t == "string" && t.startsWith("audio"), re = C === "loading", ie = re && !f, ae = !(f || typeof n == "function") || re, oe = !f || re, se = b ? "primary" : "secondary", ce = O($.root, {
			[$.rootFullScreen]: b,
			[$.rootHideControls]: y,
			[$.rootWaiting]: p && x,
			[$.rootAudio]: ne
		}, e);
		return /* @__PURE__ */ j("div", {
			...d,
			className: ce,
			ref: this.playerRef,
			style: { width: a },
			children: [/* @__PURE__ */ A("div", {
				className: $.videoWrapper,
				children: !!f && /* @__PURE__ */ A("video", {
					className: $.video,
					ref: this.videoRef,
					onDurationChange: this.updateProgress,
					onTimeUpdate: this.updateProgress,
					onWaiting: this.handleWaiting,
					onPlaying: this.handlePlaying,
					onProgress: this.updateBuffer,
					onEnded: this.handleEnded,
					onError: this.handleError,
					children: /* @__PURE__ */ A("source", { src: f })
				})
			}), te && /* @__PURE__ */ j("div", {
				className: O($.controls, { [$.unstyled]: s }),
				children: [
					w && /* @__PURE__ */ A(h, {
						onClick: this.handleTogglePlayClick,
						className: $.control,
						disabled: ae,
						isLoading: ie,
						icon: p ? "pause" : "play",
						variant: se
					}),
					T && (i ? /* @__PURE__ */ A(g, {
						variant: se,
						className: $.control,
						disabled: oe,
						children: /* @__PURE__ */ A("a", {
							href: f,
							download: !0,
							target: "_blank",
							rel: "noopener noreferrer",
							className: $.downloadLink,
							children: /* @__PURE__ */ A(u, { name: "download" })
						})
					}) : /* @__PURE__ */ A(h, {
						icon: "download",
						variant: se,
						className: $.control,
						disabled: ae,
						onClick: this.handleDownloadClick
					})),
					E && /* @__PURE__ */ j("div", {
						className: $.progress,
						children: [/* @__PURE__ */ A(Uc, {
							hideAnnotations: !0,
							className: $.progressSlider,
							min: 0,
							max: m,
							value: _,
							onChange: (e) => !Array.isArray(e) && this.seek(e / m),
							dark: b,
							highlightRange: S?.map((e) => e * m)
						}), /* @__PURE__ */ A("span", {
							className: $.timestamp,
							children: Xl(m)
						})]
					}),
					D && /* @__PURE__ */ j("div", {
						className: $.volume,
						children: [/* @__PURE__ */ A(u, {
							className: $.volumeMuteControl,
							name: v === 0 ? "volume-off" : "volume-up",
							onClick: this.handleMute
						}), /* @__PURE__ */ A(Uc, {
							hideAnnotations: !0,
							className: $.volumeSlider,
							value: v,
							onChange: (e) => !Array.isArray(e) && this.handleVolume(e),
							dark: b
						})]
					}),
					ee && !ne && /* @__PURE__ */ A(h, {
						variant: se,
						onClick: this.handleFullscreenToggle,
						className: $.control,
						icon: "expand"
					})
				]
			})]
		});
	}
}, Ql = { root: "h-modalBody--modalBody__root" }, $l = class extends N {
	render() {
		let { className: e, children: t, ...n } = this.props, r = O({ [Ql.root]: !0 }, e);
		return /* @__PURE__ */ A("div", {
			...n,
			className: r,
			children: t
		});
	}
}, eu = {
	root: "h-modalFoot--modalFoot__root",
	confirm: "h-modalFoot--modalFoot__confirm",
	confirmSecondary: "h-modalFoot--modalFoot__confirmSecondary",
	cancel: "h-modalFoot--modalFoot__cancel"
}, tu = class extends N {
	static defaultProps;
	render() {
		let { className: e, confirmOnClick: t, confirmSecondaryOnClick: n, cancelOnClick: r, confirmName: i, confirmSecondaryName: a, cancelName: o, confirmProps: s, confirmSecondaryProps: c, cancelProps: l, children: u, ...d } = this.props, f = O({ [eu.root]: !0 }, e), p = O({ [eu.cancel]: !0 }, l?.className), m = O({ [eu.confirm]: !0 }, s?.className), h = O({ [eu.confirmSecondary]: !0 }, c?.className);
		return /* @__PURE__ */ j("div", {
			...d,
			className: f,
			children: [
				u,
				n && /* @__PURE__ */ A(g, {
					variant: "secondary",
					...c,
					className: h,
					onClick: n,
					children: a
				}),
				r && /* @__PURE__ */ A(g, {
					variant: "tertiary",
					...l,
					className: p,
					onClick: r,
					children: o
				}),
				t && /* @__PURE__ */ A(g, {
					variant: "primary",
					...s,
					className: m,
					onClick: t,
					children: i
				})
			]
		});
	}
};
tu.defaultProps = {
	confirmName: "Save",
	cancelName: "Cancel",
	confirmProps: {},
	cancelProps: {}
};
var nu = {
	root: "h-modalHead--modalHead__root",
	top: "h-modalHead--modalHead__top",
	title: "h-modalHead--modalHead__title",
	buttons: "h-modalHead--modalHead__buttons",
	caption: "h-modalHead--modalHead__caption",
	icon: "h-modalHead--modalHead__icon"
}, ru = ({ className: e, title: t, children: n, onClose: r, secondaryButton: a, buttonsClassName: o, buttonsSlot: s, ...c }) => {
	let l = O({ [nu.root]: !0 }, e);
	return /* @__PURE__ */ j("div", {
		...c,
		className: l,
		children: [/* @__PURE__ */ j("div", {
			className: nu.top,
			children: [/* @__PURE__ */ A(i.Heading, {
				className: nu.title,
				children: t
			}), /* @__PURE__ */ j("div", {
				className: O(nu.buttons, o),
				children: [
					s,
					typeof a?.onClick == "function" && /* @__PURE__ */ A(U, {
						content: a?.tooltipContent,
						children: /* @__PURE__ */ A(h, {
							icon: a?.icon,
							variant: "tertiary",
							onClick: a?.onClick
						})
					}),
					typeof r == "function" && /* @__PURE__ */ A(h, {
						icon: "close",
						iconSize: 24,
						variant: "tertiary",
						onClick: r
					})
				]
			})]
		}), !!n && /* @__PURE__ */ A(i.Paragraph, {
			variant: "2",
			color: "secondary",
			className: nu.caption,
			children: n
		})]
	});
}, iu = { root: "h-page-body--pageBody__root" }, au = F(function({ children: e, className: t, ...n }, r) {
	return /* @__PURE__ */ A(q.Row, {
		...n,
		ref: r,
		className: O(iu.root, t),
		scrollable: !0,
		noMinHeight: !0,
		noHorizontalPadding: !0,
		noVerticalPadding: !0,
		children: e
	});
}), ou = { root: "h-page-head--pageHead__root" }, su = F(function({ className: e, title: t, controls: n, ...r }, a) {
	return /* @__PURE__ */ j(q.Row, {
		...r,
		ref: a,
		as: "header",
		className: O(ou.root, e),
		slottable: !0,
		borderBottom: !0,
		children: [/* @__PURE__ */ A(q.Slot, {
			placement: "start",
			children: /* @__PURE__ */ A(i.Heading, {
				variant: "heading-2",
				as: "h1",
				children: t
			})
		}), n && /* @__PURE__ */ A(q.Slot, {
			placement: "end",
			children: /* @__PURE__ */ A(G, {
				alignItems: "center",
				gap: "200",
				children: n
			})
		})]
	});
}), cu = {
	root: "h-page-section--pageSection__root",
	head: "h-page-section--pageSection__head",
	callout: "h-page-section--pageSection__callout",
	content: "h-page-section--pageSection__content"
}, lu = F(function({ children: e, className: t, title: n, titleMeta: r, controls: a, callout: o, ...s }, c) {
	let l = !!(n || r || a);
	return /* @__PURE__ */ j(q.Row, {
		...s,
		ref: c,
		as: "section",
		className: O(cu.root, t),
		noMinHeight: !0,
		children: [
			l && /* @__PURE__ */ j(q.Row, {
				className: cu.head,
				slottable: !0,
				noMinHeight: !0,
				noVerticalPadding: !0,
				noHorizontalPadding: !0,
				children: [(n || r) && /* @__PURE__ */ A(q.Slot, {
					placement: "start",
					noVerticalPadding: !0,
					children: /* @__PURE__ */ j(G, {
						alignItems: "center",
						gap: "200",
						children: [n && /* @__PURE__ */ A(i.Heading, {
							variant: "heading-3",
							as: "h2",
							children: n
						}), r && /* @__PURE__ */ A(G, {
							alignItems: "center",
							gap: "200",
							children: r
						})]
					})
				}), a && /* @__PURE__ */ A(q.Slot, {
					placement: "end",
					noVerticalPadding: !0,
					children: /* @__PURE__ */ A(G, {
						alignItems: "center",
						gap: "200",
						children: a
					})
				})]
			}),
			o && /* @__PURE__ */ A(q.Row, {
				className: cu.callout,
				noMinHeight: !0,
				noVerticalPadding: !0,
				noHorizontalPadding: !0,
				children: o
			}),
			/* @__PURE__ */ A(q.Row, {
				className: cu.content,
				size: 1,
				noVerticalPadding: !0,
				noHorizontalPadding: !0,
				children: e
			})
		]
	});
}), uu = F(function({ children: e, className: t, ...n }, r) {
	return /* @__PURE__ */ A(q.Row, {
		...n,
		ref: r,
		className: t,
		borderBottom: !0,
		noVerticalPadding: !0,
		noMinHeight: !0,
		children: e
	});
}), du = ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ A(Hn, {
	...n,
	ref: r,
	as: "article",
	className: t,
	children: /* @__PURE__ */ A(q, { children: e })
}), fu = Object.assign(F(du), {
	name: du.name,
	Head: su,
	Body: au,
	Section: lu,
	Tabs: uu
}), pu = {
	radio: "h-radio--radio__radio",
	radioDisabled: "h-radio--radio__radioDisabled",
	radioChecked: "h-radio--radio__radioChecked",
	input: "h-radio--radio__input"
}, mu = F(function(e, t) {
	let { id: n, checked: r, disabled: i, className: a, labelProps: o, ...s } = e, c = O(pu.radio, { [pu.radioChecked]: r }, { [pu.radioDisabled]: i }, a), l = n || `radio_${Math.random()}`;
	return /* @__PURE__ */ A("label", {
		...o,
		className: c,
		htmlFor: l,
		"data-testid": "radio",
		children: /* @__PURE__ */ A("input", {
			...s,
			ref: t,
			id: l,
			onChange: s.onChange || K,
			checked: r,
			disabled: i,
			type: "radio",
			className: pu.input,
			"data-testid": "input"
		})
	});
}), hu = {
	root: "h-reverseScroll--reverseScroll__root",
	column: "h-reverseScroll--reverseScroll__column",
	row: "h-reverseScroll--reverseScroll__row",
	scrollHandle: "h-reverseScroll--reverseScroll__scrollHandle"
}, gu = "reverse-scroll", _u = F(function({ children: e, className: t, direction: n = "column", ...r }, i) {
	let a = B(null), o = B(null), s = B(null), c = pc(e), l = z(() => c.reverse(), [c]), u = (e) => s.current?.scrollIntoView(e), d = (e) => o.current?.scrollIntoView(e), f = (e) => a.current?.children[1]?.scrollIntoView(e), p = (e) => (a.current?.children[a.current.children.length - 2])?.scrollIntoView(e);
	return Ce(i, () => ({
		rootElem: a.current,
		scrollToEnd: u,
		scrollToStart: d,
		scrollToFirstChild: p,
		scrollToLastChild: f
	})), /* @__PURE__ */ j("div", {
		...r,
		"data-testid": gu,
		ref: a,
		className: O(t, hu.root, {
			[hu.row]: n === "row",
			[hu.column]: n === "column"
		}),
		children: [
			/* @__PURE__ */ A("div", {
				ref: s,
				className: hu.scrollHandle
			}),
			l,
			/* @__PURE__ */ A("div", {
				ref: o,
				className: hu.scrollHandle
			})
		]
	});
}), vu = {
	root: "h-removableCard--removableCard__root",
	close: "h-removableCard--removableCard__close",
	title: "h-removableCard--removableCard__title",
	titleIcon: "h-removableCard--removableCard__titleIcon"
}, yu = class extends N {
	render() {
		let { icon: e, title: t, children: n, onRemove: r, className: i, ...o } = this.props, s = O({ [vu.root]: vu.root }, i);
		return /* @__PURE__ */ j(a, {
			padding: "300",
			background: "neutral.100",
			borderRadius: !0,
			...o,
			className: s,
			children: [
				/* @__PURE__ */ A(a, {
					as: "button",
					"aria-label": "Remove",
					className: vu.close,
					onClick: r,
					children: /* @__PURE__ */ A(u, { name: "close" })
				}),
				/* @__PURE__ */ j(G, {
					alignItems: "flex-start",
					justifyContent: "flex-start",
					className: vu.title,
					children: [e && /* @__PURE__ */ A(u, {
						name: e,
						className: vu.titleIcon
					}), t]
				}),
				/* @__PURE__ */ A(a, { margin: "300 0 0 0" }),
				n
			]
		});
	}
}, bu = ({ colorMode: e = "light" }) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${e}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${e};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, xu = { frame: "h-sandboxIframe--sandboxIframe__frame" }, Su = class e extends N {
	frameRef;
	static defaultProps;
	constructor(e) {
		super(e), this.state = { iframeHeight: 0 }, this.frameRef = P(), this.handlePostMessage = this.handlePostMessage.bind(this);
	}
	componentDidMount() {
		this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
	}
	componentDidUpdate(e) {
		let { content: t, headContent: n, colorMode: r } = this.props;
		(e.content !== t || e.headContent !== n || e.colorMode !== r) && this.buildSandbox();
	}
	componentWillUnmount() {
		window.removeEventListener("message", this.handlePostMessage);
	}
	static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
	buildSandbox() {
		let { content: e, headContent: t = "", colorMode: n = "light" } = this.props, { current: r } = this.frameRef;
		if (r) {
			let i = "";
			i = e.indexOf("</body>") === -1 ? `<html><head><meta charset="utf-8" /><base target="_parent" />${t}</head><body>${e}${bu({ colorMode: n })}</body></html>` : e.replace("</body>", `${bu({ colorMode: n })}</body>`), r.src = `data:text/html;base64,${window.btoa(unescape(encodeURIComponent(i)))}`;
		}
	}
	handlePostMessage(e) {
		let { current: t } = this.frameRef;
		if (t && e.source === t.contentWindow) {
			let { data: t } = e;
			typeof t == "object" && t && t.event === "heightChange" && typeof t.value == "number" && this.setState({ iframeHeight: t.value });
		}
	}
	render() {
		let { className: t, content: n, headContent: r, sandbox: i, colorMode: a, ...o } = this.props, { iframeHeight: s } = this.state, c = O({}, t);
		return /* @__PURE__ */ A("div", {
			...o,
			className: c,
			children: /* @__PURE__ */ A("iframe", {
				title: "message",
				sandbox: i ?? e.defaultSandboxParams,
				allowFullScreen: !0,
				scrolling: "no",
				frameBorder: "no",
				style: { height: `${s}px` },
				className: xu.frame,
				ref: this.frameRef
			})
		});
	}
}, Cu = {
	track: "h-scrollbar--scrollbar__track",
	handle: "h-scrollbar--scrollbar__handle"
}, wu = class extends N {
	constructor(e) {
		super(e), this.state = {
			size: 0,
			progress: 0,
			offset: 0
		}, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
	}
	componentDidMount() {
		let { container: e } = this.props;
		e.current && e.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
	}
	componentWillUnmount() {
		let { container: e } = this.props;
		e.current && e.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
	}
	updateSize = () => {
		let { container: e } = this.props;
		if (e.current) {
			let { current: t } = e;
			this.setState({
				size: t.offsetHeight / t.scrollHeight,
				progress: t.scrollTop / t.scrollHeight
			});
		}
	};
	handleTrackClick(e) {
		let { container: t } = this.props, { size: n } = this.state;
		if (this.setState({ offset: n / 2 }), t.current) {
			let r = t.current.getBoundingClientRect(), i = (e.clientY - r.top) / t.current.offsetHeight - n / 2;
			i < 0 && (i = 0), i + n > 1 && (i = 1 - n), t.current.scrollTop = i * t.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
		}
	}
	handleHandleClick(e) {
		let { size: t } = this.state;
		if (e.stopPropagation(), !(e.target instanceof Element)) return;
		let n = e.target.getBoundingClientRect();
		this.setState({ offset: (e.clientY - n.top) / n.height * t }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
	}
	handleDrag(e) {
		e.preventDefault();
		let { container: t } = this.props, { size: n, offset: r } = this.state;
		if (t.current) {
			let i = t.current.getBoundingClientRect(), a = (e.clientY - i.top) / t.current.offsetHeight - r;
			a < 0 && (a = 0), a + n > 1 && (a = 1 - n), t.current.scrollTop = a * t.current.scrollHeight;
		}
	}
	handleDrop() {
		window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
	}
	render() {
		let { className: e, thumbClassName: t, trackClassName: n, ...r } = this.props, { size: i, progress: a } = this.state, o = O(e);
		return /* @__PURE__ */ A("div", {
			...r,
			className: o,
			children: /* @__PURE__ */ A("div", {
				className: O(Cu.track, n),
				onMouseDown: this.handleTrackClick,
				children: /* @__PURE__ */ A("div", {
					className: O(Cu.handle, t),
					onMouseDown: this.handleHandleClick,
					style: {
						height: `${i * 100}%`,
						top: `${a * 100}%`
					}
				})
			})
		});
	}
}, Tu = {
	wrapper: "h-scrollShadow--scrollShadow__wrapper",
	content: "h-scrollShadow--scrollShadow__content"
}, Eu = ({ className: e, children: t, ...n }) => /* @__PURE__ */ A("div", {
	className: O(Tu.wrapper, e),
	...n,
	children: /* @__PURE__ */ A("div", {
		className: Tu.content,
		children: t
	})
}), Du = {
	root: "h-searchInput--searchInput__root",
	input: "h-searchInput--searchInput__input",
	inputButton: "h-searchInput--searchInput__inputButton"
}, Ou = 275, ku = 300, Au = ({ className: e, initialSearch: t, maxWidth: n = Ou, placeholder: r, onChange: i, onSubmit: a, onToggle: o, ...s }) => {
	let l = B(null), [u, d] = V(!!t), [f, p] = V(!1), [m, g] = V(t ?? "");
	ke(() => {
		f && (d(!1), p(!1), g(""));
	}, ku, [f]), Ie(() => {
		o?.(u), u && requestAnimationFrame(() => l.current?.focus());
	}, [u]);
	let _ = L(() => {
		d(!0);
	}, []), v = L(() => {
		p(!0);
	}, []), y = L((e) => {
		e.preventDefault(), a(m);
	}, [a, m]), b = L((e) => {
		let { target: { value: t } } = e;
		g(t), i?.(t);
	}, [i]), x = L(({ key: e }) => {
		e === "Enter" && _();
	}, [_]), S = L(({ key: e }) => {
		(e === "Esc" || e === "Escape") && v();
	}, [v]);
	return /* @__PURE__ */ A("div", {
		className: O(Du.root, e),
		style: {
			"--max-width": `${u && !f ? n : 32}px`,
			"--transition-delay": `${ku}ms`
		},
		...s,
		children: u ? /* @__PURE__ */ A("form", {
			onSubmit: y,
			children: /* @__PURE__ */ A(c, {
				className: Du.input,
				ref: l,
				onChange: b,
				placeholder: r ?? "Search...",
				type: "search",
				value: m,
				prefix: {
					type: "button",
					button: {
						icon: "search",
						onClick: y,
						className: Du.inputButton
					}
				},
				suffix: {
					type: "button",
					button: {
						icon: "close",
						onClick: v,
						className: Du.inputButton
					}
				},
				onKeyDown: S
			})
		}) : /* @__PURE__ */ A(h, {
			icon: "search",
			variant: "secondary",
			onClick: _,
			onKeyDown: x,
			"data-testid": "search-input-button"
		})
	});
}, ju = {
	root: "h-selectOption--selectOption__root",
	checkbox: "h-selectOption--selectOption__checkbox",
	content: "h-selectOption--selectOption__content"
}, Mu = (e) => /* @__PURE__ */ j("label", {
	className: O(ju.root),
	children: [/* @__PURE__ */ A(tn, {
		...e,
		className: O(ju.checkbox, e.className)
	}), /* @__PURE__ */ A("div", {
		className: ju.content,
		children: e.name
	})]
}), Nu = {
	container: "h-simpleProgressBar--simpleProgressBar__container",
	progressBar: "h-simpleProgressBar--simpleProgressBar__progressBar",
	progressBarFill: "h-simpleProgressBar--simpleProgressBar__progressBarFill"
}, Pu = "simpleProgressBarId";
function Fu({ progress: e, base: t = 100, progressColor: n = "purple.500", backgroundColor: r = "neutral.200", tooltipContent: i, tooltipProps: a, ...o }) {
	let [c, l] = V(0);
	R(() => l(e), [e]);
	let u = t >= c ? c / t : 1, d = () => 4 / u, f = { backgroundColor: s(r) }, p = {
		transform: `scaleX(${u})`,
		borderTopRightRadius: `${d()}px 4px`,
		borderBottomRightRadius: `${d()}px 4px`,
		backgroundColor: s(n)
	};
	return /* @__PURE__ */ A(G, {
		"test-id": Pu,
		"align-items": "center",
		"justify-content": "center",
		className: Nu.container,
		...o,
		children: /* @__PURE__ */ A(U, {
			disabled: !i,
			content: i,
			wrap: "none",
			...a,
			children: /* @__PURE__ */ A("div", {
				className: Nu.progressBar,
				style: f,
				children: /* @__PURE__ */ A("div", {
					className: Nu.progressBarFill,
					style: p
				})
			})
		})
	});
}
var Iu = {
	container: "h-tabsWithContent--tabsWithContent__container",
	containerTop: "h-tabsWithContent--tabsWithContent__containerTop",
	containerLeft: "h-tabsWithContent--tabsWithContent__containerLeft",
	containerRight: "h-tabsWithContent--tabsWithContent__containerRight",
	containerBottom: "h-tabsWithContent--tabsWithContent__containerBottom",
	childrenContainer: "h-tabsWithContent--tabsWithContent__childrenContainer"
}, Lu = class e extends me {
	static defaultProps = { tabsPlacement: "top" };
	constructor(e) {
		super(e), this.state = { activeTab: e.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
	}
	handleTabChange(e) {
		this.ensureTabIsValid(e) && (this.setState({ activeTab: e }), this.props.onChange?.(e));
	}
	ensureTabIsValid(e) {
		return this.props.tabs.some((t) => t.id === e);
	}
	getActiveChildIndex() {
		return this.props.tabs.findIndex(({ id: e }) => e === this.state.activeTab);
	}
	render() {
		let { className: t, tabsClassName: n, tabClassName: r, tabSelectedClassName: i, childrenWrapperClassName: a, tabs: o, children: s, tabsPlacement: c } = this.props, { activeTab: l } = this.state, u = M.toArray(s);
		if (u.length !== o.length) {
			let t = `${e.name}: Number of tabs don't match the number of children.`;
			console.warn(t);
		}
		let d = this.getActiveChildIndex();
		if (d === -1) {
			let t = `${e.name}: The selected tab does not exist in tabs array!`;
			console.warn(t);
		}
		let f = O(t, Iu.container, {
			[Iu.containerTop]: c === "top",
			[Iu.containerLeft]: c === "left",
			[Iu.containerBottom]: c === "bottom",
			[Iu.containerRight]: c === "right"
		}), p = O(a, Iu.childrenContainer);
		return /* @__PURE__ */ j("section", {
			className: f,
			children: [/* @__PURE__ */ A(ms, {
				className: n,
				tabClassName: r,
				tabSelectedClassName: i,
				tabs: o,
				onChange: this.handleTabChange,
				selectedId: l,
				tabsPlacement: c
			}), /* @__PURE__ */ A("div", {
				className: p,
				children: u[d]
			})]
		});
	}
}, Ru = {
	root: "h-tagsInput--tagsInput__root",
	wrapper: "h-tagsInput--tagsInput__wrapper",
	hiddenSpan: "h-tagsInput--tagsInput__hiddenSpan",
	input: "h-tagsInput--tagsInput__input",
	inputIsHidden: "h-tagsInput--tagsInput__inputIsHidden",
	placeholder: "h-tagsInput--tagsInput__placeholder",
	placeholderText: "h-tagsInput--tagsInput__placeholderText",
	iconBox: "h-tagsInput--tagsInput__iconBox",
	iconText: "h-tagsInput--tagsInput__iconText",
	tag: "h-tagsInput--tagsInput__tag",
	tagIsActive: "h-tagsInput--tagsInput__tagIsActive",
	tagButton: "h-tagsInput--tagsInput__tagButton"
};
//#endregion
//#region src/components/tagsInput/tagsInput.tsx
function zu(e = [], t) {
	switch (t) {
		case "asc": return e.sort();
		case "desc": return e.sort().reverse();
		default: return e;
	}
}
var Bu = 255, Vu = ({ className: e, disabled: t, limit: r, placeholder: a, selectedTags: o, sortDirection: s, onChange: c }) => {
	let l = B(null), d = B(null), [f, p] = V(""), [m, h] = V(zu(o, s)), [g, _] = V(""), [v, y] = V(!1);
	Oe(l, () => y(!1)), Ie(() => c(m), [m, c]), Ie(() => {
		d.current && v && d.current.focus();
	}, [d.current, v]);
	let b = (e) => {
		p(e.target.value ?? "");
	}, x = (e) => {
		let t = m.indexOf(g);
		switch (e.key) {
			case "Enter":
				!g && f && h((e) => {
					let t = Array.from(/* @__PURE__ */ new Set([...e, f]));
					return p(""), zu(t, s);
				});
				break;
			case "Backspace":
				!g && f.length === 0 && _(m[m.length - 1]), g && (S(g), _(""));
				break;
			case "ArrowLeft":
				g && t > 0 && _(m[t - 1]);
				break;
			case "ArrowRight":
				g && t < m.length - 1 && _(m[t + 1]);
				break;
			default: g && _("");
		}
	}, S = (e) => {
		h((t) => {
			let n = [...t];
			return n.splice(n.indexOf(e), 1), n;
		});
	}, C = v ? m.length : r || m.length, w = C < m.length, T = m.slice(0, C);
	return /* @__PURE__ */ A(n, {
		ref: l,
		className: O(Ru.root, e),
		onClick: () => y(!0),
		disabled: t,
		children: /* @__PURE__ */ j("div", {
			className: Ru.wrapper,
			"data-testid": "tags-wrapper",
			children: [
				T.map((e) => /* @__PURE__ */ A(la, {
					className: O(Ru.tag, { [Ru.tagIsActive]: e === g }),
					onDelete: () => S(e),
					"data-testid": "tag",
					children: e
				}, e)),
				!v && w && /* @__PURE__ */ j(la, {
					className: O(Ru.tag, Ru.tagButton),
					"data-testid": "tag",
					children: ["+", m.length - C]
				}),
				!v && !m.length && !f && /* @__PURE__ */ A(G, {
					className: Ru.placeholder,
					alignItems: "center",
					gap: "200",
					children: a ? /* @__PURE__ */ A(i.Paragraph, {
						className: Ru.placeholderText,
						variant: "2",
						children: a
					}) : /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A(i.Paragraph, {
						className: Ru.placeholderText,
						variant: "2",
						children: "Type words or phrases and add with"
					}), /* @__PURE__ */ j("div", {
						className: Ru.iconBox,
						children: [/* @__PURE__ */ A(u, {
							name: "enter",
							color: "neutral.500"
						}), /* @__PURE__ */ A(i.Paragraph, {
							className: Ru.iconText,
							children: "enter"
						})]
					})] })
				}),
				/* @__PURE__ */ A("input", {
					className: O(Ru.input, { [Ru.inputIsHidden]: !v }),
					onChange: b,
					onKeyDown: x,
					maxLength: Bu,
					ref: d,
					type: "text",
					value: f,
					"data-testid": "tag-input"
				})
			]
		})
	});
}, Hu = { highlight: "h-textWithHighlight--textWithHighlight__highlight" }, Uu = xe(({ text: e, highlight: t, className: n, highlightClassName: r, ignoreCase: i = !0 }) => {
	if (!t?.trim()) return /* @__PURE__ */ A(k, { children: e });
	let a = new RegExp(ki(t.trim()), i ? "ig" : "g"), o = e.match(a);
	return /* @__PURE__ */ A("span", {
		className: n,
		children: e.split(a).map((e, t) => /* @__PURE__ */ j("span", { children: [e, o?.[t] && /* @__PURE__ */ A("em", {
			className: O(Hu.highlight, r),
			children: o[t]
		})] }, t))
	});
});
Uu.name = "TextWithHighlight";
var Wu = {
	timestamp: "h-timestamp--timestamp__timestamp",
	print: "h-timestamp--timestamp__print",
	screen: "h-timestamp--timestamp__screen"
}, Gu = 1e4, Ku = class extends me {
	interval;
	static defaultProps = { refreshRate: Gu };
	constructor(e) {
		super(e);
		let { relative: t, counter: n, initialFormat: r } = e, i = r ?? "absolute";
		t ? i = "ago" : n && (i = "counter"), this.state = {
			format: i,
			pristine: !0
		}, this.handleClick = this.handleClick.bind(this), this.interval = null;
	}
	componentDidMount() {
		let { format: e } = this.state;
		(e === "ago" || e === "counter") && this.startTicker();
	}
	componentDidUpdate(e) {
		let { relative: t, initialFormat: n } = this.props, { pristine: r } = this.state;
		t !== e.relative && r && this.setState({ format: t ? "ago" : "absolute" }), n && n !== e.initialFormat && this.setState({ format: n });
	}
	componentWillUnmount() {
		this.stopTicker();
	}
	startTicker() {
		this.interval = setInterval(() => {
			this.forceUpdate();
		}, this.props.refreshRate ?? 0);
	}
	stopTicker() {
		this.interval && clearInterval(this.interval);
	}
	handleClick(e) {
		let { onClick: t } = this.props, { format: n } = this.state, r = this.state.format;
		n === "ago" ? (r = "full", this.stopTicker()) : n === "full" ? r = "absolute" : n === "absolute" && (r = "ago", this.startTicker()), this.setState({
			pristine: !1,
			format: r
		}), t?.(r, e);
	}
	getTimeString(e) {
		let { time: t } = this.props, { isSecondsDisplayed: n, customFormatters: r } = this.props, i = "";
		if (typeof t == "number") {
			let e = /* @__PURE__ */ new Date();
			e.setTime(t * 1e3), t = e;
		}
		let a = H(t).utc().local();
		if (e === "counter") {
			let e = H(t).utc(), n = H().utc().diff(e) / 1e3, r = Math.floor(n / 3600), a = Math.floor(r / 24), o = r % 24, s = r * 60 * 60, c = Math.floor((n - s) / 60), l = c * 60, u = Math.floor(n - s - l);
			i = [
				o.toString().padStart(2, "0"),
				c.toString().padStart(2, "0"),
				u.toString().padStart(2, "0")
			].join(":"), a > 0 && (i = `${a} ${a === 1 ? "DAY" : "DAYS"} ${i}`);
		} else if (e === "full") {
			let e = r?.full ?? (n ? "MMM Do YYYY, hh:mm:ss A" : "lll");
			i = a.format(e);
		} else if (e === "absolute") if (H().diff(H(t), "hours") > 12) {
			let e = r?.absolute ?? `D MMMM LT${n ? "S" : ""}`;
			i = a.format(e);
		} else {
			let e = r?.absolute ?? `LT${n ? "S" : ""}`;
			i = a.format(e);
		}
		else i = si(a);
		return i;
	}
	render() {
		let { className: e, relative: t, time: n, refreshRate: r, counter: i, customFormatters: a, isSecondsDisplayed: o, initialFormat: s, onClick: c, ...l } = this.props, u = O({ [Wu.timestamp]: !0 }, e);
		return /* @__PURE__ */ j(k, { children: [/* @__PURE__ */ A("span", {
			...l,
			...sn(this.handleClick),
			className: O(u, Wu.screen),
			children: this.getTimeString(this.state.format)
		}), /* @__PURE__ */ A("span", {
			className: O(u, Wu.print),
			"aria-hidden": !0,
			children: this.getTimeString("full")
		})] });
	}
}, qu = {
	root: "h-token--token__root",
	select: "h-token--token__select",
	label: "h-token--token__label",
	rootReadonly: "h-token--token__rootReadonly",
	rootPrimary: "h-token--token__rootPrimary",
	rootWithError: "h-token--token__rootWithError",
	value: "h-token--token__value",
	icon: "h-token--token__icon"
}, Ju = class extends N {
	render() {
		let { onDelete: e, id: t, label: n, options: r, valueLabel: i, primary: a, input: o, meta: s, defaultOption: c, className: l, ...d } = this.props, f = O({
			[qu.root]: !0,
			[qu.rootPrimary]: a,
			[qu.rootWithError]: s?.error,
			[qu.rootReadonly]: !r && !e
		}, l), p = i;
		if (!p && o && r && r.length) {
			let e = r.filter(({ value: e }) => o.value === e);
			e.length && (p = e[0].label);
		}
		return !p && c && (p = c), /* @__PURE__ */ j("div", {
			...d,
			className: f,
			children: [!!r && /* @__PURE__ */ j("select", {
				...o,
				className: qu.select,
				id: t,
				children: [!!c && /* @__PURE__ */ A("option", {
					disabled: !0,
					hidden: !0,
					value: "",
					children: c
				}), r.map((e) => /* @__PURE__ */ A("option", {
					value: e.value,
					children: e.label
				}, e.value?.toString()))]
			}), /* @__PURE__ */ j("label", {
				className: qu.label,
				htmlFor: t,
				children: [
					n,
					/* @__PURE__ */ A("span", {
						className: qu.value,
						children: p
					}),
					!!r && /* @__PURE__ */ A(u, {
						className: qu.icon,
						name: "angle-down"
					}),
					!!e && /* @__PURE__ */ A("span", {
						...sn(e),
						children: /* @__PURE__ */ A(u, {
							className: qu.icon,
							name: "close",
							onClick: e
						})
					})
				]
			})]
		});
	}
}, Yu = {
	root: "h-skeleton--skeleton__root",
	rootAnimationPulse: "h-skeleton--skeleton__rootAnimationPulse",
	pulse: "h-skeleton--skeleton__pulse",
	rootAnimationWave: "h-skeleton--skeleton__rootAnimationWave",
	wave: "h-skeleton--skeleton__wave"
};
//#endregion
//#region src/components/skeleton/skeleton.tsx
function Xu({ className: e, animation: t = "pulse", ...n }, r) {
	return /* @__PURE__ */ A(a, {
		className: O({
			[Yu.root]: !0,
			[Yu.rootAnimationPulse]: t === "pulse",
			[Yu.rootAnimationWave]: t === "wave"
		}, e),
		...n,
		ref: r
	});
}
var Zu = Object.assign(F(Xu), { name: Xu.name }), Qu = {
	root: "h-breadcrumbs--breadcrumbs__root",
	list: "h-breadcrumbs--breadcrumbs__list",
	item: "h-breadcrumbs--breadcrumbs__item",
	separator: "h-breadcrumbs--breadcrumbs__separator"
}, $u = F(function({ className: e, children: t, as: n, separator: r = /* @__PURE__ */ A(u, { name: "angle-right" }), "aria-label": i = "breadcrumb", ...a }, o) {
	let s = n ?? "nav", c = M.toArray(t).filter(Boolean);
	return /* @__PURE__ */ A(s, {
		...a,
		ref: o,
		className: O(Qu.root, e),
		"aria-label": i,
		children: /* @__PURE__ */ A("ol", {
			className: Qu.list,
			children: c.map((e, t) => {
				let n = t === c.length - 1, i = typeof e == "string" || typeof e == "number" ? /* @__PURE__ */ A("span", { children: e }) : e;
				return /* @__PURE__ */ j(he, { children: [/* @__PURE__ */ A("li", {
					className: Qu.item,
					"aria-current": n ? "page" : void 0,
					children: i
				}), !n && /* @__PURE__ */ A("li", {
					className: Qu.separator,
					"data-testid": "breadcrumbs-separator",
					"aria-hidden": "true",
					children: r
				})] }, t);
			})
		})
	});
});
//#endregion
export { Ro as AddonTriggerContext, zo as AddonTriggerEvents, lt as Attachment, Pt as Avatar, Qi as AvatarSelectItem, Bt as Badge, Ut as Banner, a as Box, $u as Breadcrumbs, g as Button, Gt as ButtonGroup, Qt as ButtonList, $i as CheckableAvatarSelectItem, Bi as CheckableBaseItem, Ki as CheckableSelectItem, Xi as CheckableTagSelectItem, tn as Checkbox, sa as Chip, Dn as CollapseCard, kn as Collapsible, zn as ColorPicker, q as Column, Hn as Columns, Xn as CopyToClipboard, Zn as CopyToClipboardButton, dl as CountryFlag, ei as DataTable, Na as DatePicker, ai as DatePickerOld, ka as DateRangePicker, ra as DeselectItem, Ia as Dialer, qt as Divider, hn as Dropdown, vn as DropdownButton, _n as DropdownButtonContext, Ri as DropdownInfinite, Fi as DropdownItem, Ua as DropdownSelect, Ha as DropdownSelectContainer, m as EMOJIS, d as EmojiPicker, Hi as EmptySelectItem, Er as EmptyState, pt as ErrorBoundary, ut as ErrorBoundaryContext, ol as FieldAddonDropdown, va as FieldAlert, Ga as FieldButton, il as FieldColorPicker, Xa as FieldDatePicker, eo as FieldDateRangePicker, Oi as FieldLabel, lc as FieldRichText, uc as FieldSelect, Rc as FieldSelectionList, Gc as FieldSlider, Yc as FieldSwitch, za as FieldText, Xc as FieldTextarea, Zc as FieldTimePicker, Qc as FieldTimeRangePicker, X as FieldWrapper, G as FlexBox, pn as FocusScope, yl as FormField, hl as FormGrid, Xr as HelpIcon, xl as HelperField, u as Icon, h as IconButton, yt as Image, rl as InputColorPicker, Ya as InputDatePicker, $a as InputDateRangePicker, El as InputDuration, ic as InputRichText, Lc as InputSelectionList, c as InputText, n as InputWrapper, Nl as Lightbox, Ul as List, Ul as ListV2, Zl as MediaPlayer, jl as Modal, $l as ModalBody, tu as ModalFoot, ru as ModalHead, Al as ModalStackContext, l as NavigationButton, fu as Page, xr as Pagination, Ol as Portal, Ti as Presets, mu as Radio, yu as RemovableCard, _u as ReverseScroll, Su as SandboxIframe, Eu as ScrollShadow, wu as Scrollbar, Au as SearchInput, da as Select, Wi as SelectItem, Mu as SelectOption, Mc as SelectionList, er as SimplePagination, Fu as SimpleProgressBar, Zu as Skeleton, Uc as Slider, r as Spinner, Jc as Switch, Jr as Table, tr as TableContext, ms as Tabs, Lu as TabsWithContent, la as Tag, aa as TagDeselectItem, Ji as TagSelectItem, ta as TagSelectSuggestion, Vu as TagsInput, i as Text, Uu as TextWithHighlight, sc as Textarea, Sa as TimePicker, wa as TimeRangePicker, Ku as Timestamp, Ju as Token, U as Tooltip, tt as WindowContext, nt as WindowProvider, _ as addSvgIconsToDocument, zt as badgeTestId, Rn as colorPickerTestId, fl as countryCodes, ii as datepickerDisableWeekends, p as defaultElementType, rs as formatShortcut, to as formattingOptions, hc as getSelectionListContext, t as iconMeta, tc as inputRichTextCommands, Fc as inputSelectionListTestId, co as isKeyCombination, gu as reverseScrollTestId, rt as useWindowContext, mt as withErrorBoundary };

//# sourceMappingURL=index.js.map